const AllGeneList = [
"A1BG",
"A1BG-AS1",
"A1CF",
"A2M",
"A2M-AS1",
"A2ML1",
"A2MP1",
"A3GALT2",
"A4GALT",
"A4GNT",
"AAAS",
"AACS",
"AACSP1",
"AADAC",
"AADACL2-AS1",
"AADACL3",
"AADACP1",
"AADAT",
"AAED1",
"AAGAB",
"AAK1",
"AAMDC",
"AAMP",
"AANAT",
"AAR2",
"AARD",
"AARS",
"AARS2",
"AARSD1",
"AASDH",
"AASDHPPT",
"AASS",
"AATBC",
"AATF",
"AATK",
"AATK-AS1",
"ABALON",
"ABAT",
"ABCA1",
"ABCA10",
"ABCA11P",
"ABCA12",
"ABCA13",
"ABCA17P",
"ABCA2",
"ABCA3",
"ABCA4",
"ABCA5",
"ABCA6",
"ABCA7",
"ABCA9",
"ABCB1",
"ABCB10",
"ABCB4",
"ABCB5",
"ABCB6",
"ABCB7",
"ABCB8",
"ABCB9",
"ABCC1",
"ABCC10",
"ABCC11",
"ABCC12",
"ABCC13",
"ABCC2",
"ABCC3",
"ABCC4",
"ABCC5",
"ABCC5-AS1",
"ABCC6",
"ABCC6P1",
"ABCC6P2",
"ABCC8",
"ABCC9",
"ABCD1",
"ABCD2",
"ABCD3",
"ABCD4",
"ABCE1",
"ABCF1",
"ABCF2",
"ABCF3",
"ABCG1",
"ABCG2",
"ABCG4",
"ABCG5",
"ABCG8",
"ABHD1",
"ABHD10",
"ABHD11",
"ABHD11-AS1",
"ABHD12",
"ABHD12B",
"ABHD13",
"ABHD14A",
"ABHD14A-ACY1",
"ABHD14B",
"ABHD15",
"ABHD16A",
"ABHD16B",
"ABHD17A",
"ABHD17B",
"ABHD17C",
"ABHD2",
"ABHD3",
"ABHD4",
"ABHD5",
"ABHD6",
"ABHD8",
"ABI1",
"ABI2",
"ABI3",
"ABI3BP",
"ABL1",
"ABL2",
"ABLIM1",
"ABLIM2",
"ABLIM3",
"ABO",
"ABR",
"ABRA",
"ABRACL",
"ABT1",
"ABTB1",
"ABTB2",
"ACAA1",
"ACAA2",
"ACACA",
"ACACB",
"ACAD10",
"ACAD11",
"ACAD8",
"ACAD9",
"ACADL",
"ACADM",
"ACADS",
"ACADSB",
"ACADVL",
"ACAN",
"ACAP1",
"ACAP2",
"ACAP3",
"ACAT1",
"ACAT2",
"ACBD3",
"ACBD4",
"ACBD5",
"ACBD6",
"ACBD7",
"ACCS",
"ACCSL",
"ACD",
"ACE",
"ACE2",
"ACER2",
"ACER3",
"ACHE",
"ACIN1",
"ACKR1",
"ACKR2",
"ACKR3",
"ACKR4",
"ACLY",
"ACMSD",
"ACO1",
"ACO2",
"ACOT1",
"ACOT11",
"ACOT12",
"ACOT13",
"ACOT2",
"ACOT4",
"ACOT6",
"ACOT7",
"ACOT8",
"ACOT9",
"ACOX1",
"ACOX2",
"ACOX3",
"ACOXL",
"ACP1",
"ACP2",
"ACP5",
"ACP6",
"ACPP",
"ACPT",
"ACR",
"ACRBP",
"ACRC",
"ACRV1",
"ACSBG1",
"ACSBG2",
"ACSF2",
"ACSF3",
"ACSL1",
"ACSL3",
"ACSL4",
"ACSL5",
"ACSL6",
"ACSM1",
"ACSM3",
"ACSM5",
"ACSM6",
"ACSS1",
"ACSS2",
"ACSS3",
"ACTA1",
"ACTA2",
"ACTA2-AS1",
"ACTB",
"ACTBL2",
"ACTC1",
"ACTG1",
"ACTG1P17",
"ACTG1P20",
"ACTG1P4",
"ACTG2",
"ACTL10",
"ACTL6A",
"ACTL6B",
"ACTL7A",
"ACTL7B",
"ACTL8",
"ACTN1",
"ACTN1-AS1",
"ACTN2",
"ACTN3",
"ACTN4",
"ACTR10",
"ACTR1A",
"ACTR1B",
"ACTR2",
"ACTR3",
"ACTR3B",
"ACTR3BP5",
"ACTR3C",
"ACTR5",
"ACTR6",
"ACTR8",
"ACTRT3",
"ACVR1",
"ACVR1B",
"ACVR1C",
"ACVR2A",
"ACVR2B",
"ACVR2B-AS1",
"ACVRL1",
"ACY1",
"ACY3",
"ACYP1",
"ACYP2",
"ADA",
"ADAD1",
"ADAD2",
"ADAL",
"ADAM10",
"ADAM11",
"ADAM12",
"ADAM15",
"ADAM17",
"ADAM18",
"ADAM19",
"ADAM1A",
"ADAM2",
"ADAM20",
"ADAM20P1",
"ADAM21",
"ADAM21P1",
"ADAM22",
"ADAM23",
"ADAM28",
"ADAM29",
"ADAM30",
"ADAM32",
"ADAM33",
"ADAM3A",
"ADAM7",
"ADAM8",
"ADAM9",
"ADAMTS1",
"ADAMTS10",
"ADAMTS12",
"ADAMTS13",
"ADAMTS14",
"ADAMTS15",
"ADAMTS16",
"ADAMTS17",
"ADAMTS18",
"ADAMTS19",
"ADAMTS19-AS1",
"ADAMTS2",
"ADAMTS20",
"ADAMTS3",
"ADAMTS4",
"ADAMTS5",
"ADAMTS6",
"ADAMTS7",
"ADAMTS7P1",
"ADAMTS8",
"ADAMTS9",
"ADAMTS9-AS1",
"ADAMTS9-AS2",
"ADAMTSL1",
"ADAMTSL2",
"ADAMTSL3",
"ADAMTSL4",
"ADAMTSL4-AS1",
"ADAMTSL5",
"ADAP1",
"ADAP2",
"ADAR",
"ADARB1",
"ADARB2",
"ADARB2-AS1",
"ADAT1",
"ADAT2",
"ADAT3",
"ADCK1",
"ADCK2",
"ADCK3",
"ADCK4",
"ADCK5",
"ADCY1",
"ADCY10",
"ADCY10P1",
"ADCY3",
"ADCY4",
"ADCY5",
"ADCY6",
"ADCY7",
"ADCY8",
"ADCY9",
"ADCYAP1",
"ADD1",
"ADD2",
"ADD3",
"ADD3-AS1",
"ADGRA1",
"ADGRA2",
"ADGRA3",
"ADGRB1",
"ADGRB2",
"ADGRB3",
"ADGRD1",
"ADGRE1",
"ADGRE2",
"ADGRE4P",
"ADGRE5",
"ADGRF1",
"ADGRF2",
"ADGRF3",
"ADGRF4",
"ADGRF5",
"ADGRG1",
"ADGRG2",
"ADGRG3",
"ADGRG4",
"ADGRG5",
"ADGRG6",
"ADGRG7",
"ADGRL1",
"ADGRL2",
"ADGRL3",
"ADGRV1",
"ADH1B",
"ADH1C",
"ADH4",
"ADH5",
"ADH6",
"ADHFE1",
"ADI1",
"ADIPOQ",
"ADIPOQ-AS1",
"ADIPOR1",
"ADIPOR2",
"ADIRF",
"ADK",
"ADM",
"ADM2",
"ADM5",
"ADNP",
"ADNP-AS1",
"ADNP2",
"ADO",
"ADORA1",
"ADORA2A",
"ADORA2A-AS1",
"ADORA2B",
"ADORA3",
"ADPGK",
"ADPGK-AS1",
"ADPRH",
"ADPRHL1",
"ADPRHL2",
"ADPRM",
"ADRA1A",
"ADRA1B",
"ADRA1D",
"ADRA2A",
"ADRA2B",
"ADRA2C",
"ADRB1",
"ADRB2",
"ADRB3",
"ADRBK1",
"ADRBK2",
"ADRM1",
"ADSL",
"ADSS",
"ADSSL1",
"ADTRP",
"AEBP1",
"AEBP2",
"AEN",
"AES",
"AFAP1",
"AFAP1-AS1",
"AFAP1L1",
"AFAP1L2",
"AFF1",
"AFF2",
"AFF3",
"AFF4",
"AFG3L1P",
"AFG3L2",
"AFM",
"AFMID",
"AFP",
"AFTPH",
"AGA",
"AGAP1",
"AGAP1-IT1",
"AGAP11",
"AGAP2",
"AGAP2-AS1",
"AGAP3",
"AGAP4",
"AGAP5",
"AGAP6",
"AGAP7P",
"AGAP9",
"AGBL1-AS1",
"AGBL2",
"AGBL3",
"AGBL4",
"AGBL5",
"AGBL5-AS1",
"AGER",
"AGFG1",
"AGFG2",
"AGGF1",
"AGK",
"AGL",
"AGMAT",
"AGO1",
"AGO2",
"AGO3",
"AGO4",
"AGPAT1",
"AGPAT2",
"AGPAT3",
"AGPAT4",
"AGPAT4-IT1",
"AGPAT5",
"AGPS",
"AGR2",
"AGR3",
"AGRN",
"AGRP",
"AGT",
"AGTPBP1",
"AGTR1",
"AGTR2",
"AGTRAP",
"AGXT",
"AGXT2",
"AHCTF1",
"AHCTF1P1",
"AHCY",
"AHCYL1",
"AHCYL2",
"AHDC1",
"AHI1",
"AHNAK",
"AHNAK2",
"AHR",
"AHRR",
"AHSA1",
"AHSA2",
"AHSG",
"AHSP",
"AICDA",
"AIDA",
"AIF1",
"AIF1L",
"AIFM1",
"AIFM2",
"AIFM3",
"AIG1",
"AIM1",
"AIM1L",
"AIM2",
"AIMP1",
"AIMP2",
"AIP",
"AIPL1",
"AIRE",
"AIRN",
"AJAP1",
"AJUBA",
"AK1",
"AK2",
"AK3",
"AK4",
"AK5",
"AK6",
"AK7",
"AK8",
"AK9",
"AKAP1",
"AKAP10",
"AKAP11",
"AKAP12",
"AKAP13",
"AKAP14",
"AKAP17A",
"AKAP2",
"AKAP3",
"AKAP5",
"AKAP6",
"AKAP7",
"AKAP8",
"AKAP8L",
"AKAP9",
"AKIP1",
"AKIRIN1",
"AKIRIN2",
"AKNA",
"AKNAD1",
"AKR1A1",
"AKR1B1",
"AKR1B10",
"AKR1B15",
"AKR1C1",
"AKR1C2",
"AKR1C3",
"AKR1C4",
"AKR1C6P",
"AKR1C8P",
"AKR1D1",
"AKR1E2",
"AKR7A2",
"AKR7A2P1",
"AKR7A3",
"AKR7L",
"AKT1",
"AKT1S1",
"AKT2",
"AKT3",
"AKTIP",
"ALAD",
"ALAS1",
"ALAS2",
"ALB",
"ALCAM",
"ALDH16A1",
"ALDH18A1",
"ALDH1A1",
"ALDH1A2",
"ALDH1A3",
"ALDH1B1",
"ALDH1L1",
"ALDH1L1-AS2",
"ALDH1L2",
"ALDH2",
"ALDH3A1",
"ALDH3A2",
"ALDH3B1",
"ALDH3B2",
"ALDH4A1",
"ALDH5A1",
"ALDH6A1",
"ALDH7A1",
"ALDH8A1",
"ALDH9A1",
"ALDOA",
"ALDOB",
"ALDOC",
"ALG1",
"ALG10",
"ALG10B",
"ALG11",
"ALG12",
"ALG13",
"ALG14",
"ALG1L",
"ALG1L2",
"ALG1L9P",
"ALG2",
"ALG3",
"ALG5",
"ALG6",
"ALG8",
"ALG9",
"ALK",
"ALKBH1",
"ALKBH2",
"ALKBH3",
"ALKBH3-AS1",
"ALKBH4",
"ALKBH5",
"ALKBH6",
"ALKBH7",
"ALKBH8",
"ALLC",
"ALMS1",
"ALMS1-IT1",
"ALMS1P",
"ALOX12",
"ALOX12-AS1",
"ALOX12B",
"ALOX12P2",
"ALOX15",
"ALOX15B",
"ALOX15P1",
"ALOX5",
"ALOX5AP",
"ALOXE3",
"ALPI",
"ALPK1",
"ALPK2",
"ALPK3",
"ALPL",
"ALPP",
"ALPPL2",
"ALS2",
"ALS2CL",
"ALS2CR11",
"ALS2CR12",
"ALX1",
"ALX3",
"ALX4",
"ALYREF",
"AMACR",
"AMBN",
"AMBP",
"AMBRA1",
"AMD1",
"AMDHD1",
"AMDHD2",
"AMER1",
"AMER2",
"AMER3",
"AMFR",
"AMH",
"AMHR2",
"AMICA1",
"AMIGO1",
"AMIGO2",
"AMIGO3",
"AMMECR1",
"AMMECR1L",
"AMN",
"AMN1",
"AMOT",
"AMOTL1",
"AMOTL2",
"AMPD1",
"AMPD2",
"AMPD3",
"AMPH",
"AMT",
"AMTN",
"AMY1A",
"AMY1B",
"AMY1C",
"AMY2A",
"AMY2B",
"AMZ1",
"AMZ2",
"AMZ2P1",
"ANAPC1",
"ANAPC10",
"ANAPC11",
"ANAPC13",
"ANAPC15",
"ANAPC16",
"ANAPC1P1",
"ANAPC2",
"ANAPC4",
"ANAPC5",
"ANAPC7",
"ANG",
"ANGEL1",
"ANGEL2",
"ANGPT1",
"ANGPT2",
"ANGPT4",
"ANGPTL1",
"ANGPTL2",
"ANGPTL3",
"ANGPTL4",
"ANGPTL5",
"ANGPTL6",
"ANGPTL7",
"ANK1",
"ANK2",
"ANK3",
"ANKAR",
"ANKDD1A",
"ANKDD1B",
"ANKEF1",
"ANKFN1",
"ANKFY1",
"ANKH",
"ANKHD1",
"ANKHD1-EIF4EBP3",
"ANKIB1",
"ANKK1",
"ANKLE1",
"ANKLE2",
"ANKMY1",
"ANKMY2",
"ANKRA2",
"ANKRD1",
"ANKRD10",
"ANKRD11",
"ANKRD12",
"ANKRD13A",
"ANKRD13B",
"ANKRD13C",
"ANKRD13D",
"ANKRD16",
"ANKRD17",
"ANKRD18A",
"ANKRD18B",
"ANKRD18DP",
"ANKRD19P",
"ANKRD2",
"ANKRD20A1",
"ANKRD20A11P",
"ANKRD20A12P",
"ANKRD20A19P",
"ANKRD20A2",
"ANKRD20A3",
"ANKRD20A4",
"ANKRD20A5P",
"ANKRD20A8P",
"ANKRD20A9P",
"ANKRD22",
"ANKRD23",
"ANKRD24",
"ANKRD26",
"ANKRD26P1",
"ANKRD26P3",
"ANKRD27",
"ANKRD28",
"ANKRD29",
"ANKRD30B",
"ANKRD30BL",
"ANKRD30BP2",
"ANKRD31",
"ANKRD33B",
"ANKRD34A",
"ANKRD34B",
"ANKRD34C",
"ANKRD35",
"ANKRD36",
"ANKRD36B",
"ANKRD36BP1",
"ANKRD36BP2",
"ANKRD36C",
"ANKRD37",
"ANKRD39",
"ANKRD40",
"ANKRD42",
"ANKRD44",
"ANKRD44-IT1",
"ANKRD45",
"ANKRD46",
"ANKRD49",
"ANKRD50",
"ANKRD52",
"ANKRD53",
"ANKRD54",
"ANKRD55",
"ANKRD6",
"ANKRD60",
"ANKRD61",
"ANKRD62",
"ANKRD62P1-PARP4P3",
"ANKRD63",
"ANKRD65",
"ANKRD7",
"ANKRD9",
"ANKS1A",
"ANKS1B",
"ANKS3",
"ANKS4B",
"ANKS6",
"ANKUB1",
"ANKZF1",
"ANLN",
"ANO1",
"ANO1-AS2",
"ANO10",
"ANO2",
"ANO3",
"ANO5",
"ANO6",
"ANO7",
"ANO8",
"ANO9",
"ANOS1",
"ANP32A",
"ANP32A-IT1",
"ANP32AP1",
"ANP32B",
"ANP32C",
"ANP32E",
"ANPEP",
"ANTXR1",
"ANTXR2",
"ANTXRL",
"ANTXRLP1",
"ANXA1",
"ANXA10",
"ANXA11",
"ANXA13",
"ANXA2",
"ANXA2P1",
"ANXA2P2",
"ANXA2R",
"ANXA3",
"ANXA4",
"ANXA5",
"ANXA6",
"ANXA7",
"ANXA8",
"ANXA8L1",
"ANXA9",
"AOAH",
"AOC1",
"AOC2",
"AOC3",
"AOC4P",
"AOX1",
"AOX2P",
"AP1AR",
"AP1B1",
"AP1B1P1",
"AP1G1",
"AP1G2",
"AP1M1",
"AP1M2",
"AP1S1",
"AP1S2",
"AP1S3",
"AP2A1",
"AP2A2",
"AP2B1",
"AP2M1",
"AP2S1",
"AP3B1",
"AP3B2",
"AP3D1",
"AP3M1",
"AP3M2",
"AP3S1",
"AP3S2",
"AP4B1",
"AP4B1-AS1",
"AP4E1",
"AP4M1",
"AP4S1",
"AP5B1",
"AP5M1",
"AP5S1",
"AP5Z1",
"APAF1",
"APBA1",
"APBA2",
"APBA3",
"APBB1",
"APBB2",
"APBB3",
"APC",
"APC2",
"APCDD1",
"APCDD1L",
"APCDD1L-AS1",
"APEH",
"APELA",
"APEX1",
"APEX2",
"APH1A",
"APH1B",
"API5",
"APIP",
"APITD1",
"APITD1-CORT",
"APLF",
"APLN",
"APLNR",
"APLP1",
"APLP2",
"APMAP",
"APOA1",
"APOA1-AS",
"APOA1BP",
"APOA2",
"APOA5",
"APOBEC2",
"APOBEC3A",
"APOBEC3A_B",
"APOBEC3B",
"APOBEC3B-AS1",
"APOBEC3C",
"APOBEC3D",
"APOBEC3F",
"APOBEC3G",
"APOBEC3H",
"APOBEC4",
"APOBR",
"APOC1",
"APOC1P1",
"APOC2",
"APOC3",
"APOC4",
"APOC4-APOC2",
"APOD",
"APOE",
"APOF",
"APOL1",
"APOL2",
"APOL3",
"APOL4",
"APOL5",
"APOL6",
"APOLD1",
"APOM",
"APOO",
"APOOL",
"APOPT1",
"APP",
"APPBP2",
"APPL1",
"APPL2",
"APRT",
"APTR",
"APTX",
"AQP1",
"AQP10",
"AQP11",
"AQP12B",
"AQP2",
"AQP3",
"AQP4",
"AQP4-AS1",
"AQP5",
"AQP6",
"AQP7",
"AQP7P1",
"AQP7P3",
"AQP8",
"AQP9",
"AQR",
"AR",
"ARAF",
"ARAP1",
"ARAP2",
"ARAP3",
"ARC",
"ARCN1",
"AREG",
"AREL1",
"ARF1",
"ARF3",
"ARF4",
"ARF5",
"ARF6",
"ARFGAP1",
"ARFGAP2",
"ARFGAP3",
"ARFGEF1",
"ARFGEF2",
"ARFGEF3",
"ARFIP1",
"ARFIP2",
"ARFRP1",
"ARG1",
"ARG2",
"ARGFX",
"ARGFXP2",
"ARGLU1",
"ARHGAP1",
"ARHGAP10",
"ARHGAP11A",
"ARHGAP11B",
"ARHGAP12",
"ARHGAP15",
"ARHGAP17",
"ARHGAP18",
"ARHGAP19",
"ARHGAP19-SLIT1",
"ARHGAP20",
"ARHGAP21",
"ARHGAP22",
"ARHGAP23",
"ARHGAP24",
"ARHGAP25",
"ARHGAP26",
"ARHGAP26-IT1",
"ARHGAP27",
"ARHGAP29",
"ARHGAP30",
"ARHGAP31",
"ARHGAP31-AS1",
"ARHGAP32",
"ARHGAP33",
"ARHGAP35",
"ARHGAP36",
"ARHGAP39",
"ARHGAP4",
"ARHGAP40",
"ARHGAP42",
"ARHGAP44",
"ARHGAP5",
"ARHGAP5-AS1",
"ARHGAP6",
"ARHGAP8",
"ARHGAP9",
"ARHGDIA",
"ARHGDIB",
"ARHGDIG",
"ARHGEF1",
"ARHGEF10",
"ARHGEF10L",
"ARHGEF11",
"ARHGEF12",
"ARHGEF15",
"ARHGEF16",
"ARHGEF17",
"ARHGEF18",
"ARHGEF19",
"ARHGEF2",
"ARHGEF25",
"ARHGEF26",
"ARHGEF26-AS1",
"ARHGEF28",
"ARHGEF3",
"ARHGEF3-AS1",
"ARHGEF33",
"ARHGEF34P",
"ARHGEF35",
"ARHGEF37",
"ARHGEF38",
"ARHGEF38-IT1",
"ARHGEF39",
"ARHGEF4",
"ARHGEF40",
"ARHGEF5",
"ARHGEF6",
"ARHGEF7",
"ARHGEF9",
"ARHGEF9-IT1",
"ARID1A",
"ARID1B",
"ARID2",
"ARID3A",
"ARID3B",
"ARID3C",
"ARID4A",
"ARID4B",
"ARID5A",
"ARID5B",
"ARIH1",
"ARIH2",
"ARIH2OS",
"ARL1",
"ARL10",
"ARL11",
"ARL13A",
"ARL13B",
"ARL14",
"ARL14EP",
"ARL14EPL",
"ARL15",
"ARL16",
"ARL17A",
"ARL17B",
"ARL2",
"ARL2-SNX15",
"ARL2BP",
"ARL3",
"ARL4A",
"ARL4C",
"ARL4D",
"ARL5A",
"ARL5B",
"ARL6",
"ARL6IP1",
"ARL6IP4",
"ARL6IP5",
"ARL6IP6",
"ARL8A",
"ARL8B",
"ARL9",
"ARMC1",
"ARMC10",
"ARMC12",
"ARMC2",
"ARMC2-AS1",
"ARMC3",
"ARMC4",
"ARMC5",
"ARMC6",
"ARMC7",
"ARMC8",
"ARMC9",
"ARMCX1",
"ARMCX2",
"ARMCX3",
"ARMCX4",
"ARMCX5",
"ARMCX5-GPRASP2",
"ARMCX6",
"ARMS2",
"ARMT1",
"ARNT",
"ARNT2",
"ARNTL",
"ARNTL2",
"ARNTL2-AS1",
"ARPC1A",
"ARPC1B",
"ARPC2",
"ARPC3",
"ARPC4",
"ARPC4-TTLL3",
"ARPC5",
"ARPC5L",
"ARPIN",
"ARPP19",
"ARR3",
"ARRB1",
"ARRB2",
"ARRDC1",
"ARRDC1-AS1",
"ARRDC2",
"ARRDC3",
"ARRDC3-AS1",
"ARRDC4",
"ARRDC5",
"ARSA",
"ARSB",
"ARSD",
"ARSE",
"ARSG",
"ARSH",
"ARSI",
"ARSJ",
"ARSK",
"ART1",
"ART3",
"ART4",
"ART5",
"ARTN",
"ARV1",
"ARVCF",
"ARX",
"AS3MT",
"ASAH1",
"ASAH2",
"ASAH2B",
"ASAP1",
"ASAP1-IT1",
"ASAP1-IT2",
"ASAP2",
"ASAP3",
"ASB1",
"ASB10",
"ASB12",
"ASB13",
"ASB14",
"ASB15",
"ASB16",
"ASB16-AS1",
"ASB18",
"ASB2",
"ASB3",
"ASB4",
"ASB5",
"ASB6",
"ASB7",
"ASB8",
"ASB9",
"ASB9P1",
"ASCC1",
"ASCC2",
"ASCC3",
"ASCL1",
"ASCL2",
"ASCL3",
"ASCL5",
"ASF1A",
"ASF1B",
"ASGR1",
"ASH1L",
"ASH1L-AS1",
"ASH2L",
"ASIC1",
"ASIC3",
"ASIC4",
"ASIP",
"ASL",
"ASMT",
"ASMTL",
"ASMTL-AS1",
"ASNA1",
"ASNS",
"ASNSD1",
"ASPDH",
"ASPG",
"ASPH",
"ASPHD1",
"ASPHD2",
"ASPM",
"ASPN",
"ASPRV1",
"ASPSCR1",
"ASRGL1",
"ASS1",
"ASTE1",
"ASTL",
"ASTN1",
"ASTN2",
"ASTN2-AS1",
"ASUN",
"ASXL1",
"ASXL2",
"ASXL3",
"ASZ1",
"ATAD1",
"ATAD2",
"ATAD2B",
"ATAD3A",
"ATAD3B",
"ATAD3C",
"ATAD5",
"ATAT1",
"ATCAY",
"ATE1",
"ATE1-AS1",
"ATF1",
"ATF2",
"ATF3",
"ATF4",
"ATF5",
"ATF6",
"ATF6B",
"ATF7",
"ATF7IP",
"ATF7IP2",
"ATG10",
"ATG101",
"ATG12",
"ATG13",
"ATG14",
"ATG16L1",
"ATG16L2",
"ATG2A",
"ATG2B",
"ATG3",
"ATG4A",
"ATG4B",
"ATG4C",
"ATG4D",
"ATG5",
"ATG7",
"ATG9A",
"ATG9B",
"ATHL1",
"ATIC",
"ATL1",
"ATL2",
"ATL3",
"ATM",
"ATMIN",
"ATN1",
"ATOH7",
"ATOH8",
"ATOX1",
"ATP10A",
"ATP10B",
"ATP10D",
"ATP11A",
"ATP11A-AS1",
"ATP11AUN",
"ATP11B",
"ATP11C",
"ATP12A",
"ATP13A1",
"ATP13A2",
"ATP13A3",
"ATP13A4",
"ATP13A4-AS1",
"ATP13A5",
"ATP13A5-AS1",
"ATP1A1",
"ATP1A1-AS1",
"ATP1A2",
"ATP1A3",
"ATP1B1",
"ATP1B2",
"ATP1B3",
"ATP1B4",
"ATP2A1",
"ATP2A1-AS1",
"ATP2A2",
"ATP2A3",
"ATP2B1",
"ATP2B2",
"ATP2B3",
"ATP2B4",
"ATP2C1",
"ATP2C2",
"ATP4A",
"ATP4B",
"ATP5A1",
"ATP5B",
"ATP5C1",
"ATP5D",
"ATP5E",
"ATP5EP2",
"ATP5F1",
"ATP5G1",
"ATP5G2",
"ATP5G3",
"ATP5H",
"ATP5I",
"ATP5J",
"ATP5J2",
"ATP5J2-PTCD1",
"ATP5L",
"ATP5L2",
"ATP5O",
"ATP5S",
"ATP5SL",
"ATP6AP1",
"ATP6AP1L",
"ATP6AP2",
"ATP6V0A1",
"ATP6V0A2",
"ATP6V0A4",
"ATP6V0B",
"ATP6V0C",
"ATP6V0D1",
"ATP6V0D2",
"ATP6V0E1",
"ATP6V0E2",
"ATP6V0E2-AS1",
"ATP6V1A",
"ATP6V1B1",
"ATP6V1B1-AS1",
"ATP6V1B2",
"ATP6V1C1",
"ATP6V1C2",
"ATP6V1D",
"ATP6V1E1",
"ATP6V1E2",
"ATP6V1F",
"ATP6V1G1",
"ATP6V1G2",
"ATP6V1G2-DDX39B",
"ATP6V1H",
"ATP7A",
"ATP7B",
"ATP8A1",
"ATP8A2",
"ATP8B1",
"ATP8B2",
"ATP8B3",
"ATP8B4",
"ATP8B5P",
"ATP9A",
"ATP9B",
"ATPAF1",
"ATPAF2",
"ATPIF1",
"ATR",
"ATRAID",
"ATRIP",
"ATRN",
"ATRNL1",
"ATRX",
"ATXN1",
"ATXN10",
"ATXN1L",
"ATXN2",
"ATXN2L",
"ATXN3",
"ATXN3L",
"ATXN7",
"ATXN7L1",
"ATXN7L2",
"ATXN7L3",
"ATXN7L3B",
"AUH",
"AUNIP",
"AUP1",
"AURKA",
"AURKAIP1",
"AURKAPS1",
"AURKB",
"AURKC",
"AUTS2",
"AVEN",
"AVIL",
"AVL9",
"AVPI1",
"AVPR1A",
"AVPR1B",
"AVPR2",
"AWAT1",
"AWAT2",
"AXDND1",
"AXIN1",
"AXIN2",
"AXL",
"AZGP1",
"AZGP1P1",
"AZI2",
"AZIN1",
"AZIN1-AS1",
"AZIN2",
"AZU1",
"B2M",
"B3GALNT1",
"B3GALNT2",
"B3GALT1",
"B3GALT2",
"B3GALT4",
"B3GALT5",
"B3GALT5-AS1",
"B3GALT6",
"B3GAT1",
"B3GAT2",
"B3GAT3",
"B3GLCT",
"B3GNT2",
"B3GNT3",
"B3GNT4",
"B3GNT5",
"B3GNT6",
"B3GNT7",
"B3GNT8",
"B3GNT9",
"B3GNTL1",
"B4GALNT1",
"B4GALNT2",
"B4GALNT3",
"B4GALNT4",
"B4GALT1",
"B4GALT1-AS1",
"B4GALT2",
"B4GALT3",
"B4GALT4",
"B4GALT4-AS1",
"B4GALT5",
"B4GALT6",
"B4GALT7",
"B4GAT1",
"B9D1",
"B9D2",
"BAALC",
"BAALC-AS1",
"BAAT",
"BABAM1",
"BACE1",
"BACE1-AS",
"BACE2",
"BACH1",
"BACH1-IT2",
"BACH2",
"BAD",
"BAG1",
"BAG2",
"BAG3",
"BAG4",
"BAG5",
"BAG6",
"BAGE",
"BAGE3",
"BAGE4",
"BAGE5",
"BAHCC1",
"BAHD1",
"BAIAP2",
"BAIAP2-AS1",
"BAIAP2L1",
"BAIAP2L2",
"BAIAP3",
"BAK1",
"BAMBI",
"BANF1",
"BANK1",
"BANP",
"BAP1",
"BARD1",
"BARHL1",
"BARX1",
"BARX2",
"BASP1",
"BASP1P1",
"BATF",
"BATF2",
"BATF3",
"BAX",
"BAZ1A",
"BAZ1B",
"BAZ2A",
"BAZ2B",
"BBC3",
"BBIP1",
"BBOX1",
"BBOX1-AS1",
"BBS1",
"BBS10",
"BBS12",
"BBS2",
"BBS4",
"BBS5",
"BBS7",
"BBS9",
"BBX",
"BCAM",
"BCAN",
"BCAP29",
"BCAP31",
"BCAR1",
"BCAR3",
"BCAR4",
"BCAS1",
"BCAS2",
"BCAS3",
"BCAS4",
"BCAT1",
"BCAT2",
"BCCIP",
"BCDIN3D",
"BCDIN3D-AS1",
"BCKDHA",
"BCKDHB",
"BCKDK",
"BCL10",
"BCL11A",
"BCL11B",
"BCL2",
"BCL2A1",
"BCL2L1",
"BCL2L10",
"BCL2L11",
"BCL2L12",
"BCL2L13",
"BCL2L14",
"BCL2L15",
"BCL2L2",
"BCL2L2-PABPN1",
"BCL3",
"BCL6",
"BCL6B",
"BCL7A",
"BCL7B",
"BCL7C",
"BCL9",
"BCL9L",
"BCLAF1",
"BCO1",
"BCO2",
"BCOR",
"BCORL1",
"BCR",
"BCRP2",
"BCRP3",
"BCS1L",
"BCYRN1",
"BDH1",
"BDH2",
"BDKRB1",
"BDKRB2",
"BDNF",
"BDNF-AS",
"BDP1",
"BEAN1",
"BECN1",
"BECN2",
"BEGAIN",
"BEND2",
"BEND3",
"BEND3P3",
"BEND4",
"BEND5",
"BEND6",
"BEND7",
"BEST1",
"BEST2",
"BEST3",
"BEST4",
"BET1",
"BET1L",
"BEX1",
"BEX2",
"BEX4",
"BEX5",
"BFAR",
"BFSP1",
"BGLAP",
"BGN",
"BHLHA15",
"BHLHA9",
"BHLHB9",
"BHLHE40",
"BHLHE40-AS1",
"BHLHE41",
"BHMG1",
"BHMT",
"BHMT2",
"BICC1",
"BICD1",
"BICD2",
"BID",
"BIK",
"BIN1",
"BIN2",
"BIN3",
"BIN3-IT1",
"BIRC2",
"BIRC3",
"BIRC5",
"BIRC6",
"BIRC6-AS2",
"BIRC7",
"BISPR",
"BIVM",
"BIVM-ERCC5",
"BLACAT1",
"BLACE",
"BLCAP",
"BLID",
"BLM",
"BLMH",
"BLNK",
"BLOC1S1",
"BLOC1S1-RDH5",
"BLOC1S2",
"BLOC1S3",
"BLOC1S4",
"BLOC1S5",
"BLOC1S5-TXNDC5",
"BLOC1S6",
"BLVRA",
"BLVRB",
"BLZF1",
"BMF",
"BMI1",
"BMP1",
"BMP2",
"BMP2K",
"BMP3",
"BMP4",
"BMP5",
"BMP6",
"BMP7",
"BMP7-AS1",
"BMP8A",
"BMP8B",
"BMPER",
"BMPR1A",
"BMPR1B",
"BMPR1B-AS1",
"BMPR2",
"BMS1",
"BMS1P17",
"BMS1P18",
"BMS1P20",
"BMS1P21",
"BMS1P4",
"BMS1P5",
"BMS1P6",
"BMX",
"BNC1",
"BNC2",
"BNIP1",
"BNIP2",
"BNIP3",
"BNIP3L",
"BNIPL",
"BOC",
"BOD1",
"BOD1L1",
"BOK",
"BOK-AS1",
"BOLA1",
"BOLA2",
"BOLA2B",
"BOLA3",
"BOLA3-AS1",
"BOLL",
"BOP1",
"BORA",
"BPESC1",
"BPGM",
"BPHL",
"BPI",
"BPIFA1",
"BPIFA2",
"BPIFA4P",
"BPIFB1",
"BPIFB2",
"BPIFB4",
"BPIFC",
"BPNT1",
"BPTF",
"BRAF",
"BRAP",
"BRAT1",
"BRCA1",
"BRCA2",
"BRCAT54",
"BRCC3",
"BRD1",
"BRD2",
"BRD3",
"BRD4",
"BRD7",
"BRD7P3",
"BRD8",
"BRD9",
"BRDT",
"BRE",
"BRE-AS1",
"BREA2",
"BRF1",
"BRF2",
"BRI3",
"BRI3BP",
"BRICD5",
"BRINP2",
"BRIP1",
"BRIX1",
"BRK1",
"BRMS1",
"BRMS1L",
"BROX",
"BRPF1",
"BRPF3",
"BRS3",
"BRSK1",
"BRSK2",
"BRWD1",
"BRWD1-AS1",
"BRWD1-IT2",
"BRWD3",
"BSCL2",
"BSDC1",
"BSG",
"BSN",
"BSN-AS2",
"BSPRY",
"BST1",
"BST2",
"BTAF1",
"BTBD1",
"BTBD10",
"BTBD11",
"BTBD16",
"BTBD18",
"BTBD19",
"BTBD2",
"BTBD3",
"BTBD6",
"BTBD7",
"BTBD8",
"BTBD9",
"BTC",
"BTD",
"BTF3",
"BTF3L4",
"BTG1",
"BTG2",
"BTG3",
"BTK",
"BTLA",
"BTN1A1",
"BTN2A1",
"BTN2A2",
"BTN2A3P",
"BTN3A1",
"BTN3A2",
"BTN3A3",
"BTNL10",
"BTNL8",
"BTNL9",
"BTRC",
"BUB1",
"BUB1B",
"BUB3",
"BUD13",
"BUD31",
"BVES",
"BVES-AS1",
"BYSL",
"BZRAP1",
"BZRAP1-AS1",
"BZW1",
"BZW2",
"C10orf10",
"C10orf105",
"C10orf107",
"C10orf11",
"C10orf111",
"C10orf113",
"C10orf12",
"C10orf126",
"C10orf128",
"C10orf131",
"C10orf142",
"C10orf2",
"C10orf25",
"C10orf32",
"C10orf32-ASMT",
"C10orf35",
"C10orf54",
"C10orf55",
"C10orf62",
"C10orf67",
"C10orf76",
"C10orf88",
"C10orf90",
"C10orf91",
"C10orf95",
"C10orf99",
"C11orf1",
"C11orf16",
"C11orf21",
"C11orf24",
"C11orf30",
"C11orf31",
"C11orf42",
"C11orf44",
"C11orf45",
"C11orf49",
"C11orf52",
"C11orf54",
"C11orf57",
"C11orf58",
"C11orf63",
"C11orf65",
"C11orf68",
"C11orf70",
"C11orf71",
"C11orf72",
"C11orf73",
"C11orf74",
"C11orf80",
"C11orf84",
"C11orf86",
"C11orf87",
"C11orf91",
"C11orf95",
"C11orf96",
"C11orf98",
"C12orf10",
"C12orf29",
"C12orf4",
"C12orf40",
"C12orf42",
"C12orf43",
"C12orf45",
"C12orf49",
"C12orf50",
"C12orf54",
"C12orf56",
"C12orf57",
"C12orf60",
"C12orf65",
"C12orf66",
"C12orf71",
"C12orf73",
"C12orf75",
"C12orf76",
"C12orf79",
"C12orf80",
"C14orf1",
"C14orf105",
"C14orf119",
"C14orf132",
"C14orf142",
"C14orf159",
"C14orf166",
"C14orf169",
"C14orf178",
"C14orf2",
"C14orf28",
"C14orf37",
"C14orf39",
"C14orf79",
"C14orf80",
"C14orf93",
"C15orf26",
"C15orf27",
"C15orf38-AP3S2",
"C15orf39",
"C15orf40",
"C15orf41",
"C15orf48",
"C15orf52",
"C15orf53",
"C15orf54",
"C15orf56",
"C15orf57",
"C15orf59",
"C15orf59-AS1",
"C15orf61",
"C15orf62",
"C15orf65",
"C16orf13",
"C16orf45",
"C16orf46",
"C16orf47",
"C16orf52",
"C16orf54",
"C16orf58",
"C16orf59",
"C16orf62",
"C16orf70",
"C16orf71",
"C16orf72",
"C16orf74",
"C16orf86",
"C16orf87",
"C16orf89",
"C16orf90",
"C16orf91",
"C16orf93",
"C16orf95",
"C16orf96",
"C17orf100",
"C17orf102",
"C17orf104",
"C17orf107",
"C17orf47",
"C17orf49",
"C17orf50",
"C17orf51",
"C17orf53",
"C17orf58",
"C17orf59",
"C17orf62",
"C17orf64",
"C17orf67",
"C17orf74",
"C17orf75",
"C17orf77",
"C17orf78",
"C17orf80",
"C17orf82",
"C17orf85",
"C17orf89",
"C17orf96",
"C17orf97",
"C17orf98",
"C17orf99",
"C18orf21",
"C18orf25",
"C18orf32",
"C18orf54",
"C18orf61",
"C18orf65",
"C18orf8",
"C19orf12",
"C19orf18",
"C19orf24",
"C19orf25",
"C19orf33",
"C19orf35",
"C19orf38",
"C19orf43",
"C19orf44",
"C19orf45",
"C19orf47",
"C19orf48",
"C19orf52",
"C19orf53",
"C19orf54",
"C19orf57",
"C19orf60",
"C19orf66",
"C19orf67",
"C19orf68",
"C19orf70",
"C19orf71",
"C19orf73",
"C19orf80",
"C19orf81",
"C19orf84",
"C1D",
"C1GALT1",
"C1GALT1C1",
"C1GALT1C1L",
"C1orf101",
"C1orf105",
"C1orf106",
"C1orf109",
"C1orf110",
"C1orf111",
"C1orf112",
"C1orf115",
"C1orf116",
"C1orf122",
"C1orf123",
"C1orf127",
"C1orf131",
"C1orf140",
"C1orf145",
"C1orf146",
"C1orf158",
"C1orf159",
"C1orf162",
"C1orf167",
"C1orf168",
"C1orf174",
"C1orf177",
"C1orf186",
"C1orf189",
"C1orf194",
"C1orf195",
"C1orf198",
"C1orf204",
"C1orf21",
"C1orf210",
"C1orf216",
"C1orf220",
"C1orf226",
"C1orf228",
"C1orf229",
"C1orf233",
"C1orf234",
"C1orf27",
"C1orf35",
"C1orf43",
"C1orf50",
"C1orf52",
"C1orf53",
"C1orf54",
"C1orf56",
"C1orf61",
"C1orf64",
"C1orf74",
"C1orf95",
"C1QBP",
"C1QL1",
"C1QL3",
"C1QL4",
"C1QTNF1",
"C1QTNF1-AS1",
"C1QTNF2",
"C1QTNF3",
"C1QTNF3-AMACR",
"C1QTNF4",
"C1QTNF5",
"C1QTNF6",
"C1QTNF7",
"C1QTNF8",
"C1QTNF9",
"C1QTNF9B",
"C1QTNF9B-AS1",
"C1R",
"C1RL",
"C1RL-AS1",
"C1S",
"C2",
"C2-AS1",
"C20orf141",
"C20orf144",
"C20orf173",
"C20orf194",
"C20orf195",
"C20orf196",
"C20orf197",
"C20orf202",
"C20orf203",
"C20orf24",
"C20orf27",
"C20orf78",
"C20orf96",
"C21orf140",
"C21orf2",
"C21orf33",
"C21orf58",
"C21orf59",
"C21orf62",
"C21orf62-AS1",
"C21orf91",
"C22orf15",
"C22orf23",
"C22orf24",
"C22orf29",
"C22orf31",
"C22orf34",
"C22orf39",
"C22orf42",
"C22orf46",
"C2CD2",
"C2CD2L",
"C2CD3",
"C2CD4A",
"C2CD4C",
"C2CD4D",
"C2CD5",
"C2orf15",
"C2orf16",
"C2orf27A",
"C2orf27B",
"C2orf40",
"C2orf42",
"C2orf44",
"C2orf47",
"C2orf48",
"C2orf49",
"C2orf50",
"C2orf54",
"C2orf57",
"C2orf61",
"C2orf66",
"C2orf68",
"C2orf69",
"C2orf70",
"C2orf71",
"C2orf72",
"C2orf74",
"C2orf76",
"C2orf78",
"C2orf81",
"C2orf82",
"C2orf83",
"C2orf88",
"C2orf91",
"C3",
"C3AR1",
"C3orf14",
"C3orf17",
"C3orf18",
"C3orf20",
"C3orf30",
"C3orf33",
"C3orf35",
"C3orf36",
"C3orf38",
"C3orf49",
"C3orf52",
"C3orf58",
"C3orf62",
"C3orf67",
"C3orf67-AS1",
"C3orf70",
"C3orf80",
"C3orf84",
"C3P1",
"C4A",
"C4B_2",
"C4BPB",
"C4orf17",
"C4orf19",
"C4orf26",
"C4orf27",
"C4orf29",
"C4orf3",
"C4orf32",
"C4orf33",
"C4orf36",
"C4orf45",
"C4orf46",
"C4orf47",
"C4orf48",
"C5",
"C5AR1",
"C5AR2",
"C5orf15",
"C5orf17",
"C5orf22",
"C5orf24",
"C5orf28",
"C5orf30",
"C5orf34",
"C5orf38",
"C5orf42",
"C5orf45",
"C5orf46",
"C5orf47",
"C5orf49",
"C5orf51",
"C5orf56",
"C5orf60",
"C5orf63",
"C5orf64",
"C5orf66",
"C5orf66-AS1",
"C5orf66-AS2",
"C5orf67",
"C6",
"C6orf1",
"C6orf10",
"C6orf106",
"C6orf118",
"C6orf120",
"C6orf132",
"C6orf136",
"C6orf141",
"C6orf15",
"C6orf163",
"C6orf165",
"C6orf201",
"C6orf203",
"C6orf222",
"C6orf223",
"C6orf226",
"C6orf229",
"C6orf25",
"C6orf47",
"C6orf48",
"C6orf52",
"C6orf58",
"C6orf62",
"C6orf89",
"C6orf99",
"C7orf13",
"C7orf25",
"C7orf26",
"C7orf31",
"C7orf43",
"C7orf49",
"C7orf50",
"C7orf55",
"C7orf55-LUC7L2",
"C7orf57",
"C7orf60",
"C7orf61",
"C7orf62",
"C7orf65",
"C7orf71",
"C7orf73",
"C8G",
"C8orf31",
"C8orf33",
"C8orf34",
"C8orf34-AS1",
"C8orf37",
"C8orf37-AS1",
"C8orf4",
"C8orf44",
"C8orf44-SGK3",
"C8orf46",
"C8orf48",
"C8orf58",
"C8orf59",
"C8orf76",
"C8orf82",
"C8orf86",
"C8orf88",
"C9orf106",
"C9orf114",
"C9orf116",
"C9orf117",
"C9orf129",
"C9orf131",
"C9orf135",
"C9orf139",
"C9orf142",
"C9orf152",
"C9orf153",
"C9orf156",
"C9orf16",
"C9orf163",
"C9orf170",
"C9orf171",
"C9orf172",
"C9orf173",
"C9orf173-AS1",
"C9orf24",
"C9orf3",
"C9orf40",
"C9orf41-AS1",
"C9orf43",
"C9orf47",
"C9orf50",
"C9orf57",
"C9orf64",
"C9orf66",
"C9orf69",
"C9orf72",
"C9orf78",
"C9orf84",
"C9orf85",
"C9orf89",
"C9orf9",
"C9orf91",
"CA1",
"CA11",
"CA12",
"CA13",
"CA14",
"CA2",
"CA3",
"CA3-AS1",
"CA4",
"CA5A",
"CA5B",
"CA5BP1",
"CA7",
"CA8",
"CA9",
"CAAP1",
"CAB39",
"CAB39L",
"CABIN1",
"CABLES1",
"CABLES2",
"CABP1",
"CABP4",
"CABP7",
"CABYR",
"CACFD1",
"CACHD1",
"CACNA1A",
"CACNA1B",
"CACNA1C",
"CACNA1C-AS1",
"CACNA1C-AS2",
"CACNA1C-AS4",
"CACNA1D",
"CACNA1E",
"CACNA1G",
"CACNA1G-AS1",
"CACNA1H",
"CACNA1I",
"CACNA1S",
"CACNA2D1",
"CACNA2D2",
"CACNA2D3",
"CACNA2D3-AS1",
"CACNA2D4",
"CACNB1",
"CACNB2",
"CACNB3",
"CACNB4",
"CACNG1",
"CACNG4",
"CACNG6",
"CACNG8",
"CACTIN",
"CACTIN-AS1",
"CACUL1",
"CACYBP",
"CAD",
"CADM1",
"CADM2",
"CADM3",
"CADM3-AS1",
"CADM4",
"CADPS",
"CADPS2",
"CAGE1",
"CAHM",
"CALB1",
"CALB2",
"CALCA",
"CALCB",
"CALCOCO1",
"CALCOCO2",
"CALCR",
"CALCRL",
"CALD1",
"CALHM1",
"CALHM2",
"CALHM3",
"CALM1",
"CALM2",
"CALM3",
"CALML3",
"CALML3-AS1",
"CALML4",
"CALML5",
"CALML6",
"CALN1",
"CALR",
"CALR3",
"CALU",
"CALY",
"CAMK1",
"CAMK1D",
"CAMK1G",
"CAMK2A",
"CAMK2B",
"CAMK2D",
"CAMK2G",
"CAMK2N1",
"CAMK2N2",
"CAMK4",
"CAMKK1",
"CAMKK2",
"CAMKMT",
"CAMKV",
"CAMLG",
"CAMP",
"CAMSAP1",
"CAMSAP2",
"CAMSAP3",
"CAMTA1",
"CAMTA2",
"CAND1",
"CAND1.11",
"CAND2",
"CANT1",
"CANX",
"CAP1",
"CAP2",
"CAPG",
"CAPN1",
"CAPN10",
"CAPN10-AS1",
"CAPN11",
"CAPN12",
"CAPN13",
"CAPN14",
"CAPN15",
"CAPN2",
"CAPN3",
"CAPN5",
"CAPN6",
"CAPN7",
"CAPN8",
"CAPN9",
"CAPNS1",
"CAPNS2",
"CAPRIN1",
"CAPRIN2",
"CAPS",
"CAPS2",
"CAPSL",
"CAPZA1",
"CAPZA2",
"CAPZB",
"CARD10",
"CARD11",
"CARD14",
"CARD16",
"CARD6",
"CARD8",
"CARD8-AS1",
"CARD9",
"CARF",
"CARHSP1",
"CARKD",
"CARM1",
"CARNMT1",
"CARNS1",
"CARS",
"CARS2",
"CASC1",
"CASC10",
"CASC11",
"CASC15",
"CASC17",
"CASC18",
"CASC19",
"CASC2",
"CASC23",
"CASC3",
"CASC4",
"CASC5",
"CASC6",
"CASC8",
"CASC9",
"CASD1",
"CASK",
"CASKIN1",
"CASKIN2",
"CASP1",
"CASP10",
"CASP14",
"CASP16P",
"CASP2",
"CASP3",
"CASP4",
"CASP6",
"CASP7",
"CASP8",
"CASP8AP2",
"CASP9",
"CASQ1",
"CASQ2",
"CASS4",
"CAST",
"CASZ1",
"CAT",
"CATIP",
"CATIP-AS1",
"CATIP-AS2",
"CATSPER1",
"CATSPER2",
"CATSPER2P1",
"CATSPER3",
"CATSPER4",
"CATSPERB",
"CATSPERD",
"CATSPERG",
"CAV1",
"CAV2",
"CAV3",
"CBARP",
"CBFA2T2",
"CBFA2T3",
"CBFB",
"CBL",
"CBLB",
"CBLC",
"CBLL1",
"CBLN2",
"CBLN3",
"CBLN4",
"CBR1",
"CBR3",
"CBR3-AS1",
"CBR4",
"CBS",
"CBWD1",
"CBWD2",
"CBWD3",
"CBWD5",
"CBWD6",
"CBX1",
"CBX2",
"CBX3",
"CBX3P2",
"CBX4",
"CBX5",
"CBX6",
"CBX7",
"CBX8",
"CBY1",
"CBY3",
"CC2D1A",
"CC2D1B",
"CC2D2A",
"CC2D2B",
"CCAR1",
"CCAR2",
"CCAT1",
"CCAT2",
"CCBE1",
"CCBL1",
"CCBL2",
"CCDC101",
"CCDC102A",
"CCDC102B",
"CCDC103",
"CCDC106",
"CCDC107",
"CCDC108",
"CCDC109B",
"CCDC110",
"CCDC112",
"CCDC113",
"CCDC114",
"CCDC115",
"CCDC116",
"CCDC117",
"CCDC12",
"CCDC120",
"CCDC121",
"CCDC122",
"CCDC124",
"CCDC125",
"CCDC126",
"CCDC127",
"CCDC129",
"CCDC13",
"CCDC130",
"CCDC134",
"CCDC136",
"CCDC137",
"CCDC138",
"CCDC14",
"CCDC141",
"CCDC142",
"CCDC144A",
"CCDC144B",
"CCDC144CP",
"CCDC144NL",
"CCDC144NL-AS1",
"CCDC146",
"CCDC148",
"CCDC149",
"CCDC15",
"CCDC150",
"CCDC151",
"CCDC152",
"CCDC153",
"CCDC154",
"CCDC157",
"CCDC158",
"CCDC159",
"CCDC160",
"CCDC162P",
"CCDC163P",
"CCDC166",
"CCDC167",
"CCDC168",
"CCDC169",
"CCDC169-SOHLH2",
"CCDC17",
"CCDC170",
"CCDC171",
"CCDC173",
"CCDC174",
"CCDC175",
"CCDC176",
"CCDC177",
"CCDC179",
"CCDC18",
"CCDC180",
"CCDC181",
"CCDC182",
"CCDC183",
"CCDC183-AS1",
"CCDC184",
"CCDC185",
"CCDC186",
"CCDC22",
"CCDC24",
"CCDC25",
"CCDC26",
"CCDC27",
"CCDC28A",
"CCDC28B",
"CCDC3",
"CCDC30",
"CCDC33",
"CCDC34",
"CCDC36",
"CCDC37",
"CCDC38",
"CCDC39",
"CCDC40",
"CCDC42B",
"CCDC43",
"CCDC47",
"CCDC50",
"CCDC51",
"CCDC53",
"CCDC57",
"CCDC58",
"CCDC59",
"CCDC6",
"CCDC60",
"CCDC61",
"CCDC62",
"CCDC63",
"CCDC64",
"CCDC64B",
"CCDC65",
"CCDC66",
"CCDC67",
"CCDC68",
"CCDC69",
"CCDC7",
"CCDC70",
"CCDC71",
"CCDC71L",
"CCDC73",
"CCDC74A",
"CCDC74B",
"CCDC77",
"CCDC78",
"CCDC79",
"CCDC8",
"CCDC80",
"CCDC81",
"CCDC82",
"CCDC83",
"CCDC84",
"CCDC85A",
"CCDC85B",
"CCDC85C",
"CCDC86",
"CCDC87",
"CCDC88A",
"CCDC88B",
"CCDC88C",
"CCDC89",
"CCDC9",
"CCDC90B",
"CCDC91",
"CCDC92",
"CCDC93",
"CCDC94",
"CCDC96",
"CCDC97",
"CCER1",
"CCER2",
"CCHCR1",
"CCIN",
"CCK",
"CCKBR",
"CCL15",
"CCL15-CCL14",
"CCL2",
"CCL20",
"CCL21",
"CCL22",
"CCL24",
"CCL25",
"CCL26",
"CCL27",
"CCL28",
"CCL3L1",
"CCL3L3",
"CCL5",
"CCM2",
"CCM2L",
"CCNA1",
"CCNA2",
"CCNB1",
"CCNB1IP1",
"CCNB2",
"CCNB3",
"CCNC",
"CCND1",
"CCND2",
"CCND3",
"CCNDBP1",
"CCNE1",
"CCNE2",
"CCNF",
"CCNG1",
"CCNG2",
"CCNH",
"CCNI",
"CCNI2",
"CCNJ",
"CCNJL",
"CCNK",
"CCNL1",
"CCNL2",
"CCNO",
"CCNT1",
"CCNT2",
"CCNT2-AS1",
"CCNY",
"CCNYL1",
"CCP110",
"CCPG1",
"CCR1",
"CCR10",
"CCR2",
"CCR3",
"CCR4",
"CCR6",
"CCR7",
"CCR8",
"CCR9",
"CCRL2",
"CCS",
"CCSAP",
"CCSER1",
"CCSER2",
"CCT2",
"CCT3",
"CCT4",
"CCT5",
"CCT6A",
"CCT6B",
"CCT6P1",
"CCT6P3",
"CCT7",
"CCT8",
"CCT8L2",
"CCZ1",
"CCZ1B",
"CD101",
"CD109",
"CD14",
"CD151",
"CD160",
"CD163",
"CD163L1",
"CD164",
"CD164L2",
"CD177",
"CD180",
"CD1C",
"CD1D",
"CD1E",
"CD2",
"CD200",
"CD200R1",
"CD200R1L",
"CD207",
"CD22",
"CD226",
"CD24",
"CD247",
"CD248",
"CD27",
"CD27-AS1",
"CD274",
"CD276",
"CD28",
"CD2AP",
"CD2BP2",
"CD300C",
"CD300E",
"CD300LB",
"CD300LG",
"CD302",
"CD320",
"CD33",
"CD36",
"CD37",
"CD3E",
"CD3EAP",
"CD3G",
"CD4",
"CD40",
"CD44",
"CD46",
"CD47",
"CD5",
"CD52",
"CD53",
"CD55",
"CD58",
"CD59",
"CD6",
"CD63",
"CD68",
"CD7",
"CD70",
"CD72",
"CD74",
"CD79A",
"CD80",
"CD81",
"CD81-AS1",
"CD82",
"CD83",
"CD86",
"CD8A",
"CD8B",
"CD9",
"CD93",
"CD96",
"CD99",
"CD99L2",
"CD99P1",
"CDA",
"CDADC1",
"CDAN1",
"CDC123",
"CDC14A",
"CDC14B",
"CDC14C",
"CDC16",
"CDC20",
"CDC20B",
"CDC23",
"CDC25A",
"CDC25B",
"CDC25C",
"CDC26",
"CDC27",
"CDC34",
"CDC37",
"CDC37L1",
"CDC37L1-AS1",
"CDC40",
"CDC42",
"CDC42BPA",
"CDC42BPB",
"CDC42BPG",
"CDC42EP1",
"CDC42EP2",
"CDC42EP3",
"CDC42EP4",
"CDC42EP5",
"CDC42P3",
"CDC42SE1",
"CDC42SE2",
"CDC45",
"CDC5L",
"CDC6",
"CDC7",
"CDC73",
"CDCA2",
"CDCA3",
"CDCA4",
"CDCA5",
"CDCA7",
"CDCA7L",
"CDCA8",
"CDCP1",
"CDH1",
"CDH11",
"CDH12",
"CDH13",
"CDH15",
"CDH16",
"CDH17",
"CDH18",
"CDH19",
"CDH2",
"CDH20",
"CDH22",
"CDH23",
"CDH24",
"CDH26",
"CDH3",
"CDH4",
"CDH5",
"CDH6",
"CDH7",
"CDH8",
"CDHR1",
"CDHR2",
"CDHR3",
"CDHR4",
"CDHR5",
"CDIP1",
"CDIPT",
"CDIPT-AS1",
"CDK1",
"CDK10",
"CDK11A",
"CDK11B",
"CDK12",
"CDK13",
"CDK14",
"CDK15",
"CDK16",
"CDK17",
"CDK18",
"CDK19",
"CDK2",
"CDK20",
"CDK2AP1",
"CDK2AP2",
"CDK3",
"CDK4",
"CDK5",
"CDK5R1",
"CDK5R2",
"CDK5RAP1",
"CDK5RAP2",
"CDK5RAP3",
"CDK6",
"CDK7",
"CDK8",
"CDK9",
"CDKAL1",
"CDKL1",
"CDKL2",
"CDKL3",
"CDKL4",
"CDKL5",
"CDKN1A",
"CDKN1B",
"CDKN1C",
"CDKN2A",
"CDKN2AIP",
"CDKN2AIPNL",
"CDKN2B",
"CDKN2B-AS1",
"CDKN2C",
"CDKN2D",
"CDKN3",
"CDNF",
"CDO1",
"CDON",
"CDPF1",
"CDR1",
"CDR2",
"CDR2L",
"CDRT1",
"CDRT15",
"CDRT15P1",
"CDRT4",
"CDS1",
"CDS2",
"CDSN",
"CDT1",
"CDV3",
"CDX2",
"CDYL",
"CDYL2",
"CEACAM1",
"CEACAM16",
"CEACAM18",
"CEACAM19",
"CEACAM20",
"CEACAM21",
"CEACAM22P",
"CEACAM3",
"CEACAM4",
"CEACAM5",
"CEACAM6",
"CEACAM7",
"CEACAM8",
"CEBPA",
"CEBPA-AS1",
"CEBPB",
"CEBPB-AS1",
"CEBPD",
"CEBPE",
"CEBPG",
"CEBPZ",
"CEBPZOS",
"CECR1",
"CECR2",
"CECR3",
"CECR5",
"CECR5-AS1",
"CECR6",
"CECR7",
"CEL",
"CELA2A",
"CELF1",
"CELF2",
"CELF2-AS1",
"CELF3",
"CELF4",
"CELF5",
"CELF6",
"CELP",
"CELSR1",
"CELSR2",
"CELSR3",
"CELSR3-AS1",
"CEMIP",
"CEMP1",
"CEND1",
"CENPA",
"CENPB",
"CENPBD1",
"CENPBD1P1",
"CENPC",
"CENPE",
"CENPF",
"CENPH",
"CENPI",
"CENPJ",
"CENPK",
"CENPL",
"CENPM",
"CENPN",
"CENPO",
"CENPP",
"CENPQ",
"CENPT",
"CENPU",
"CENPV",
"CENPW",
"CEP104",
"CEP112",
"CEP120",
"CEP126",
"CEP128",
"CEP131",
"CEP135",
"CEP152",
"CEP162",
"CEP164",
"CEP170",
"CEP170B",
"CEP170P1",
"CEP19",
"CEP192",
"CEP250",
"CEP290",
"CEP295",
"CEP295NL",
"CEP350",
"CEP41",
"CEP44",
"CEP55",
"CEP57",
"CEP57L1",
"CEP63",
"CEP68",
"CEP70",
"CEP72",
"CEP76",
"CEP78",
"CEP83",
"CEP83-AS1",
"CEP85",
"CEP85L",
"CEP89",
"CEP95",
"CEP97",
"CEPT1",
"CER1",
"CERCAM",
"CERK",
"CERKL",
"CERS1",
"CERS2",
"CERS3",
"CERS4",
"CERS5",
"CERS6",
"CERS6-AS1",
"CES1",
"CES1P1",
"CES1P2",
"CES2",
"CES3",
"CES4A",
"CES5A",
"CES5AP1",
"CETN1",
"CETN2",
"CETN3",
"CETN4P",
"CETP",
"CFAP126",
"CFAP20",
"CFAP221",
"CFAP36",
"CFAP43",
"CFAP44",
"CFAP44-AS1",
"CFAP45",
"CFAP46",
"CFAP47",
"CFAP52",
"CFAP53",
"CFAP54",
"CFAP57",
"CFAP58",
"CFAP58-AS1",
"CFAP61",
"CFAP69",
"CFAP70",
"CFAP74",
"CFAP97",
"CFAP99",
"CFB",
"CFD",
"CFDP1",
"CFH",
"CFHR1",
"CFHR4",
"CFHR5",
"CFI",
"CFL1",
"CFL1P1",
"CFL2",
"CFLAR",
"CFLAR-AS1",
"CFP",
"CFTR",
"CGA",
"CGB",
"CGB1",
"CGB2",
"CGB5",
"CGB7",
"CGB8",
"CGGBP1",
"CGN",
"CGNL1",
"CGREF1",
"CGRRF1",
"CH17-340M24.3",
"CH17-360D5.1",
"CH17-408M7.1",
"CH25H",
"CHAC1",
"CHAC2",
"CHAD",
"CHADL",
"CHAF1A",
"CHAF1B",
"CHAMP1",
"CHCHD1",
"CHCHD10",
"CHCHD2",
"CHCHD3",
"CHCHD4",
"CHCHD5",
"CHCHD6",
"CHCHD7",
"CHD1",
"CHD1L",
"CHD2",
"CHD3",
"CHD4",
"CHD5",
"CHD6",
"CHD7",
"CHD8",
"CHD9",
"CHDH",
"CHEK1",
"CHEK2",
"CHERP",
"CHFR",
"CHGA",
"CHGB",
"CHI3L1",
"CHI3L2",
"CHIC1",
"CHIC2",
"CHID1",
"CHIT1",
"CHKA",
"CHKB",
"CHKB-AS1",
"CHKB-CPT1B",
"CHM",
"CHML",
"CHMP1A",
"CHMP1B",
"CHMP1B2P",
"CHMP2A",
"CHMP2B",
"CHMP3",
"CHMP4A",
"CHMP4B",
"CHMP4C",
"CHMP5",
"CHMP6",
"CHMP7",
"CHN1",
"CHN2",
"CHODL",
"CHORDC1",
"CHP1",
"CHP2",
"CHPF",
"CHPF2",
"CHPT1",
"CHRAC1",
"CHRD",
"CHRDL1",
"CHRDL2",
"CHRFAM7A",
"CHRM1",
"CHRM2",
"CHRM3",
"CHRM3-AS2",
"CHRM4",
"CHRM5",
"CHRNA1",
"CHRNA10",
"CHRNA2",
"CHRNA3",
"CHRNA4",
"CHRNA5",
"CHRNA6",
"CHRNA7",
"CHRNA9",
"CHRNB1",
"CHRNB2",
"CHRNB4",
"CHRND",
"CHRNE",
"CHRNG",
"CHST1",
"CHST10",
"CHST11",
"CHST12",
"CHST13",
"CHST14",
"CHST15",
"CHST2",
"CHST3",
"CHST4",
"CHST5",
"CHST6",
"CHST7",
"CHST8",
"CHSY1",
"CHSY3",
"CHTF18",
"CHTF8",
"CHTOP",
"CHUK",
"CHURC1",
"CHURC1-FNTB",
"CIAO1",
"CIAPIN1",
"CIART",
"CIB1",
"CIB2",
"CIB3",
"CIB4",
"CIC",
"CIDEA",
"CIDEB",
"CIDEC",
"CIDECP",
"CIITA",
"CILP",
"CILP2",
"CINP",
"CIPC",
"CIR1",
"CIRBP",
"CIRBP-AS1",
"CIRH1A",
"CISD1",
"CISD2",
"CISD3",
"CISH",
"CIT",
"CITED1",
"CITED2",
"CITED4",
"CIZ1",
"CKAP2",
"CKAP2L",
"CKAP4",
"CKAP5",
"CKB",
"CKLF",
"CKLF-CMTM1",
"CKM",
"CKMT1A",
"CKMT1B",
"CKMT2",
"CKMT2-AS1",
"CKS1B",
"CKS2",
"CLASP1",
"CLASP2",
"CLASRP",
"CLC",
"CLCA1",
"CLCA2",
"CLCA4",
"CLCC1",
"CLCF1",
"CLCN1",
"CLCN2",
"CLCN3",
"CLCN4",
"CLCN5",
"CLCN6",
"CLCN7",
"CLCNKA",
"CLCNKB",
"CLDN1",
"CLDN11",
"CLDN12",
"CLDN14",
"CLDN15",
"CLDN16",
"CLDN18",
"CLDN19",
"CLDN2",
"CLDN20",
"CLDN22",
"CLDN23",
"CLDN24",
"CLDN3",
"CLDN34",
"CLDN4",
"CLDN5",
"CLDN6",
"CLDN7",
"CLDN9",
"CLDND1",
"CLDND2",
"CLEC11A",
"CLEC12A",
"CLEC12B",
"CLEC14A",
"CLEC16A",
"CLEC17A",
"CLEC18A",
"CLEC18B",
"CLEC18C",
"CLEC19A",
"CLEC1A",
"CLEC2B",
"CLEC2D",
"CLEC3A",
"CLEC3B",
"CLEC4A",
"CLEC4F",
"CLEC4GP1",
"CLEC5A",
"CLEC7A",
"CLEC9A",
"CLECL1",
"CLGN",
"CLHC1",
"CLIC1",
"CLIC2",
"CLIC3",
"CLIC4",
"CLIC5",
"CLIC6",
"CLINT1",
"CLIP1",
"CLIP1-AS1",
"CLIP2",
"CLIP3",
"CLIP4",
"CLK1",
"CLK2",
"CLK3",
"CLK4",
"CLMN",
"CLMP",
"CLN3",
"CLN5",
"CLN6",
"CLN8",
"CLNS1A",
"CLOCK",
"CLP1",
"CLPB",
"CLPP",
"CLPSL1",
"CLPSL2",
"CLPTM1",
"CLPTM1L",
"CLPX",
"CLRN1",
"CLRN1-AS1",
"CLRN3",
"CLSPN",
"CLSTN1",
"CLSTN2",
"CLSTN2-AS1",
"CLSTN3",
"CLTA",
"CLTB",
"CLTC",
"CLTCL1",
"CLU",
"CLUAP1",
"CLUH",
"CLUHP3",
"CLUL1",
"CLVS1",
"CLVS2",
"CLYBL",
"CLYBL-AS1",
"CLYBL-AS2",
"CMA1",
"CMAHP",
"CMAS",
"CMBL",
"CMC1",
"CMC2",
"CMC4",
"CMIP",
"CMKLR1",
"CMPK1",
"CMPK2",
"CMSS1",
"CMTM1",
"CMTM2",
"CMTM3",
"CMTM4",
"CMTM6",
"CMTM7",
"CMTM8",
"CMTR1",
"CMTR2",
"CMYA5",
"CNBD1",
"CNBD2",
"CNBP",
"CNDP1",
"CNDP2",
"CNEP1R1",
"CNFN",
"CNGA1",
"CNGA3",
"CNGA4",
"CNGB1",
"CNGB3",
"CNIH1",
"CNIH2",
"CNIH3",
"CNIH4",
"CNKSR1",
"CNKSR2",
"CNKSR3",
"CNN1",
"CNN2",
"CNN3",
"CNNM1",
"CNNM2",
"CNNM3",
"CNNM4",
"CNOT1",
"CNOT10",
"CNOT11",
"CNOT2",
"CNOT3",
"CNOT4",
"CNOT6",
"CNOT6L",
"CNOT7",
"CNOT8",
"CNP",
"CNPPD1",
"CNPY1",
"CNPY2",
"CNPY3",
"CNPY4",
"CNR1",
"CNR2",
"CNRIP1",
"CNST",
"CNTD1",
"CNTD2",
"CNTF",
"CNTFR",
"CNTLN",
"CNTN1",
"CNTN2",
"CNTN3",
"CNTN4",
"CNTNAP1",
"CNTNAP2",
"CNTNAP3",
"CNTNAP3B",
"CNTNAP3P2",
"CNTRL",
"CNTROB",
"COA1",
"COA3",
"COA4",
"COA5",
"COA6",
"COA7",
"COASY",
"COBL",
"COBLL1",
"COCH",
"COG1",
"COG2",
"COG3",
"COG4",
"COG5",
"COG6",
"COG7",
"COG8",
"COIL",
"COL10A1",
"COL11A1",
"COL11A2",
"COL12A1",
"COL13A1",
"COL14A1",
"COL15A1",
"COL16A1",
"COL17A1",
"COL18A1",
"COL18A1-AS1",
"COL18A1-AS2",
"COL19A1",
"COL1A1",
"COL1A2",
"COL20A1",
"COL21A1",
"COL23A1",
"COL24A1",
"COL25A1",
"COL26A1",
"COL27A1",
"COL28A1",
"COL2A1",
"COL3A1",
"COL4A1",
"COL4A2",
"COL4A2-AS1",
"COL4A3",
"COL4A3BP",
"COL4A4",
"COL4A5",
"COL4A6",
"COL5A1",
"COL5A2",
"COL5A3",
"COL6A1",
"COL6A2",
"COL6A3",
"COL6A4P1",
"COL6A5",
"COL6A6",
"COL7A1",
"COL8A1",
"COL8A2",
"COL9A2",
"COL9A3",
"COLCA1",
"COLEC10",
"COLEC11",
"COLEC12",
"COLGALT1",
"COLGALT2",
"COLQ",
"COMMD1",
"COMMD10",
"COMMD2",
"COMMD3",
"COMMD3-BMI1",
"COMMD4",
"COMMD5",
"COMMD6",
"COMMD7",
"COMMD8",
"COMMD9",
"COMP",
"COMT",
"COMTD1",
"COPA",
"COPB1",
"COPB2",
"COPE",
"COPG1",
"COPG2",
"COPG2IT1",
"COPRS",
"COPS2",
"COPS3",
"COPS4",
"COPS5",
"COPS6",
"COPS7A",
"COPS7B",
"COPS8",
"COPZ1",
"COPZ2",
"COQ10A",
"COQ10B",
"COQ2",
"COQ3",
"COQ4",
"COQ5",
"COQ6",
"COQ7",
"COQ9",
"CORIN",
"CORO1A",
"CORO1B",
"CORO1C",
"CORO2A",
"CORO2B",
"CORO6",
"CORO7",
"CORO7-PAM16",
"CORT",
"COTL1",
"COX10",
"COX10-AS1",
"COX11",
"COX14",
"COX15",
"COX16",
"COX17",
"COX18",
"COX19",
"COX20",
"COX4I1",
"COX5A",
"COX5B",
"COX6A1",
"COX6B1",
"COX6B2",
"COX6C",
"COX7A1",
"COX7A2",
"COX7A2L",
"COX7B",
"COX7C",
"COX8A",
"COX8C",
"CP",
"CPA2",
"CPA4",
"CPA5",
"CPA6",
"CPAMD8",
"CPB2",
"CPB2-AS1",
"CPD",
"CPE",
"CPEB1",
"CPEB1-AS1",
"CPEB2",
"CPEB2-AS1",
"CPEB3",
"CPEB4",
"CPED1",
"CPLX1",
"CPLX2",
"CPLX3",
"CPLX4",
"CPM",
"CPN2",
"CPNE1",
"CPNE2",
"CPNE3",
"CPNE4",
"CPNE5",
"CPNE6",
"CPNE7",
"CPNE8",
"CPNE9",
"CPO",
"CPOX",
"CPPED1",
"CPQ",
"CPS1",
"CPS1-IT1",
"CPSF1",
"CPSF2",
"CPSF3",
"CPSF3L",
"CPSF4",
"CPSF4L",
"CPSF6",
"CPSF7",
"CPT1A",
"CPT1B",
"CPT1C",
"CPT2",
"CPTP",
"CPVL",
"CPXM1",
"CPXM2",
"CPZ",
"CR1",
"CR1L",
"CR2",
"CRABP1",
"CRABP2",
"CRACR2A",
"CRACR2B",
"CRADD",
"CRAMP1L",
"CRAT",
"CRAT37",
"CRB1",
"CRB2",
"CRB3",
"CRBN",
"CRCP",
"CRCT1",
"CREB1",
"CREB3",
"CREB3L1",
"CREB3L2",
"CREB3L3",
"CREB3L4",
"CREB5",
"CREBBP",
"CREBL2",
"CREBRF",
"CREBZF",
"CREG1",
"CREG2",
"CRELD1",
"CRELD2",
"CREM",
"CRH",
"CRHR1-IT1",
"CRHR2",
"CRIM1",
"CRIP1",
"CRIP2",
"CRIP3",
"CRIPAK",
"CRIPT",
"CRISP2",
"CRISP3",
"CRISPLD1",
"CRISPLD2",
"CRK",
"CRKL",
"CRLF1",
"CRLF2",
"CRLF3",
"CRLS1",
"CRMP1",
"CRNDE",
"CRNKL1",
"CROCC",
"CROCCP2",
"CROCCP3",
"CROT",
"CRTAC1",
"CRTAM",
"CRTAP",
"CRTC1",
"CRTC2",
"CRTC3",
"CRTC3-AS1",
"CRX",
"CRY1",
"CRY2",
"CRYAB",
"CRYBA1",
"CRYBA2",
"CRYBA4",
"CRYBB2",
"CRYBB2P1",
"CRYBB3",
"CRYBG3",
"CRYGC",
"CRYGN",
"CRYGS",
"CRYL1",
"CRYM",
"CRYM-AS1",
"CRYZ",
"CRYZL1",
"CS",
"CSAD",
"CSDC2",
"CSDE1",
"CSE1L",
"CSE1L-AS1",
"CSF1",
"CSF1R",
"CSF2",
"CSF2RA",
"CSF2RB",
"CSF3",
"CSF3R",
"CSGALNACT1",
"CSGALNACT2",
"CSK",
"CSMD1",
"CSMD2",
"CSMD3",
"CSN2",
"CSNK1A1",
"CSNK1A1L",
"CSNK1A1P1",
"CSNK1D",
"CSNK1E",
"CSNK1G1",
"CSNK1G2",
"CSNK1G2-AS1",
"CSNK1G3",
"CSNK2A1",
"CSNK2A2",
"CSNK2A3",
"CSNK2B",
"CSPG4",
"CSPG5",
"CSPP1",
"CSRNP1",
"CSRNP2",
"CSRNP3",
"CSRP1",
"CSRP2",
"CSRP2BP",
"CSRP3",
"CST1",
"CST13P",
"CST2",
"CST3",
"CST4",
"CST5",
"CST6",
"CST7",
"CST9",
"CSTA",
"CSTB",
"CSTF1",
"CSTF2",
"CSTF2T",
"CSTF3",
"CSTF3-AS1",
"CSTL1",
"CT45A1",
"CT45A10",
"CT45A2",
"CT45A3",
"CT45A5",
"CT45A6",
"CT45A7",
"CT45A8",
"CT55",
"CT62",
"CT83",
"CTAG1A",
"CTAGE1",
"CTAGE10P",
"CTAGE11P",
"CTAGE15",
"CTAGE4",
"CTAGE5",
"CTAGE6",
"CTAGE7P",
"CTAGE8",
"CTAGE9",
"CTB-113P19.1",
"CTB-178M22.2",
"CTBP1",
"CTBP1-AS",
"CTBP1-AS2",
"CTBP2",
"CTBS",
"CTC-338M12.4",
"CTC-436P18.1",
"CTC1",
"CTCF",
"CTD-2151A2.1",
"CTD-2194D22.4",
"CTD-2201E9.1",
"CTD-2201I18.1",
"CTD-3080P12.3",
"CTDNEP1",
"CTDP1",
"CTDSP1",
"CTDSP2",
"CTDSPL",
"CTDSPL2",
"CTF1",
"CTGF",
"CTGLF12P",
"CTH",
"CTHRC1",
"CTIF",
"CTLA4",
"CTNNA1",
"CTNNA2",
"CTNNA3",
"CTNNAL1",
"CTNNB1",
"CTNNBIP1",
"CTNNBL1",
"CTNND1",
"CTNND2",
"CTNS",
"CTPS1",
"CTPS2",
"CTR9",
"CTRB1",
"CTRB2",
"CTRC",
"CTRL",
"CTSA",
"CTSB",
"CTSC",
"CTSD",
"CTSE",
"CTSF",
"CTSH",
"CTSK",
"CTSL",
"CTSLP2",
"CTSO",
"CTSS",
"CTSV",
"CTSW",
"CTSZ",
"CTTN",
"CTTNBP2",
"CTTNBP2NL",
"CTU1",
"CTU2",
"CTXN1",
"CTXN2",
"CUBN",
"CUEDC1",
"CUEDC2",
"CUL1",
"CUL2",
"CUL3",
"CUL4A",
"CUL4B",
"CUL5",
"CUL7",
"CUL9",
"CUTA",
"CUTC",
"CUX1",
"CUX2",
"CUZD1",
"CWC15",
"CWC22",
"CWC25",
"CWC27",
"CWF19L1",
"CWF19L2",
"CX3CL1",
"CX3CR1",
"CXADR",
"CXADRP2",
"CXADRP3",
"CXCL1",
"CXCL10",
"CXCL11",
"CXCL12",
"CXCL13",
"CXCL14",
"CXCL16",
"CXCL17",
"CXCL2",
"CXCL3",
"CXCL5",
"CXCL6",
"CXCL8",
"CXCL9",
"CXCR1",
"CXCR2",
"CXCR3",
"CXCR4",
"CXCR5",
"CXCR6",
"CXorf23",
"CXorf36",
"CXorf38",
"CXorf40A",
"CXorf40B",
"CXorf49",
"CXorf51A",
"CXorf51B",
"CXorf56",
"CXorf57",
"CXorf58",
"CXorf66",
"CXXC1",
"CXXC4",
"CXXC5",
"CYB561",
"CYB561A3",
"CYB561D1",
"CYB561D2",
"CYB5A",
"CYB5B",
"CYB5D1",
"CYB5D2",
"CYB5R1",
"CYB5R2",
"CYB5R3",
"CYB5R4",
"CYB5RL",
"CYBA",
"CYBB",
"CYBRD1",
"CYC1",
"CYCS",
"CYCSP52",
"CYFIP1",
"CYFIP2",
"CYGB",
"CYHR1",
"CYLD",
"CYP11A1",
"CYP11B1",
"CYP17A1",
"CYP19A1",
"CYP1A1",
"CYP1A2",
"CYP1B1",
"CYP1B1-AS1",
"CYP20A1",
"CYP21A1P",
"CYP21A2",
"CYP24A1",
"CYP26A1",
"CYP26B1",
"CYP26C1",
"CYP27A1",
"CYP27B1",
"CYP27C1",
"CYP2A13",
"CYP2A6",
"CYP2A7",
"CYP2B6",
"CYP2B7P",
"CYP2C18",
"CYP2C19",
"CYP2C8",
"CYP2C9",
"CYP2D6",
"CYP2D7",
"CYP2E1",
"CYP2F1",
"CYP2G1P",
"CYP2J2",
"CYP2R1",
"CYP2S1",
"CYP2U1",
"CYP2W1",
"CYP39A1",
"CYP3A4",
"CYP3A5",
"CYP3A7",
"CYP3A7-CYP3A51P",
"CYP46A1",
"CYP4A11",
"CYP4A22",
"CYP4B1",
"CYP4F11",
"CYP4F12",
"CYP4F2",
"CYP4F22",
"CYP4F24P",
"CYP4F29P",
"CYP4F3",
"CYP4F30P",
"CYP4F35P",
"CYP4F62P",
"CYP4F8",
"CYP4V2",
"CYP4X1",
"CYP4Z1",
"CYP4Z2P",
"CYP51A1",
"CYP51A1-AS1",
"CYP7A1",
"CYP7B1",
"CYP8B1",
"CYR61",
"CYS1",
"CYSLTR1",
"CYSLTR2",
"CYSRT1",
"CYSTM1",
"CYTH1",
"CYTH2",
"CYTH3",
"CYTH4",
"CYTIP",
"CYYR1",
"D2HGDH",
"DAAM1",
"DAAM2",
"DAB2",
"DAB2IP",
"DACH1",
"DACH2",
"DACT1",
"DACT2",
"DACT3",
"DACT3-AS1",
"DAD1",
"DAG1",
"DAGLA",
"DAGLB",
"DALRD3",
"DANCR",
"DAND5",
"DANT2",
"DAOA-AS1",
"DAP",
"DAP3",
"DAPK1",
"DAPK2",
"DAPK3",
"DAPP1",
"DARS",
"DARS-AS1",
"DARS2",
"DAW1",
"DAXX",
"DAZAP1",
"DAZAP2",
"DAZL",
"DBET",
"DBF4",
"DBF4B",
"DBH-AS1",
"DBI",
"DBIL5P",
"DBIL5P2",
"DBN1",
"DBNDD1",
"DBNDD2",
"DBNL",
"DBP",
"DBR1",
"DBT",
"DBX2",
"DCAF10",
"DCAF11",
"DCAF12",
"DCAF12L2",
"DCAF13",
"DCAF13P3",
"DCAF15",
"DCAF16",
"DCAF17",
"DCAF4",
"DCAF4L1",
"DCAF5",
"DCAF6",
"DCAF7",
"DCAF8",
"DCAKD",
"DCBLD1",
"DCBLD2",
"DCC",
"DCDC1",
"DCDC2",
"DCDC2B",
"DCDC2C",
"DCDC5",
"DCHS1",
"DCHS2",
"DCK",
"DCLK1",
"DCLK2",
"DCLK3",
"DCLRE1A",
"DCLRE1B",
"DCLRE1C",
"DCN",
"DCP1A",
"DCP1B",
"DCP2",
"DCPS",
"DCST1",
"DCST2",
"DCSTAMP",
"DCT",
"DCTD",
"DCTN1",
"DCTN1-AS1",
"DCTN2",
"DCTN3",
"DCTN4",
"DCTN5",
"DCTN6",
"DCTPP1",
"DCUN1D1",
"DCUN1D2",
"DCUN1D3",
"DCUN1D4",
"DCUN1D5",
"DCX",
"DCXR",
"DDA1",
"DDAH1",
"DDAH2",
"DDB1",
"DDB2",
"DDC",
"DDC-AS1",
"DDHD1",
"DDHD2",
"DDI1",
"DDI2",
"DDIAS",
"DDIT3",
"DDIT4",
"DDIT4L",
"DDN",
"DDOST",
"DDR1",
"DDR2",
"DDRGK1",
"DDT",
"DDTL",
"DDX1",
"DDX10",
"DDX11",
"DDX11-AS1",
"DDX11L1",
"DDX11L10",
"DDX11L16",
"DDX11L2",
"DDX11L5",
"DDX11L9",
"DDX12P",
"DDX17",
"DDX18",
"DDX19A",
"DDX19B",
"DDX20",
"DDX21",
"DDX23",
"DDX24",
"DDX25",
"DDX26B",
"DDX26B-AS1",
"DDX27",
"DDX28",
"DDX31",
"DDX39A",
"DDX39B",
"DDX3X",
"DDX4",
"DDX41",
"DDX42",
"DDX43",
"DDX46",
"DDX47",
"DDX49",
"DDX5",
"DDX50",
"DDX51",
"DDX52",
"DDX54",
"DDX55",
"DDX56",
"DDX58",
"DDX59",
"DDX6",
"DDX60",
"DDX60L",
"DEAF1",
"DEAR",
"DEC1",
"DECR1",
"DECR2",
"DEDD",
"DEDD2",
"DEF6",
"DEF8",
"DEFB1",
"DEFB109P1B",
"DEFB126",
"DEFB134",
"DEGS1",
"DEGS2",
"DEK",
"DENND1A",
"DENND1B",
"DENND1C",
"DENND2A",
"DENND2C",
"DENND2D",
"DENND3",
"DENND4A",
"DENND4B",
"DENND4C",
"DENND5A",
"DENND5B",
"DENND5B-AS1",
"DENND6A",
"DENND6B",
"DENR",
"DEPDC1",
"DEPDC1-AS1",
"DEPDC1B",
"DEPDC4",
"DEPDC5",
"DEPDC7",
"DEPTOR",
"DERA",
"DERL1",
"DERL2",
"DERL3",
"DES",
"DESI1",
"DESI2",
"DET1",
"DEXI",
"DFFA",
"DFFB",
"DFNA5",
"DFNB31",
"DFNB59",
"DGAT1",
"DGAT2",
"DGAT2L6",
"DGCR10",
"DGCR11",
"DGCR14",
"DGCR2",
"DGCR5",
"DGCR6",
"DGCR6L",
"DGCR8",
"DGCR9",
"DGKA",
"DGKB",
"DGKD",
"DGKE",
"DGKG",
"DGKH",
"DGKI",
"DGKQ",
"DGKZ",
"DGUOK",
"DGUOK-AS1",
"DHCR24",
"DHCR7",
"DHDDS",
"DHDH",
"DHFR",
"DHFRL1",
"DHH",
"DHODH",
"DHPS",
"DHRS1",
"DHRS11",
"DHRS12",
"DHRS13",
"DHRS2",
"DHRS3",
"DHRS4",
"DHRS4-AS1",
"DHRS4L1",
"DHRS4L2",
"DHRS7",
"DHRS7B",
"DHRS9",
"DHRSX",
"DHTKD1",
"DHX15",
"DHX16",
"DHX29",
"DHX30",
"DHX32",
"DHX33",
"DHX34",
"DHX35",
"DHX36",
"DHX37",
"DHX38",
"DHX40",
"DHX57",
"DHX58",
"DHX8",
"DHX9",
"DIABLO",
"DIAPH1",
"DIAPH2",
"DIAPH2-AS1",
"DIAPH3",
"DIAPH3-AS1",
"DICER1",
"DICER1-AS1",
"DIDO1",
"DIEXF",
"DIMT1",
"DIO1",
"DIO2",
"DIO2-AS1",
"DIO3",
"DIO3OS",
"DIP2A",
"DIP2A-IT1",
"DIP2B",
"DIP2C",
"DIRAS1",
"DIRAS2",
"DIRAS3",
"DIRC1",
"DIRC2",
"DIRC3",
"DIS3",
"DIS3L",
"DIS3L2",
"DISC1",
"DISC1-IT1",
"DISC1FP1",
"DISC2",
"DISP1",
"DISP2",
"DIXDC1",
"DKC1",
"DKFZP434A062",
"DKFZP434H168",
"DKFZP434I0714",
"DKFZp434J0226",
"DKFZp451B082",
"DKFZP586I1420",
"DKFZp779M0652",
"DKK1",
"DKK2",
"DKK3",
"DKK4",
"DKKL1",
"DLAT",
"DLC1",
"DLD",
"DLEC1",
"DLEU1",
"DLEU1-AS1",
"DLEU2",
"DLEU2L",
"DLEU7",
"DLEU7-AS1",
"DLG1",
"DLG1-AS1",
"DLG2",
"DLG3",
"DLG3-AS1",
"DLG4",
"DLG5",
"DLG5-AS1",
"DLGAP1",
"DLGAP1-AS1",
"DLGAP1-AS2",
"DLGAP1-AS4",
"DLGAP1-AS5",
"DLGAP2",
"DLGAP3",
"DLGAP4",
"DLGAP4-AS1",
"DLGAP5",
"DLK1",
"DLK2",
"DLL1",
"DLL3",
"DLL4",
"DLST",
"DLSTP1",
"DLX1",
"DLX2",
"DLX2-AS1",
"DLX3",
"DLX4",
"DLX5",
"DLX6",
"DLX6-AS1",
"DMAP1",
"DMBT1",
"DMBX1",
"DMC1",
"DMD",
"DMGDH",
"DMKN",
"DMP1",
"DMPK",
"DMRT1",
"DMRT2",
"DMRTA1",
"DMRTA2",
"DMRTC1",
"DMTF1",
"DMTN",
"DMWD",
"DMXL1",
"DMXL2",
"DNA2",
"DNAAF1",
"DNAAF2",
"DNAAF3",
"DNAAF5",
"DNAH1",
"DNAH10",
"DNAH11",
"DNAH12",
"DNAH14",
"DNAH17",
"DNAH17-AS1",
"DNAH2",
"DNAH3",
"DNAH5",
"DNAH6",
"DNAH7",
"DNAH8",
"DNAH9",
"DNAI1",
"DNAJA1",
"DNAJA2",
"DNAJA3",
"DNAJA4",
"DNAJB1",
"DNAJB11",
"DNAJB12",
"DNAJB13",
"DNAJB14",
"DNAJB2",
"DNAJB3",
"DNAJB4",
"DNAJB5",
"DNAJB5-AS1",
"DNAJB6",
"DNAJB7",
"DNAJB8",
"DNAJB8-AS1",
"DNAJB9",
"DNAJC1",
"DNAJC10",
"DNAJC11",
"DNAJC12",
"DNAJC13",
"DNAJC14",
"DNAJC15",
"DNAJC16",
"DNAJC17",
"DNAJC18",
"DNAJC19",
"DNAJC2",
"DNAJC21",
"DNAJC22",
"DNAJC24",
"DNAJC25",
"DNAJC25-GNG10",
"DNAJC27",
"DNAJC27-AS1",
"DNAJC28",
"DNAJC3",
"DNAJC3-AS1",
"DNAJC30",
"DNAJC4",
"DNAJC5",
"DNAJC5B",
"DNAJC5G",
"DNAJC6",
"DNAJC7",
"DNAJC8",
"DNAJC9",
"DNAJC9-AS1",
"DNAL1",
"DNAL4",
"DNALI1",
"DNASE1",
"DNASE1L1",
"DNASE1L2",
"DNASE1L3",
"DNASE2",
"DNASE2B",
"DND1",
"DNER",
"DNHD1",
"DNLZ",
"DNM1",
"DNM1L",
"DNM1P35",
"DNM1P41",
"DNM1P46",
"DNM2",
"DNM3",
"DNM3OS",
"DNMBP",
"DNMBP-AS1",
"DNMT1",
"DNMT3A",
"DNMT3B",
"DNMT3L",
"DNPEP",
"DNPH1",
"DNTT",
"DNTTIP1",
"DNTTIP2",
"DOC2A",
"DOC2B",
"DOCK1",
"DOCK10",
"DOCK11",
"DOCK2",
"DOCK3",
"DOCK4",
"DOCK4-AS1",
"DOCK5",
"DOCK6",
"DOCK7",
"DOCK8",
"DOCK9",
"DOCK9-AS1",
"DOCK9-AS2",
"DOHH",
"DOK1",
"DOK2",
"DOK3",
"DOK4",
"DOK5",
"DOK6",
"DOK7",
"DOLK",
"DOLPP1",
"DONSON",
"DOPEY1",
"DOPEY2",
"DOT1L",
"DPAGT1",
"DPCD",
"DPCR1",
"DPEP1",
"DPEP2",
"DPEP3",
"DPF1",
"DPF2",
"DPF3",
"DPH1",
"DPH2",
"DPH3",
"DPH3P1",
"DPH5",
"DPH6",
"DPH6-AS1",
"DPH7",
"DPM1",
"DPM2",
"DPM3",
"DPP3",
"DPP4",
"DPP6",
"DPP7",
"DPP8",
"DPP9",
"DPP9-AS1",
"DPPA2",
"DPPA2P3",
"DPPA3",
"DPPA5",
"DPRX",
"DPRXP4",
"DPY19L1",
"DPY19L1P1",
"DPY19L2",
"DPY19L2P1",
"DPY19L2P2",
"DPY19L2P3",
"DPY19L2P4",
"DPY19L3",
"DPY19L4",
"DPY30",
"DPYD",
"DPYD-AS2",
"DPYS",
"DPYSL2",
"DPYSL3",
"DPYSL4",
"DPYSL5",
"DQX1",
"DR1",
"DRAIC",
"DRAM1",
"DRAM2",
"DRAP1",
"DRAXIN",
"DRC1",
"DRC7",
"DRD1",
"DRD2",
"DRD4",
"DRD5P2",
"DRG1",
"DRG2",
"DRGX",
"DRICH1",
"DROSHA",
"DRP2",
"DSC1",
"DSC2",
"DSC3",
"DSCAM",
"DSCAM-AS1",
"DSCAML1",
"DSCC1",
"DSCR3",
"DSCR8",
"DSCR9",
"DSE",
"DSEL",
"DSG1",
"DSG1-AS1",
"DSG2",
"DSG2-AS1",
"DSG3",
"DSG4",
"DSN1",
"DSP",
"DSPP",
"DST",
"DSTN",
"DSTNP2",
"DSTYK",
"DTD1",
"DTD2",
"DTL",
"DTNA",
"DTNB",
"DTNBP1",
"DTWD1",
"DTWD2",
"DTX1",
"DTX2",
"DTX2P1-UPK3BP1-PMS2P11",
"DTX3",
"DTX3L",
"DTX4",
"DTYMK",
"DUOX1",
"DUOX2",
"DUOXA1",
"DUS1L",
"DUS2",
"DUS3L",
"DUS4L",
"DUSP1",
"DUSP10",
"DUSP11",
"DUSP12",
"DUSP13",
"DUSP14",
"DUSP15",
"DUSP16",
"DUSP18",
"DUSP19",
"DUSP2",
"DUSP22",
"DUSP23",
"DUSP27",
"DUSP28",
"DUSP3",
"DUSP4",
"DUSP5",
"DUSP5P1",
"DUSP6",
"DUSP7",
"DUSP8",
"DUSP9",
"DUT",
"DUX4",
"DUXAP10",
"DUXAP8",
"DVL1",
"DVL2",
"DVL3",
"DXO",
"DYM",
"DYNAP",
"DYNC1H1",
"DYNC1I1",
"DYNC1I2",
"DYNC1LI1",
"DYNC1LI2",
"DYNC2H1",
"DYNC2LI1",
"DYNLL1",
"DYNLL2",
"DYNLRB1",
"DYNLRB2",
"DYNLT1",
"DYNLT3",
"DYRK1A",
"DYRK1B",
"DYRK2",
"DYRK3",
"DYRK4",
"DYSF",
"DYX1C1",
"DYX1C1-CCPG1",
"DZANK1",
"DZIP1",
"DZIP1L",
"DZIP3",
"E2F1",
"E2F2",
"E2F3",
"E2F4",
"E2F5",
"E2F6",
"E2F7",
"E2F8",
"E4F1",
"EAF1",
"EAF2",
"EAPP",
"EARS2",
"EBAG9",
"EBF1",
"EBF2",
"EBF3",
"EBF4",
"EBI3",
"EBLN1",
"EBLN2",
"EBLN3",
"EBNA1BP2",
"EBP",
"EBPL",
"ECD",
"ECE1",
"ECE2",
"ECEL1",
"ECEL1P2",
"ECH1",
"ECHDC1",
"ECHDC2",
"ECHDC3",
"ECHS1",
"ECI1",
"ECI2",
"ECM1",
"ECM2",
"ECRP",
"ECSIT",
"ECT2",
"ECT2L",
"EDA",
"EDA2R",
"EDAR",
"EDARADD",
"EDC3",
"EDC4",
"EDEM1",
"EDEM2",
"EDEM3",
"EDF1",
"EDIL3",
"EDN1",
"EDN2",
"EDNRA",
"EDNRB",
"EDNRB-AS1",
"EDRF1",
"EEA1",
"EED",
"EEF1A1",
"EEF1A2",
"EEF1B2",
"EEF1D",
"EEF1DP3",
"EEF1E1",
"EEF1E1-BLOC1S5",
"EEF1G",
"EEF2",
"EEF2K",
"EEF2KMT",
"EEFSEC",
"EEPD1",
"EFCAB1",
"EFCAB10",
"EFCAB11",
"EFCAB12",
"EFCAB13",
"EFCAB14",
"EFCAB14-AS1",
"EFCAB2",
"EFCAB3",
"EFCAB5",
"EFCAB6",
"EFCAB7",
"EFCAB9",
"EFCC1",
"EFEMP1",
"EFEMP2",
"EFHB",
"EFHC1",
"EFHC2",
"EFHD1",
"EFHD2",
"EFNA1",
"EFNA2",
"EFNA3",
"EFNA4",
"EFNA5",
"EFNB1",
"EFNB2",
"EFNB3",
"EFR3A",
"EFR3B",
"EFTUD1",
"EFTUD1P1",
"EFTUD2",
"EGF",
"EGFEM1P",
"EGFL6",
"EGFL7",
"EGFL8",
"EGFLAM",
"EGFR",
"EGFR-AS1",
"EGLN1",
"EGLN2",
"EGLN3",
"EGOT",
"EGR1",
"EGR2",
"EGR3",
"EGR4",
"EHBP1",
"EHBP1L1",
"EHD1",
"EHD2",
"EHD3",
"EHD4",
"EHD4-AS1",
"EHF",
"EHHADH",
"EHMT1",
"EHMT1-IT1",
"EHMT2",
"EI24",
"EID1",
"EID2",
"EID2B",
"EID3",
"EIF1",
"EIF1AD",
"EIF1AX",
"EIF1AX-AS1",
"EIF1B",
"EIF1B-AS1",
"EIF2A",
"EIF2AK1",
"EIF2AK2",
"EIF2AK3",
"EIF2AK4",
"EIF2B1",
"EIF2B2",
"EIF2B3",
"EIF2B4",
"EIF2B5",
"EIF2B5-AS1",
"EIF2D",
"EIF2S1",
"EIF2S2",
"EIF2S3",
"EIF3A",
"EIF3B",
"EIF3C",
"EIF3CL",
"EIF3D",
"EIF3E",
"EIF3F",
"EIF3G",
"EIF3H",
"EIF3I",
"EIF3IP1",
"EIF3J",
"EIF3J-AS1",
"EIF3K",
"EIF3L",
"EIF3M",
"EIF4A1",
"EIF4A2",
"EIF4A3",
"EIF4B",
"EIF4E",
"EIF4E1B",
"EIF4E2",
"EIF4E3",
"EIF4EBP1",
"EIF4EBP2",
"EIF4EBP3",
"EIF4ENIF1",
"EIF4G1",
"EIF4G2",
"EIF4G3",
"EIF4H",
"EIF5",
"EIF5A",
"EIF5A2",
"EIF5AL1",
"EIF5B",
"EIF6",
"ELAC1",
"ELAC2",
"ELAVL1",
"ELAVL2",
"ELAVL3",
"ELAVL4",
"ELF1",
"ELF2",
"ELF3",
"ELF4",
"ELF5",
"ELFN1",
"ELFN1-AS1",
"ELFN2",
"ELK1",
"ELK2AP",
"ELK3",
"ELK4",
"ELL",
"ELL2",
"ELL3",
"ELMO1",
"ELMO2",
"ELMO3",
"ELMOD1",
"ELMOD2",
"ELMOD3",
"ELMSAN1",
"ELN",
"ELOF1",
"ELOVL1",
"ELOVL2",
"ELOVL2-AS1",
"ELOVL3",
"ELOVL4",
"ELOVL5",
"ELOVL6",
"ELOVL7",
"ELP2",
"ELP3",
"ELP4",
"ELP5",
"ELP6",
"ELSPBP1",
"EMB",
"EMBP1",
"EMC1",
"EMC10",
"EMC2",
"EMC3",
"EMC3-AS1",
"EMC4",
"EMC6",
"EMC7",
"EMC8",
"EMC9",
"EMCN",
"EMD",
"EME1",
"EME2",
"EMG1",
"EMID1",
"EMILIN1",
"EMILIN2",
"EMILIN3",
"EML1",
"EML2",
"EML2-AS1",
"EML3",
"EML4",
"EML5",
"EML6",
"EMP1",
"EMP2",
"EMP3",
"EMX1",
"EMX2",
"EMX2OS",
"EN1",
"EN2",
"ENAH",
"ENAM",
"ENC1",
"ENDOD1",
"ENDOG",
"ENDOU",
"ENDOV",
"ENG",
"ENGASE",
"ENHO",
"ENKD1",
"ENKUR",
"ENO1",
"ENO1-AS1",
"ENO2",
"ENO3",
"ENO4",
"ENOPH1",
"ENOSF1",
"ENOX1",
"ENOX1-AS2",
"ENOX2",
"ENPEP",
"ENPP1",
"ENPP2",
"ENPP3",
"ENPP4",
"ENPP5",
"ENPP6",
"ENPP7",
"ENPP7P13",
"ENSA",
"ENTHD1",
"ENTHD2",
"ENTPD1",
"ENTPD1-AS1",
"ENTPD2",
"ENTPD3",
"ENTPD3-AS1",
"ENTPD4",
"ENTPD5",
"ENTPD6",
"ENTPD7",
"ENTPD8",
"ENY2",
"EOGT",
"EOMES",
"EP300",
"EP300-AS1",
"EP400",
"EP400NL",
"EPAS1",
"EPB41",
"EPB41L1",
"EPB41L2",
"EPB41L3",
"EPB41L4A",
"EPB41L4A-AS1",
"EPB41L4A-AS2",
"EPB41L4B",
"EPB41L5",
"EPC1",
"EPC2",
"EPCAM",
"EPDR1",
"EPG5",
"EPGN",
"EPHA1",
"EPHA1-AS1",
"EPHA10",
"EPHA2",
"EPHA3",
"EPHA4",
"EPHA5",
"EPHA5-AS1",
"EPHA6",
"EPHA7",
"EPHA8",
"EPHB1",
"EPHB2",
"EPHB3",
"EPHB4",
"EPHB6",
"EPHX1",
"EPHX2",
"EPHX3",
"EPHX4",
"EPM2A",
"EPM2AIP1",
"EPN1",
"EPN2",
"EPN2-AS1",
"EPN2-IT1",
"EPN3",
"EPO",
"EPOR",
"EPPIN",
"EPPIN-WFDC6",
"EPPK1",
"EPRS",
"EPS15",
"EPS15L1",
"EPS8",
"EPS8L1",
"EPS8L2",
"EPS8L3",
"EPSTI1",
"EPT1",
"EPX",
"EPYC",
"ERAL1",
"ERAP1",
"ERAP2",
"ERAS",
"ERBB2",
"ERBB2IP",
"ERBB3",
"ERBB4",
"ERC1",
"ERC2",
"ERC2-IT1",
"ERCC1",
"ERCC2",
"ERCC3",
"ERCC4",
"ERCC5",
"ERCC6",
"ERCC6-PGBD3",
"ERCC6L",
"ERCC6L2",
"ERCC8",
"EREG",
"ERF",
"ERG",
"ERGIC1",
"ERGIC2",
"ERGIC3",
"ERH",
"ERI1",
"ERI2",
"ERI3",
"ERI3-IT1",
"ERICH1",
"ERICH2",
"ERICH3",
"ERICH4",
"ERICH5",
"ERICH6",
"ERICH6-AS1",
"ERLEC1",
"ERLIN1",
"ERLIN2",
"ERMAP",
"ERMARD",
"ERMN",
"ERMP1",
"ERN1",
"ERN2",
"ERO1A",
"ERO1B",
"ERP27",
"ERP29",
"ERP44",
"ERRFI1",
"ERV3-1",
"ERVFRD-1",
"ERVH48-1",
"ERVK13-1",
"ERVMER34-1",
"ERVV-1",
"ERVV-2",
"ERVW-1",
"ESAM",
"ESCO1",
"ESCO2",
"ESD",
"ESF1",
"ESM1",
"ESPL1",
"ESPN",
"ESPNL",
"ESPNP",
"ESR1",
"ESR2",
"ESRG",
"ESRP1",
"ESRP2",
"ESRRA",
"ESRRB",
"ESRRG",
"ESX1",
"ESYT1",
"ESYT2",
"ESYT3",
"ETAA1",
"ETF1",
"ETFA",
"ETFB",
"ETFDH",
"ETHE1",
"ETNK1",
"ETNK2",
"ETNPPL",
"ETS1",
"ETS2",
"ETV1",
"ETV2",
"ETV3",
"ETV3L",
"ETV4",
"ETV5",
"ETV6",
"ETV7",
"EVA1A",
"EVA1B",
"EVA1C",
"EVADR",
"EVC",
"EVI2A",
"EVI2B",
"EVI5",
"EVI5L",
"EVL",
"EVPL",
"EVPLL",
"EVX1",
"EWSAT1",
"EWSR1",
"EXD1",
"EXD2",
"EXD3",
"EXO1",
"EXO5",
"EXOC1",
"EXOC2",
"EXOC3",
"EXOC3-AS1",
"EXOC3L1",
"EXOC3L2",
"EXOC3L4",
"EXOC4",
"EXOC5",
"EXOC6",
"EXOC6B",
"EXOC7",
"EXOC8",
"EXOG",
"EXOSC1",
"EXOSC10",
"EXOSC2",
"EXOSC3",
"EXOSC4",
"EXOSC5",
"EXOSC6",
"EXOSC7",
"EXOSC8",
"EXOSC9",
"EXPH5",
"EXT1",
"EXT2",
"EXTL1",
"EXTL2",
"EXTL3",
"EXTL3-AS1",
"EYA1",
"EYA2",
"EYA3",
"EYA4",
"EYS",
"EZH1",
"EZH2",
"EZR",
"F10",
"F11R",
"F12",
"F13B",
"F2",
"F2R",
"F2RL1",
"F2RL2",
"F2RL3",
"F3",
"F5",
"F7",
"F8",
"F8A1",
"F8A2",
"F8A3",
"F9",
"FA2H",
"FAAH",
"FAAH2",
"FAAHP1",
"FAAP100",
"FAAP20",
"FAAP24",
"FABP12",
"FABP2",
"FABP3",
"FABP4",
"FABP5",
"FABP5P3",
"FABP6",
"FABP7",
"FADD",
"FADS1",
"FADS2",
"FADS3",
"FADS6",
"FAF1",
"FAF2",
"FAH",
"FAHD1",
"FAHD2A",
"FAHD2B",
"FAHD2CP",
"FAIM",
"FAIM2",
"FALEC",
"FAM101A",
"FAM101B",
"FAM102A",
"FAM102B",
"FAM103A1",
"FAM104A",
"FAM104B",
"FAM105A",
"FAM106A",
"FAM106B",
"FAM106CP",
"FAM107A",
"FAM107B",
"FAM109A",
"FAM109B",
"FAM110A",
"FAM110B",
"FAM110C",
"FAM110D",
"FAM111A",
"FAM111B",
"FAM114A1",
"FAM114A2",
"FAM117A",
"FAM117B",
"FAM118A",
"FAM118B",
"FAM120A",
"FAM120AOS",
"FAM120B",
"FAM120C",
"FAM122A",
"FAM122B",
"FAM122C",
"FAM124A",
"FAM124B",
"FAM126A",
"FAM126B",
"FAM127A",
"FAM127B",
"FAM127C",
"FAM129A",
"FAM129B",
"FAM129C",
"FAM131A",
"FAM131B",
"FAM131C",
"FAM132A",
"FAM132B",
"FAM133B",
"FAM133CP",
"FAM133DP",
"FAM134A",
"FAM134B",
"FAM134C",
"FAM135A",
"FAM135B",
"FAM136A",
"FAM138A",
"FAM138B",
"FAM138C",
"FAM138D",
"FAM138E",
"FAM13A",
"FAM13A-AS1",
"FAM13B",
"FAM13C",
"FAM149A",
"FAM149B1",
"FAM150B",
"FAM151A",
"FAM151B",
"FAM153A",
"FAM153B",
"FAM153C",
"FAM155A",
"FAM155A-IT1",
"FAM155B",
"FAM156A",
"FAM156B",
"FAM157A",
"FAM157B",
"FAM157C",
"FAM159B",
"FAM160A1",
"FAM160A2",
"FAM160B1",
"FAM160B2",
"FAM161A",
"FAM161B",
"FAM162A",
"FAM162B",
"FAM163A",
"FAM163B",
"FAM166A",
"FAM166B",
"FAM167A",
"FAM167A-AS1",
"FAM167B",
"FAM168A",
"FAM168B",
"FAM169A",
"FAM169B",
"FAM170A",
"FAM171A1",
"FAM171A2",
"FAM171B",
"FAM172A",
"FAM172BP",
"FAM173A",
"FAM173B",
"FAM174A",
"FAM174B",
"FAM175A",
"FAM175B",
"FAM177A1",
"FAM177B",
"FAM178B",
"FAM179A",
"FAM179B",
"FAM180A",
"FAM180B",
"FAM181A",
"FAM181A-AS1",
"FAM181B",
"FAM182A",
"FAM182B",
"FAM183A",
"FAM183B",
"FAM183CP",
"FAM184A",
"FAM184B",
"FAM185A",
"FAM186A",
"FAM186B",
"FAM187B",
"FAM188A",
"FAM188B",
"FAM189A1",
"FAM189A2",
"FAM189B",
"FAM192A",
"FAM193A",
"FAM193B",
"FAM195A",
"FAM195B",
"FAM196A",
"FAM196B",
"FAM198A",
"FAM198B",
"FAM199X",
"FAM19A2",
"FAM19A3",
"FAM19A4",
"FAM19A5",
"FAM200A",
"FAM200B",
"FAM201A",
"FAM204A",
"FAM205A",
"FAM205BP",
"FAM205C",
"FAM206A",
"FAM207A",
"FAM208A",
"FAM208B",
"FAM209A",
"FAM209B",
"FAM20A",
"FAM20B",
"FAM20C",
"FAM210A",
"FAM210B",
"FAM212A",
"FAM212B",
"FAM212B-AS1",
"FAM213A",
"FAM213B",
"FAM214A",
"FAM214B",
"FAM215A",
"FAM216A",
"FAM216B",
"FAM217A",
"FAM217B",
"FAM218A",
"FAM219A",
"FAM219B",
"FAM21A",
"FAM21C",
"FAM21EP",
"FAM220A",
"FAM221A",
"FAM221B",
"FAM222A",
"FAM222A-AS1",
"FAM222B",
"FAM223B",
"FAM225A",
"FAM225B",
"FAM226A",
"FAM226B",
"FAM227A",
"FAM227B",
"FAM228A",
"FAM228B",
"FAM229A",
"FAM229B",
"FAM230B",
"FAM230C",
"FAM231A",
"FAM231B",
"FAM231C",
"FAM231D",
"FAM24A",
"FAM24B",
"FAM24B-CUZD1",
"FAM25A",
"FAM25BP",
"FAM25C",
"FAM25G",
"FAM26F",
"FAM27B",
"FAM27C",
"FAM27E2",
"FAM27E3",
"FAM32A",
"FAM35A",
"FAM35BP",
"FAM35DP",
"FAM3A",
"FAM3B",
"FAM3C",
"FAM3D",
"FAM41C",
"FAM43A",
"FAM43B",
"FAM45A",
"FAM45B",
"FAM46A",
"FAM46B",
"FAM46C",
"FAM47A",
"FAM47E",
"FAM47E-STBD1",
"FAM49A",
"FAM49B",
"FAM50A",
"FAM50B",
"FAM53A",
"FAM53B",
"FAM53B-AS1",
"FAM53C",
"FAM57A",
"FAM57B",
"FAM58A",
"FAM60A",
"FAM63A",
"FAM63B",
"FAM64A",
"FAM65A",
"FAM65B",
"FAM65C",
"FAM66A",
"FAM66B",
"FAM66C",
"FAM66D",
"FAM66E",
"FAM69A",
"FAM69B",
"FAM69C",
"FAM71A",
"FAM71C",
"FAM71D",
"FAM71E1",
"FAM71E2",
"FAM71F1",
"FAM71F2",
"FAM72A",
"FAM72B",
"FAM72C",
"FAM72D",
"FAM73A",
"FAM73B",
"FAM74A3",
"FAM74A7",
"FAM76A",
"FAM76B",
"FAM78A",
"FAM78B",
"FAM81A",
"FAM81B",
"FAM83A",
"FAM83A-AS1",
"FAM83B",
"FAM83C",
"FAM83C-AS1",
"FAM83D",
"FAM83E",
"FAM83F",
"FAM83G",
"FAM83H",
"FAM83H-AS1",
"FAM84A",
"FAM84B",
"FAM86B1",
"FAM86B2",
"FAM86B3P",
"FAM86C1",
"FAM86C2P",
"FAM86DP",
"FAM86EP",
"FAM86FP",
"FAM86HP",
"FAM86JP",
"FAM87A",
"FAM87B",
"FAM89A",
"FAM89B",
"FAM8A1",
"FAM90A1",
"FAM90A25P",
"FAM90A2P",
"FAM90A7P",
"FAM91A1",
"FAM92A1",
"FAM95A",
"FAM95B1",
"FAM95C",
"FAM96A",
"FAM96B",
"FAM98A",
"FAM98B",
"FAM98C",
"FAM9B",
"FAM9C",
"FAN1",
"FANCA",
"FANCB",
"FANCC",
"FANCD2",
"FANCD2OS",
"FANCE",
"FANCF",
"FANCG",
"FANCI",
"FANCL",
"FANCM",
"FANK1",
"FAP",
"FAR1",
"FAR2",
"FAR2P1",
"FAR2P2",
"FARP1",
"FARP2",
"FARS2",
"FARSA",
"FARSB",
"FAS",
"FAS-AS1",
"FASLG",
"FASN",
"FASTK",
"FASTKD1",
"FASTKD2",
"FASTKD3",
"FASTKD5",
"FAT1",
"FAT2",
"FAT3",
"FAT4",
"FATE1",
"FAU",
"FAXC",
"FAXDC2",
"FBF1",
"FBL",
"FBLIM1",
"FBLL1",
"FBLN1",
"FBLN2",
"FBLN5",
"FBLN7",
"FBN1",
"FBN2",
"FBN3",
"FBP1",
"FBP2",
"FBRS",
"FBRSL1",
"FBXL12",
"FBXL13",
"FBXL14",
"FBXL15",
"FBXL16",
"FBXL17",
"FBXL18",
"FBXL19",
"FBXL19-AS1",
"FBXL2",
"FBXL20",
"FBXL22",
"FBXL3",
"FBXL4",
"FBXL5",
"FBXL6",
"FBXL8",
"FBXO10",
"FBXO11",
"FBXO15",
"FBXO16",
"FBXO17",
"FBXO18",
"FBXO2",
"FBXO21",
"FBXO22",
"FBXO22-AS1",
"FBXO24",
"FBXO25",
"FBXO27",
"FBXO28",
"FBXO3",
"FBXO30",
"FBXO31",
"FBXO32",
"FBXO33",
"FBXO34",
"FBXO36",
"FBXO38",
"FBXO39",
"FBXO4",
"FBXO40",
"FBXO41",
"FBXO42",
"FBXO43",
"FBXO44",
"FBXO45",
"FBXO46",
"FBXO47",
"FBXO48",
"FBXO5",
"FBXO6",
"FBXO7",
"FBXO8",
"FBXO9",
"FBXW10",
"FBXW11",
"FBXW2",
"FBXW4",
"FBXW4P1",
"FBXW5",
"FBXW7",
"FBXW8",
"FBXW9",
"FCAMR",
"FCER1G",
"FCER2",
"FCF1",
"FCGBP",
"FCGR1A",
"FCGR1B",
"FCGR1C",
"FCGR2A",
"FCGR2B",
"FCGR2C",
"FCGR3A",
"FCGR3B",
"FCGRT",
"FCHO1",
"FCHO2",
"FCHSD1",
"FCHSD2",
"FCMR",
"FCN3",
"FCRL6",
"FCRLA",
"FCRLB",
"FDCSP",
"FDFT1",
"FDPS",
"FDPSP2",
"FDX1",
"FDX1L",
"FDXACB1",
"FDXR",
"FECH",
"FEM1A",
"FEM1B",
"FEM1C",
"FEN1",
"FENDRR",
"FER",
"FER1L4",
"FER1L5",
"FER1L6",
"FER1L6-AS1",
"FER1L6-AS2",
"FERMT1",
"FERMT2",
"FERMT3",
"FES",
"FETUB",
"FEZ1",
"FEZ2",
"FEZF1",
"FEZF1-AS1",
"FFAR2",
"FFAR3",
"FFAR4",
"FGB",
"FGD1",
"FGD2",
"FGD3",
"FGD4",
"FGD5",
"FGD5-AS1",
"FGD5P1",
"FGD6",
"FGF1",
"FGF11",
"FGF12",
"FGF13",
"FGF13-AS1",
"FGF14",
"FGF14-AS2",
"FGF14-IT1",
"FGF17",
"FGF18",
"FGF19",
"FGF2",
"FGF20",
"FGF21",
"FGF22",
"FGF23",
"FGF5",
"FGF7",
"FGF8",
"FGF9",
"FGFBP1",
"FGFBP2",
"FGFBP3",
"FGFR1",
"FGFR1OP",
"FGFR1OP2",
"FGFR2",
"FGFR3",
"FGFR4",
"FGFRL1",
"FGG",
"FGGY",
"FGL1",
"FGL2",
"FGR",
"FH",
"FHAD1",
"FHDC1",
"FHIT",
"FHL1",
"FHL2",
"FHL3",
"FHOD1",
"FHOD3",
"FIBCD1",
"FIBIN",
"FIBP",
"FICD",
"FIG4",
"FIGF",
"FIGN",
"FIGNL1",
"FIGNL2",
"FILIP1",
"FILIP1L",
"FIP1L1",
"FIRRE",
"FIS1",
"FITM1",
"FITM2",
"FIZ1",
"FJX1",
"FKBP10",
"FKBP11",
"FKBP14",
"FKBP15",
"FKBP1A",
"FKBP1A-SDCBP2",
"FKBP1AP1",
"FKBP1B",
"FKBP2",
"FKBP3",
"FKBP4",
"FKBP5",
"FKBP6",
"FKBP7",
"FKBP8",
"FKBP9",
"FKBP9P1",
"FKBPL",
"FKRP",
"FKSG29",
"FKTN",
"FLAD1",
"FLCN",
"FLG",
"FLG-AS1",
"FLG2",
"FLI1",
"FLII",
"FLJ10038",
"FLJ12825",
"FLJ13224",
"FLJ16171",
"FLJ16779",
"FLJ20021",
"FLJ21408",
"FLJ22447",
"FLJ23867",
"FLJ25758",
"FLJ26850",
"FLJ27354",
"FLJ30679",
"FLJ31104",
"FLJ31356",
"FLJ31662",
"FLJ32255",
"FLJ33360",
"FLJ33534",
"FLJ34503",
"FLJ35934",
"FLJ36777",
"FLJ37035",
"FLJ37201",
"FLJ37453",
"FLJ38122",
"FLJ38576",
"FLJ40194",
"FLJ40288",
"FLJ41200",
"FLJ41278",
"FLJ41941",
"FLJ42102",
"FLJ42351",
"FLJ42393",
"FLJ42627",
"FLJ42969",
"FLJ43315",
"FLJ43879",
"FLJ44635",
"FLJ45513",
"FLJ46284",
"FLJ46906",
"FLNA",
"FLNB",
"FLNC",
"FLOT1",
"FLOT2",
"FLRT1",
"FLRT2",
"FLRT3",
"FLT1",
"FLT3",
"FLT3LG",
"FLT4",
"FLVCR1",
"FLVCR1-AS1",
"FLVCR2",
"FLYWCH1",
"FLYWCH2",
"FMN1",
"FMN2",
"FMNL1",
"FMNL2",
"FMNL3",
"FMO1",
"FMO2",
"FMO3",
"FMO4",
"FMO5",
"FMO6P",
"FMOD",
"FMR1",
"FMR1-AS1",
"FMR1NB",
"FN1",
"FN3K",
"FN3KRP",
"FNBP1",
"FNBP1L",
"FNBP4",
"FNDC3A",
"FNDC3B",
"FNDC4",
"FNDC5",
"FNDC7",
"FNDC8",
"FNDC9",
"FNIP1",
"FNIP2",
"FNTA",
"FNTB",
"FOCAD",
"FOCAD-AS1",
"FOLR1",
"FOLR2",
"FOLR3",
"FOPNL",
"FOS",
"FOSB",
"FOSL1",
"FOSL2",
"FOXA1",
"FOXA2",
"FOXA3",
"FOXB2",
"FOXC1",
"FOXC2",
"FOXCUT",
"FOXD1",
"FOXD2",
"FOXD2-AS1",
"FOXD3",
"FOXD3-AS1",
"FOXD4",
"FOXD4L1",
"FOXD4L3",
"FOXD4L4",
"FOXD4L5",
"FOXD4L6",
"FOXE1",
"FOXE3",
"FOXF1",
"FOXF2",
"FOXG1",
"FOXG1-AS1",
"FOXH1",
"FOXI1",
"FOXI3",
"FOXJ1",
"FOXJ2",
"FOXJ3",
"FOXK1",
"FOXK2",
"FOXL1",
"FOXL2",
"FOXL2NB",
"FOXM1",
"FOXN1",
"FOXN2",
"FOXN3",
"FOXN3-AS1",
"FOXN3-AS2",
"FOXN4",
"FOXO1",
"FOXO3",
"FOXO3B",
"FOXO4",
"FOXO6",
"FOXP1",
"FOXP1-AS1",
"FOXP2",
"FOXP3",
"FOXP4",
"FOXP4-AS1",
"FOXQ1",
"FOXR1",
"FOXRED1",
"FOXRED2",
"FOXS1",
"FPGS",
"FPGT",
"FPGT-TNNI3K",
"FPR1",
"FPR2",
"FRA10AC1",
"FRAS1",
"FRAT1",
"FRAT2",
"FREM1",
"FREM2",
"FREM3",
"FRG1",
"FRG1BP",
"FRG1CP",
"FRG1DP",
"FRG1HP",
"FRG1JP",
"FRG2",
"FRG2B",
"FRG2EP",
"FRK",
"FRMD1",
"FRMD3",
"FRMD4A",
"FRMD4B",
"FRMD5",
"FRMD6",
"FRMD6-AS1",
"FRMD6-AS2",
"FRMD7",
"FRMD8",
"FRMPD1",
"FRMPD2",
"FRMPD2B",
"FRMPD3",
"FRMPD4",
"FRRS1",
"FRS2",
"FRS3",
"FRY",
"FRY-AS1",
"FRYL",
"FRZB",
"FSBP",
"FSCB",
"FSCN1",
"FSCN2",
"FSCN3",
"FSD1",
"FSD1L",
"FSD2",
"FSIP1",
"FSIP2",
"FST",
"FSTL1",
"FSTL3",
"FSTL4",
"FSTL5",
"FTCD",
"FTCDNL1",
"FTH1",
"FTH1P18",
"FTH1P3",
"FTL",
"FTO",
"FTO-IT1",
"FTSJ1",
"FTSJ2",
"FTSJ3",
"FTX",
"FUBP1",
"FUBP3",
"FUCA1",
"FUCA2",
"FUK",
"FUNDC1",
"FUNDC2",
"FUOM",
"FURIN",
"FUS",
"FUT1",
"FUT10",
"FUT11",
"FUT2",
"FUT3",
"FUT4",
"FUT5",
"FUT6",
"FUT7",
"FUT8",
"FUT8-AS1",
"FUT9",
"FUZ",
"FXN",
"FXR1",
"FXR2",
"FXYD1",
"FXYD3",
"FXYD4",
"FXYD5",
"FXYD6",
"FXYD7",
"FYB",
"FYCO1",
"FYN",
"FYTTD1",
"FZD1",
"FZD10",
"FZD10-AS1",
"FZD2",
"FZD3",
"FZD4",
"FZD5",
"FZD6",
"FZD7",
"FZD8",
"FZD9",
"FZR1",
"G0S2",
"G2E3",
"G3BP1",
"G3BP2",
"G6PC",
"G6PC3",
"G6PD",
"GAA",
"GAB1",
"GAB2",
"GAB3",
"GABARAP",
"GABARAPL1",
"GABARAPL2",
"GABARAPL3",
"GABBR1",
"GABBR2",
"GABPA",
"GABPB1",
"GABPB1-AS1",
"GABPB2",
"GABRA2",
"GABRA3",
"GABRA4",
"GABRB1",
"GABRD",
"GABRE",
"GABRP",
"GABRR1",
"GABRR2",
"GACAT2",
"GAD1",
"GADD45A",
"GADD45B",
"GADD45G",
"GADD45GIP1",
"GADL1",
"GAGE1",
"GAGE12B",
"GAGE12D",
"GAGE12E",
"GAGE12G",
"GAGE12H",
"GAGE12J",
"GAGE2B",
"GAGE2E",
"GAGE4",
"GAGE6",
"GAGE8",
"GAK",
"GAL",
"GAL3ST1",
"GAL3ST2",
"GAL3ST3",
"GAL3ST4",
"GALC",
"GALE",
"GALK1",
"GALK2",
"GALM",
"GALNS",
"GALNT1",
"GALNT10",
"GALNT11",
"GALNT12",
"GALNT13",
"GALNT14",
"GALNT15",
"GALNT16",
"GALNT18",
"GALNT2",
"GALNT3",
"GALNT4",
"GALNT5",
"GALNT6",
"GALNT7",
"GALNT8",
"GALNT9",
"GALNTL6",
"GALR2",
"GALR3",
"GALT",
"GAMT",
"GAN",
"GANAB",
"GANC",
"GAPDH",
"GAPDHS",
"GAPLINC",
"GAPVD1",
"GAR1",
"GAREM",
"GAREML",
"GARNL3",
"GARS",
"GART",
"GAS1",
"GAS2",
"GAS2L1",
"GAS2L1P2",
"GAS2L2",
"GAS2L3",
"GAS5",
"GAS5-AS1",
"GAS6",
"GAS6-AS1",
"GAS6-AS2",
"GAS7",
"GAS8",
"GAS8-AS1",
"GAST",
"GATA1",
"GATA2",
"GATA2-AS1",
"GATA3",
"GATA3-AS1",
"GATA4",
"GATA5",
"GATA6",
"GATA6-AS1",
"GATAD1",
"GATAD2A",
"GATAD2B",
"GATB",
"GATC",
"GATM",
"GATS",
"GATSL2",
"GATSL3",
"GBA",
"GBA2",
"GBA3",
"GBAP1",
"GBAS",
"GBAT2",
"GBE1",
"GBF1",
"GBGT1",
"GBP1",
"GBP1P1",
"GBP2",
"GBP3",
"GBP4",
"GBP5",
"GBP6",
"GBX1",
"GBX2",
"GCA",
"GCAT",
"GCC1",
"GCC2",
"GCDH",
"GCFC2",
"GCGR",
"GCH1",
"GCHFR",
"GCK",
"GCLC",
"GCLM",
"GCM1",
"GCM2",
"GCN1",
"GCNT1",
"GCNT2",
"GCNT3",
"GCNT4",
"GCNT7",
"GCOM1",
"GCSAM",
"GCSH",
"GCSHP3",
"GDA",
"GDAP1",
"GDAP1L1",
"GDAP2",
"GDE1",
"GDF11",
"GDF15",
"GDF3",
"GDF5",
"GDF6",
"GDF7",
"GDF9",
"GDI1",
"GDI2",
"GDNF",
"GDNF-AS1",
"GDPD1",
"GDPD2",
"GDPD3",
"GDPD5",
"GDPGP1",
"GEM",
"GEMIN2",
"GEMIN4",
"GEMIN5",
"GEMIN6",
"GEMIN7",
"GEMIN8",
"GEMIN8P4",
"GEN1",
"GET4",
"GFAP",
"GFER",
"GFI1",
"GFM1",
"GFM2",
"GFOD1",
"GFOD2",
"GFPT1",
"GFPT2",
"GFRA1",
"GFRA2",
"GFRA3",
"GFY",
"GGA1",
"GGA2",
"GGA3",
"GGACT",
"GGCT",
"GGCX",
"GGH",
"GGN",
"GGNBP1",
"GGNBP2",
"GGPS1",
"GGT1",
"GGT3P",
"GGT5",
"GGT6",
"GGT7",
"GGT8P",
"GGTLC1",
"GGTLC2",
"GH2",
"GHDC",
"GHET1",
"GHITM",
"GHR",
"GHRHR",
"GHRL",
"GHRLOS",
"GHSR",
"GID4",
"GID8",
"GIF",
"GIGYF1",
"GIGYF2",
"GIMAP2",
"GIMAP8",
"GIN1",
"GINM1",
"GINS1",
"GINS2",
"GINS3",
"GINS4",
"GIP",
"GIPC1",
"GIPC2",
"GIPR",
"GIT1",
"GIT2",
"GJA1",
"GJA10",
"GJA3",
"GJA4",
"GJA5",
"GJA8",
"GJA9",
"GJA9-MYCBP",
"GJB1",
"GJB2",
"GJB3",
"GJB4",
"GJB5",
"GJB6",
"GJB7",
"GJC1",
"GJC2",
"GJC3",
"GJD2",
"GJD3",
"GJD4",
"GK",
"GK3P",
"GK5",
"GKAP1",
"GKN2",
"GLA",
"GLB1",
"GLB1L",
"GLB1L2",
"GLB1L3",
"GLCCI1",
"GLCE",
"GLDC",
"GLDN",
"GLE1",
"GLG1",
"GLI1",
"GLI2",
"GLI3",
"GLI4",
"GLIDR",
"GLIPR1",
"GLIPR1L1",
"GLIPR1L2",
"GLIPR2",
"GLIS1",
"GLIS2",
"GLIS3",
"GLIS3-AS1",
"GLMN",
"GLMP",
"GLO1",
"GLOD4",
"GLOD5",
"GLP1R",
"GLP2R",
"GLRA1",
"GLRA2",
"GLRA3",
"GLRB",
"GLRX",
"GLRX2",
"GLRX3",
"GLRX5",
"GLS",
"GLS2",
"GLT1D1",
"GLT8D1",
"GLT8D2",
"GLTP",
"GLTPD2",
"GLTSCR1",
"GLTSCR1L",
"GLTSCR2",
"GLUD1",
"GLUD1P3",
"GLUD1P7",
"GLUD2",
"GLUL",
"GLYAT",
"GLYATL1",
"GLYATL2",
"GLYATL3",
"GLYCTK",
"GLYCTK-AS1",
"GLYR1",
"GM2A",
"GMCL1",
"GMCL1P1",
"GMDS",
"GMDS-AS1",
"GMEB1",
"GMEB2",
"GMFB",
"GMFG",
"GMIP",
"GMNC",
"GMNN",
"GMPPA",
"GMPPB",
"GMPR",
"GMPR2",
"GMPS",
"GNA11",
"GNA12",
"GNA13",
"GNA14",
"GNA14-AS1",
"GNA15",
"GNAI1",
"GNAI2",
"GNAI3",
"GNAL",
"GNAO1",
"GNAQ",
"GNAS",
"GNAS-AS1",
"GNAT1",
"GNAT2",
"GNAZ",
"GNB1",
"GNB1L",
"GNB2",
"GNB2L1",
"GNB3",
"GNB4",
"GNB5",
"GNE",
"GNG10",
"GNG11",
"GNG12",
"GNG12-AS1",
"GNG13",
"GNG2",
"GNG3",
"GNG4",
"GNG5",
"GNG7",
"GNGT1",
"GNGT2",
"GNL1",
"GNL2",
"GNL3",
"GNL3L",
"GNLY",
"GNMT",
"GNPAT",
"GNPDA1",
"GNPDA2",
"GNPNAT1",
"GNPTAB",
"GNPTG",
"GNRH1",
"GNRH2",
"GNRHR",
"GNRHR2",
"GNS",
"GOLGA1",
"GOLGA2",
"GOLGA2P10",
"GOLGA2P5",
"GOLGA2P6",
"GOLGA2P7",
"GOLGA3",
"GOLGA4",
"GOLGA5",
"GOLGA6A",
"GOLGA6B",
"GOLGA6C",
"GOLGA6D",
"GOLGA6L1",
"GOLGA6L10",
"GOLGA6L17P",
"GOLGA6L22",
"GOLGA6L3",
"GOLGA6L4",
"GOLGA6L5P",
"GOLGA6L6",
"GOLGA6L9",
"GOLGA7",
"GOLGA7B",
"GOLGA8A",
"GOLGA8B",
"GOLGA8CP",
"GOLGA8DP",
"GOLGA8EP",
"GOLGA8F",
"GOLGA8G",
"GOLGA8H",
"GOLGA8IP",
"GOLGA8J",
"GOLGA8K",
"GOLGA8M",
"GOLGA8N",
"GOLGA8O",
"GOLGA8R",
"GOLGA8S",
"GOLGA8T",
"GOLGB1",
"GOLIM4",
"GOLM1",
"GOLPH3",
"GOLPH3L",
"GOLT1A",
"GOLT1B",
"GON4L",
"GOPC",
"GORAB",
"GORASP1",
"GORASP2",
"GOSR1",
"GOSR2",
"GOT1",
"GOT2",
"GP1BA",
"GP1BB",
"GP2",
"GP5",
"GP6",
"GPA33",
"GPAA1",
"GPALPP1",
"GPAM",
"GPANK1",
"GPAT2",
"GPAT3",
"GPAT4",
"GPATCH1",
"GPATCH11",
"GPATCH2",
"GPATCH2L",
"GPATCH3",
"GPATCH4",
"GPATCH8",
"GPBAR1",
"GPBP1",
"GPBP1L1",
"GPC1",
"GPC2",
"GPC3",
"GPC4",
"GPC5",
"GPC6",
"GPC6-AS1",
"GPC6-AS2",
"GPCPD1",
"GPD1",
"GPD1L",
"GPD2",
"GPER1",
"GPHA2",
"GPHN",
"GPI",
"GPIHBP1",
"GPKOW",
"GPLD1",
"GPM6A",
"GPM6B",
"GPN1",
"GPN2",
"GPN3",
"GPNMB",
"GPR1",
"GPR1-AS",
"GPR101",
"GPR107",
"GPR108",
"GPR132",
"GPR135",
"GPR137",
"GPR137B",
"GPR137C",
"GPR139",
"GPR141",
"GPR143",
"GPR146",
"GPR15",
"GPR150",
"GPR151",
"GPR152",
"GPR153",
"GPR155",
"GPR156",
"GPR157",
"GPR158",
"GPR160",
"GPR161",
"GPR162",
"GPR17",
"GPR171",
"GPR173",
"GPR176",
"GPR179",
"GPR18",
"GPR180",
"GPR182",
"GPR183",
"GPR19",
"GPR20",
"GPR21",
"GPR22",
"GPR25",
"GPR26",
"GPR27",
"GPR3",
"GPR32",
"GPR33",
"GPR34",
"GPR35",
"GPR37",
"GPR37L1",
"GPR39",
"GPR4",
"GPR45",
"GPR50",
"GPR52",
"GPR55",
"GPR6",
"GPR61",
"GPR62",
"GPR63",
"GPR65",
"GPR68",
"GPR75",
"GPR75-ASB3",
"GPR78",
"GPR82",
"GPR83",
"GPR84",
"GPR85",
"GPR87",
"GPR88",
"GPR89A",
"GPR89B",
"GPRASP1",
"GPRASP2",
"GPRC5A",
"GPRC5B",
"GPRC5C",
"GPRC5D",
"GPRIN1",
"GPRIN2",
"GPRIN3",
"GPS1",
"GPS2",
"GPSM1",
"GPSM2",
"GPSM3",
"GPT",
"GPT2",
"GPX1",
"GPX2",
"GPX3",
"GPX4",
"GPX7",
"GPX8",
"GRAMD1A",
"GRAMD1B",
"GRAMD1C",
"GRAMD2",
"GRAMD3",
"GRAMD4",
"GRAP",
"GRAP2",
"GRAPL",
"GRASP",
"GRB10",
"GRB14",
"GRB2",
"GRB7",
"GREB1",
"GREB1L",
"GREM1",
"GREM2",
"GRHL1",
"GRHL2",
"GRHL3",
"GRHPR",
"GRIA2",
"GRIA3",
"GRIA4",
"GRID1",
"GRID2IP",
"GRIK1",
"GRIK1-AS2",
"GRIK2",
"GRIK3",
"GRIK4",
"GRIK5",
"GRIN1",
"GRIN2A",
"GRIN2B",
"GRIN2C",
"GRIN2D",
"GRIN3A",
"GRIN3B",
"GRINA",
"GRIP1",
"GRIP2",
"GRIPAP1",
"GRK1",
"GRK4",
"GRK5",
"GRK6",
"GRK7",
"GRM1",
"GRM2",
"GRM3",
"GRM4",
"GRM6",
"GRM8",
"GRN",
"GRPEL1",
"GRPEL2",
"GRPR",
"GRSF1",
"GRTP1",
"GRTP1-AS1",
"GRWD1",
"GS1-124K5.11",
"GS1-24F4.2",
"GS1-259H13.2",
"GS1-279B7.1",
"GSAP",
"GSC",
"GSDMA",
"GSDMB",
"GSDMC",
"GSDMD",
"GSE1",
"GSG1",
"GSG1L",
"GSG1L2",
"GSG2",
"GSK3A",
"GSK3B",
"GSKIP",
"GSN",
"GSN-AS1",
"GSPT1",
"GSPT2",
"GSR",
"GSS",
"GSTA1",
"GSTA2",
"GSTA4",
"GSTA7P",
"GSTCD",
"GSTK1",
"GSTM1",
"GSTM2",
"GSTM2P1",
"GSTM3",
"GSTM4",
"GSTM5",
"GSTO1",
"GSTO2",
"GSTP1",
"GSTT2",
"GSTT2B",
"GSTTP1",
"GSTTP2",
"GSTZ1",
"GTDC1",
"GTF2A1",
"GTF2A1L",
"GTF2A2",
"GTF2B",
"GTF2E1",
"GTF2E2",
"GTF2F1",
"GTF2F2",
"GTF2H1",
"GTF2H2",
"GTF2H2B",
"GTF2H2C",
"GTF2H2C_2",
"GTF2H3",
"GTF2H4",
"GTF2H5",
"GTF2I",
"GTF2IP1",
"GTF2IP20",
"GTF2IP4",
"GTF2IRD1",
"GTF2IRD1P1",
"GTF2IRD2",
"GTF2IRD2B",
"GTF3A",
"GTF3C1",
"GTF3C2",
"GTF3C2-AS1",
"GTF3C3",
"GTF3C4",
"GTF3C5",
"GTF3C6",
"GTPBP1",
"GTPBP10",
"GTPBP2",
"GTPBP3",
"GTPBP4",
"GTPBP6",
"GTPBP8",
"GTSE1",
"GTSE1-AS1",
"GTSF1",
"GTSF1L",
"GUCA1A",
"GUCA1B",
"GUCA2A",
"GUCD1",
"GUCY1A2",
"GUCY1A3",
"GUCY1B2",
"GUCY1B3",
"GUCY2C",
"GUCY2D",
"GUF1",
"GUK1",
"GULP1",
"GUSB",
"GUSBP1",
"GUSBP11",
"GUSBP2",
"GUSBP3",
"GUSBP4",
"GUSBP5",
"GUSBP9",
"GVINP1",
"GXYLT1",
"GXYLT1P3",
"GXYLT2",
"GYG1",
"GYG2",
"GYLTL1B",
"GYPE",
"GYS1",
"GYS2",
"GZF1",
"GZMB",
"GZMM",
"H19",
"H1F0",
"H1FNT",
"H1FOO",
"H1FX",
"H1FX-AS1",
"H2AFB1",
"H2AFB2",
"H2AFJ",
"H2AFV",
"H2AFX",
"H2AFY",
"H2AFY2",
"H2AFZ",
"H2BFM",
"H2BFXP",
"H3F3A",
"H3F3AP4",
"H3F3B",
"H3F3C",
"H6PD",
"HAAO",
"HABP2",
"HABP4",
"HACD1",
"HACD2",
"HACD3",
"HACD4",
"HACE1",
"HACL1",
"HADH",
"HADHA",
"HADHB",
"HAGH",
"HAGHL",
"HAGLR",
"HAGLROS",
"HAL",
"HAMP",
"HAND1",
"HAND2",
"HAO1",
"HAP1",
"HAPLN1",
"HAPLN2",
"HAPLN3",
"HAPLN4",
"HAR1A",
"HAR1B",
"HARBI1",
"HARS",
"HARS2",
"HAS1",
"HAS2",
"HAS2-AS1",
"HAS3",
"HAT1",
"HAUS1",
"HAUS2",
"HAUS3",
"HAUS4",
"HAUS5",
"HAUS6",
"HAUS7",
"HAUS8",
"HAVCR1P1",
"HAVCR2",
"HAX1",
"HBA1",
"HBA2",
"HBB",
"HBE1",
"HBEGF",
"HBM",
"HBP1",
"HBQ1",
"HBS1L",
"HCAR1",
"HCAR2",
"HCAR3",
"HCCAT5",
"HCCS",
"HCFC1",
"HCFC1-AS1",
"HCFC1R1",
"HCFC2",
"HCG11",
"HCG14",
"HCG17",
"HCG18",
"HCG2040054",
"HCG22",
"HCG25",
"HCG26",
"HCG27",
"HCG4",
"HCG4B",
"HCG8",
"HCG9",
"HCK",
"HCLS1",
"HCN2",
"HCN3",
"HCN4",
"HCP5",
"HCRTR1",
"HCRTR2",
"HCST",
"HDAC1",
"HDAC10",
"HDAC11",
"HDAC11-AS1",
"HDAC2",
"HDAC3",
"HDAC4",
"HDAC5",
"HDAC6",
"HDAC7",
"HDAC8",
"HDAC9",
"HDC",
"HDDC2",
"HDDC3",
"HDGF",
"HDGFRP2",
"HDGFRP3",
"HDHD1",
"HDHD2",
"HDHD3",
"HDLBP",
"HDX",
"HEATR1",
"HEATR3",
"HEATR4",
"HEATR5A",
"HEATR5B",
"HEATR6",
"HEATR9",
"HEBP1",
"HEBP2",
"HECA",
"HECTD1",
"HECTD2",
"HECTD2-AS1",
"HECTD3",
"HECTD4",
"HECW1",
"HECW2",
"HEG1",
"HEIH",
"HELB",
"HELLS",
"HELQ",
"HELT",
"HELZ",
"HELZ2",
"HEMGN",
"HEMK1",
"HENMT1",
"HEPACAM",
"HEPACAM2",
"HEPH",
"HEPHL1",
"HERC1",
"HERC2",
"HERC2P10",
"HERC2P2",
"HERC2P3",
"HERC2P4",
"HERC2P7",
"HERC2P9",
"HERC3",
"HERC4",
"HERC5",
"HERC6",
"HERPUD1",
"HERPUD2",
"HES1",
"HES2",
"HES3",
"HES4",
"HES5",
"HES6",
"HES7",
"HESX1",
"HEXA",
"HEXA-AS1",
"HEXB",
"HEXDC",
"HEXIM1",
"HEXIM2",
"HEY1",
"HEY2",
"HEYL",
"HFE",
"HFE2",
"HFM1",
"HGC6.3",
"HGD",
"HGFAC",
"HGH1",
"HGS",
"HGSNAT",
"HHAT",
"HHEX",
"HHIP",
"HHIP-AS1",
"HHIPL1",
"HHIPL2",
"HHLA2",
"HHLA3",
"HIAT1",
"HIATL1",
"HIATL2",
"HIBADH",
"HIBCH",
"HIC1",
"HIC2",
"HID1",
"HID1-AS1",
"HIF1A",
"HIF1A-AS1",
"HIF1A-AS2",
"HIF1AN",
"HIF3A",
"HIGD1A",
"HIGD1B",
"HIGD2A",
"HIGD2B",
"HILPDA",
"HINFP",
"HINT1",
"HINT2",
"HINT3",
"HIP1",
"HIP1R",
"HIPK1",
"HIPK1-AS1",
"HIPK2",
"HIPK3",
"HIPK4",
"HIRA",
"HIRIP3",
"HIST1H1A",
"HIST1H1B",
"HIST1H1C",
"HIST1H1D",
"HIST1H1E",
"HIST1H1T",
"HIST1H2AA",
"HIST1H2AB",
"HIST1H2AC",
"HIST1H2AD",
"HIST1H2AE",
"HIST1H2AG",
"HIST1H2AH",
"HIST1H2AI",
"HIST1H2AJ",
"HIST1H2AK",
"HIST1H2AL",
"HIST1H2AM",
"HIST1H2BA",
"HIST1H2BB",
"HIST1H2BC",
"HIST1H2BD",
"HIST1H2BE",
"HIST1H2BF",
"HIST1H2BG",
"HIST1H2BH",
"HIST1H2BI",
"HIST1H2BJ",
"HIST1H2BK",
"HIST1H2BL",
"HIST1H2BM",
"HIST1H2BN",
"HIST1H2BO",
"HIST1H3A",
"HIST1H3B",
"HIST1H3C",
"HIST1H3D",
"HIST1H3E",
"HIST1H3F",
"HIST1H3G",
"HIST1H3H",
"HIST1H3I",
"HIST1H3J",
"HIST1H4A",
"HIST1H4B",
"HIST1H4C",
"HIST1H4D",
"HIST1H4E",
"HIST1H4F",
"HIST1H4H",
"HIST1H4I",
"HIST1H4J",
"HIST1H4K",
"HIST1H4L",
"HIST2H2AA3",
"HIST2H2AB",
"HIST2H2AC",
"HIST2H2BA",
"HIST2H2BC",
"HIST2H2BE",
"HIST2H2BF",
"HIST2H3A",
"HIST2H3C",
"HIST2H3D",
"HIST2H4B",
"HIST3H2A",
"HIST3H2BB",
"HIST3H3",
"HIST4H4",
"HIVEP1",
"HIVEP2",
"HIVEP3",
"HJURP",
"HK1",
"HK2",
"HK3",
"HKDC1",
"HKR1",
"HLA-A",
"HLA-B",
"HLA-C",
"HLA-DMA",
"HLA-DMB",
"HLA-DOA",
"HLA-DOB",
"HLA-DPA1",
"HLA-DPB1",
"HLA-DQA1",
"HLA-DQB1",
"HLA-DRA",
"HLA-DRB1",
"HLA-DRB5",
"HLA-DRB6",
"HLA-E",
"HLA-F",
"HLA-F-AS1",
"HLA-G",
"HLA-H",
"HLA-J",
"HLA-L",
"HLCS",
"HLF",
"HLTF",
"HLX",
"HM13",
"HM13-AS1",
"HMBOX1",
"HMBS",
"HMCES",
"HMCN1",
"HMCN2",
"HMG20A",
"HMG20B",
"HMGA1",
"HMGA1P7",
"HMGA2",
"HMGB1",
"HMGB2",
"HMGB3",
"HMGB3P1",
"HMGCL",
"HMGCLL1",
"HMGCR",
"HMGCS1",
"HMGCS2",
"HMGN1",
"HMGN2",
"HMGN2P46",
"HMGN3",
"HMGN3-AS1",
"HMGN4",
"HMGN5",
"HMGXB3",
"HMGXB4",
"HMHA1",
"HMMR",
"HMMR-AS1",
"HMOX1",
"HMOX2",
"HMP19",
"HMSD",
"HMX2",
"HN1",
"HN1L",
"HNCAT21",
"HNF1A",
"HNF1A-AS1",
"HNF1B",
"HNF4A",
"HNF4G",
"HNMT",
"HNRNPA0",
"HNRNPA1",
"HNRNPA1L2",
"HNRNPA1P10",
"HNRNPA1P33",
"HNRNPA2B1",
"HNRNPA3",
"HNRNPA3P1",
"HNRNPAB",
"HNRNPC",
"HNRNPCL1",
"HNRNPCL2",
"HNRNPCL3",
"HNRNPCL4",
"HNRNPD",
"HNRNPDL",
"HNRNPF",
"HNRNPH1",
"HNRNPH2",
"HNRNPH3",
"HNRNPK",
"HNRNPL",
"HNRNPLL",
"HNRNPM",
"HNRNPR",
"HNRNPU",
"HNRNPU-AS1",
"HNRNPUL1",
"HNRNPUL2",
"HNRNPUL2-BSCL2",
"HOGA1",
"HOMER1",
"HOMER2",
"HOMER3",
"HOMEZ",
"HOOK1",
"HOOK2",
"HOOK3",
"HOPX",
"HORMAD1",
"HORMAD2",
"HORMAD2-AS1",
"HOTAIR",
"HOTAIRM1",
"HOTS",
"HOTTIP",
"HOXA-AS2",
"HOXA-AS3",
"HOXA1",
"HOXA10",
"HOXA10-AS",
"HOXA10-HOXA9",
"HOXA11",
"HOXA11-AS",
"HOXA13",
"HOXA2",
"HOXA3",
"HOXA4",
"HOXA5",
"HOXA6",
"HOXA7",
"HOXA9",
"HOXB-AS1",
"HOXB-AS3",
"HOXB1",
"HOXB13",
"HOXB2",
"HOXB3",
"HOXB4",
"HOXB5",
"HOXB6",
"HOXB7",
"HOXB8",
"HOXB9",
"HOXC-AS1",
"HOXC-AS2",
"HOXC-AS3",
"HOXC10",
"HOXC11",
"HOXC12",
"HOXC13",
"HOXC13-AS",
"HOXC4",
"HOXC5",
"HOXC6",
"HOXC8",
"HOXC9",
"HOXD1",
"HOXD10",
"HOXD11",
"HOXD12",
"HOXD13",
"HOXD3",
"HOXD8",
"HOXD9",
"HP",
"HP09025",
"HP09053",
"HP1BP3",
"HPCA",
"HPCAL1",
"HPCAL4",
"HPD",
"HPDL",
"HPGD",
"HPGDS",
"HPN",
"HPN-AS1",
"HPR",
"HPRT1",
"HPS1",
"HPS3",
"HPS4",
"HPS5",
"HPS6",
"HPSE",
"HPX",
"HR",
"HRAS",
"HRASLS",
"HRASLS2",
"HRASLS5",
"HRAT5",
"HRAT56",
"HRAT92",
"HRC",
"HRCT1",
"HRG",
"HRH1",
"HRH2",
"HRH3",
"HRH4",
"HRK",
"HRNR",
"HRSP12",
"HS1BP3",
"HS1BP3-IT1",
"HS2ST1",
"HS3ST1",
"HS3ST3A1",
"HS3ST3B1",
"HS3ST5",
"HS3ST6",
"HS6ST1",
"HS6ST2",
"HS6ST2-AS1",
"HS6ST3",
"HSBP1",
"HSBP1L1",
"HSCB",
"HSD11B1",
"HSD11B1L",
"HSD11B2",
"HSD17B1",
"HSD17B10",
"HSD17B11",
"HSD17B12",
"HSD17B13",
"HSD17B14",
"HSD17B2",
"HSD17B3",
"HSD17B4",
"HSD17B6",
"HSD17B7",
"HSD17B7P2",
"HSD17B8",
"HSD3B1",
"HSD3B2",
"HSD3B7",
"HSD3BP4",
"HSDL1",
"HSDL2",
"HSF1",
"HSF2",
"HSF2BP",
"HSF4",
"HSF5",
"HSFX1",
"HSFX2",
"HSFY1P1",
"HSH2D",
"HSP90AA1",
"HSP90AB1",
"HSP90AB4P",
"HSP90B1",
"HSP90B2P",
"HSPA12A",
"HSPA12B",
"HSPA13",
"HSPA14",
"HSPA1A",
"HSPA1B",
"HSPA1L",
"HSPA2",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA6",
"HSPA7",
"HSPA8",
"HSPA9",
"HSPB1",
"HSPB11",
"HSPB2-C11orf52",
"HSPB3",
"HSPB6",
"HSPB7",
"HSPB8",
"HSPB9",
"HSPBAP1",
"HSPBP1",
"HSPD1",
"HSPE1",
"HSPE1-MOB4",
"HSPG2",
"HSPH1",
"HTATIP2",
"HTATSF1",
"HTATSF1P2",
"HTR1A",
"HTR1D",
"HTR1E",
"HTR1F",
"HTR2A",
"HTR2B",
"HTR2C",
"HTR3A",
"HTR3E",
"HTR6",
"HTR7",
"HTR7P1",
"HTRA1",
"HTRA2",
"HTRA3",
"HTRA4",
"HTT",
"HTT-AS",
"HULC",
"HUNK",
"HUS1",
"HUS1B",
"HUWE1",
"HVCN1",
"HYAL1",
"HYAL2",
"HYAL3",
"HYAL4",
"HYALP1",
"HYDIN",
"HYDIN2",
"HYI",
"HYKK",
"HYLS1",
"HYMAI",
"HYOU1",
"HYPK",
"HYPM",
"IAH1",
"IAPP",
"IARS",
"IARS2",
"IBA57",
"IBA57-AS1",
"IBSP",
"IBTK",
"ICA1",
"ICA1L",
"ICAM1",
"ICAM2",
"ICAM3",
"ICAM4",
"ICAM5",
"ICE1",
"ICE2",
"ICK",
"ICMT",
"ICOS",
"ICOSLG",
"ICT1",
"ID1",
"ID2",
"ID2-AS1",
"ID3",
"ID4",
"IDE",
"IDH1",
"IDH1-AS1",
"IDH2",
"IDH3A",
"IDH3B",
"IDH3G",
"IDI1",
"IDI2",
"IDI2-AS1",
"IDNK",
"IDO1",
"IDO2",
"IDS",
"IDUA",
"IER2",
"IER3",
"IER3IP1",
"IER5",
"IER5L",
"IFFO1",
"IFFO2",
"IFI16",
"IFI27",
"IFI27L1",
"IFI27L2",
"IFI30",
"IFI35",
"IFI44",
"IFI44L",
"IFI6",
"IFIH1",
"IFIT1",
"IFIT1B",
"IFIT2",
"IFIT3",
"IFIT5",
"IFITM1",
"IFITM10",
"IFITM2",
"IFITM3",
"IFITM4P",
"IFITM5",
"IFNA22P",
"IFNAR1",
"IFNAR2",
"IFNB1",
"IFNGR1",
"IFNGR2",
"IFNK",
"IFNL1",
"IFNL2",
"IFNL4",
"IFNLR1",
"IFNW1",
"IFRD1",
"IFRD2",
"IFT122",
"IFT140",
"IFT172",
"IFT20",
"IFT22",
"IFT27",
"IFT43",
"IFT46",
"IFT52",
"IFT57",
"IFT74",
"IFT74-AS1",
"IFT80",
"IFT81",
"IFT88",
"IGBP1",
"IGBP1P1",
"IGDCC3",
"IGDCC4",
"IGF1",
"IGF1R",
"IGF2",
"IGF2-AS",
"IGF2BP1",
"IGF2BP2",
"IGF2BP2-AS1",
"IGF2BP3",
"IGF2R",
"IGFALS",
"IGFBP2",
"IGFBP3",
"IGFBP4",
"IGFBP5",
"IGFBP6",
"IGFBP7",
"IGFBPL1",
"IGFL1",
"IGFL2",
"IGFL3",
"IGFLR1",
"IGFN1",
"IGHMBP2",
"IGIP",
"IGLL1",
"IGLL3P",
"IGLON5",
"IGSF1",
"IGSF10",
"IGSF11",
"IGSF22",
"IGSF23",
"IGSF3",
"IGSF5",
"IGSF6",
"IGSF8",
"IGSF9",
"IGSF9B",
"IHH",
"IK",
"IKBIP",
"IKBKAP",
"IKBKB",
"IKBKE",
"IKBKG",
"IKZF1",
"IKZF2",
"IKZF3",
"IKZF4",
"IKZF5",
"IL10",
"IL10RA",
"IL10RB",
"IL10RB-AS1",
"IL11",
"IL11RA",
"IL12A",
"IL12A-AS1",
"IL12B",
"IL12RB1",
"IL12RB2",
"IL13",
"IL13RA1",
"IL13RA2",
"IL15",
"IL15RA",
"IL16",
"IL17A",
"IL17B",
"IL17C",
"IL17D",
"IL17F",
"IL17RA",
"IL17RB",
"IL17RC",
"IL17RD",
"IL17RE",
"IL17REL",
"IL18",
"IL18BP",
"IL18R1",
"IL19",
"IL1A",
"IL1B",
"IL1F10",
"IL1R1",
"IL1R2",
"IL1RAP",
"IL1RAPL2",
"IL1RL1",
"IL1RL2",
"IL1RN",
"IL2",
"IL20",
"IL20RA",
"IL20RB",
"IL21",
"IL21-AS1",
"IL21R",
"IL21R-AS1",
"IL22RA1",
"IL22RA2",
"IL23A",
"IL24",
"IL27",
"IL27RA",
"IL2RB",
"IL2RG",
"IL31",
"IL31RA",
"IL32",
"IL33",
"IL34",
"IL36G",
"IL36RN",
"IL37",
"IL3RA",
"IL4I1",
"IL4R",
"IL5RA",
"IL6",
"IL6R",
"IL6ST",
"IL7",
"IL7R",
"IL9R",
"ILDR1",
"ILDR2",
"ILF2",
"ILF3",
"ILF3-AS1",
"ILK",
"ILKAP",
"ILVBL",
"IMMP1L",
"IMMP2L",
"IMMT",
"IMP3",
"IMP4",
"IMPA1",
"IMPA2",
"IMPACT",
"IMPAD1",
"IMPDH1",
"IMPDH2",
"IMPG1",
"IMPG2",
"INA",
"INADL",
"INAFM1",
"INAFM2",
"INCA1",
"INCENP",
"INE1",
"INE2",
"INF2",
"ING1",
"ING2",
"ING3",
"ING4",
"ING5",
"INGX",
"INHA",
"INHBA",
"INHBA-AS1",
"INHBB",
"INHBC",
"INHBE",
"INIP",
"INMT",
"INMT-FAM188B",
"INO80",
"INO80B",
"INO80B-WBP1",
"INO80C",
"INO80D",
"INO80E",
"INPP1",
"INPP4A",
"INPP4B",
"INPP5A",
"INPP5B",
"INPP5D",
"INPP5E",
"INPP5F",
"INPP5J",
"INPP5K",
"INPPL1",
"INS",
"INS-IGF2",
"INSC",
"INSIG1",
"INSIG2",
"INSL3",
"INSL4",
"INSL5",
"INSL6",
"INSM1",
"INSM2",
"INSR",
"INSRR",
"INTS1",
"INTS10",
"INTS12",
"INTS2",
"INTS3",
"INTS4",
"INTS4P2",
"INTS5",
"INTS6",
"INTS6-AS1",
"INTS7",
"INTS8",
"INTS9",
"INTU",
"INVS",
"IP6K1",
"IP6K2",
"IP6K3",
"IPCEF1",
"IPMK",
"IPO11",
"IPO11-LRRC70",
"IPO13",
"IPO4",
"IPO5",
"IPO5P1",
"IPO7",
"IPO8",
"IPO9",
"IPO9-AS1",
"IPP",
"IPPK",
"IPW",
"IQCA1",
"IQCA1L",
"IQCB1",
"IQCC",
"IQCD",
"IQCE",
"IQCF1",
"IQCG",
"IQCH",
"IQCH-AS1",
"IQCJ",
"IQCJ-SCHIP1",
"IQCJ-SCHIP1-AS1",
"IQCK",
"IQGAP1",
"IQGAP2",
"IQGAP3",
"IQSEC1",
"IQSEC2",
"IQSEC3",
"IQUB",
"IRAIN",
"IRAK1",
"IRAK1BP1",
"IRAK2",
"IRAK3",
"IRAK4",
"IREB2",
"IRF1",
"IRF2",
"IRF2BP1",
"IRF2BP2",
"IRF2BPL",
"IRF3",
"IRF4",
"IRF5",
"IRF6",
"IRF7",
"IRF8",
"IRF9",
"IRG1",
"IRGC",
"IRGM",
"IRGQ",
"IRS1",
"IRS2",
"IRS4",
"IRX1",
"IRX2",
"IRX3",
"IRX4",
"IRX5",
"IRX6",
"ISCA1",
"ISCA2",
"ISCU",
"ISG15",
"ISG20",
"ISG20L2",
"ISL1",
"ISL2",
"ISLR",
"ISLR2",
"ISM1",
"ISM1-AS1",
"ISM2",
"ISOC1",
"ISOC2",
"ISPD",
"ISPD-AS1",
"IST1",
"ISX",
"ISY1",
"ISY1-RAB43",
"ISYNA1",
"ITCH",
"ITFG1",
"ITFG1-AS1",
"ITFG2",
"ITFG3",
"ITGA1",
"ITGA10",
"ITGA11",
"ITGA2",
"ITGA2B",
"ITGA3",
"ITGA4",
"ITGA5",
"ITGA6",
"ITGA7",
"ITGA8",
"ITGA9",
"ITGA9-AS1",
"ITGAD",
"ITGAE",
"ITGAL",
"ITGAM",
"ITGAV",
"ITGAX",
"ITGB1",
"ITGB1BP1",
"ITGB1BP2",
"ITGB2",
"ITGB2-AS1",
"ITGB3",
"ITGB3BP",
"ITGB4",
"ITGB5",
"ITGB6",
"ITGB7",
"ITGB8",
"ITGBL1",
"ITIH2",
"ITIH3",
"ITIH4",
"ITIH5",
"ITIH6",
"ITLN2",
"ITM2A",
"ITM2B",
"ITM2C",
"ITPA",
"ITPK1",
"ITPK1-AS1",
"ITPKA",
"ITPKB",
"ITPKB-IT1",
"ITPKC",
"ITPR1",
"ITPR1-AS1",
"ITPR2",
"ITPR3",
"ITPRIP",
"ITPRIPL1",
"ITPRIPL2",
"ITSN1",
"ITSN2",
"IVD",
"IVL",
"IVNS1ABP",
"IWS1",
"IYD",
"IZUMO1",
"IZUMO1R",
"IZUMO4",
"JADE1",
"JADE2",
"JADE3",
"JAG1",
"JAG2",
"JAGN1",
"JAK1",
"JAK2",
"JAK3",
"JAKMIP1",
"JAKMIP2",
"JAKMIP2-AS1",
"JAKMIP3",
"JAM2",
"JAM3",
"JARID2",
"JARID2-AS1",
"JAZF1",
"JAZF1-AS1",
"JCHAIN",
"JDP2",
"JHDM1D-AS1",
"JKAMP",
"JMJD1C",
"JMJD1C-AS1",
"JMJD4",
"JMJD6",
"JMJD7",
"JMJD7-PLA2G4B",
"JMJD8",
"JMY",
"JOSD1",
"JOSD2",
"JPH1",
"JPH2",
"JPH3",
"JPH4",
"JPX",
"JRK",
"JRKL",
"JSRP1",
"JTB",
"JUN",
"JUNB",
"JUND",
"JUP",
"KAAG1",
"KALRN",
"KANK1",
"KANK2",
"KANK3",
"KANK4",
"KANSL1",
"KANSL1-AS1",
"KANSL1L",
"KANSL2",
"KANSL3",
"KANTR",
"KARS",
"KAT2A",
"KAT2B",
"KAT5",
"KAT6A",
"KAT6B",
"KAT7",
"KAT8",
"KATNA1",
"KATNAL1",
"KATNAL2",
"KATNB1",
"KATNBL1",
"KATNBL1P6",
"KAZALD1",
"KAZN",
"KBTBD11",
"KBTBD11-OT1",
"KBTBD12",
"KBTBD13",
"KBTBD2",
"KBTBD3",
"KBTBD4",
"KBTBD6",
"KBTBD7",
"KBTBD8",
"KCCAT198",
"KCCAT211",
"KCCAT333",
"KCMF1",
"KCNA1",
"KCNA2",
"KCNA4",
"KCNA7",
"KCNAB1",
"KCNAB2",
"KCNAB3",
"KCNB1",
"KCNB2",
"KCNC1",
"KCNC3",
"KCNC4",
"KCNC4-AS1",
"KCND1",
"KCND2",
"KCND3",
"KCND3-IT1",
"KCNE1",
"KCNE2",
"KCNE3",
"KCNE4",
"KCNE5",
"KCNF1",
"KCNG1",
"KCNG2",
"KCNG3",
"KCNH1",
"KCNH2",
"KCNH3",
"KCNH4",
"KCNH5",
"KCNH6",
"KCNH7",
"KCNH8",
"KCNIP1",
"KCNIP2",
"KCNIP2-AS1",
"KCNIP3",
"KCNIP4",
"KCNIP4-IT1",
"KCNJ1",
"KCNJ10",
"KCNJ11",
"KCNJ12",
"KCNJ13",
"KCNJ14",
"KCNJ15",
"KCNJ16",
"KCNJ18",
"KCNJ2",
"KCNJ2-AS1",
"KCNJ3",
"KCNJ4",
"KCNJ5",
"KCNJ6",
"KCNJ8",
"KCNJ9",
"KCNK1",
"KCNK10",
"KCNK12",
"KCNK13",
"KCNK15",
"KCNK17",
"KCNK2",
"KCNK3",
"KCNK4",
"KCNK5",
"KCNK6",
"KCNK7",
"KCNK9",
"KCNMA1",
"KCNMA1-AS3",
"KCNMB1",
"KCNMB2",
"KCNMB2-AS1",
"KCNMB3",
"KCNMB4",
"KCNN1",
"KCNN2",
"KCNN3",
"KCNN4",
"KCNQ1",
"KCNQ1OT1",
"KCNQ2",
"KCNQ3",
"KCNQ4",
"KCNQ5",
"KCNQ5-AS1",
"KCNQ5-IT1",
"KCNRG",
"KCNS1",
"KCNS2",
"KCNS3",
"KCNT1",
"KCNT2",
"KCNV1",
"KCNV2",
"KCP",
"KCTD1",
"KCTD10",
"KCTD11",
"KCTD12",
"KCTD13",
"KCTD14",
"KCTD15",
"KCTD16",
"KCTD17",
"KCTD18",
"KCTD19",
"KCTD2",
"KCTD20",
"KCTD21",
"KCTD21-AS1",
"KCTD3",
"KCTD4",
"KCTD5",
"KCTD6",
"KCTD7",
"KCTD8",
"KCTD9",
"KDELC1",
"KDELC2",
"KDELR1",
"KDELR2",
"KDELR3",
"KDF1",
"KDM1A",
"KDM1B",
"KDM2A",
"KDM2B",
"KDM3A",
"KDM3B",
"KDM4A",
"KDM4A-AS1",
"KDM4B",
"KDM4C",
"KDM4D",
"KDM5A",
"KDM5B",
"KDM5C",
"KDM6A",
"KDM6B",
"KDM7A",
"KDM8",
"KDR",
"KDSR",
"KEAP1",
"KEL",
"KGFLP1",
"KGFLP2",
"KHDC1",
"KHDC1L",
"KHDC3L",
"KHDRBS1",
"KHDRBS3",
"KHK",
"KHNYN",
"KHSRP",
"KIAA0020",
"KIAA0040",
"KIAA0087",
"KIAA0100",
"KIAA0101",
"KIAA0125",
"KIAA0141",
"KIAA0195",
"KIAA0196",
"KIAA0226",
"KIAA0226L",
"KIAA0232",
"KIAA0319",
"KIAA0319L",
"KIAA0355",
"KIAA0368",
"KIAA0391",
"KIAA0408",
"KIAA0430",
"KIAA0513",
"KIAA0556",
"KIAA0586",
"KIAA0753",
"KIAA0754",
"KIAA0825",
"KIAA0895",
"KIAA0895L",
"KIAA0907",
"KIAA0922",
"KIAA0930",
"KIAA1024",
"KIAA1024L",
"KIAA1033",
"KIAA1107",
"KIAA1109",
"KIAA1143",
"KIAA1147",
"KIAA1161",
"KIAA1191",
"KIAA1210",
"KIAA1211",
"KIAA1211L",
"KIAA1217",
"KIAA1257",
"KIAA1279",
"KIAA1324",
"KIAA1324L",
"KIAA1328",
"KIAA1407",
"KIAA1429",
"KIAA1456",
"KIAA1462",
"KIAA1467",
"KIAA1468",
"KIAA1522",
"KIAA1524",
"KIAA1549",
"KIAA1549L",
"KIAA1551",
"KIAA1586",
"KIAA1614",
"KIAA1644",
"KIAA1656",
"KIAA1671",
"KIAA1683",
"KIAA1715",
"KIAA1755",
"KIAA1804",
"KIAA1841",
"KIAA1875",
"KIAA1919",
"KIAA1958",
"KIAA2012",
"KIAA2013",
"KIAA2018",
"KIAA2022",
"KIAA2026",
"KIDINS220",
"KIF11",
"KIF12",
"KIF13A",
"KIF13B",
"KIF14",
"KIF15",
"KIF16B",
"KIF17",
"KIF18A",
"KIF18B",
"KIF1A",
"KIF1B",
"KIF1C",
"KIF20A",
"KIF20B",
"KIF21A",
"KIF21B",
"KIF22",
"KIF23",
"KIF24",
"KIF26A",
"KIF26B",
"KIF27",
"KIF2A",
"KIF2C",
"KIF3A",
"KIF3B",
"KIF3C",
"KIF4A",
"KIF4B",
"KIF5A",
"KIF5B",
"KIF5C",
"KIF6",
"KIF7",
"KIF9",
"KIF9-AS1",
"KIFAP3",
"KIFC1",
"KIFC2",
"KIFC3",
"KIN",
"KIR2DL1",
"KIR2DL2",
"KIR3DX1",
"KIRREL",
"KIRREL2",
"KIRREL3",
"KISS1",
"KIT",
"KITLG",
"KIZ",
"KIZ-AS1",
"KL",
"KLB",
"KLC1",
"KLC2",
"KLC3",
"KLC4",
"KLF1",
"KLF10",
"KLF11",
"KLF12",
"KLF13",
"KLF14",
"KLF15",
"KLF16",
"KLF17",
"KLF2",
"KLF3",
"KLF3-AS1",
"KLF4",
"KLF5",
"KLF6",
"KLF7",
"KLF8",
"KLF9",
"KLHDC1",
"KLHDC10",
"KLHDC2",
"KLHDC3",
"KLHDC4",
"KLHDC7A",
"KLHDC7B",
"KLHDC8A",
"KLHDC8B",
"KLHDC9",
"KLHL1",
"KLHL10",
"KLHL11",
"KLHL12",
"KLHL13",
"KLHL14",
"KLHL15",
"KLHL17",
"KLHL18",
"KLHL2",
"KLHL20",
"KLHL21",
"KLHL22",
"KLHL23",
"KLHL24",
"KLHL25",
"KLHL26",
"KLHL28",
"KLHL29",
"KLHL3",
"KLHL30",
"KLHL31",
"KLHL32",
"KLHL34",
"KLHL35",
"KLHL36",
"KLHL38",
"KLHL41",
"KLHL42",
"KLHL5",
"KLHL6",
"KLHL6-AS1",
"KLHL7",
"KLHL7-AS1",
"KLHL8",
"KLHL9",
"KLK1",
"KLK10",
"KLK11",
"KLK13",
"KLK14",
"KLK5",
"KLK6",
"KLK7",
"KLK8",
"KLKB1",
"KLLN",
"KLRAP1",
"KLRC1",
"KLRC2",
"KLRC3",
"KLRD1",
"KLRG1",
"KLRG2",
"KLRK1",
"KMO",
"KMT2A",
"KMT2B",
"KMT2C",
"KMT2D",
"KMT2E",
"KMT2E-AS1",
"KNCN",
"KNDC1",
"KNG1",
"KNOP1",
"KNSTRN",
"KNTC1",
"KPNA1",
"KPNA2",
"KPNA3",
"KPNA4",
"KPNA5",
"KPNA6",
"KPNA7",
"KPNB1",
"KPTN",
"KRAS",
"KRBA1",
"KRBA2",
"KRBOX1",
"KRBOX4",
"KRCC1",
"KREMEN1",
"KREMEN2",
"KRI1",
"KRIT1",
"KRR1",
"KRT1",
"KRT10",
"KRT12",
"KRT13",
"KRT14",
"KRT15",
"KRT16",
"KRT16P1",
"KRT16P2",
"KRT16P3",
"KRT17",
"KRT17P5",
"KRT18",
"KRT18P55",
"KRT19",
"KRT2",
"KRT20",
"KRT222",
"KRT23",
"KRT24",
"KRT3",
"KRT32",
"KRT33A",
"KRT33B",
"KRT34",
"KRT37",
"KRT38",
"KRT39",
"KRT4",
"KRT40",
"KRT42P",
"KRT5",
"KRT6A",
"KRT6B",
"KRT6C",
"KRT7",
"KRT71",
"KRT72",
"KRT74",
"KRT75",
"KRT76",
"KRT77",
"KRT78",
"KRT79",
"KRT8",
"KRT80",
"KRT81",
"KRT82",
"KRT83",
"KRT84",
"KRT85",
"KRT86",
"KRT8P41",
"KRT9",
"KRTAP1-5",
"KRTAP12-1",
"KRTAP13-2",
"KRTAP2-1",
"KRTAP2-3",
"KRTAP3-1",
"KRTAP3-2",
"KRTAP4-1",
"KRTAP5-1",
"KRTAP5-10",
"KRTAP5-11",
"KRTAP5-2",
"KRTAP5-3",
"KRTAP5-4",
"KRTAP5-7",
"KRTAP5-8",
"KRTAP5-9",
"KRTAP5-AS1",
"KRTAP9-1",
"KRTCAP2",
"KRTCAP3",
"KRTDAP",
"KSR1",
"KSR2",
"KTI12",
"KTN1",
"KTN1-AS1",
"KU-MEL-3",
"KXD1",
"KY",
"KYNU",
"L1CAM",
"L1TD1",
"L2HGDH",
"L3HYPDH",
"L3MBTL1",
"L3MBTL2",
"L3MBTL3",
"L3MBTL4",
"LACAT8",
"LACC1",
"LACE1",
"LACTB",
"LACTB2",
"LACTB2-AS1",
"LAD1",
"LAG3",
"LAGE3",
"LAIR1",
"LALBA",
"LAMA1",
"LAMA2",
"LAMA3",
"LAMA4",
"LAMA5",
"LAMA5-AS1",
"LAMB1",
"LAMB2",
"LAMB2P1",
"LAMB3",
"LAMB4",
"LAMC1",
"LAMC2",
"LAMC3",
"LAMP1",
"LAMP2",
"LAMP3",
"LAMP5",
"LAMP5-AS1",
"LAMTOR1",
"LAMTOR2",
"LAMTOR3",
"LAMTOR4",
"LAMTOR5",
"LAMTOR5-AS1",
"LANCL1",
"LANCL1-AS1",
"LANCL2",
"LANCL3",
"LAP3",
"LAPTM4A",
"LAPTM4B",
"LAPTM5",
"LARGE",
"LARGE-AS1",
"LARP1",
"LARP1B",
"LARP4",
"LARP4B",
"LARP6",
"LARP7",
"LARS",
"LARS2",
"LARS2-AS1",
"LAS1L",
"LASP1",
"LAT",
"LAT2",
"LATS1",
"LATS2",
"LAX1",
"LAYN",
"LBH",
"LBHD1",
"LBP",
"LBR",
"LBX1-AS1",
"LBX2",
"LBX2-AS1",
"LCA10",
"LCA5",
"LCA5L",
"LCAL1",
"LCAT",
"LCE1B",
"LCE1C",
"LCE1E",
"LCK",
"LCLAT1",
"LCMT1",
"LCMT1-AS1",
"LCMT1-AS2",
"LCMT2",
"LCN10",
"LCN2",
"LCN6",
"LCNL1",
"LCOR",
"LCORL",
"LCP1",
"LCP2",
"LCT",
"LCTL",
"LDAH",
"LDB1",
"LDB2",
"LDB3",
"LDHA",
"LDHAL6A",
"LDHAL6B",
"LDHB",
"LDHC",
"LDHD",
"LDLR",
"LDLRAD1",
"LDLRAD2",
"LDLRAD3",
"LDLRAD4",
"LDLRAD4-AS1",
"LDLRAP1",
"LDOC1",
"LDOC1L",
"LEAP2",
"LECT1",
"LEF1",
"LEF1-AS1",
"LEFTY1",
"LEFTY2",
"LEKR1",
"LEMD1",
"LEMD1-AS1",
"LEMD2",
"LEMD3",
"LENEP",
"LENG1",
"LENG8",
"LENG8-AS1",
"LENG9",
"LEO1",
"LEP",
"LEPR",
"LEPROT",
"LEPROTL1",
"LETM1",
"LETM2",
"LETMD1",
"LFNG",
"LGALS1",
"LGALS12",
"LGALS13",
"LGALS2",
"LGALS3",
"LGALS3BP",
"LGALS4",
"LGALS7",
"LGALS7B",
"LGALS8",
"LGALS8-AS1",
"LGALS9",
"LGALSL",
"LGI1",
"LGI2",
"LGI3",
"LGI4",
"LGMN",
"LGR4",
"LGR5",
"LGR6",
"LGSN",
"LHB",
"LHCGR",
"LHFP",
"LHFPL2",
"LHFPL3",
"LHFPL3-AS1",
"LHFPL3-AS2",
"LHFPL4",
"LHFPL5",
"LHPP",
"LHX1",
"LHX2",
"LHX3",
"LHX4",
"LHX4-AS1",
"LHX6",
"LHX8",
"LHX9",
"LIAS",
"LIF",
"LIFR",
"LIFR-AS1",
"LIG1",
"LIG3",
"LIG4",
"LILRA2",
"LILRA4",
"LILRA6",
"LILRB3",
"LILRB5",
"LIM2",
"LIMA1",
"LIMCH1",
"LIMD1",
"LIMD1-AS1",
"LIMD2",
"LIME1",
"LIMK1",
"LIMK2",
"LIMS1",
"LIMS2",
"LIMS3",
"LIMS3-LOC440895",
"LIMS3L",
"LIN28A",
"LIN28B",
"LIN37",
"LIN52",
"LIN54",
"LIN7A",
"LIN7B",
"LIN7C",
"LIN9",
"LINC-PINT",
"LINC-ROR",
"LINC00051",
"LINC00052",
"LINC00092",
"LINC00094",
"LINC00102",
"LINC00106",
"LINC00111",
"LINC00112",
"LINC00115",
"LINC00116",
"LINC00152",
"LINC00158",
"LINC00160",
"LINC00162",
"LINC00163",
"LINC00167",
"LINC00173",
"LINC00174",
"LINC00176",
"LINC00184",
"LINC00189",
"LINC00200",
"LINC00202-1",
"LINC00202-2",
"LINC00208",
"LINC00211",
"LINC00222",
"LINC00235",
"LINC00239",
"LINC00240",
"LINC00242",
"LINC00243",
"LINC00244",
"LINC00260",
"LINC00261",
"LINC00264",
"LINC00265",
"LINC00266-1",
"LINC00266-3",
"LINC00271",
"LINC00272",
"LINC00276",
"LINC00282",
"LINC00284",
"LINC00293",
"LINC00294",
"LINC00299",
"LINC00301",
"LINC00304",
"LINC00309",
"LINC00310",
"LINC00311",
"LINC00312",
"LINC00313",
"LINC00314",
"LINC00316",
"LINC00319",
"LINC00322",
"LINC00323",
"LINC00324",
"LINC00326",
"LINC00330",
"LINC00332",
"LINC00333",
"LINC00336",
"LINC00337",
"LINC00339",
"LINC00341",
"LINC00342",
"LINC00346",
"LINC00365",
"LINC00371",
"LINC00377",
"LINC00382",
"LINC00398",
"LINC00400",
"LINC00410",
"LINC00412",
"LINC00417",
"LINC00423",
"LINC00426",
"LINC00428",
"LINC00431",
"LINC00437",
"LINC00441",
"LINC00442",
"LINC00452",
"LINC00456",
"LINC00458",
"LINC00460",
"LINC00461",
"LINC00462",
"LINC00463",
"LINC00466",
"LINC00467",
"LINC00470",
"LINC00471",
"LINC00472",
"LINC00473",
"LINC00475",
"LINC00476",
"LINC00479",
"LINC00482",
"LINC00485",
"LINC00486",
"LINC00491",
"LINC00493",
"LINC00494",
"LINC00501",
"LINC00504",
"LINC00506",
"LINC00507",
"LINC00511",
"LINC00514",
"LINC00515",
"LINC00518",
"LINC00520",
"LINC00521",
"LINC00525",
"LINC00526",
"LINC00528",
"LINC00534",
"LINC00535",
"LINC00536",
"LINC00539",
"LINC00540",
"LINC00548",
"LINC00552",
"LINC00554",
"LINC00557",
"LINC00558",
"LINC00562",
"LINC00563",
"LINC00564",
"LINC00565",
"LINC00570",
"LINC00571",
"LINC00572",
"LINC00574",
"LINC00575",
"LINC00578",
"LINC00589",
"LINC00592",
"LINC00597",
"LINC00598",
"LINC00601",
"LINC00602",
"LINC00605",
"LINC00607",
"LINC00608",
"LINC00612",
"LINC00616",
"LINC00618",
"LINC00620",
"LINC00622",
"LINC00623",
"LINC00624",
"LINC00626",
"LINC00628",
"LINC00629",
"LINC00630",
"LINC00632",
"LINC00633",
"LINC00634",
"LINC00635",
"LINC00636",
"LINC00637",
"LINC00638",
"LINC00639",
"LINC00640",
"LINC00641",
"LINC00643",
"LINC00645",
"LINC00648",
"LINC00649",
"LINC00652",
"LINC00654",
"LINC00656",
"LINC00657",
"LINC00659",
"LINC00661",
"LINC00662",
"LINC00663",
"LINC00664",
"LINC00665",
"LINC00667",
"LINC00668",
"LINC00669",
"LINC00672",
"LINC00673",
"LINC00674",
"LINC00675",
"LINC00678",
"LINC00683",
"LINC00685",
"LINC00687",
"LINC00689",
"LINC00691",
"LINC00693",
"LINC00696",
"LINC00700",
"LINC00701",
"LINC00702",
"LINC00703",
"LINC00704",
"LINC00705",
"LINC00706",
"LINC00707",
"LINC00708",
"LINC00824",
"LINC00836",
"LINC00839",
"LINC00840",
"LINC00842",
"LINC00847",
"LINC00852",
"LINC00853",
"LINC00854",
"LINC00857",
"LINC00858",
"LINC00862",
"LINC00865",
"LINC00867",
"LINC00869",
"LINC00870",
"LINC00880",
"LINC00881",
"LINC00882",
"LINC00883",
"LINC00884",
"LINC00885",
"LINC00886",
"LINC00887",
"LINC00888",
"LINC00889",
"LINC00891",
"LINC00892",
"LINC00893",
"LINC00894",
"LINC00896",
"LINC00898",
"LINC00899",
"LINC00907",
"LINC00908",
"LINC00909",
"LINC00910",
"LINC00920",
"LINC00921",
"LINC00922",
"LINC00923",
"LINC00925",
"LINC00926",
"LINC00928",
"LINC00930",
"LINC00933",
"LINC00935",
"LINC00936",
"LINC00937",
"LINC00938",
"LINC00940",
"LINC00941",
"LINC00942",
"LINC00943",
"LINC00944",
"LINC00950",
"LINC00954",
"LINC00955",
"LINC00957",
"LINC00958",
"LINC00959",
"LINC00960",
"LINC00961",
"LINC00963",
"LINC00964",
"LINC00965",
"LINC00967",
"LINC00968",
"LINC00969",
"LINC00970",
"LINC00971",
"LINC00974",
"LINC00982",
"LINC00987",
"LINC00992",
"LINC00994",
"LINC00996",
"LINC00997",
"LINC00998",
"LINC00999",
"LINC01000",
"LINC01001",
"LINC01002",
"LINC01003",
"LINC01004",
"LINC01006",
"LINC01007",
"LINC01011",
"LINC01012",
"LINC01013",
"LINC01015",
"LINC01016",
"LINC01018",
"LINC01021",
"LINC01023",
"LINC01024",
"LINC01030",
"LINC01031",
"LINC01038",
"LINC01039",
"LINC01046",
"LINC01057",
"LINC01058",
"LINC01061",
"LINC01063",
"LINC01068",
"LINC01085",
"LINC01087",
"LINC01088",
"LINC01089",
"LINC01091",
"LINC01093",
"LINC01094",
"LINC01096",
"LINC01097",
"LINC01098",
"LINC01099",
"LINC01101",
"LINC01106",
"LINC01107",
"LINC01108",
"LINC01111",
"LINC01115",
"LINC01116",
"LINC01117",
"LINC01118",
"LINC01119",
"LINC01121",
"LINC01123",
"LINC01124",
"LINC01125",
"LINC01126",
"LINC01127",
"LINC01128",
"LINC01132",
"LINC01133",
"LINC01134",
"LINC01135",
"LINC01136",
"LINC01137",
"LINC01138",
"LINC01139",
"LINC01140",
"LINC01143",
"LINC01144",
"LINC01146",
"LINC01152",
"LINC01160",
"LINC01164",
"LINC01166",
"LINC01167",
"LINC01168",
"LINC01169",
"LINC01176",
"LINC01179",
"LINC01180",
"LINC01182",
"LINC01184",
"LINC01185",
"LINC01186",
"LINC01189",
"LINC01191",
"LINC01193",
"LINC01198",
"LINC01204",
"LINC01207",
"LINC01208",
"LINC01209",
"LINC01212",
"LINC01213",
"LINC01214",
"LINC01215",
"LINC01219",
"LINC01220",
"LINC01224",
"LINC01225",
"LINC01226",
"LINC01227",
"LINC01229",
"LINC01232",
"LINC01234",
"LINC01237",
"LINC01239",
"LINC01247",
"LINC01248",
"LINC01250",
"LINC01251",
"LINC01252",
"LINC01257",
"LINC01260",
"LINC01264",
"LINC01267",
"LINC01268",
"LINC01269",
"LINC01270",
"LINC01271",
"LINC01272",
"LINC01273",
"LINC01277",
"LINC01278",
"LINC01279",
"LINC01280",
"LINC01285",
"LINC01291",
"LINC01296",
"LINC01298",
"LINC01300",
"LINC01301",
"LINC01305",
"LINC01310",
"LINC01311",
"LINC01314",
"LINC01315",
"LINC01317",
"LINC01333",
"LINC01336",
"LINC01337",
"LINC01338",
"LINC01340",
"LINC01341",
"LINC01342",
"LINC01347",
"LINC01348",
"LINC01351",
"LINC01352",
"LINC01353",
"LINC01354",
"LINC01355",
"LINC01356",
"LINC01359",
"LINC01360",
"LINC01363",
"LINC01364",
"LINC01366",
"LINC01372",
"LINC01375",
"LINC01389",
"LINC01391",
"LINC01393",
"LINC01395",
"LINC01397",
"LINC01399",
"LINC01405",
"LINC01410",
"LINC01411",
"LINC01419",
"LINC01420",
"LINC01422",
"LINC01424",
"LINC01425",
"LINC01426",
"LINC01429",
"LINC01431",
"LINC01433",
"LINC01436",
"LINC01441",
"LINC01443",
"LINC01444",
"LINC01447",
"LINC01449",
"LINC01450",
"LINC01461",
"LINC01465",
"LINC01468",
"LINC01473",
"LINC01477",
"LINC01481",
"LINC01482",
"LINC01484",
"LINC01485",
"LINC01488",
"LINC01492",
"LINC01494",
"LINC01501",
"LINC01503",
"LINC01504",
"LINC01508",
"LINC01510",
"LINC01511",
"LINC01512",
"LINC01515",
"LINC01518",
"LINC01521",
"LINC01522",
"LINC01523",
"LINC01524",
"LINC01526",
"LINC01529",
"LINC01530",
"LINC01534",
"LINC01535",
"LINC01537",
"LINC01538",
"LINC01543",
"LINC01544",
"LINC01545",
"LINC01547",
"LINC01550",
"LINC01551",
"LINC01552",
"LINC01553",
"LINC01554",
"LINC01555",
"LINC01556",
"LINC01559",
"LINC01560",
"LINC01561",
"LINC01563",
"LINC01564",
"LINC01565",
"LINC01567",
"LINC01569",
"LINC01572",
"LINC01573",
"LINC01578",
"LINC01581",
"LINC01583",
"LINC01585",
"LINC01586",
"LINC01587",
"LINC01588",
"LINC01589",
"LINC01590",
"LINC01599",
"LINC01600",
"LINC01602",
"LINC01603",
"LINC01604",
"LINC01605",
"LINC01607",
"LINC01611",
"LINC01612",
"LINCMD1",
"LINCR-0001",
"LINGO1",
"LINGO1-AS1",
"LINGO2",
"LINGO3",
"LINGO4",
"LINS",
"LIPA",
"LIPC",
"LIPE",
"LIPE-AS1",
"LIPF",
"LIPG",
"LIPH",
"LIPI",
"LIPK",
"LIPT1",
"LIPT2",
"LITAF",
"LIX1",
"LIX1L",
"LKAAEAR1",
"LLGL1",
"LLGL2",
"LLPH",
"LLPH-AS1",
"LMAN1",
"LMAN1L",
"LMAN2",
"LMAN2L",
"LMBR1",
"LMBR1L",
"LMBRD1",
"LMBRD2",
"LMCD1",
"LMCD1-AS1",
"LMF1",
"LMF1-AS1",
"LMF2",
"LMLN",
"LMNA",
"LMNB1",
"LMNB2",
"LMNTD1",
"LMNTD2",
"LMO1",
"LMO2",
"LMO3",
"LMO4",
"LMO7",
"LMO7-AS1",
"LMO7DN",
"LMOD1",
"LMOD2",
"LMTK2",
"LMTK3",
"LMX1B",
"LNP1",
"LNPEP",
"LNX1",
"LNX1-AS1",
"LNX1-AS2",
"LNX2",
"LOC100049716",
"LOC100101148",
"LOC100101478",
"LOC100126784",
"LOC100128006",
"LOC100128076",
"LOC100128164",
"LOC100128176",
"LOC100128233",
"LOC100128239",
"LOC100128288",
"LOC100128361",
"LOC100128398",
"LOC100128494",
"LOC100128531",
"LOC100128568",
"LOC100128573",
"LOC100128593",
"LOC100128770",
"LOC100128885",
"LOC100129027",
"LOC100129034",
"LOC100129046",
"LOC100129055",
"LOC100129083",
"LOC100129138",
"LOC100129148",
"LOC100129203",
"LOC100129307",
"LOC100129434",
"LOC100129461",
"LOC100129518",
"LOC100129520",
"LOC100129534",
"LOC100129550",
"LOC100129603",
"LOC100129617",
"LOC100129620",
"LOC100129636",
"LOC100129697",
"LOC100129917",
"LOC100129924",
"LOC100129931",
"LOC100129940",
"LOC100129973",
"LOC100130075",
"LOC100130093",
"LOC100130238",
"LOC100130264",
"LOC100130298",
"LOC100130331",
"LOC100130357",
"LOC100130370",
"LOC100130417",
"LOC100130451",
"LOC100130452",
"LOC100130476",
"LOC100130673",
"LOC100130691",
"LOC100130705",
"LOC100130744",
"LOC100130872",
"LOC100130880",
"LOC100130899",
"LOC100130950",
"LOC100130987",
"LOC100130992",
"LOC100131107",
"LOC100131257",
"LOC100131289",
"LOC100131315",
"LOC100131347",
"LOC100131496",
"LOC100131564",
"LOC100131626",
"LOC100131655",
"LOC100132057",
"LOC100132077",
"LOC100132111",
"LOC100132215",
"LOC100132287",
"LOC100132356",
"LOC100132741",
"LOC100132781",
"LOC100132831",
"LOC100133050",
"LOC100133077",
"LOC100133091",
"LOC100133286",
"LOC100133315",
"LOC100133331",
"LOC100133669",
"LOC100133920",
"LOC100133985",
"LOC100134317",
"LOC100134368",
"LOC100134868",
"LOC100144595",
"LOC100147773",
"LOC100190986",
"LOC100192426",
"LOC100233156",
"LOC100240734",
"LOC100240735",
"LOC100268168",
"LOC100270746",
"LOC100270804",
"LOC100271832",
"LOC100272216",
"LOC100272217",
"LOC100286922",
"LOC100287010",
"LOC100287015",
"LOC100287036",
"LOC100287042",
"LOC100287072",
"LOC100287225",
"LOC100287632",
"LOC100287792",
"LOC100287846",
"LOC100287944",
"LOC100288069",
"LOC100288123",
"LOC100288152",
"LOC100288162",
"LOC100288181",
"LOC100288254",
"LOC100288637",
"LOC100288748",
"LOC100288778",
"LOC100288798",
"LOC100288842",
"LOC100288846",
"LOC100288866",
"LOC100288911",
"LOC100288966",
"LOC100289230",
"LOC100289333",
"LOC100289361",
"LOC100289473",
"LOC100289495",
"LOC100289511",
"LOC100289561",
"LOC100289580",
"LOC100289650",
"LOC100289656",
"LOC100294145",
"LOC100294362",
"LOC100303749",
"LOC100335030",
"LOC100379224",
"LOC100419583",
"LOC100420587",
"LOC100422556",
"LOC100499194",
"LOC100499484",
"LOC100499484-C9ORF174",
"LOC100499489",
"LOC100505478",
"LOC100505530",
"LOC100505549",
"LOC100505625",
"LOC100505658",
"LOC100505666",
"LOC100505715",
"LOC100505716",
"LOC100505736",
"LOC100505782",
"LOC100505795",
"LOC100505817",
"LOC100505912",
"LOC100505915",
"LOC100505918",
"LOC100505920",
"LOC100505921",
"LOC100505938",
"LOC100505942",
"LOC100505978",
"LOC100505984",
"LOC100506022",
"LOC100506023",
"LOC100506071",
"LOC100506076",
"LOC100506082",
"LOC100506083",
"LOC100506085",
"LOC100506100",
"LOC100506123",
"LOC100506124",
"LOC100506125",
"LOC100506127",
"LOC100506136",
"LOC100506142",
"LOC100506175",
"LOC100506178",
"LOC100506188",
"LOC100506207",
"LOC100506258",
"LOC100506271",
"LOC100506272",
"LOC100506281",
"LOC100506302",
"LOC100506314",
"LOC100506321",
"LOC100506368",
"LOC100506371",
"LOC100506388",
"LOC100506393",
"LOC100506403",
"LOC100506472",
"LOC100506476",
"LOC100506497",
"LOC100506526",
"LOC100506548",
"LOC100506551",
"LOC100506585",
"LOC100506603",
"LOC100506606",
"LOC100506639",
"LOC100506679",
"LOC100506682",
"LOC100506688",
"LOC100506730",
"LOC100506746",
"LOC100506747",
"LOC100506790",
"LOC100506801",
"LOC100506804",
"LOC100506834",
"LOC100506844",
"LOC100506860",
"LOC100506895",
"LOC100506985",
"LOC100506990",
"LOC100507002",
"LOC100507006",
"LOC100507053",
"LOC100507065",
"LOC100507091",
"LOC100507140",
"LOC100507144",
"LOC100507156",
"LOC100507175",
"LOC100507194",
"LOC100507250",
"LOC100507283",
"LOC100507291",
"LOC100507334",
"LOC100507346",
"LOC100507351",
"LOC100507373",
"LOC100507377",
"LOC100507387",
"LOC100507388",
"LOC100507391",
"LOC100507412",
"LOC100507424",
"LOC100507431",
"LOC100507437",
"LOC100507462",
"LOC100507472",
"LOC100507487",
"LOC100507506",
"LOC100507534",
"LOC100507547",
"LOC100507557",
"LOC100507564",
"LOC100507577",
"LOC100507600",
"LOC100507634",
"LOC100507639",
"LOC100507642",
"LOC100508046",
"LOC100630923",
"LOC100652758",
"LOC100652768",
"LOC100652999",
"LOC100996251",
"LOC100996255",
"LOC100996286",
"LOC100996291",
"LOC100996325",
"LOC100996338",
"LOC100996342",
"LOC100996351",
"LOC100996385",
"LOC100996437",
"LOC100996447",
"LOC100996455",
"LOC100996579",
"LOC100996583",
"LOC100996634",
"LOC100996654",
"LOC100996693",
"LOC101054525",
"LOC101059948",
"LOC101060091",
"LOC101060321",
"LOC101060389",
"LOC101060498",
"LOC101060524",
"LOC101060542",
"LOC101060553",
"LOC101241902",
"LOC101243545",
"LOC101409256",
"LOC101448202",
"LOC101559451",
"LOC101593348",
"LOC101926889",
"LOC101926892",
"LOC101926897",
"LOC101926898",
"LOC101926905",
"LOC101926908",
"LOC101926911",
"LOC101926913",
"LOC101926915",
"LOC101926933",
"LOC101926935",
"LOC101926941",
"LOC101926943",
"LOC101926955",
"LOC101926963",
"LOC101926975",
"LOC101927018",
"LOC101927021",
"LOC101927023",
"LOC101927027",
"LOC101927040",
"LOC101927043",
"LOC101927045",
"LOC101927051",
"LOC101927053",
"LOC101927056",
"LOC101927066",
"LOC101927069",
"LOC101927070",
"LOC101927100",
"LOC101927120",
"LOC101927124",
"LOC101927131",
"LOC101927136",
"LOC101927142",
"LOC101927143",
"LOC101927151",
"LOC101927157",
"LOC101927164",
"LOC101927166",
"LOC101927178",
"LOC101927179",
"LOC101927181",
"LOC101927188",
"LOC101927189",
"LOC101927190",
"LOC101927204",
"LOC101927211",
"LOC101927230",
"LOC101927237",
"LOC101927243",
"LOC101927257",
"LOC101927267",
"LOC101927272",
"LOC101927284",
"LOC101927286",
"LOC101927296",
"LOC101927305",
"LOC101927318",
"LOC101927322",
"LOC101927342",
"LOC101927354",
"LOC101927356",
"LOC101927359",
"LOC101927365",
"LOC101927374",
"LOC101927391",
"LOC101927415",
"LOC101927416",
"LOC101927418",
"LOC101927438",
"LOC101927450",
"LOC101927460",
"LOC101927468",
"LOC101927472",
"LOC101927476",
"LOC101927478",
"LOC101927481",
"LOC101927482",
"LOC101927495",
"LOC101927497",
"LOC101927501",
"LOC101927502",
"LOC101927523",
"LOC101927539",
"LOC101927543",
"LOC101927550",
"LOC101927557",
"LOC101927560",
"LOC101927571",
"LOC101927572",
"LOC101927575",
"LOC101927580",
"LOC101927583",
"LOC101927587",
"LOC101927588",
"LOC101927604",
"LOC101927620",
"LOC101927623",
"LOC101927630",
"LOC101927653",
"LOC101927657",
"LOC101927666",
"LOC101927668",
"LOC101927692",
"LOC101927701",
"LOC101927708",
"LOC101927740",
"LOC101927746",
"LOC101927755",
"LOC101927762",
"LOC101927765",
"LOC101927766",
"LOC101927768",
"LOC101927769",
"LOC101927770",
"LOC101927780",
"LOC101927787",
"LOC101927795",
"LOC101927797",
"LOC101927811",
"LOC101927814",
"LOC101927817",
"LOC101927822",
"LOC101927827",
"LOC101927830",
"LOC101927839",
"LOC101927844",
"LOC101927845",
"LOC101927851",
"LOC101927854",
"LOC101927865",
"LOC101927870",
"LOC101927881",
"LOC101927884",
"LOC101927901",
"LOC101927905",
"LOC101927911",
"LOC101927914",
"LOC101927919",
"LOC101927924",
"LOC101927932",
"LOC101927934",
"LOC101927950",
"LOC101927954",
"LOC101927969",
"LOC101927972",
"LOC101927973",
"LOC101928002",
"LOC101928008",
"LOC101928020",
"LOC101928034",
"LOC101928043",
"LOC101928053",
"LOC101928063",
"LOC101928068",
"LOC101928069",
"LOC101928075",
"LOC101928093",
"LOC101928100",
"LOC101928103",
"LOC101928105",
"LOC101928118",
"LOC101928131",
"LOC101928137",
"LOC101928140",
"LOC101928150",
"LOC101928161",
"LOC101928163",
"LOC101928174",
"LOC101928191",
"LOC101928205",
"LOC101928222",
"LOC101928231",
"LOC101928233",
"LOC101928254",
"LOC101928259",
"LOC101928266",
"LOC101928272",
"LOC101928279",
"LOC101928280",
"LOC101928283",
"LOC101928295",
"LOC101928303",
"LOC101928314",
"LOC101928323",
"LOC101928324",
"LOC101928333",
"LOC101928335",
"LOC101928336",
"LOC101928358",
"LOC101928370",
"LOC101928371",
"LOC101928372",
"LOC101928381",
"LOC101928398",
"LOC101928401",
"LOC101928402",
"LOC101928404",
"LOC101928414",
"LOC101928417",
"LOC101928436",
"LOC101928438",
"LOC101928443",
"LOC101928445",
"LOC101928446",
"LOC101928453",
"LOC101928460",
"LOC101928461",
"LOC101928489",
"LOC101928491",
"LOC101928495",
"LOC101928505",
"LOC101928514",
"LOC101928517",
"LOC101928519",
"LOC101928525",
"LOC101928530",
"LOC101928535",
"LOC101928539",
"LOC101928551",
"LOC101928567",
"LOC101928580",
"LOC101928597",
"LOC101928600",
"LOC101928605",
"LOC101928626",
"LOC101928650",
"LOC101928673",
"LOC101928674",
"LOC101928682",
"LOC101928694",
"LOC101928708",
"LOC101928710",
"LOC101928718",
"LOC101928731",
"LOC101928737",
"LOC101928738",
"LOC101928748",
"LOC101928751",
"LOC101928766",
"LOC101928775",
"LOC101928778",
"LOC101928786",
"LOC101928794",
"LOC101928796",
"LOC101928809",
"LOC101928812",
"LOC101928823",
"LOC101928834",
"LOC101928837",
"LOC101928841",
"LOC101928844",
"LOC101928847",
"LOC101928855",
"LOC101928858",
"LOC101928861",
"LOC101928865",
"LOC101928882",
"LOC101928885",
"LOC101928886",
"LOC101928891",
"LOC101928896",
"LOC101928909",
"LOC101928936",
"LOC101928937",
"LOC101928940",
"LOC101928943",
"LOC101928944",
"LOC101928961",
"LOC101928973",
"LOC101928977",
"LOC101928978",
"LOC101928979",
"LOC101928988",
"LOC101928992",
"LOC101928994",
"LOC101928995",
"LOC101929023",
"LOC101929057",
"LOC101929064",
"LOC101929066",
"LOC101929076",
"LOC101929080",
"LOC101929084",
"LOC101929089",
"LOC101929095",
"LOC101929099",
"LOC101929125",
"LOC101929128",
"LOC101929140",
"LOC101929147",
"LOC101929162",
"LOC101929181",
"LOC101929194",
"LOC101929199",
"LOC101929217",
"LOC101929224",
"LOC101929229",
"LOC101929231",
"LOC101929234",
"LOC101929237",
"LOC101929259",
"LOC101929260",
"LOC101929268",
"LOC101929279",
"LOC101929295",
"LOC101929319",
"LOC101929331",
"LOC101929340",
"LOC101929372",
"LOC101929374",
"LOC101929378",
"LOC101929380",
"LOC101929384",
"LOC101929395",
"LOC101929412",
"LOC101929413",
"LOC101929415",
"LOC101929431",
"LOC101929439",
"LOC101929441",
"LOC101929450",
"LOC101929464",
"LOC101929468",
"LOC101929470",
"LOC101929504",
"LOC101929505",
"LOC101929512",
"LOC101929516",
"LOC101929524",
"LOC101929526",
"LOC101929532",
"LOC101929541",
"LOC101929549",
"LOC101929555",
"LOC101929563",
"LOC101929565",
"LOC101929567",
"LOC101929570",
"LOC101929572",
"LOC101929574",
"LOC101929577",
"LOC101929579",
"LOC101929584",
"LOC101929586",
"LOC101929595",
"LOC101929596",
"LOC101929607",
"LOC101929613",
"LOC101929622",
"LOC101929626",
"LOC101929633",
"LOC101929657",
"LOC101929660",
"LOC101929679",
"LOC101929680",
"LOC101929694",
"LOC101929696",
"LOC101929698",
"LOC101929705",
"LOC101929709",
"LOC101929710",
"LOC101929715",
"LOC101929717",
"LOC101929718",
"LOC101929719",
"LOC101929723",
"LOC101929733",
"LOC101929741",
"LOC101929762",
"LOC101929767",
"LOC101929771",
"LOC101929829",
"LOC101929897",
"LOC101930010",
"LOC101930071",
"LOC101930452",
"LOC102467081",
"LOC102467147",
"LOC102467214",
"LOC102467224",
"LOC102467225",
"LOC102546226",
"LOC102546229",
"LOC102546294",
"LOC102546298",
"LOC102606465",
"LOC102606466",
"LOC102723344",
"LOC102723354",
"LOC102723373",
"LOC102723385",
"LOC102723439",
"LOC102723505",
"LOC102723517",
"LOC102723582",
"LOC102723604",
"LOC102723649",
"LOC102723701",
"LOC102723703",
"LOC102723704",
"LOC102723709",
"LOC102723729",
"LOC102723766",
"LOC102723769",
"LOC102723780",
"LOC102723809",
"LOC102723824",
"LOC102723828",
"LOC102723854",
"LOC102723885",
"LOC102723927",
"LOC102723968",
"LOC102724009",
"LOC102724020",
"LOC102724034",
"LOC102724050",
"LOC102724084",
"LOC102724094",
"LOC102724096",
"LOC102724153",
"LOC102724163",
"LOC102724190",
"LOC102724201",
"LOC102724238",
"LOC102724301",
"LOC102724312",
"LOC102724323",
"LOC102724434",
"LOC102724467",
"LOC102724484",
"LOC102724539",
"LOC102724552",
"LOC102724596",
"LOC102724623",
"LOC102724691",
"LOC102724699",
"LOC102724719",
"LOC102724784",
"LOC102724814",
"LOC102724919",
"LOC102724927",
"LOC102724933",
"LOC102800447",
"LOC103021295",
"LOC103021296",
"LOC103091866",
"LOC103171574",
"LOC103191607",
"LOC103344931",
"LOC103611081",
"LOC103908605",
"LOC104054148",
"LOC104968399",
"LOC105274304",
"LOC105372795",
"LOC105373300",
"LOC105373383",
"LOC105373609",
"LOC105375734",
"LOC105376360",
"LOC105376671",
"LOC105377348",
"LOC105378732",
"LOC105447645",
"LOC105447648",
"LOC105616981",
"LOC105747689",
"LOC105748977",
"LOC113230",
"LOC115110",
"LOC143666",
"LOC145474",
"LOC145783",
"LOC145845",
"LOC146880",
"LOC148413",
"LOC148696",
"LOC148709",
"LOC149950",
"LOC150776",
"LOC151475",
"LOC152225",
"LOC153684",
"LOC153910",
"LOC154761",
"LOC155060",
"LOC158435",
"LOC171391",
"LOC200772",
"LOC202181",
"LOC220729",
"LOC221122",
"LOC221946",
"LOC254896",
"LOC255187",
"LOC255654",
"LOC256880",
"LOC257396",
"LOC283038",
"LOC283045",
"LOC283140",
"LOC283177",
"LOC283194",
"LOC283214",
"LOC283299",
"LOC283332",
"LOC283335",
"LOC283352",
"LOC283440",
"LOC283575",
"LOC283683",
"LOC283731",
"LOC283788",
"LOC283922",
"LOC284009",
"LOC284023",
"LOC284080",
"LOC284344",
"LOC284379",
"LOC284395",
"LOC284412",
"LOC284454",
"LOC284578",
"LOC284581",
"LOC284632",
"LOC284648",
"LOC284825",
"LOC284865",
"LOC284930",
"LOC284933",
"LOC284950",
"LOC285074",
"LOC285593",
"LOC285626",
"LOC285627",
"LOC285629",
"LOC285696",
"LOC285740",
"LOC285762",
"LOC285768",
"LOC285804",
"LOC285819",
"LOC285847",
"LOC285889",
"LOC286059",
"LOC286297",
"LOC286359",
"LOC286437",
"LOC338694",
"LOC338963",
"LOC339059",
"LOC339166",
"LOC339260",
"LOC339529",
"LOC339539",
"LOC339593",
"LOC339666",
"LOC339803",
"LOC339807",
"LOC339874",
"LOC339975",
"LOC340017",
"LOC340074",
"LOC340512",
"LOC341056",
"LOC344887",
"LOC344967",
"LOC374443",
"LOC388242",
"LOC388282",
"LOC388406",
"LOC388436",
"LOC388692",
"LOC388780",
"LOC388849",
"LOC388882",
"LOC388942",
"LOC389199",
"LOC389247",
"LOC389332",
"LOC389602",
"LOC389641",
"LOC389705",
"LOC389765",
"LOC389831",
"LOC389834",
"LOC389895",
"LOC389906",
"LOC390705",
"LOC391322",
"LOC392196",
"LOC392232",
"LOC392452",
"LOC399715",
"LOC399815",
"LOC399886",
"LOC400043",
"LOC400541",
"LOC400548",
"LOC400553",
"LOC400558",
"LOC400620",
"LOC400661",
"LOC400684",
"LOC400685",
"LOC400706",
"LOC400867",
"LOC400927",
"LOC400927-CSNK1E",
"LOC400958",
"LOC400997",
"LOC401010",
"LOC401052",
"LOC401127",
"LOC401177",
"LOC401242",
"LOC401286",
"LOC401312",
"LOC401320",
"LOC401357",
"LOC401585",
"LOC403312",
"LOC403323",
"LOC407835",
"LOC414300",
"LOC439933",
"LOC439994",
"LOC440028",
"LOC440040",
"LOC440173",
"LOC440300",
"LOC440311",
"LOC440390",
"LOC440434",
"LOC440446",
"LOC440461",
"LOC440600",
"LOC440602",
"LOC440700",
"LOC440895",
"LOC440896",
"LOC440910",
"LOC440982",
"LOC441081",
"LOC441155",
"LOC441178",
"LOC441204",
"LOC441242",
"LOC441454",
"LOC441455",
"LOC441666",
"LOC442028",
"LOC494141",
"LOC51145",
"LOC541472",
"LOC541473",
"LOC553103",
"LOC55338",
"LOC554206",
"LOC554223",
"LOC554249",
"LOC574538",
"LOC606724",
"LOC613037",
"LOC613038",
"LOC613266",
"LOC63930",
"LOC641367",
"LOC641746",
"LOC642361",
"LOC642366",
"LOC642423",
"LOC642846",
"LOC642852",
"LOC642929",
"LOC642943",
"LOC643072",
"LOC643201",
"LOC643355",
"LOC643387",
"LOC643406",
"LOC643441",
"LOC643623",
"LOC643711",
"LOC643770",
"LOC643802",
"LOC643923",
"LOC644172",
"LOC644189",
"LOC644285",
"LOC644656",
"LOC644669",
"LOC644762",
"LOC644919",
"LOC644936",
"LOC645166",
"LOC645354",
"LOC645382",
"LOC645513",
"LOC645752",
"LOC645949",
"LOC646029",
"LOC646214",
"LOC646471",
"LOC646522",
"LOC646626",
"LOC646736",
"LOC646762",
"LOC646903",
"LOC646938",
"LOC647323",
"LOC647859",
"LOC648987",
"LOC649133",
"LOC649324",
"LOC649352",
"LOC650226",
"LOC650293",
"LOC652276",
"LOC653160",
"LOC653513",
"LOC653602",
"LOC653653",
"LOC653712",
"LOC653786",
"LOC654342",
"LOC654841",
"LOC727751",
"LOC727896",
"LOC728024",
"LOC728084",
"LOC728095",
"LOC728175",
"LOC728323",
"LOC728485",
"LOC728554",
"LOC728613",
"LOC728673",
"LOC728730",
"LOC728739",
"LOC728743",
"LOC728752",
"LOC728989",
"LOC729080",
"LOC729083",
"LOC729159",
"LOC729218",
"LOC729296",
"LOC729348",
"LOC729603",
"LOC729609",
"LOC729658",
"LOC729683",
"LOC729732",
"LOC729737",
"LOC729739",
"LOC729867",
"LOC729930",
"LOC729970",
"LOC729987",
"LOC730101",
"LOC730102",
"LOC730183",
"LOC730202",
"LOC730668",
"LOC731157",
"LOC731424",
"LOC79160",
"LOC79999",
"LOC81691",
"LOC90246",
"LOC90768",
"LOC90784",
"LOC91450",
"LOC93622",
"LOH12CR1",
"LOH12CR2",
"LONP1",
"LONP2",
"LONRF1",
"LONRF2",
"LONRF3",
"LOX",
"LOXL1",
"LOXL1-AS1",
"LOXL2",
"LOXL3",
"LOXL4",
"LPA",
"LPAL2",
"LPAR1",
"LPAR2",
"LPAR3",
"LPAR5",
"LPAR6",
"LPCAT1",
"LPCAT2",
"LPCAT3",
"LPCAT4",
"LPGAT1",
"LPIN1",
"LPIN2",
"LPIN3",
"LPL",
"LPP",
"LPP-AS1",
"LPP-AS2",
"LPPR1",
"LPPR2",
"LPPR3",
"LPPR4",
"LPPR5",
"LPXN",
"LRAT",
"LRBA",
"LRCH1",
"LRCH3",
"LRCH4",
"LRFN1",
"LRFN2",
"LRFN3",
"LRFN4",
"LRFN5",
"LRG1",
"LRGUK",
"LRIF1",
"LRIG1",
"LRIG2",
"LRIG3",
"LRIT1",
"LRIT3",
"LRP1",
"LRP1-AS",
"LRP10",
"LRP11",
"LRP12",
"LRP1B",
"LRP2",
"LRP2BP",
"LRP3",
"LRP4",
"LRP4-AS1",
"LRP5",
"LRP5L",
"LRP6",
"LRP8",
"LRPAP1",
"LRPPRC",
"LRR1",
"LRRC1",
"LRRC10",
"LRRC10B",
"LRRC14",
"LRRC14B",
"LRRC15",
"LRRC16A",
"LRRC16B",
"LRRC17",
"LRRC18",
"LRRC19",
"LRRC2",
"LRRC2-AS1",
"LRRC20",
"LRRC23",
"LRRC24",
"LRRC25",
"LRRC26",
"LRRC27",
"LRRC28",
"LRRC29",
"LRRC3",
"LRRC3-AS1",
"LRRC31",
"LRRC32",
"LRRC34",
"LRRC36",
"LRRC37A",
"LRRC37A11P",
"LRRC37A2",
"LRRC37A3",
"LRRC37A4P",
"LRRC37A5P",
"LRRC37A6P",
"LRRC37A8P",
"LRRC37B",
"LRRC37BP1",
"LRRC39",
"LRRC4",
"LRRC40",
"LRRC41",
"LRRC42",
"LRRC43",
"LRRC45",
"LRRC46",
"LRRC47",
"LRRC48",
"LRRC49",
"LRRC4B",
"LRRC4C",
"LRRC55",
"LRRC56",
"LRRC57",
"LRRC58",
"LRRC59",
"LRRC6",
"LRRC61",
"LRRC63",
"LRRC66",
"LRRC69",
"LRRC7",
"LRRC70",
"LRRC71",
"LRRC73",
"LRRC74B",
"LRRC75A",
"LRRC75A-AS1",
"LRRC75B",
"LRRC8A",
"LRRC8B",
"LRRC8C",
"LRRC8D",
"LRRC8E",
"LRRC9",
"LRRCC1",
"LRRD1",
"LRRFIP1",
"LRRFIP2",
"LRRIQ1",
"LRRIQ3",
"LRRIQ4",
"LRRK1",
"LRRK2",
"LRRN1",
"LRRN2",
"LRRN3",
"LRRN4",
"LRRN4CL",
"LRRTM1",
"LRRTM2",
"LRRTM3",
"LRRTM4",
"LRSAM1",
"LRTM1",
"LRTM2",
"LRTOMT",
"LRWD1",
"LSAMP",
"LSG1",
"LSM1",
"LSM10",
"LSM11",
"LSM12",
"LSM14A",
"LSM14B",
"LSM2",
"LSM3",
"LSM4",
"LSM5",
"LSM6",
"LSM7",
"LSM8",
"LSMEM1",
"LSMEM2",
"LSP1",
"LSR",
"LSS",
"LST1",
"LTA",
"LTA4H",
"LTB",
"LTB4R",
"LTB4R2",
"LTBP1",
"LTBP2",
"LTBP3",
"LTBP4",
"LTBR",
"LTC4S",
"LTF",
"LTK",
"LTN1",
"LTV1",
"LUC7L",
"LUC7L2",
"LUC7L3",
"LUCAT1",
"LUM",
"LUNAR1",
"LURAP1",
"LURAP1L",
"LURAP1L-AS1",
"LUZP1",
"LUZP2",
"LUZP6",
"LVCAT8",
"LVRN",
"LXN",
"LY6D",
"LY6E",
"LY6G5B",
"LY6G5C",
"LY6G6C",
"LY6G6F",
"LY6H",
"LY6K",
"LY75",
"LY86",
"LY9",
"LY96",
"LYAR",
"LYG1",
"LYG2",
"LYL1",
"LYN",
"LYNX1",
"LYPD1",
"LYPD2",
"LYPD3",
"LYPD5",
"LYPD6",
"LYPD6B",
"LYPLA1",
"LYPLA2",
"LYPLA2P2",
"LYPLAL1",
"LYPLAL1-AS1",
"LYRM1",
"LYRM2",
"LYRM4",
"LYRM5",
"LYRM7",
"LYRM9",
"LYSMD1",
"LYSMD2",
"LYSMD3",
"LYSMD4",
"LYST",
"LYVE1",
"LYZ",
"LYZL2",
"LZIC",
"LZTFL1",
"LZTR1",
"LZTS1",
"LZTS2",
"LZTS3",
"M1AP",
"M6PR",
"MAATS1",
"MAB21L1",
"MAB21L2",
"MAB21L3",
"MACC1",
"MACC1-AS1",
"MACF1",
"MACROD1",
"MACROD2",
"MACROD2-AS1",
"MACROD2-IT1",
"MAD1L1",
"MAD2L1",
"MAD2L1BP",
"MAD2L2",
"MADCAM1",
"MADD",
"MAEA",
"MAF",
"MAF1",
"MAFA",
"MAFB",
"MAFF",
"MAFG",
"MAFG-AS1",
"MAFIP",
"MAFK",
"MAFTRR",
"MAG",
"MAGEA1",
"MAGEA10",
"MAGEA10-MAGEA5",
"MAGEA11",
"MAGEA2",
"MAGEA2B",
"MAGEA5",
"MAGEA8",
"MAGEA8-AS1",
"MAGEA9",
"MAGEA9B",
"MAGEB1",
"MAGEB17",
"MAGEB2",
"MAGEB6",
"MAGEC1",
"MAGEC2",
"MAGEC3",
"MAGED1",
"MAGED2",
"MAGED4",
"MAGED4B",
"MAGEE1",
"MAGEE2",
"MAGEF1",
"MAGEH1",
"MAGI1",
"MAGI1-AS1",
"MAGI2",
"MAGI2-AS3",
"MAGI3",
"MAGIX",
"MAGOH",
"MAGOH2P",
"MAGOHB",
"MAGT1",
"MAK",
"MAK16",
"MAL",
"MAL2",
"MALAT1",
"MALL",
"MALRD1",
"MALSU1",
"MALT1",
"MAMDC2",
"MAMDC2-AS1",
"MAMDC4",
"MAML1",
"MAML2",
"MAML3",
"MAMLD1",
"MAMSTR",
"MAN1A1",
"MAN1A2",
"MAN1B1",
"MAN1B1-AS1",
"MAN1C1",
"MAN2A1",
"MAN2A2",
"MAN2B1",
"MAN2B2",
"MAN2C1",
"MANBA",
"MANBAL",
"MANEA",
"MANEA-AS1",
"MANEAL",
"MANF",
"MANSC1",
"MANSC4",
"MAOA",
"MAOB",
"MAP10",
"MAP1A",
"MAP1B",
"MAP1LC3A",
"MAP1LC3B",
"MAP1LC3B2",
"MAP1LC3C",
"MAP1S",
"MAP2",
"MAP2K1",
"MAP2K2",
"MAP2K3",
"MAP2K4",
"MAP2K4P1",
"MAP2K5",
"MAP2K6",
"MAP2K7",
"MAP3K1",
"MAP3K10",
"MAP3K11",
"MAP3K12",
"MAP3K13",
"MAP3K14",
"MAP3K14-AS1",
"MAP3K15",
"MAP3K19",
"MAP3K2",
"MAP3K3",
"MAP3K4",
"MAP3K5",
"MAP3K6",
"MAP3K7",
"MAP3K7CL",
"MAP3K8",
"MAP3K9",
"MAP4",
"MAP4K1",
"MAP4K2",
"MAP4K3",
"MAP4K4",
"MAP4K5",
"MAP6",
"MAP6D1",
"MAP7",
"MAP7D1",
"MAP7D2",
"MAP7D3",
"MAP9",
"MAPK1",
"MAPK10",
"MAPK11",
"MAPK12",
"MAPK13",
"MAPK14",
"MAPK15",
"MAPK1IP1L",
"MAPK3",
"MAPK4",
"MAPK6",
"MAPK7",
"MAPK8",
"MAPK8IP1",
"MAPK8IP2",
"MAPK8IP3",
"MAPK9",
"MAPKAP1",
"MAPKAPK2",
"MAPKAPK3",
"MAPKAPK5",
"MAPKAPK5-AS1",
"MAPKBP1",
"MAPRE1",
"MAPRE2",
"MAPRE3",
"MAPT",
"MAPT-AS1",
"MAPT-IT1",
"MARC1",
"MARC2",
"MARCH1",
"MARCH10",
"MARCH11",
"MARCH2",
"MARCH3",
"MARCH4",
"MARCH5",
"MARCH6",
"MARCH7",
"MARCH8",
"MARCH9",
"MARCKS",
"MARCKSL1",
"MARCO",
"MARK1",
"MARK2",
"MARK2P9",
"MARK3",
"MARK4",
"MARS",
"MARS2",
"MARVELD1",
"MARVELD2",
"MARVELD3",
"MASP1",
"MASP2",
"MAST1",
"MAST2",
"MAST3",
"MAST4",
"MASTL",
"MAT1A",
"MAT2A",
"MAT2B",
"MATK",
"MATN1",
"MATN1-AS1",
"MATN2",
"MATN3",
"MATN4",
"MATR3",
"MAU2",
"MAVS",
"MAX",
"MAZ",
"MB",
"MB21D1",
"MB21D2",
"MBD1",
"MBD2",
"MBD3",
"MBD4",
"MBD5",
"MBD6",
"MBIP",
"MBL1P",
"MBL2",
"MBLAC1",
"MBLAC2",
"MBNL1",
"MBNL1-AS1",
"MBNL2",
"MBNL3",
"MBOAT1",
"MBOAT2",
"MBOAT4",
"MBOAT7",
"MBP",
"MBTD1",
"MBTPS1",
"MBTPS2",
"MC1R",
"MC2R",
"MC3R",
"MC5R",
"MCAM",
"MCAT",
"MCC",
"MCCC1",
"MCCC2",
"MCCD1",
"MCEE",
"MCEMP1",
"MCF2",
"MCF2L",
"MCF2L-AS1",
"MCF2L2",
"MCFD2",
"MCHR1",
"MCHR2",
"MCIDAS",
"MCL1",
"MCM10",
"MCM2",
"MCM3",
"MCM3AP",
"MCM3AP-AS1",
"MCM4",
"MCM5",
"MCM6",
"MCM7",
"MCM8",
"MCM8-AS1",
"MCM9",
"MCMBP",
"MCMDC2",
"MCOLN1",
"MCOLN2",
"MCOLN3",
"MCPH1",
"MCPH1-AS1",
"MCRS1",
"MCTP1",
"MCTP2",
"MCTS1",
"MCTS2P",
"MCU",
"MCUR1",
"MDC1",
"MDFI",
"MDFIC",
"MDGA1",
"MDGA2",
"MDH1",
"MDH1B",
"MDH2",
"MDK",
"MDM1",
"MDM2",
"MDM4",
"MDN1",
"MDP1",
"ME1",
"ME2",
"ME3",
"MEA1",
"MEAF6",
"MEAT6",
"MECOM",
"MECP2",
"MECR",
"MED1",
"MED10",
"MED11",
"MED12",
"MED12L",
"MED13",
"MED13L",
"MED14",
"MED14OS",
"MED15",
"MED15P9",
"MED16",
"MED17",
"MED18",
"MED19",
"MED20",
"MED21",
"MED22",
"MED23",
"MED24",
"MED25",
"MED26",
"MED27",
"MED28",
"MED29",
"MED30",
"MED31",
"MED4",
"MED4-AS1",
"MED6",
"MED7",
"MED8",
"MED9",
"MEDAG",
"MEF2A",
"MEF2B",
"MEF2BNB",
"MEF2BNB-MEF2B",
"MEF2C",
"MEF2D",
"MEFV",
"MEG3",
"MEG9",
"MEGF10",
"MEGF11",
"MEGF6",
"MEGF8",
"MEGF9",
"MEI1",
"MEIG1",
"MEIKIN",
"MEIOB",
"MEIS1",
"MEIS1-AS2",
"MEIS1-AS3",
"MEIS2",
"MEIS3",
"MEIS3P1",
"MELK",
"MEMO1",
"MEN1",
"MEOX1",
"MEP1A",
"MEP1B",
"MEPCE",
"MEPE",
"MERTK",
"MESDC1",
"MESDC2",
"MESP1",
"MESP2",
"MEST",
"MESTIT1",
"MET",
"METAP1",
"METAP1D",
"METAP2",
"METRN",
"METRNL",
"METTL1",
"METTL10",
"METTL12",
"METTL13",
"METTL14",
"METTL15",
"METTL16",
"METTL17",
"METTL18",
"METTL20",
"METTL21A",
"METTL21B",
"METTL21C",
"METTL21EP",
"METTL22",
"METTL23",
"METTL25",
"METTL2A",
"METTL2B",
"METTL3",
"METTL4",
"METTL5",
"METTL6",
"METTL7A",
"METTL7B",
"METTL8",
"METTL9",
"MEX3A",
"MEX3B",
"MEX3C",
"MEX3D",
"MFAP1",
"MFAP2",
"MFAP3",
"MFAP3L",
"MFAP4",
"MFAP5",
"MFF",
"MFGE8",
"MFHAS1",
"MFI2",
"MFI2-AS1",
"MFN1",
"MFN2",
"MFNG",
"MFSD1",
"MFSD10",
"MFSD11",
"MFSD12",
"MFSD2A",
"MFSD2B",
"MFSD3",
"MFSD4",
"MFSD5",
"MFSD6",
"MFSD7",
"MFSD8",
"MFSD9",
"MGA",
"MGAM",
"MGAM2",
"MGARP",
"MGAT1",
"MGAT2",
"MGAT3",
"MGAT3-AS1",
"MGAT4A",
"MGAT4B",
"MGAT4C",
"MGAT4EP",
"MGAT5",
"MGAT5B",
"MGC12916",
"MGC15885",
"MGC16025",
"MGC16142",
"MGC16275",
"MGC27345",
"MGC27382",
"MGC2889",
"MGC32805",
"MGC34796",
"MGC39584",
"MGC45922",
"MGC50722",
"MGC57346",
"MGC57346-CRHR1",
"MGC70870",
"MGC72080",
"MGEA5",
"MGLL",
"MGME1",
"MGMT",
"MGP",
"MGRN1",
"MGST1",
"MGST2",
"MGST3",
"MIA",
"MIA-RAB4B",
"MIA2",
"MIA3",
"MIAT",
"MIATNB",
"MIB1",
"MIB2",
"MICA",
"MICAL1",
"MICAL2",
"MICAL3",
"MICALCL",
"MICALL1",
"MICALL2",
"MICB",
"MICU1",
"MICU2",
"MICU3",
"MID1",
"MID1IP1",
"MID1IP1-AS1",
"MID2",
"MIDN",
"MIEF1",
"MIEF2",
"MIEN1",
"MIER1",
"MIER2",
"MIER3",
"MIF",
"MIF-AS1",
"MIF4GD",
"MIIP",
"MILR1",
"MINA",
"MINK1",
"MINOS1",
"MINOS1-NBL1",
"MINOS1P1",
"MINPP1",
"MIOS",
"MIOX",
"MIP",
"MIPEP",
"MIPEPP3",
"MIPOL1",
"MIR100HG",
"MIR133A1HG",
"MIR137HG",
"MIR143HG",
"MIR155HG",
"MIR17HG",
"MIR181A1HG",
"MIR181A2HG",
"MIR2052HG",
"MIR205HG",
"MIR210HG",
"MIR22HG",
"MIR31HG",
"MIR325HG",
"MIR3648-1",
"MIR3976HG",
"MIR4435-2HG",
"MIR4458HG",
"MIR4697HG",
"MIR497HG",
"MIR503HG",
"MIR600HG",
"MIR646HG",
"MIR6753",
"MIR762HG",
"MIR7851",
"MIR99AHG",
"MIRLET7BHG",
"MIRLET7DHG",
"MIS12",
"MIS18A",
"MIS18BP1",
"MISP",
"MITD1",
"MITF",
"MIXL1",
"MKI67",
"MKKS",
"MKL1",
"MKL2",
"MKLN1",
"MKLN1-AS",
"MKNK1",
"MKNK1-AS1",
"MKNK2",
"MKRN1",
"MKRN2",
"MKRN2OS",
"MKRN3",
"MKRN9P",
"MKS1",
"MKX",
"MLANA",
"MLC1",
"MLEC",
"MLF1",
"MLF2",
"MLH1",
"MLH3",
"MLIP",
"MLIP-IT1",
"MLK7-AS1",
"MLKL",
"MLLT1",
"MLLT10",
"MLLT10P1",
"MLLT11",
"MLLT3",
"MLLT4",
"MLLT4-AS1",
"MLLT6",
"MLNR",
"MLPH",
"MLST8",
"MLX",
"MLXIP",
"MLXIPL",
"MLYCD",
"MMAA",
"MMAB",
"MMACHC",
"MMADHC",
"MMD",
"MMD2",
"MME",
"MMEL1",
"MMGT1",
"MMP1",
"MMP10",
"MMP11",
"MMP13",
"MMP14",
"MMP15",
"MMP16",
"MMP17",
"MMP19",
"MMP2",
"MMP20",
"MMP21",
"MMP23A",
"MMP23B",
"MMP24",
"MMP24-AS1",
"MMP25",
"MMP25-AS1",
"MMP27",
"MMP28",
"MMP3",
"MMP7",
"MMP9",
"MMRN1",
"MMRN2",
"MMS19",
"MMS22L",
"MN1",
"MNAT1",
"MND1",
"MNS1",
"MNT",
"MNX1",
"MNX1-AS1",
"MOAP1",
"MOB1A",
"MOB1B",
"MOB2",
"MOB3A",
"MOB3B",
"MOB3C",
"MOB4",
"MOBP",
"MOCOS",
"MOCS1",
"MOCS2",
"MOCS3",
"MOG",
"MOGAT1",
"MOGAT2",
"MOGS",
"MOK",
"MON1A",
"MON1B",
"MON2",
"MORC2",
"MORC2-AS1",
"MORC3",
"MORC4",
"MORF4L1",
"MORF4L2",
"MORF4L2-AS1",
"MORN1",
"MORN2",
"MORN3",
"MORN4",
"MOSPD1",
"MOSPD2",
"MOSPD3",
"MOV10",
"MOV10L1",
"MOXD1",
"MPC1",
"MPC1L",
"MPC2",
"MPDU1",
"MPDZ",
"MPEG1",
"MPG",
"MPHOSPH10",
"MPHOSPH6",
"MPHOSPH8",
"MPHOSPH9",
"MPI",
"MPL",
"MPLKIP",
"MPND",
"MPP1",
"MPP2",
"MPP3",
"MPP4",
"MPP5",
"MPP6",
"MPP7",
"MPPE1",
"MPPED2",
"MPRIP",
"MPST",
"MPV17",
"MPV17L",
"MPV17L2",
"MPZ",
"MPZL1",
"MPZL2",
"MPZL3",
"MR1",
"MRAP",
"MRAP2",
"MRAS",
"MRC1",
"MRC2",
"MRE11A",
"MREG",
"MRFAP1",
"MRFAP1L1",
"MRGBP",
"MRGPRD",
"MRGPRF",
"MRGPRG-AS1",
"MRGPRX1",
"MRGPRX2",
"MRGPRX3",
"MRI1",
"MRM1",
"MRO",
"MROH1",
"MROH2A",
"MROH5",
"MROH6",
"MROH7",
"MROH7-TTC4",
"MROH8",
"MRPL1",
"MRPL10",
"MRPL11",
"MRPL12",
"MRPL13",
"MRPL14",
"MRPL15",
"MRPL16",
"MRPL17",
"MRPL18",
"MRPL19",
"MRPL2",
"MRPL20",
"MRPL21",
"MRPL22",
"MRPL23",
"MRPL23-AS1",
"MRPL24",
"MRPL27",
"MRPL28",
"MRPL3",
"MRPL30",
"MRPL32",
"MRPL33",
"MRPL34",
"MRPL35",
"MRPL36",
"MRPL37",
"MRPL38",
"MRPL39",
"MRPL4",
"MRPL40",
"MRPL41",
"MRPL42",
"MRPL42P5",
"MRPL43",
"MRPL44",
"MRPL45",
"MRPL45P2",
"MRPL46",
"MRPL47",
"MRPL48",
"MRPL49",
"MRPL50",
"MRPL51",
"MRPL52",
"MRPL53",
"MRPL54",
"MRPL55",
"MRPL57",
"MRPL9",
"MRPS10",
"MRPS11",
"MRPS12",
"MRPS14",
"MRPS15",
"MRPS16",
"MRPS17",
"MRPS18A",
"MRPS18B",
"MRPS18C",
"MRPS2",
"MRPS21",
"MRPS22",
"MRPS23",
"MRPS24",
"MRPS25",
"MRPS26",
"MRPS27",
"MRPS28",
"MRPS30",
"MRPS31",
"MRPS31P5",
"MRPS33",
"MRPS34",
"MRPS35",
"MRPS36",
"MRPS5",
"MRPS6",
"MRPS7",
"MRPS9",
"MRRF",
"MRS2",
"MRS2P2",
"MRTO4",
"MRVI1",
"MRVI1-AS1",
"MS4A1",
"MSANTD1",
"MSANTD2",
"MSANTD3",
"MSANTD3-TMEFF1",
"MSANTD4",
"MSC",
"MSC-AS1",
"MSH2",
"MSH3",
"MSH4",
"MSH5",
"MSH5-SAPCD1",
"MSH6",
"MSI1",
"MSI2",
"MSL1",
"MSL2",
"MSL3",
"MSL3P1",
"MSLN",
"MSMB",
"MSMO1",
"MSMP",
"MSN",
"MSRA",
"MSRB1",
"MSRB2",
"MSRB3",
"MSS51",
"MST1",
"MST1L",
"MST1P2",
"MST1R",
"MSTN",
"MSTO1",
"MSTO2P",
"MSX1",
"MSX2",
"MT1B",
"MT1E",
"MT1F",
"MT1JP",
"MT1L",
"MT1X",
"MT2A",
"MTA1",
"MTA2",
"MTA3",
"MTAP",
"MTBP",
"MTCH1",
"MTCH2",
"MTCL1",
"MTCP1",
"MTDH",
"MTERF1",
"MTERF2",
"MTERF3",
"MTERF4",
"MTF1",
"MTF2",
"MTFMT",
"MTFP1",
"MTFR1",
"MTFR1L",
"MTFR2",
"MTG1",
"MTG2",
"MTHFD1",
"MTHFD1L",
"MTHFD2",
"MTHFD2L",
"MTHFD2P1",
"MTHFR",
"MTHFS",
"MTHFSD",
"MTIF2",
"MTIF3",
"MTL5",
"MTM1",
"MTMR1",
"MTMR10",
"MTMR11",
"MTMR12",
"MTMR14",
"MTMR2",
"MTMR3",
"MTMR4",
"MTMR6",
"MTMR7",
"MTMR8",
"MTMR9",
"MTMR9LP",
"MTNR1A",
"MTO1",
"MTOR",
"MTOR-AS1",
"MTPAP",
"MTR",
"MTRF1",
"MTRF1L",
"MTRNR2L2",
"MTRNR2L3",
"MTRNR2L4",
"MTRNR2L5",
"MTRNR2L8",
"MTRR",
"MTSS1",
"MTSS1L",
"MTTP",
"MTURN",
"MTUS1",
"MTUS2",
"MTUS2-AS1",
"MTVR2",
"MTX1",
"MTX2",
"MTX3",
"MUC1",
"MUC12",
"MUC13",
"MUC16",
"MUC17",
"MUC19",
"MUC2",
"MUC20",
"MUC21",
"MUC22",
"MUC3A",
"MUC4",
"MUC5AC",
"MUC5B",
"MUC6",
"MUC7",
"MUCL1",
"MUL1",
"MUM1",
"MUM1L1",
"MURC",
"MUS81",
"MUSK",
"MUSTN1",
"MUT",
"MUTYH",
"MVB12A",
"MVB12B",
"MVD",
"MVK",
"MVP",
"MX1",
"MX2",
"MXD1",
"MXD3",
"MXD4",
"MXI1",
"MXRA5",
"MXRA7",
"MXRA8",
"MYADM",
"MYADML2",
"MYB",
"MYBBP1A",
"MYBL1",
"MYBL2",
"MYBPC1",
"MYBPC2",
"MYBPC3",
"MYBPH",
"MYC",
"MYCBP",
"MYCBP2",
"MYCBP2-AS1",
"MYCBPAP",
"MYCL",
"MYCN",
"MYCNOS",
"MYCT1",
"MYD88",
"MYDGF",
"MYEF2",
"MYEOV",
"MYEOV2",
"MYH10",
"MYH11",
"MYH14",
"MYH15",
"MYH16",
"MYH3",
"MYH6",
"MYH7",
"MYH7B",
"MYH9",
"MYHAS",
"MYL12A",
"MYL12B",
"MYL2",
"MYL3",
"MYL4",
"MYL5",
"MYL6",
"MYL6B",
"MYL7",
"MYL9",
"MYLIP",
"MYLK",
"MYLK-AS1",
"MYLK2",
"MYLK3",
"MYLK4",
"MYLPF",
"MYNN",
"MYO10",
"MYO15A",
"MYO15B",
"MYO16",
"MYO18A",
"MYO18B",
"MYO19",
"MYO1A",
"MYO1B",
"MYO1C",
"MYO1D",
"MYO1E",
"MYO1F",
"MYO1G",
"MYO1H",
"MYO3B",
"MYO5A",
"MYO5B",
"MYO5C",
"MYO6",
"MYO7A",
"MYO7B",
"MYO9A",
"MYO9B",
"MYOC",
"MYOF",
"MYOG",
"MYOM1",
"MYOM2",
"MYOM3",
"MYOT",
"MYOZ1",
"MYOZ2",
"MYOZ3",
"MYPN",
"MYPOP",
"MYRF",
"MYRFL",
"MYRIP",
"MYSM1",
"MYT1",
"MYT1L",
"MYZAP",
"MZB1",
"MZF1",
"MZF1-AS1",
"MZT1",
"MZT2A",
"MZT2B",
"N4BP1",
"N4BP2",
"N4BP2L1",
"N4BP2L2",
"N4BP2L2-IT2",
"N4BP3",
"N6AMT1",
"N6AMT2",
"NAA10",
"NAA15",
"NAA16",
"NAA20",
"NAA25",
"NAA30",
"NAA35",
"NAA38",
"NAA40",
"NAA50",
"NAA60",
"NAAA",
"NAALAD2",
"NAALADL1",
"NAALADL2",
"NAALADL2-AS2",
"NAB1",
"NAB2",
"NABP1",
"NABP2",
"NACA",
"NACA2",
"NACAD",
"NACAP1",
"NACC1",
"NACC2",
"NADK",
"NADK2",
"NADSYN1",
"NAE1",
"NAF1",
"NAGA",
"NAGK",
"NAGLU",
"NAGPA",
"NAGPA-AS1",
"NAGS",
"NAIF1",
"NAIP",
"NALCN",
"NALCN-AS1",
"NAMA",
"NAMPT",
"NANOG",
"NANOS1",
"NANOS2",
"NANOS3",
"NANP",
"NANS",
"NAP1L1",
"NAP1L2",
"NAP1L3",
"NAP1L4",
"NAP1L5",
"NAP1L6",
"NAPA",
"NAPA-AS1",
"NAPB",
"NAPEPLD",
"NAPG",
"NAPRT",
"NAPSA",
"NAPSB",
"NARF",
"NARFL",
"NARR",
"NARS",
"NARS2",
"NASP",
"NAT1",
"NAT10",
"NAT14",
"NAT16",
"NAT2",
"NAT6",
"NAT8",
"NAT8B",
"NAT8L",
"NAT9",
"NATD1",
"NAV1",
"NAV2",
"NAV2-AS2",
"NAV2-AS4",
"NAV2-AS5",
"NAV3",
"NBAS",
"NBAT1",
"NBEA",
"NBEAL1",
"NBEAL2",
"NBEAP1",
"NBL1",
"NBN",
"NBPF1",
"NBPF10",
"NBPF11",
"NBPF12",
"NBPF13P",
"NBPF14",
"NBPF15",
"NBPF18P",
"NBPF20",
"NBPF22P",
"NBPF25P",
"NBPF3",
"NBPF4",
"NBPF6",
"NBPF7",
"NBPF8",
"NBPF9",
"NBR1",
"NBR2",
"NCALD",
"NCAM1",
"NCAM2",
"NCAN",
"NCAPD2",
"NCAPD3",
"NCAPG",
"NCAPG2",
"NCAPH",
"NCAPH2",
"NCBP1",
"NCBP2",
"NCBP2-AS2",
"NCCRP1",
"NCDN",
"NCEH1",
"NCF1",
"NCF1B",
"NCF1C",
"NCF2",
"NCF4",
"NCK1",
"NCK1-AS1",
"NCK2",
"NCKAP1",
"NCKAP1L",
"NCKAP5",
"NCKAP5L",
"NCKIPSD",
"NCL",
"NCLN",
"NCMAP",
"NCOA1",
"NCOA2",
"NCOA3",
"NCOA4",
"NCOA5",
"NCOA6",
"NCOA7",
"NCOA7-AS1",
"NCOR1",
"NCOR1P1",
"NCOR2",
"NCR3",
"NCR3LG1",
"NCRNA00250",
"NCRUPAR",
"NCS1",
"NCSTN",
"NDC1",
"NDC80",
"NDE1",
"NDEL1",
"NDFIP1",
"NDFIP2",
"NDNF",
"NDNL2",
"NDOR1",
"NDP",
"NDRG1",
"NDRG2",
"NDRG3",
"NDRG4",
"NDST1",
"NDST2",
"NDST3",
"NDUFA1",
"NDUFA10",
"NDUFA11",
"NDUFA12",
"NDUFA13",
"NDUFA2",
"NDUFA3",
"NDUFA4",
"NDUFA4L2",
"NDUFA5",
"NDUFA6",
"NDUFA6-AS1",
"NDUFA7",
"NDUFA8",
"NDUFA9",
"NDUFAB1",
"NDUFAF1",
"NDUFAF2",
"NDUFAF3",
"NDUFAF4",
"NDUFAF4P1",
"NDUFAF5",
"NDUFAF6",
"NDUFAF7",
"NDUFB1",
"NDUFB10",
"NDUFB11",
"NDUFB2",
"NDUFB2-AS1",
"NDUFB3",
"NDUFB4",
"NDUFB5",
"NDUFB6",
"NDUFB7",
"NDUFB8",
"NDUFB9",
"NDUFC1",
"NDUFC2",
"NDUFC2-KCTD14",
"NDUFS1",
"NDUFS2",
"NDUFS3",
"NDUFS4",
"NDUFS5",
"NDUFS6",
"NDUFS7",
"NDUFS8",
"NDUFV1",
"NDUFV2",
"NDUFV2-AS1",
"NDUFV3",
"NEAT1",
"NEB",
"NEBL",
"NEBL-AS1",
"NECAB1",
"NECAB2",
"NECAB3",
"NECAP1",
"NECAP2",
"NEDD1",
"NEDD4",
"NEDD4L",
"NEDD8",
"NEDD8-MDP1",
"NEDD9",
"NEFH",
"NEFL",
"NEFM",
"NEGR1",
"NEIL1",
"NEIL2",
"NEIL3",
"NEK1",
"NEK10",
"NEK11",
"NEK2",
"NEK3",
"NEK4",
"NEK5",
"NEK6",
"NEK7",
"NEK8",
"NEK9",
"NELFA",
"NELFB",
"NELFCD",
"NELFE",
"NELL2",
"NEMF",
"NEMP1",
"NEMP2",
"NENF",
"NEO1",
"NES",
"NET1",
"NETO2",
"NEU1",
"NEU2",
"NEU3",
"NEU4",
"NEURL1",
"NEURL1B",
"NEURL2",
"NEURL3",
"NEURL4",
"NEUROD2",
"NEUROD4",
"NEUROG2",
"NEXN",
"NEXN-AS1",
"NF1",
"NF2",
"NFAM1",
"NFASC",
"NFAT5",
"NFATC1",
"NFATC2",
"NFATC2IP",
"NFATC3",
"NFATC4",
"NFE2",
"NFE2L1",
"NFE2L2",
"NFE2L3",
"NFIA",
"NFIB",
"NFIC",
"NFIL3",
"NFIX",
"NFKB1",
"NFKB2",
"NFKBIA",
"NFKBIB",
"NFKBID",
"NFKBIE",
"NFKBIL1",
"NFKBIZ",
"NFRKB",
"NFS1",
"NFU1",
"NFX1",
"NFXL1",
"NFYA",
"NFYB",
"NFYC",
"NFYC-AS1",
"NGDN",
"NGEF",
"NGF",
"NGFR",
"NGFRAP1",
"NGLY1",
"NGRN",
"NHEJ1",
"NHLH1",
"NHLH2",
"NHLRC1",
"NHLRC2",
"NHLRC3",
"NHLRC4",
"NHP2",
"NHS",
"NHSL1",
"NHSL2",
"NICN1",
"NID1",
"NID2",
"NIF3L1",
"NIFK",
"NIFK-AS1",
"NIM1K",
"NIN",
"NINJ1",
"NINJ2",
"NINL",
"NIP7",
"NIPA1",
"NIPA2",
"NIPAL1",
"NIPAL2",
"NIPAL3",
"NIPAL4",
"NIPBL",
"NIPBL-AS1",
"NIPSNAP1",
"NIPSNAP3A",
"NIPSNAP3B",
"NISCH",
"NIT1",
"NIT2",
"NKAIN1",
"NKAIN2",
"NKAIN3",
"NKAIN4",
"NKAP",
"NKAPL",
"NKAPP1",
"NKD1",
"NKD2",
"NKG7",
"NKILA",
"NKIRAS1",
"NKIRAS2",
"NKPD1",
"NKRF",
"NKTR",
"NKX1-2",
"NKX2-1",
"NKX2-1-AS1",
"NKX2-2",
"NKX2-3",
"NKX2-4",
"NKX2-8",
"NKX3-1",
"NKX3-2",
"NKX6-1",
"NKX6-2",
"NLE1",
"NLGN1",
"NLGN1-AS1",
"NLGN2",
"NLGN3",
"NLK",
"NLN",
"NLRC3",
"NLRC4",
"NLRC5",
"NLRP1",
"NLRP10",
"NLRP11",
"NLRP12",
"NLRP14",
"NLRP2",
"NLRP3",
"NLRP4",
"NLRP5",
"NLRP6",
"NLRP7",
"NLRP8",
"NLRP9",
"NLRX1",
"NMB",
"NMBR",
"NMD3",
"NME1",
"NME1-NME2",
"NME2",
"NME3",
"NME4",
"NME5",
"NME6",
"NME7",
"NME9",
"NMI",
"NMNAT1",
"NMNAT2",
"NMNAT3",
"NMRAL1",
"NMRK1",
"NMRK2",
"NMT1",
"NMT2",
"NMU",
"NMUR2",
"NNAT",
"NNMT",
"NNT",
"NNT-AS1",
"NOA1",
"NOB1",
"NOBOX",
"NOC2L",
"NOC3L",
"NOC4L",
"NOCT",
"NOD1",
"NOD2",
"NODAL",
"NOG",
"NOL10",
"NOL11",
"NOL12",
"NOL3",
"NOL4",
"NOL4L",
"NOL6",
"NOL7",
"NOL8",
"NOL9",
"NOLC1",
"NOM1",
"NOMO1",
"NOMO2",
"NOMO3",
"NONO",
"NOP10",
"NOP14",
"NOP14-AS1",
"NOP16",
"NOP2",
"NOP56",
"NOP58",
"NOP9",
"NOS1",
"NOS1AP",
"NOS2",
"NOS3",
"NOSIP",
"NOSTRIN",
"NOTCH1",
"NOTCH2",
"NOTCH2NL",
"NOTCH3",
"NOTCH4",
"NOTO",
"NOTUM",
"NOV",
"NOVA1",
"NOVA2",
"NOX1",
"NOX3",
"NOX5",
"NOXA1",
"NOXO1",
"NOXRED1",
"NPAP1",
"NPAS1",
"NPAS2",
"NPAS3",
"NPAS4",
"NPAT",
"NPB",
"NPBWR1",
"NPBWR2",
"NPC1",
"NPC1L1",
"NPC2",
"NPDC1",
"NPEPL1",
"NPEPPS",
"NPFF",
"NPFFR2",
"NPHP1",
"NPHP3",
"NPHP3-ACAD11",
"NPHP3-AS1",
"NPHP4",
"NPHS1",
"NPHS2",
"NPIPA1",
"NPIPA2",
"NPIPA3",
"NPIPA5",
"NPIPA7",
"NPIPB11",
"NPIPB15",
"NPIPB3",
"NPIPB4",
"NPIPB5",
"NPIPB6",
"NPIPB8",
"NPIPB9",
"NPL",
"NPLOC4",
"NPM1",
"NPM2",
"NPM3",
"NPNT",
"NPPA",
"NPPA-AS1",
"NPPB",
"NPPC",
"NPR1",
"NPR2",
"NPR3",
"NPRL2",
"NPRL3",
"NPSR1",
"NPSR1-AS1",
"NPTN",
"NPTN-IT1",
"NPTX1",
"NPTX2",
"NPTXR",
"NPW",
"NPY1R",
"NPY4R",
"NPY5R",
"NPY6R",
"NQO1",
"NQO2",
"NR0B2",
"NR1D1",
"NR1D2",
"NR1H2",
"NR1H3",
"NR1H4",
"NR1I2",
"NR1I3",
"NR2C1",
"NR2C2",
"NR2C2AP",
"NR2E1",
"NR2E3",
"NR2F1",
"NR2F1-AS1",
"NR2F2",
"NR2F2-AS1",
"NR2F6",
"NR3C1",
"NR3C2",
"NR4A1",
"NR4A2",
"NR4A3",
"NR5A1",
"NR5A2",
"NR6A1",
"NRADDP",
"NRAP",
"NRARP",
"NRAS",
"NRAV",
"NRBF2",
"NRBP1",
"NRBP2",
"NRCAM",
"NRD1",
"NRDE2",
"NREP",
"NRF1",
"NRG1",
"NRG2",
"NRG3",
"NRG4",
"NRGN",
"NRIP1",
"NRIP2",
"NRIP3",
"NRK",
"NRL",
"NRM",
"NRN1",
"NRN1L",
"NRON",
"NRP1",
"NRP2",
"NRROS",
"NRSN1",
"NRSN2",
"NRSN2-AS1",
"NRTN",
"NRXN1",
"NRXN2",
"NRXN3",
"NSA2",
"NSD1",
"NSDHL",
"NSF",
"NSFL1C",
"NSFP1",
"NSG1",
"NSL1",
"NSMAF",
"NSMCE1",
"NSMCE2",
"NSMCE4A",
"NSMF",
"NSRP1",
"NSUN2",
"NSUN3",
"NSUN4",
"NSUN5",
"NSUN5P1",
"NSUN5P2",
"NSUN6",
"NSUN7",
"NT5C",
"NT5C1A",
"NT5C1B",
"NT5C1B-RDH14",
"NT5C2",
"NT5C3A",
"NT5C3B",
"NT5DC1",
"NT5DC2",
"NT5DC3",
"NT5E",
"NT5M",
"NTAN1",
"NTF4",
"NTHL1",
"NTMT1",
"NTN1",
"NTN3",
"NTN4",
"NTN5",
"NTNG1",
"NTNG2",
"NTPCR",
"NTRK1",
"NTRK2",
"NTRK3",
"NTSR1",
"NTSR2",
"NUAK1",
"NUAK2",
"NUB1",
"NUBP1",
"NUBP2",
"NUBPL",
"NUCB1",
"NUCB1-AS1",
"NUCB2",
"NUCKS1",
"NUDC",
"NUDCD1",
"NUDCD2",
"NUDCD3",
"NUDT1",
"NUDT10",
"NUDT11",
"NUDT12",
"NUDT13",
"NUDT14",
"NUDT15",
"NUDT16",
"NUDT16L1",
"NUDT16P1",
"NUDT17",
"NUDT18",
"NUDT19",
"NUDT2",
"NUDT21",
"NUDT22",
"NUDT3",
"NUDT4",
"NUDT4P1",
"NUDT4P2",
"NUDT5",
"NUDT6",
"NUDT7",
"NUDT8",
"NUDT9",
"NUDT9P1",
"NUF2",
"NUFIP1",
"NUFIP2",
"NUGGC",
"NUMA1",
"NUMB",
"NUMBL",
"NUP107",
"NUP133",
"NUP153",
"NUP155",
"NUP160",
"NUP188",
"NUP205",
"NUP210",
"NUP210L",
"NUP214",
"NUP35",
"NUP37",
"NUP43",
"NUP50",
"NUP50-AS1",
"NUP54",
"NUP62",
"NUP62CL",
"NUP85",
"NUP88",
"NUP93",
"NUP98",
"NUPL1",
"NUPL2",
"NUPR1",
"NUPR1L",
"NUS1",
"NUSAP1",
"NUTF2",
"NUTM1",
"NUTM2A",
"NUTM2A-AS1",
"NUTM2B",
"NUTM2B-AS1",
"NUTM2D",
"NUTM2F",
"NUTM2G",
"NVL",
"NWD1",
"NWD2",
"NXF1",
"NXF3",
"NXF4",
"NXN",
"NXNL2",
"NXPE1",
"NXPE3",
"NXPE4",
"NXPH1",
"NXPH2",
"NXPH3",
"NXPH4",
"NXT1",
"NXT2",
"NYAP1",
"NYAP2",
"NYNRIN",
"NYX",
"OAF",
"OARD1",
"OAS1",
"OAS2",
"OAS3",
"OASL",
"OAT",
"OAZ1",
"OAZ2",
"OAZ3",
"OBFC1",
"OBP2A",
"OBP2B",
"OBSCN",
"OBSL1",
"OC90",
"OCEL1",
"OCIAD1",
"OCIAD2",
"OCLM",
"OCLN",
"OCM",
"OCM2",
"OCRL",
"ODAM",
"ODC1",
"ODF2",
"ODF2L",
"ODF3",
"ODF3B",
"ODF3L1",
"ODF3L2",
"ODF4",
"OFD1",
"OGDH",
"OGDHL",
"OGFOD1",
"OGFOD2",
"OGFOD3",
"OGFR",
"OGFR-AS1",
"OGFRL1",
"OGFRP1",
"OGG1",
"OGN",
"OGT",
"OIP5",
"OIP5-AS1",
"OIT3",
"OLA1",
"OLAH",
"OLFM1",
"OLFM2",
"OLFM4",
"OLFML1",
"OLFML2A",
"OLFML2B",
"OLFML3",
"OLMALINC",
"OLR1",
"OMA1",
"OMD",
"OMG",
"OMP",
"ONECUT1",
"ONECUT2",
"OOEP",
"OOSP1",
"OPA1",
"OPA1-AS1",
"OPA3",
"OPHN1",
"OPLAH",
"OPN1LW",
"OPN1MW",
"OPN1MW2",
"OPN1SW",
"OPN3",
"OPN5",
"OPRD1",
"OPRK1",
"OPRL1",
"OPRM1",
"OPTC",
"OPTN",
"OR10A2",
"OR10A3",
"OR10A4",
"OR10A5",
"OR10A6",
"OR10A7",
"OR10AD1",
"OR10H1",
"OR10H5",
"OR10J5",
"OR10K2",
"OR10S1",
"OR10T2",
"OR10V1",
"OR10V2P",
"OR11H1",
"OR11H12",
"OR11H2",
"OR11H4",
"OR13C4",
"OR13D1",
"OR13G1",
"OR13H1",
"OR13J1",
"OR1D5",
"OR1F1",
"OR1F2P",
"OR1J1",
"OR1J2",
"OR1J4",
"OR1K1",
"OR1L4",
"OR1L6",
"OR1N1",
"OR1N2",
"OR1Q1",
"OR2A1",
"OR2A1-AS1",
"OR2A12",
"OR2A2",
"OR2A20P",
"OR2A4",
"OR2A42",
"OR2A7",
"OR2A9P",
"OR2AE1",
"OR2AG1",
"OR2AG2",
"OR2B2",
"OR2B6",
"OR2C1",
"OR2C3",
"OR2D2",
"OR2D3",
"OR2H1",
"OR2H2",
"OR2K2",
"OR2S2",
"OR2T12",
"OR2T33",
"OR2T8",
"OR2W3",
"OR4D1",
"OR4F16",
"OR4F21",
"OR4F3",
"OR4F4",
"OR4F5",
"OR4K15",
"OR51B4",
"OR51B5",
"OR51E1",
"OR51I2",
"OR51Q1",
"OR52B2",
"OR52B6",
"OR52D1",
"OR52H1",
"OR52I1",
"OR52I2",
"OR52W1",
"OR56B4",
"OR5AU1",
"OR5B12",
"OR5C1",
"OR5E1P",
"OR5K1",
"OR5K2",
"OR5M11",
"OR5P3",
"OR6A2",
"OR6B2",
"OR6B3",
"OR6C4",
"OR6F1",
"OR6V1",
"OR6W1P",
"OR7A5",
"OR7D2",
"OR7E12P",
"OR7E14P",
"OR7E156P",
"OR7E24",
"OR7E2P",
"OR7E37P",
"OR7E47P",
"OR7E5P",
"OR7E91P",
"OR8A1",
"OR8B12",
"OR8B2",
"OR8B3",
"OR8B4",
"OR8B8",
"OR8D1",
"OR8D2",
"OR8G1",
"OR8G2",
"OR8G5",
"OR8S1",
"OR9A2",
"OR9A4",
"OR9G1",
"ORAI1",
"ORAI2",
"ORAI3",
"ORAOV1",
"ORC1",
"ORC2",
"ORC3",
"ORC4",
"ORC5",
"ORC6",
"ORM1",
"ORMDL1",
"ORMDL2",
"ORMDL3",
"OS9",
"OSBP",
"OSBP2",
"OSBPL10",
"OSBPL11",
"OSBPL1A",
"OSBPL2",
"OSBPL3",
"OSBPL5",
"OSBPL6",
"OSBPL7",
"OSBPL8",
"OSBPL9",
"OSCAR",
"OSCP1",
"OSER1",
"OSER1-AS1",
"OSGEP",
"OSGEPL1",
"OSGEPL1-AS1",
"OSGIN1",
"OSGIN2",
"OSM",
"OSMR",
"OSR1",
"OSR2",
"OST4",
"OSTC",
"OSTCP1",
"OSTF1",
"OSTM1",
"OTOA",
"OTOF",
"OTOG",
"OTOGL",
"OTOL1",
"OTOP1",
"OTOP2",
"OTOP3",
"OTOR",
"OTOS",
"OTP",
"OTUB1",
"OTUB2",
"OTUD1",
"OTUD3",
"OTUD4",
"OTUD5",
"OTUD6A",
"OTUD6B",
"OTUD6B-AS1",
"OTUD7A",
"OTUD7B",
"OTULIN",
"OTX1",
"OVCA2",
"OVCH1",
"OVCH1-AS1",
"OVCH2",
"OVGP1",
"OVOL1",
"OVOL1-AS1",
"OVOL2",
"OVOL3",
"OXA1L",
"OXCT1",
"OXCT1-AS1",
"OXCT2",
"OXER1",
"OXGR1",
"OXLD1",
"OXNAD1",
"OXR1",
"OXSM",
"OXSR1",
"OXTR",
"P2RX1",
"P2RX2",
"P2RX4",
"P2RX5",
"P2RX5-TAX1BP3",
"P2RX6",
"P2RX7",
"P2RY1",
"P2RY10",
"P2RY11",
"P2RY12",
"P2RY13",
"P2RY14",
"P2RY2",
"P2RY4",
"P2RY6",
"P2RY8",
"P3H1",
"P3H2",
"P3H2-AS1",
"P3H3",
"P3H4",
"P4HA1",
"P4HA2",
"P4HA2-AS1",
"P4HA3",
"P4HB",
"P4HTM",
"PA2G4",
"PA2G4P4",
"PAAF1",
"PABPC1",
"PABPC1L",
"PABPC1L2A",
"PABPC1L2B",
"PABPC1L2B-AS1",
"PABPC3",
"PABPC4",
"PABPC4L",
"PABPC5",
"PABPC5-AS1",
"PABPN1",
"PABPN1L",
"PACERR",
"PACRG",
"PACRG-AS1",
"PACRGL",
"PACS1",
"PACS2",
"PACSIN1",
"PACSIN2",
"PACSIN3",
"PADI1",
"PADI2",
"PADI3",
"PADI4",
"PADI6",
"PAEP",
"PAF1",
"PAFAH1B1",
"PAFAH1B2",
"PAFAH1B3",
"PAFAH2",
"PAG1",
"PAGE1",
"PAGE2B",
"PAGE5",
"PAGR1",
"PAH",
"PAICS",
"PAIP1",
"PAIP2",
"PAIP2B",
"PAK1",
"PAK1IP1",
"PAK2",
"PAK3",
"PAK4",
"PAK6",
"PAK7",
"PALB2",
"PALD1",
"PALLD",
"PALM",
"PALM2",
"PALM2-AKAP2",
"PALM3",
"PALMD",
"PAM",
"PAM16",
"PAMR1",
"PAN2",
"PAN3",
"PAN3-AS1",
"PANDAR",
"PANK1",
"PANK2",
"PANK3",
"PANK4",
"PANO1",
"PANX1",
"PANX2",
"PANX3",
"PAOX",
"PAPD4",
"PAPD5",
"PAPD7",
"PAPL",
"PAPLN",
"PAPOLA",
"PAPOLB",
"PAPOLG",
"PAPPA",
"PAPPA-AS1",
"PAPPA2",
"PAPSS1",
"PAPSS2",
"PAQR3",
"PAQR4",
"PAQR5",
"PAQR6",
"PAQR7",
"PAQR8",
"PAQR9",
"PARD3",
"PARD3-AS1",
"PARD3B",
"PARD6A",
"PARD6B",
"PARD6G",
"PARD6G-AS1",
"PARG",
"PARGP1",
"PARK2",
"PARK7",
"PARL",
"PARM1",
"PARN",
"PARP1",
"PARP10",
"PARP11",
"PARP12",
"PARP14",
"PARP15",
"PARP16",
"PARP2",
"PARP3",
"PARP4",
"PARP6",
"PARP8",
"PARP9",
"PARPBP",
"PARS2",
"PART1",
"PARTICL",
"PARVA",
"PARVB",
"PASK",
"PATE1",
"PATE2",
"PATE3",
"PATE4",
"PATL1",
"PATL2",
"PATZ1",
"PAUPAR",
"PAWR",
"PAX2",
"PAX3",
"PAX4",
"PAX5",
"PAX6",
"PAX7",
"PAX8",
"PAX8-AS1",
"PAX9",
"PAXBP1",
"PAXBP1-AS1",
"PAXIP1",
"PAXIP1-AS1",
"PAXIP1-AS2",
"PBDC1",
"PBK",
"PBLD",
"PBOV1",
"PBRM1",
"PBX1",
"PBX2",
"PBX3",
"PBX4",
"PBXIP1",
"PC",
"PCA3",
"PCAT1",
"PCAT14",
"PCAT19",
"PCAT29",
"PCAT4",
"PCAT5",
"PCAT6",
"PCAT7",
"PCBD1",
"PCBD2",
"PCBP1",
"PCBP1-AS1",
"PCBP2",
"PCBP2-OT1",
"PCBP3",
"PCBP4",
"PCCA",
"PCCB",
"PCDH1",
"PCDH10",
"PCDH11X",
"PCDH12",
"PCDH17",
"PCDH19",
"PCDH20",
"PCDH7",
"PCDH8",
"PCDH9",
"PCDHA1",
"PCDHA10",
"PCDHA11",
"PCDHA12",
"PCDHA13",
"PCDHA2",
"PCDHA3",
"PCDHA4",
"PCDHA5",
"PCDHA6",
"PCDHA7",
"PCDHA8",
"PCDHA9",
"PCDHAC1",
"PCDHAC2",
"PCDHB1",
"PCDHB10",
"PCDHB11",
"PCDHB12",
"PCDHB13",
"PCDHB14",
"PCDHB15",
"PCDHB16",
"PCDHB17P",
"PCDHB18P",
"PCDHB19P",
"PCDHB2",
"PCDHB3",
"PCDHB4",
"PCDHB5",
"PCDHB6",
"PCDHB7",
"PCDHB8",
"PCDHB9",
"PCDHGA1",
"PCDHGA10",
"PCDHGA11",
"PCDHGA12",
"PCDHGA2",
"PCDHGA3",
"PCDHGA4",
"PCDHGA5",
"PCDHGA6",
"PCDHGA7",
"PCDHGA8",
"PCDHGA9",
"PCDHGB1",
"PCDHGB2",
"PCDHGB3",
"PCDHGB4",
"PCDHGB5",
"PCDHGB6",
"PCDHGB7",
"PCDHGB8P",
"PCDHGC3",
"PCDHGC4",
"PCDHGC5",
"PCED1A",
"PCED1B",
"PCED1B-AS1",
"PCF11",
"PCGF1",
"PCGF2",
"PCGF3",
"PCGF5",
"PCGF6",
"PCID2",
"PCIF1",
"PCK1",
"PCK2",
"PCLO",
"PCM1",
"PCMT1",
"PCMTD1",
"PCMTD2",
"PCNA",
"PCNA-AS1",
"PCNAP1",
"PCNP",
"PCNT",
"PCNX",
"PCNXL2",
"PCNXL3",
"PCNXL4",
"PCOLCE",
"PCOLCE-AS1",
"PCOLCE2",
"PCP2",
"PCP4",
"PCP4L1",
"PCSK1",
"PCSK1N",
"PCSK2",
"PCSK4",
"PCSK5",
"PCSK6",
"PCSK7",
"PCSK9",
"PCTP",
"PCYOX1",
"PCYOX1L",
"PCYT1A",
"PCYT1B",
"PCYT2",
"PDAP1",
"PDC",
"PDCD1",
"PDCD10",
"PDCD11",
"PDCD1LG2",
"PDCD2",
"PDCD2L",
"PDCD4",
"PDCD4-AS1",
"PDCD5",
"PDCD6",
"PDCD6IP",
"PDCD6IPP2",
"PDCD7",
"PDCL",
"PDCL2",
"PDCL3",
"PDCL3P4",
"PDDC1",
"PDE10A",
"PDE11A",
"PDE12",
"PDE1A",
"PDE1B",
"PDE1C",
"PDE2A",
"PDE3A",
"PDE3B",
"PDE4A",
"PDE4B",
"PDE4C",
"PDE4D",
"PDE4DIP",
"PDE5A",
"PDE6A",
"PDE6B",
"PDE6D",
"PDE6G",
"PDE6H",
"PDE7A",
"PDE7B",
"PDE8A",
"PDE8B",
"PDE9A",
"PDF",
"PDGFA",
"PDGFB",
"PDGFC",
"PDGFD",
"PDGFRA",
"PDGFRB",
"PDGFRL",
"PDHA1",
"PDHB",
"PDHX",
"PDIA2",
"PDIA3",
"PDIA3P1",
"PDIA4",
"PDIA5",
"PDIA6",
"PDIK1L",
"PDILT",
"PDK1",
"PDK2",
"PDK3",
"PDK4",
"PDLIM1",
"PDLIM2",
"PDLIM3",
"PDLIM4",
"PDLIM5",
"PDLIM7",
"PDP1",
"PDP2",
"PDPK1",
"PDPN",
"PDPR",
"PDRG1",
"PDS5A",
"PDS5B",
"PDSS1",
"PDSS2",
"PDX1",
"PDX1-AS1",
"PDXDC1",
"PDXDC2P",
"PDXK",
"PDXP",
"PDZD11",
"PDZD2",
"PDZD3",
"PDZD4",
"PDZD7",
"PDZD8",
"PDZD9",
"PDZK1",
"PDZK1IP1",
"PDZK1P1",
"PDZRN3",
"PDZRN3-AS1",
"PEA15",
"PEAK1",
"PEAR1",
"PEBP1",
"PEBP4",
"PECAM1",
"PECR",
"PEF1",
"PEG10",
"PELI1",
"PELI2",
"PELI3",
"PELO",
"PELP1",
"PEMT",
"PENK",
"PEPD",
"PER1",
"PER2",
"PER3",
"PERM1",
"PERP",
"PES1",
"PET100",
"PET117",
"PEX1",
"PEX10",
"PEX11A",
"PEX11B",
"PEX11G",
"PEX12",
"PEX13",
"PEX14",
"PEX16",
"PEX19",
"PEX2",
"PEX26",
"PEX3",
"PEX5",
"PEX5L",
"PEX6",
"PEX7",
"PF4",
"PFAS",
"PFDN1",
"PFDN2",
"PFDN4",
"PFDN5",
"PFDN6",
"PFKFB1",
"PFKFB2",
"PFKFB3",
"PFKFB4",
"PFKL",
"PFKM",
"PFKP",
"PFN1",
"PFN1P2",
"PFN2",
"PFN3",
"PFN4",
"PGA3",
"PGA4",
"PGA5",
"PGAM1",
"PGAM1P5",
"PGAM2",
"PGAM4",
"PGAM5",
"PGAP1",
"PGAP2",
"PGAP3",
"PGBD1",
"PGBD2",
"PGBD3",
"PGBD4",
"PGBD5",
"PGC",
"PGD",
"PGF",
"PGGT1B",
"PGK1",
"PGK2",
"PGLS",
"PGLYRP1",
"PGLYRP2",
"PGLYRP4",
"PGM1",
"PGM2",
"PGM2L1",
"PGM3",
"PGM5",
"PGM5-AS1",
"PGM5P2",
"PGM5P3-AS1",
"PGM5P4-AS1",
"PGP",
"PGPEP1",
"PGPEP1L",
"PGR",
"PGRMC1",
"PGRMC2",
"PGS1",
"PHACTR1",
"PHACTR2",
"PHACTR3",
"PHACTR4",
"PHAX",
"PHB",
"PHB2",
"PHC1",
"PHC2",
"PHC3",
"PHEX",
"PHEX-AS1",
"PHF1",
"PHF10",
"PHF11",
"PHF12",
"PHF13",
"PHF14",
"PHF19",
"PHF2",
"PHF20",
"PHF20L1",
"PHF21A",
"PHF21B",
"PHF23",
"PHF24",
"PHF3",
"PHF5A",
"PHF6",
"PHF7",
"PHF8",
"PHGDH",
"PHGR1",
"PHIP",
"PHKA1",
"PHKA2",
"PHKA2-AS1",
"PHKB",
"PHKG1",
"PHKG2",
"PHLDA1",
"PHLDA2",
"PHLDA3",
"PHLDB1",
"PHLDB2",
"PHLDB3",
"PHLPP1",
"PHLPP2",
"PHOSPHO1",
"PHOSPHO2",
"PHOSPHO2-KLHL23",
"PHOX2A",
"PHPT1",
"PHRF1",
"PHTF1",
"PHTF2",
"PHYH",
"PHYHD1",
"PHYHIP",
"PHYKPL",
"PI15",
"PI16",
"PI3",
"PI4K2A",
"PI4K2B",
"PI4KA",
"PI4KAP1",
"PI4KAP2",
"PI4KB",
"PIANP",
"PIAS1",
"PIAS2",
"PIAS3",
"PIAS4",
"PIBF1",
"PICALM",
"PICK1",
"PID1",
"PIDD1",
"PIEZO1",
"PIEZO2",
"PIF1",
"PIFO",
"PIGA",
"PIGB",
"PIGBOS1",
"PIGC",
"PIGF",
"PIGG",
"PIGH",
"PIGK",
"PIGL",
"PIGM",
"PIGN",
"PIGO",
"PIGP",
"PIGQ",
"PIGR",
"PIGS",
"PIGT",
"PIGU",
"PIGV",
"PIGW",
"PIGX",
"PIGY",
"PIGZ",
"PIH1D1",
"PIH1D2",
"PIK3AP1",
"PIK3C2A",
"PIK3C2B",
"PIK3C2G",
"PIK3C3",
"PIK3CA",
"PIK3CB",
"PIK3CD",
"PIK3CD-AS1",
"PIK3CD-AS2",
"PIK3IP1",
"PIK3IP1-AS1",
"PIK3R1",
"PIK3R2",
"PIK3R3",
"PIK3R4",
"PIK3R5",
"PIKFYVE",
"PILRA",
"PILRB",
"PIM1",
"PIM2",
"PIM3",
"PIN1",
"PIN4",
"PIN4P1",
"PINK1",
"PINK1-AS",
"PINLYP",
"PINX1",
"PIP",
"PIP4K2A",
"PIP4K2B",
"PIP4K2C",
"PIP5K1A",
"PIP5K1B",
"PIP5K1C",
"PIP5K1P1",
"PIP5KL1",
"PIPOX",
"PIPSL",
"PIR",
"PIR-FIGF",
"PIRT",
"PISD",
"PITHD1",
"PITPNA",
"PITPNA-AS1",
"PITPNB",
"PITPNC1",
"PITPNM1",
"PITPNM2",
"PITPNM3",
"PITRM1",
"PITRM1-AS1",
"PITX1",
"PITX2",
"PITX3",
"PIWIL2",
"PIWIL3",
"PIWIL4",
"PJA1",
"PJA2",
"PKD1",
"PKD1L1",
"PKD1L2",
"PKD1L3",
"PKD1P1",
"PKD1P6",
"PKD2",
"PKD2L1",
"PKD2L2",
"PKDCC",
"PKDREJ",
"PKHD1",
"PKHD1L1",
"PKI55",
"PKIA",
"PKIA-AS1",
"PKIB",
"PKIG",
"PKLR",
"PKM",
"PKMYT1",
"PKN1",
"PKN2",
"PKN2-AS1",
"PKN3",
"PKNOX1",
"PKNOX2",
"PKP1",
"PKP2",
"PKP3",
"PKP4",
"PLA1A",
"PLA2G10",
"PLA2G12A",
"PLA2G12B",
"PLA2G15",
"PLA2G16",
"PLA2G1B",
"PLA2G2A",
"PLA2G2F",
"PLA2G3",
"PLA2G4A",
"PLA2G4B",
"PLA2G4C",
"PLA2G4D",
"PLA2G4E",
"PLA2G4E-AS1",
"PLA2G4F",
"PLA2G5",
"PLA2G6",
"PLA2G7",
"PLA2R1",
"PLAA",
"PLAC1",
"PLAC4",
"PLAC8",
"PLAC8L1",
"PLAG1",
"PLAGL1",
"PLAGL2",
"PLAT",
"PLAU",
"PLAUR",
"PLB1",
"PLBD1",
"PLBD1-AS1",
"PLBD2",
"PLCB1",
"PLCB2",
"PLCB3",
"PLCB4",
"PLCD1",
"PLCD3",
"PLCD4",
"PLCE1",
"PLCE1-AS1",
"PLCE1-AS2",
"PLCG1",
"PLCG1-AS1",
"PLCG2",
"PLCH1",
"PLCH2",
"PLCL1",
"PLCL2",
"PLCXD1",
"PLCXD2",
"PLCXD2-AS1",
"PLCXD3",
"PLCZ1",
"PLD1",
"PLD2",
"PLD3",
"PLD4",
"PLD5",
"PLD6",
"PLEC",
"PLEK",
"PLEK2",
"PLEKHA1",
"PLEKHA2",
"PLEKHA3",
"PLEKHA4",
"PLEKHA5",
"PLEKHA6",
"PLEKHA7",
"PLEKHA8",
"PLEKHA8P1",
"PLEKHB1",
"PLEKHB2",
"PLEKHD1",
"PLEKHF1",
"PLEKHF2",
"PLEKHG1",
"PLEKHG2",
"PLEKHG3",
"PLEKHG4",
"PLEKHG4B",
"PLEKHG5",
"PLEKHG6",
"PLEKHG7",
"PLEKHH1",
"PLEKHH2",
"PLEKHH3",
"PLEKHJ1",
"PLEKHM1",
"PLEKHM1P",
"PLEKHM2",
"PLEKHM3",
"PLEKHN1",
"PLEKHO1",
"PLEKHO2",
"PLEKHS1",
"PLET1",
"PLG",
"PLGLA",
"PLGLB1",
"PLGLB2",
"PLGRKT",
"PLIN1",
"PLIN2",
"PLIN3",
"PLIN4",
"PLIN5",
"PLK1",
"PLK2",
"PLK3",
"PLK4",
"PLK5",
"PLLP",
"PLN",
"PLOD1",
"PLOD2",
"PLOD3",
"PLP1",
"PLP2",
"PLRG1",
"PLS1",
"PLS3",
"PLS3-AS1",
"PLSCR1",
"PLSCR2",
"PLSCR3",
"PLSCR4",
"PLTP",
"PLVAP",
"PLXDC1",
"PLXDC2",
"PLXNA1",
"PLXNA2",
"PLXNA3",
"PLXNA4",
"PLXNB1",
"PLXNB2",
"PLXNB3",
"PLXNC1",
"PLXND1",
"PM20D1",
"PM20D2",
"PMAIP1",
"PMCH",
"PMEL",
"PMEPA1",
"PMF1",
"PMF1-BGLAP",
"PMFBP1",
"PML",
"PMM1",
"PMM2",
"PMP22",
"PMPCA",
"PMPCB",
"PMS1",
"PMS2",
"PMS2CL",
"PMS2P1",
"PMS2P2",
"PMS2P3",
"PMS2P4",
"PMS2P5",
"PMS2P7",
"PMS2P9",
"PMVK",
"PNCK",
"PNISR",
"PNKD",
"PNKP",
"PNLDC1",
"PNLIP",
"PNLIPRP1",
"PNLIPRP3",
"PNMA1",
"PNMA2",
"PNMA3",
"PNMA5",
"PNMA6A",
"PNMAL1",
"PNMAL2",
"PNMT",
"PNN",
"PNO1",
"PNOC",
"PNP",
"PNPLA1",
"PNPLA2",
"PNPLA3",
"PNPLA4",
"PNPLA6",
"PNPLA7",
"PNPLA8",
"PNPO",
"PNPT1",
"PNRC1",
"PNRC2",
"POC1A",
"POC1B",
"POC1B-GALNT4",
"POC5",
"PODNL1",
"PODXL",
"PODXL2",
"POF1B",
"POFUT1",
"POFUT2",
"POGK",
"POGLUT1",
"POGZ",
"POLA1",
"POLA2",
"POLB",
"POLD1",
"POLD2",
"POLD3",
"POLD4",
"POLDIP2",
"POLDIP3",
"POLE",
"POLE2",
"POLE3",
"POLE4",
"POLG",
"POLG2",
"POLH",
"POLI",
"POLK",
"POLL",
"POLM",
"POLN",
"POLQ",
"POLR1A",
"POLR1B",
"POLR1C",
"POLR1D",
"POLR1E",
"POLR2A",
"POLR2B",
"POLR2C",
"POLR2D",
"POLR2E",
"POLR2F",
"POLR2G",
"POLR2H",
"POLR2I",
"POLR2J",
"POLR2J2",
"POLR2J3",
"POLR2J4",
"POLR2K",
"POLR2L",
"POLR2M",
"POLR3A",
"POLR3B",
"POLR3C",
"POLR3D",
"POLR3E",
"POLR3F",
"POLR3G",
"POLR3GL",
"POLR3H",
"POLR3K",
"POLRMT",
"POM121",
"POM121C",
"POM121L10P",
"POM121L1P",
"POM121L2",
"POM121L4P",
"POM121L8P",
"POM121L9P",
"POMGNT1",
"POMGNT2",
"POMK",
"POMP",
"POMT1",
"POMT2",
"POMZP3",
"PON1",
"PON2",
"PON3",
"POP1",
"POP4",
"POP5",
"POP7",
"POPDC2",
"POPDC3",
"POR",
"PORCN",
"POSTN",
"POT1",
"POT1-AS1",
"POTEB2",
"POTEB3",
"POTEC",
"POTED",
"POTEE",
"POTEF",
"POTEG",
"POTEH",
"POTEH-AS1",
"POTEI",
"POTEJ",
"POTEKP",
"POTEM",
"POU1F1",
"POU2AF1",
"POU2F1",
"POU2F2",
"POU2F3",
"POU3F1",
"POU3F2",
"POU3F3",
"POU4F1",
"POU4F3",
"POU5F1",
"POU5F1B",
"POU5F1P3",
"POU5F1P4",
"POU5F1P5",
"POU5F2",
"POU6F1",
"PP14571",
"PP2D1",
"PP7080",
"PPA1",
"PPA2",
"PPAN",
"PPAN-P2RY11",
"PPAP2A",
"PPAP2B",
"PPAP2C",
"PPAPDC1A",
"PPAPDC1B",
"PPAPDC2",
"PPAPDC3",
"PPARA",
"PPARD",
"PPARG",
"PPARGC1A",
"PPARGC1B",
"PPAT",
"PPBP",
"PPBPP2",
"PPCDC",
"PPCS",
"PPDPF",
"PPEF1",
"PPEF2",
"PPFIA1",
"PPFIA2",
"PPFIA3",
"PPFIA4",
"PPFIBP1",
"PPFIBP2",
"PPHLN1",
"PPIA",
"PPIAL4A",
"PPIAL4C",
"PPIAL4D",
"PPIAL4E",
"PPIAL4G",
"PPIAP30",
"PPIB",
"PPIC",
"PPID",
"PPIE",
"PPIEL",
"PPIF",
"PPIG",
"PPIH",
"PPIL1",
"PPIL2",
"PPIL3",
"PPIL4",
"PPIL6",
"PPIP5K1",
"PPIP5K2",
"PPL",
"PPM1A",
"PPM1B",
"PPM1D",
"PPM1E",
"PPM1F",
"PPM1G",
"PPM1H",
"PPM1J",
"PPM1K",
"PPM1L",
"PPM1M",
"PPM1N",
"PPME1",
"PPOX",
"PPP1CA",
"PPP1CB",
"PPP1CC",
"PPP1R10",
"PPP1R11",
"PPP1R12A",
"PPP1R12B",
"PPP1R12C",
"PPP1R13B",
"PPP1R13L",
"PPP1R14A",
"PPP1R14B",
"PPP1R14C",
"PPP1R14D",
"PPP1R15A",
"PPP1R15B",
"PPP1R16A",
"PPP1R16B",
"PPP1R18",
"PPP1R1A",
"PPP1R1B",
"PPP1R1C",
"PPP1R2",
"PPP1R21",
"PPP1R26",
"PPP1R26-AS1",
"PPP1R27",
"PPP1R32",
"PPP1R35",
"PPP1R36",
"PPP1R37",
"PPP1R3B",
"PPP1R3C",
"PPP1R3D",
"PPP1R3E",
"PPP1R3F",
"PPP1R3G",
"PPP1R42",
"PPP1R7",
"PPP1R8",
"PPP1R9A",
"PPP1R9B",
"PPP2CA",
"PPP2CB",
"PPP2R1A",
"PPP2R1B",
"PPP2R2A",
"PPP2R2B",
"PPP2R2C",
"PPP2R2D",
"PPP2R3A",
"PPP2R3B",
"PPP2R3C",
"PPP2R4",
"PPP2R5A",
"PPP2R5B",
"PPP2R5C",
"PPP2R5D",
"PPP2R5E",
"PPP3CA",
"PPP3CB",
"PPP3CB-AS1",
"PPP3CC",
"PPP3R1",
"PPP3R2",
"PPP4C",
"PPP4R1",
"PPP4R1-AS1",
"PPP4R1L",
"PPP4R2",
"PPP4R3A",
"PPP4R3B",
"PPP4R4",
"PPP5C",
"PPP5D1",
"PPP6C",
"PPP6R1",
"PPP6R2",
"PPP6R3",
"PPRC1",
"PPT1",
"PPT2",
"PPT2-EGFL8",
"PPTC7",
"PPWD1",
"PPY",
"PQBP1",
"PQLC1",
"PQLC2",
"PQLC2L",
"PQLC3",
"PRADC1",
"PRAF2",
"PRAM1",
"PRAME",
"PRAMEF10",
"PRAMEF12",
"PRAMEF16",
"PRAMEF17",
"PRAP1",
"PRB1",
"PRB2",
"PRB3",
"PRB4",
"PRC1",
"PRC1-AS1",
"PRCAT47",
"PRCC",
"PRCD",
"PRCP",
"PRDM1",
"PRDM10",
"PRDM11",
"PRDM12",
"PRDM13",
"PRDM14",
"PRDM15",
"PRDM16",
"PRDM2",
"PRDM4",
"PRDM5",
"PRDM6",
"PRDM7",
"PRDM8",
"PRDM9",
"PRDX1",
"PRDX2",
"PRDX3",
"PRDX4",
"PRDX5",
"PRDX6",
"PREB",
"PRELID1",
"PRELID2",
"PRELP",
"PREP",
"PREPL",
"PREX1",
"PREX2",
"PRF1",
"PRG1",
"PRG2",
"PRG4",
"PRH1",
"PRH1-PRR4",
"PRH2",
"PRICKLE1",
"PRICKLE2",
"PRICKLE2-AS1",
"PRICKLE2-AS2",
"PRICKLE2-AS3",
"PRICKLE3",
"PRICKLE4",
"PRIM1",
"PRIM2",
"PRIMA1",
"PRIMPOL",
"PRKAA1",
"PRKAA2",
"PRKAB1",
"PRKAB2",
"PRKACA",
"PRKACB",
"PRKACG",
"PRKAG1",
"PRKAG2",
"PRKAG2-AS1",
"PRKAG3",
"PRKAR1A",
"PRKAR1B",
"PRKAR2A",
"PRKAR2A-AS1",
"PRKAR2B",
"PRKCA",
"PRKCA-AS1",
"PRKCD",
"PRKCDBP",
"PRKCE",
"PRKCG",
"PRKCH",
"PRKCI",
"PRKCQ",
"PRKCQ-AS1",
"PRKCSH",
"PRKCZ",
"PRKD1",
"PRKD2",
"PRKD3",
"PRKDC",
"PRKG1",
"PRKG1-AS1",
"PRKG2",
"PRKRA",
"PRKRIP1",
"PRKRIR",
"PRKX",
"PRKX-AS1",
"PRKXP1",
"PRKY",
"PRLR",
"PRMT1",
"PRMT2",
"PRMT3",
"PRMT5",
"PRMT5-AS1",
"PRMT6",
"PRMT7",
"PRMT8",
"PRMT9",
"PRNCR1",
"PRNP",
"PRO1804",
"PROB1",
"PROC",
"PROCA1",
"PROCR",
"PRODH",
"PROKR1",
"PROM1",
"PROM2",
"PROP1",
"PRORSD1P",
"PROS1",
"PROSC",
"PROSER1",
"PROSER2",
"PROSER2-AS1",
"PROSER3",
"PROX1",
"PROX2",
"PROZ",
"PRPF18",
"PRPF19",
"PRPF3",
"PRPF31",
"PRPF38A",
"PRPF38B",
"PRPF39",
"PRPF4",
"PRPF40A",
"PRPF40B",
"PRPF4B",
"PRPF6",
"PRPF8",
"PRPH",
"PRPH2",
"PRPS1",
"PRPS2",
"PRPSAP1",
"PRPSAP2",
"PRR11",
"PRR12",
"PRR13",
"PRR14",
"PRR14L",
"PRR15",
"PRR15L",
"PRR16",
"PRR18",
"PRR19",
"PRR22",
"PRR23A",
"PRR23B",
"PRR23C",
"PRR23D1",
"PRR23D2",
"PRR25",
"PRR26",
"PRR29",
"PRR29-AS1",
"PRR3",
"PRR34",
"PRR34-AS1",
"PRR36",
"PRR4",
"PRR5",
"PRR5-ARHGAP8",
"PRR5L",
"PRR7",
"PRR7-AS1",
"PRRC1",
"PRRC2A",
"PRRC2B",
"PRRC2C",
"PRRG1",
"PRRG2",
"PRRG4",
"PRRT1",
"PRRT2",
"PRRT3",
"PRRT3-AS1",
"PRRT4",
"PRRX1",
"PRRX2",
"PRRX2-AS1",
"PRSS1",
"PRSS12",
"PRSS16",
"PRSS2",
"PRSS22",
"PRSS23",
"PRSS27",
"PRSS3",
"PRSS30P",
"PRSS33",
"PRSS35",
"PRSS36",
"PRSS37",
"PRSS38",
"PRSS41",
"PRSS48",
"PRSS53",
"PRSS54",
"PRSS56",
"PRSS57",
"PRSS8",
"PRTFDC1",
"PRTG",
"PRUNE",
"PRUNE2",
"PRX",
"PSAP",
"PSAPL1",
"PSAT1",
"PSCA",
"PSD",
"PSD2",
"PSD3",
"PSD4",
"PSEN1",
"PSEN2",
"PSENEN",
"PSG1",
"PSG10P",
"PSG2",
"PSG3",
"PSG4",
"PSG5",
"PSG6",
"PSG7",
"PSG8",
"PSG9",
"PSIP1",
"PSKH1",
"PSKH2",
"PSMA1",
"PSMA2",
"PSMA3",
"PSMA3-AS1",
"PSMA4",
"PSMA5",
"PSMA6",
"PSMA7",
"PSMB1",
"PSMB10",
"PSMB11",
"PSMB2",
"PSMB3",
"PSMB4",
"PSMB5",
"PSMB6",
"PSMB7",
"PSMB8",
"PSMB8-AS1",
"PSMB9",
"PSMC1",
"PSMC2",
"PSMC3",
"PSMC3IP",
"PSMC4",
"PSMC5",
"PSMC6",
"PSMD1",
"PSMD10",
"PSMD11",
"PSMD12",
"PSMD13",
"PSMD14",
"PSMD2",
"PSMD3",
"PSMD4",
"PSMD5",
"PSMD5-AS1",
"PSMD6",
"PSMD6-AS2",
"PSMD7",
"PSMD8",
"PSMD9",
"PSME1",
"PSME2",
"PSME3",
"PSME4",
"PSMF1",
"PSMG1",
"PSMG2",
"PSMG3",
"PSMG3-AS1",
"PSMG4",
"PSORS1C1",
"PSORS1C2",
"PSORS1C3",
"PSPC1",
"PSPH",
"PSPN",
"PSRC1",
"PSTK",
"PSTPIP1",
"PSTPIP2",
"PTAFR",
"PTAR1",
"PTBP1",
"PTBP2",
"PTBP3",
"PTCD1",
"PTCD2",
"PTCD3",
"PTCH1",
"PTCH2",
"PTCHD2",
"PTCHD3",
"PTCHD4",
"PTCRA",
"PTCSC3",
"PTDSS1",
"PTDSS2",
"PTEN",
"PTENP1",
"PTENP1-AS",
"PTER",
"PTGDR",
"PTGDR2",
"PTGDS",
"PTGER1",
"PTGER2",
"PTGER3",
"PTGER4",
"PTGER4P2-CDK2AP2P2",
"PTGES",
"PTGES2",
"PTGES2-AS1",
"PTGES3",
"PTGES3L",
"PTGES3L-AARSD1",
"PTGFR",
"PTGFRN",
"PTGIR",
"PTGIS",
"PTGR1",
"PTGR2",
"PTGS1",
"PTGS2",
"PTH",
"PTH1R",
"PTH2R",
"PTHLH",
"PTK2",
"PTK2B",
"PTK6",
"PTK7",
"PTMA",
"PTMS",
"PTOV1",
"PTOV1-AS1",
"PTOV1-AS2",
"PTP4A1",
"PTP4A2",
"PTP4A3",
"PTPDC1",
"PTPMT1",
"PTPN1",
"PTPN11",
"PTPN12",
"PTPN13",
"PTPN14",
"PTPN18",
"PTPN2",
"PTPN20",
"PTPN21",
"PTPN22",
"PTPN23",
"PTPN3",
"PTPN4",
"PTPN5",
"PTPN6",
"PTPN7",
"PTPN9",
"PTPRA",
"PTPRB",
"PTPRC",
"PTPRCAP",
"PTPRD",
"PTPRE",
"PTPRF",
"PTPRG",
"PTPRG-AS1",
"PTPRH",
"PTPRJ",
"PTPRK",
"PTPRM",
"PTPRN",
"PTPRN2",
"PTPRO",
"PTPRQ",
"PTPRR",
"PTPRS",
"PTPRT",
"PTPRU",
"PTPRVP",
"PTPRZ1",
"PTRF",
"PTRH1",
"PTRH2",
"PTRHD1",
"PTS",
"PTTG1",
"PTTG1IP",
"PTTG2",
"PTTG3P",
"PTX3",
"PTX4",
"PUF60",
"PUM1",
"PUM2",
"PURA",
"PURB",
"PURG",
"PUS1",
"PUS10",
"PUS3",
"PUS7",
"PUS7L",
"PUSL1",
"PVALB",
"PVR",
"PVRIG",
"PVRIG2P",
"PVRL1",
"PVRL2",
"PVRL3",
"PVRL3-AS1",
"PVRL4",
"PVT1",
"PWAR1",
"PWAR5",
"PWARSN",
"PWP1",
"PWP2",
"PWRN1",
"PWWP2A",
"PWWP2B",
"PXDC1",
"PXDN",
"PXDNL",
"PXK",
"PXMP2",
"PXMP4",
"PXN",
"PXN-AS1",
"PXT1",
"PXYLP1",
"PYCARD",
"PYCARD-AS1",
"PYCR1",
"PYCR2",
"PYCRL",
"PYDC1",
"PYGB",
"PYGL",
"PYGM",
"PYGO1",
"PYGO2",
"PYROXD1",
"PYROXD2",
"PYY",
"PYY2",
"PZP",
"QARS",
"QDPR",
"QKI",
"QPCT",
"QPCTL",
"QPRT",
"QRFP",
"QRFPR",
"QRICH1",
"QRICH2",
"QRSL1",
"QSER1",
"QSOX1",
"QSOX2",
"QTRT1",
"QTRTD1",
"R3HCC1",
"R3HCC1L",
"R3HDM1",
"R3HDM2",
"R3HDM4",
"RAB10",
"RAB11A",
"RAB11B",
"RAB11B-AS1",
"RAB11FIP1",
"RAB11FIP2",
"RAB11FIP3",
"RAB11FIP4",
"RAB11FIP5",
"RAB12",
"RAB13",
"RAB14",
"RAB15",
"RAB17",
"RAB18",
"RAB19",
"RAB1A",
"RAB1B",
"RAB20",
"RAB21",
"RAB22A",
"RAB23",
"RAB24",
"RAB25",
"RAB26",
"RAB27A",
"RAB27B",
"RAB28",
"RAB29",
"RAB2A",
"RAB2B",
"RAB30",
"RAB30-AS1",
"RAB31",
"RAB32",
"RAB33A",
"RAB33B",
"RAB34",
"RAB35",
"RAB36",
"RAB37",
"RAB38",
"RAB39A",
"RAB39B",
"RAB3A",
"RAB3B",
"RAB3C",
"RAB3D",
"RAB3GAP1",
"RAB3GAP2",
"RAB3IL1",
"RAB3IP",
"RAB40A",
"RAB40AL",
"RAB40B",
"RAB40C",
"RAB41",
"RAB42",
"RAB43",
"RAB44",
"RAB4A",
"RAB4B",
"RAB4B-EGLN2",
"RAB5A",
"RAB5B",
"RAB5C",
"RAB6A",
"RAB6B",
"RAB6C",
"RAB6C-AS1",
"RAB7A",
"RAB7B",
"RAB8A",
"RAB8B",
"RAB9A",
"RAB9B",
"RABAC1",
"RABEP1",
"RABEP2",
"RABEPK",
"RABGAP1",
"RABGAP1L",
"RABGEF1",
"RABGGTA",
"RABGGTB",
"RABIF",
"RABL2A",
"RABL2B",
"RABL3",
"RABL6",
"RAC1",
"RAC2",
"RAC3",
"RACGAP1",
"RACGAP1P",
"RAD1",
"RAD17",
"RAD18",
"RAD21",
"RAD21-AS1",
"RAD21L1",
"RAD23A",
"RAD23B",
"RAD50",
"RAD51",
"RAD51-AS1",
"RAD51AP1",
"RAD51AP2",
"RAD51B",
"RAD51C",
"RAD51D",
"RAD51L3-RFFL",
"RAD52",
"RAD54B",
"RAD54L",
"RAD54L2",
"RAD9A",
"RAD9B",
"RADIL",
"RAE1",
"RAET1E",
"RAET1E-AS1",
"RAET1G",
"RAET1K",
"RAET1L",
"RAF1",
"RAG1",
"RAG2",
"RAI1",
"RAI1-AS1",
"RAI14",
"RAI2",
"RALA",
"RALB",
"RALBP1",
"RALGAPA1",
"RALGAPA1P",
"RALGAPA2",
"RALGAPB",
"RALGDS",
"RALGPS1",
"RALGPS2",
"RALY",
"RALY-AS1",
"RALYL",
"RAMP1",
"RAMP2",
"RAMP2-AS1",
"RAMP3",
"RAN",
"RANBP1",
"RANBP10",
"RANBP17",
"RANBP2",
"RANBP3",
"RANBP3L",
"RANBP6",
"RANBP9",
"RANGAP1",
"RANGRF",
"RAP1A",
"RAP1B",
"RAP1GAP",
"RAP1GAP2",
"RAP1GDS1",
"RAP2A",
"RAP2B",
"RAP2C",
"RAP2C-AS1",
"RAPGEF1",
"RAPGEF2",
"RAPGEF3",
"RAPGEF4",
"RAPGEF4-AS1",
"RAPGEF5",
"RAPGEF6",
"RAPGEFL1",
"RAPH1",
"RAPSN",
"RARA",
"RARA-AS1",
"RARB",
"RARG",
"RARRES1",
"RARRES2",
"RARRES3",
"RARS",
"RARS2",
"RASA1",
"RASA2",
"RASA3",
"RASA4",
"RASA4B",
"RASA4CP",
"RASAL1",
"RASAL2",
"RASAL2-AS1",
"RASAL3",
"RASD1",
"RASD2",
"RASEF",
"RASGEF1A",
"RASGEF1B",
"RASGEF1C",
"RASGRF1",
"RASGRF2",
"RASGRP1",
"RASGRP2",
"RASGRP3",
"RASGRP4",
"RASIP1",
"RASL10A",
"RASL10B",
"RASL11A",
"RASL11B",
"RASL12",
"RASSF1",
"RASSF1-AS1",
"RASSF10",
"RASSF2",
"RASSF3",
"RASSF4",
"RASSF5",
"RASSF6",
"RASSF7",
"RASSF8",
"RASSF8-AS1",
"RASSF9",
"RAVER1",
"RAVER2",
"RAX",
"RAX2",
"RB1",
"RB1CC1",
"RBAK",
"RBAK-RBAKDN",
"RBAKDN",
"RBBP4",
"RBBP5",
"RBBP6",
"RBBP7",
"RBBP8",
"RBBP8NL",
"RBBP9",
"RBCK1",
"RBFA",
"RBFADN",
"RBFOX2",
"RBFOX3",
"RBKS",
"RBL1",
"RBL2",
"RBM10",
"RBM11",
"RBM12",
"RBM12B",
"RBM12B-AS1",
"RBM14",
"RBM14-RBM4",
"RBM15",
"RBM15B",
"RBM17",
"RBM18",
"RBM19",
"RBM20",
"RBM22",
"RBM23",
"RBM24",
"RBM25",
"RBM26",
"RBM26-AS1",
"RBM27",
"RBM28",
"RBM3",
"RBM33",
"RBM34",
"RBM38",
"RBM39",
"RBM4",
"RBM41",
"RBM42",
"RBM43",
"RBM44",
"RBM45",
"RBM46",
"RBM47",
"RBM48",
"RBM4B",
"RBM5",
"RBM5-AS1",
"RBM6",
"RBM7",
"RBM8A",
"RBMS1",
"RBMS2",
"RBMS3",
"RBMX",
"RBMX2",
"RBMXL1",
"RBMXL2",
"RBP1",
"RBP2",
"RBP3",
"RBP4",
"RBP5",
"RBP7",
"RBPJ",
"RBPJL",
"RBPMS",
"RBPMS-AS1",
"RBPMS2",
"RBSN",
"RBX1",
"RC3H1",
"RC3H2",
"RCAN1",
"RCAN2",
"RCAN3",
"RCAN3AS",
"RCBTB1",
"RCBTB2",
"RCC1",
"RCC2",
"RCCD1",
"RCE1",
"RCHY1",
"RCL1",
"RCN1",
"RCN2",
"RCN3",
"RCOR1",
"RCOR2",
"RCOR3",
"RD3",
"RDH10",
"RDH10-AS1",
"RDH11",
"RDH12",
"RDH13",
"RDH14",
"RDH16",
"RDH5",
"RDH8",
"RDM1",
"RDX",
"REC114",
"REC8",
"RECK",
"RECQL",
"RECQL4",
"RECQL5",
"REEP1",
"REEP2",
"REEP3",
"REEP4",
"REEP5",
"REEP6",
"REG1A",
"REG4",
"REL",
"RELA",
"RELB",
"RELL1",
"RELL2",
"RELN",
"RELT",
"REM2",
"REN",
"RENBP",
"REP15",
"REPIN1",
"REPS1",
"REPS2",
"RER1",
"RERE",
"REREP3",
"RERG",
"RERGL",
"RESP18",
"REST",
"RET",
"RETSAT",
"REV1",
"REV3L",
"REXO1",
"REXO1L2P",
"REXO2",
"REXO4",
"RFC1",
"RFC2",
"RFC3",
"RFC4",
"RFC5",
"RFESD",
"RFFL",
"RFK",
"RFNG",
"RFPL1",
"RFPL1S",
"RFPL2",
"RFPL3S",
"RFPL4A",
"RFPL4AL1",
"RFPL4B",
"RFT1",
"RFTN1",
"RFTN2",
"RFWD2",
"RFWD3",
"RFX1",
"RFX2",
"RFX3",
"RFX3-AS1",
"RFX4",
"RFX5",
"RFX6",
"RFX7",
"RFX8",
"RFXANK",
"RFXAP",
"RGAG1",
"RGAG4",
"RGCC",
"RGL1",
"RGL2",
"RGL3",
"RGL4",
"RGMA",
"RGMB",
"RGMB-AS1",
"RGN",
"RGP1",
"RGPD1",
"RGPD2",
"RGPD3",
"RGPD4",
"RGPD4-AS1",
"RGPD5",
"RGPD6",
"RGPD8",
"RGS10",
"RGS11",
"RGS12",
"RGS14",
"RGS16",
"RGS17",
"RGS18",
"RGS19",
"RGS2",
"RGS20",
"RGS22",
"RGS3",
"RGS4",
"RGS5",
"RGS6",
"RGS7",
"RGS9",
"RGS9BP",
"RHAG",
"RHBDD1",
"RHBDD2",
"RHBDD3",
"RHBDF1",
"RHBDF2",
"RHBDL1",
"RHBDL2",
"RHBDL3",
"RHBG",
"RHCE",
"RHCG",
"RHD",
"RHEB",
"RHEBL1",
"RHNO1",
"RHO",
"RHOA",
"RHOB",
"RHOBTB1",
"RHOBTB2",
"RHOBTB3",
"RHOC",
"RHOD",
"RHOF",
"RHOG",
"RHOH",
"RHOQ",
"RHOT1",
"RHOT2",
"RHOU",
"RHOV",
"RHOXF1-AS1",
"RHOXF1P1",
"RHOXF2",
"RHOXF2B",
"RHPN1",
"RHPN1-AS1",
"RHPN2",
"RIBC1",
"RIBC2",
"RIC1",
"RIC3",
"RIC8A",
"RIC8B",
"RICTOR",
"RIF1",
"RIIAD1",
"RILP",
"RILPL1",
"RILPL2",
"RIMBP2",
"RIMBP3",
"RIMBP3B",
"RIMBP3C",
"RIMKLA",
"RIMKLB",
"RIMS1",
"RIMS2",
"RIMS3",
"RIMS4",
"RIN1",
"RIN2",
"RIN3",
"RING1",
"RINL",
"RINT1",
"RIOK1",
"RIOK2",
"RIOK3",
"RIPK1",
"RIPK2",
"RIPK3",
"RIPK4",
"RIPPLY1",
"RIPPLY2",
"RIPPLY3",
"RIT1",
"RITA1",
"RLBP1",
"RLF",
"RLIM",
"RLN1",
"RLN2",
"RLN3",
"RLTPR",
"RMDN1",
"RMDN2",
"RMDN2-AS1",
"RMDN3",
"RMI1",
"RMI2",
"RMND1",
"RMND5A",
"RMND5B",
"RMRP",
"RMST",
"RN7SK",
"RN7SL1",
"RN7SL2",
"RNA18S5",
"RNA28S5",
"RNA45S5",
"RNA5-8S5",
"RNASE1",
"RNASE13",
"RNASE2",
"RNASE4",
"RNASE7",
"RNASEH1",
"RNASEH1-AS1",
"RNASEH2A",
"RNASEH2B",
"RNASEH2B-AS1",
"RNASEH2C",
"RNASEK",
"RNASEK-C17orf49",
"RNASEL",
"RNASET2",
"RND1",
"RND2",
"RND3",
"RNF10",
"RNF103",
"RNF103-CHMP3",
"RNF11",
"RNF111",
"RNF112",
"RNF113A",
"RNF113B",
"RNF114",
"RNF115",
"RNF121",
"RNF122",
"RNF123",
"RNF125",
"RNF126",
"RNF126P1",
"RNF128",
"RNF13",
"RNF130",
"RNF133",
"RNF135",
"RNF138",
"RNF138P1",
"RNF139",
"RNF139-AS1",
"RNF14",
"RNF141",
"RNF144A",
"RNF144A-AS1",
"RNF144B",
"RNF145",
"RNF146",
"RNF148",
"RNF149",
"RNF150",
"RNF151",
"RNF152",
"RNF157",
"RNF157-AS1",
"RNF165",
"RNF166",
"RNF167",
"RNF168",
"RNF169",
"RNF17",
"RNF170",
"RNF175",
"RNF180",
"RNF181",
"RNF182",
"RNF183",
"RNF185",
"RNF186",
"RNF187",
"RNF19A",
"RNF19B",
"RNF2",
"RNF20",
"RNF207",
"RNF208",
"RNF212",
"RNF212B",
"RNF213",
"RNF214",
"RNF215",
"RNF216",
"RNF216P1",
"RNF217",
"RNF217-AS1",
"RNF219",
"RNF219-AS1",
"RNF220",
"RNF222",
"RNF223",
"RNF224",
"RNF225",
"RNF24",
"RNF25",
"RNF26",
"RNF31",
"RNF32",
"RNF34",
"RNF38",
"RNF39",
"RNF4",
"RNF40",
"RNF41",
"RNF43",
"RNF44",
"RNF5",
"RNF5P1",
"RNF6",
"RNF7",
"RNF8",
"RNFT1",
"RNFT2",
"RNGTT",
"RNH1",
"RNLS",
"RNMT",
"RNMTL1",
"RNPC3",
"RNPEP",
"RNPEPL1",
"RNPS1",
"RNU1-1",
"RNU1-2",
"RNU1-28P",
"RNU105B",
"RNU2-1",
"RNVU1-1",
"RNVU1-14",
"RNVU1-15",
"RNVU1-18",
"RNVU1-19",
"RNVU1-20",
"RNVU1-4",
"RNVU1-6",
"RNVU1-7",
"ROBO1",
"ROBO3",
"ROBO4",
"ROCK1",
"ROCK1P1",
"ROCK2",
"ROGDI",
"ROM1",
"ROMO1",
"ROPN1",
"ROPN1B",
"ROPN1L",
"ROPN1L-AS1",
"ROR1",
"ROR1-AS1",
"ROR2",
"RORA",
"RORA-AS1",
"RORB",
"RORB-AS1",
"RORC",
"ROS1",
"RP1",
"RP1L1",
"RP2",
"RP9",
"RP9P",
"RPA1",
"RPA2",
"RPA3",
"RPA4",
"RPAIN",
"RPAP1",
"RPAP2",
"RPAP3",
"RPARP-AS1",
"RPE",
"RPE65",
"RPEL1",
"RPF1",
"RPF2",
"RPGR",
"RPGRIP1",
"RPGRIP1L",
"RPH3A",
"RPH3AL",
"RPIA",
"RPL10",
"RPL10A",
"RPL11",
"RPL12",
"RPL13",
"RPL13A",
"RPL13AP20",
"RPL13AP3",
"RPL13AP5",
"RPL13AP6",
"RPL13P5",
"RPL14",
"RPL15",
"RPL17",
"RPL17-C18orf32",
"RPL18",
"RPL18A",
"RPL19",
"RPL19P12",
"RPL21",
"RPL21P28",
"RPL21P44",
"RPL22",
"RPL22L1",
"RPL23",
"RPL23A",
"RPL23AP32",
"RPL23AP53",
"RPL23AP64",
"RPL23AP7",
"RPL23AP82",
"RPL23AP87",
"RPL23P8",
"RPL24",
"RPL26",
"RPL26L1",
"RPL27",
"RPL27A",
"RPL28",
"RPL29",
"RPL29P2",
"RPL3",
"RPL30",
"RPL31",
"RPL32",
"RPL32P3",
"RPL34",
"RPL34-AS1",
"RPL35",
"RPL35A",
"RPL36",
"RPL36A",
"RPL36A-HNRNPH2",
"RPL36AL",
"RPL37",
"RPL37A",
"RPL38",
"RPL39",
"RPL39L",
"RPL3L",
"RPL4",
"RPL41",
"RPL5",
"RPL6",
"RPL7",
"RPL7A",
"RPL7L1",
"RPL8",
"RPL9",
"RPLP0",
"RPLP0P2",
"RPLP1",
"RPLP2",
"RPN1",
"RPN2",
"RPP14",
"RPP21",
"RPP25",
"RPP25L",
"RPP30",
"RPP38",
"RPP40",
"RPPH1",
"RPRD1A",
"RPRD1B",
"RPRD2",
"RPRM",
"RPRML",
"RPS10",
"RPS10-NUDT3",
"RPS10P7",
"RPS11",
"RPS12",
"RPS13",
"RPS14",
"RPS14P3",
"RPS15",
"RPS15A",
"RPS15AP10",
"RPS16",
"RPS16P5",
"RPS17",
"RPS18",
"RPS18P9",
"RPS19",
"RPS19BP1",
"RPS2",
"RPS20",
"RPS21",
"RPS23",
"RPS24",
"RPS25",
"RPS26",
"RPS26P11",
"RPS27",
"RPS27A",
"RPS27L",
"RPS28",
"RPS29",
"RPS2P32",
"RPS3",
"RPS3A",
"RPS4X",
"RPS5",
"RPS6",
"RPS6KA1",
"RPS6KA2",
"RPS6KA2-AS1",
"RPS6KA3",
"RPS6KA4",
"RPS6KA5",
"RPS6KA6",
"RPS6KB1",
"RPS6KB2",
"RPS6KC1",
"RPS6KL1",
"RPS7",
"RPS8",
"RPS9",
"RPSA",
"RPSAP52",
"RPSAP58",
"RPSAP9",
"RPTN",
"RPTOR",
"RPUSD1",
"RPUSD2",
"RPUSD3",
"RPUSD4",
"RQCD1",
"RRAD",
"RRAGA",
"RRAGB",
"RRAGC",
"RRAGD",
"RRAS",
"RRAS2",
"RRBP1",
"RREB1",
"RRH",
"RRM1",
"RRM2",
"RRM2B",
"RRN3",
"RRN3P1",
"RRN3P2",
"RRN3P3",
"RRNAD1",
"RRP1",
"RRP12",
"RRP15",
"RRP1B",
"RRP36",
"RRP7A",
"RRP7BP",
"RRP8",
"RRP9",
"RRS1",
"RRS1-AS1",
"RS1",
"RSAD1",
"RSAD2",
"RSBN1",
"RSBN1L",
"RSC1A1",
"RSF1",
"RSG1",
"RSL1D1",
"RSL24D1",
"RSPH1",
"RSPH10B2",
"RSPH14",
"RSPH3",
"RSPH4A",
"RSPH6A",
"RSPH9",
"RSPO1",
"RSPO2",
"RSPO3",
"RSPO4",
"RSPRY1",
"RSRC1",
"RSRC2",
"RSRP1",
"RSU1",
"RSU1P2",
"RTBDN",
"RTCA",
"RTCA-AS1",
"RTCB",
"RTEL1",
"RTEL1-TNFRSF6B",
"RTF1",
"RTFDC1",
"RTKN",
"RTKN2",
"RTL1",
"RTN1",
"RTN2",
"RTN3",
"RTN4",
"RTN4IP1",
"RTN4R",
"RTN4RL1",
"RTN4RL2",
"RTP2",
"RTP3",
"RTP4",
"RTTN",
"RUFY1",
"RUFY2",
"RUFY3",
"RUNDC1",
"RUNDC3A",
"RUNDC3A-AS1",
"RUNDC3B",
"RUNX1",
"RUNX1-IT1",
"RUNX1T1",
"RUNX2",
"RUNX3",
"RUSC1",
"RUSC1-AS1",
"RUSC2",
"RUVBL1",
"RUVBL1-AS1",
"RUVBL2",
"RWDD1",
"RWDD2A",
"RWDD2B",
"RWDD3",
"RWDD4",
"RXFP1",
"RXFP3",
"RXFP4",
"RXRA",
"RXRB",
"RYBP",
"RYK",
"RYR1",
"RYR2",
"RYR3",
"S100A1",
"S100A10",
"S100A11",
"S100A12",
"S100A13",
"S100A14",
"S100A16",
"S100A2",
"S100A3",
"S100A4",
"S100A5",
"S100A6",
"S100A7",
"S100A8",
"S100A9",
"S100B",
"S100G",
"S100P",
"S100PBP",
"S1PR1",
"S1PR2",
"S1PR3",
"S1PR4",
"S1PR5",
"SAA1",
"SAA2",
"SAA2-SAA4",
"SAAL1",
"SAC3D1",
"SACM1L",
"SACS",
"SACS-AS1",
"SAE1",
"SAFB",
"SAFB2",
"SALL2",
"SALL4",
"SALRNA1",
"SALRNA2",
"SALRNA3",
"SAMD1",
"SAMD10",
"SAMD11",
"SAMD12",
"SAMD12-AS1",
"SAMD13",
"SAMD14",
"SAMD15",
"SAMD3",
"SAMD4A",
"SAMD4B",
"SAMD5",
"SAMD7",
"SAMD8",
"SAMD9",
"SAMD9L",
"SAMHD1",
"SAMM50",
"SAMSN1",
"SAP130",
"SAP18",
"SAP25",
"SAP30",
"SAP30BP",
"SAP30L",
"SAP30L-AS1",
"SAPCD1",
"SAPCD1-AS1",
"SAPCD2",
"SAR1A",
"SAR1B",
"SARAF",
"SARDH",
"SARM1",
"SARNP",
"SARS",
"SARS2",
"SART1",
"SART3",
"SASH1",
"SASH3",
"SASS6",
"SAT1",
"SAT2",
"SATB1",
"SATB1-AS1",
"SATB2",
"SATB2-AS1",
"SATL1",
"SAV1",
"SAXO1",
"SAXO2",
"SAYSD1",
"SBDS",
"SBDSP1",
"SBF1",
"SBF2",
"SBF2-AS1",
"SBK1",
"SBK2",
"SBK3",
"SBNO1",
"SBNO2",
"SBSN",
"SBSPON",
"SC5D",
"SCAF1",
"SCAF11",
"SCAF4",
"SCAF8",
"SCAI",
"SCAMP1",
"SCAMP1-AS1",
"SCAMP2",
"SCAMP3",
"SCAMP4",
"SCAMP5",
"SCAND1",
"SCAND2P",
"SCAP",
"SCAPER",
"SCARA3",
"SCARA5",
"SCARB1",
"SCARB2",
"SCARF1",
"SCARF2",
"SCARNA1",
"SCARNA10",
"SCARNA12",
"SCARNA13",
"SCARNA16",
"SCARNA17",
"SCARNA2",
"SCARNA5",
"SCARNA6",
"SCARNA7",
"SCARNA9",
"SCARNA9L",
"SCART1",
"SCCPDH",
"SCD",
"SCD5",
"SCEL",
"SCFD1",
"SCFD2",
"SCG2",
"SCG3",
"SCG5",
"SCGB1A1",
"SCGB1B2P",
"SCGB2A1",
"SCGB2B2",
"SCGB2B3P",
"SCGB3A1",
"SCGB3A2",
"SCGN",
"SCHIP1",
"SCHLAP1",
"SCIMP",
"SCIN",
"SCLT1",
"SCLY",
"SCMH1",
"SCML1",
"SCML2",
"SCN11A",
"SCN1A",
"SCN1B",
"SCN2A",
"SCN3A",
"SCN3B",
"SCN4A",
"SCN4B",
"SCN5A",
"SCN7A",
"SCN8A",
"SCN9A",
"SCNM1",
"SCNN1A",
"SCNN1B",
"SCNN1D",
"SCNN1G",
"SCO1",
"SCO2",
"SCOC",
"SCOC-AS1",
"SCP2",
"SCPEP1",
"SCRG1",
"SCRIB",
"SCRN1",
"SCRN2",
"SCRN3",
"SCRT1",
"SCRT2",
"SCT",
"SCTR",
"SCUBE1",
"SCUBE2",
"SCUBE3",
"SCX",
"SCYL1",
"SCYL2",
"SCYL3",
"SDAD1",
"SDC1",
"SDC2",
"SDC3",
"SDC4",
"SDCBP",
"SDCBP2",
"SDCBP2-AS1",
"SDCCAG3",
"SDCCAG8",
"SDE2",
"SDF2",
"SDF2L1",
"SDF4",
"SDHA",
"SDHAF1",
"SDHAF2",
"SDHAF3",
"SDHAF4",
"SDHAP1",
"SDHAP2",
"SDHAP3",
"SDHB",
"SDHC",
"SDHD",
"SDK1",
"SDK2",
"SDPR",
"SDR16C5",
"SDR39U1",
"SDR42E1",
"SDR9C7",
"SDS",
"SDSL",
"SEBOX",
"SEC11A",
"SEC11C",
"SEC13",
"SEC14L1",
"SEC14L1P1",
"SEC14L2",
"SEC14L3",
"SEC14L4",
"SEC14L5",
"SEC14L6",
"SEC16A",
"SEC16B",
"SEC1P",
"SEC22A",
"SEC22B",
"SEC22C",
"SEC23A",
"SEC23B",
"SEC23IP",
"SEC24A",
"SEC24B",
"SEC24B-AS1",
"SEC24C",
"SEC24D",
"SEC31A",
"SEC31B",
"SEC61A1",
"SEC61A2",
"SEC61B",
"SEC61G",
"SEC62",
"SEC63",
"SECISBP2",
"SECISBP2L",
"SECTM1",
"SEH1L",
"SEL1L",
"SEL1L3",
"SELE",
"SELENBP1",
"SELK",
"SELL",
"SELM",
"SELO",
"SELP",
"SELPLG",
"SELT",
"SELV",
"SEMA3A",
"SEMA3B",
"SEMA3B-AS1",
"SEMA3C",
"SEMA3D",
"SEMA3E",
"SEMA3F",
"SEMA3G",
"SEMA4A",
"SEMA4B",
"SEMA4C",
"SEMA4D",
"SEMA4F",
"SEMA4G",
"SEMA5A",
"SEMA5B",
"SEMA6A",
"SEMA6A-AS1",
"SEMA6B",
"SEMA6C",
"SEMA6D",
"SEMA7A",
"SEMG1",
"SEMG2",
"SENCR",
"SENP1",
"SENP2",
"SENP3",
"SENP3-EIF4A1",
"SENP5",
"SENP6",
"SENP7",
"SENP8",
"SEP15",
"SEPHS1",
"SEPHS2",
"SEPN1",
"SEPP1",
"SEPSECS",
"SEPSECS-AS1",
"SEPT1",
"SEPT10",
"SEPT11",
"SEPT12",
"SEPT14",
"SEPT2",
"SEPT3",
"SEPT4",
"SEPT4-AS1",
"SEPT5",
"SEPT5-GP1BB",
"SEPT6",
"SEPT7",
"SEPT7-AS1",
"SEPT7P2",
"SEPT7P9",
"SEPT8",
"SEPT9",
"SEPW1",
"SERAC1",
"SERBP1",
"SERF1A",
"SERF1B",
"SERF2",
"SERF2-C15ORF63",
"SERGEF",
"SERHL",
"SERHL2",
"SERINC1",
"SERINC2",
"SERINC3",
"SERINC4",
"SERINC5",
"SERP1",
"SERPINA1",
"SERPINA10",
"SERPINA11",
"SERPINA12",
"SERPINA3",
"SERPINA4",
"SERPINA5",
"SERPINA6",
"SERPINA9",
"SERPINB1",
"SERPINB10",
"SERPINB12",
"SERPINB13",
"SERPINB2",
"SERPINB3",
"SERPINB4",
"SERPINB5",
"SERPINB6",
"SERPINB7",
"SERPINB8",
"SERPINB9",
"SERPINB9P1",
"SERPINC1",
"SERPIND1",
"SERPINE1",
"SERPINE2",
"SERPINE3",
"SERPINF1",
"SERPINF2",
"SERPING1",
"SERPINH1",
"SERPINI1",
"SERPINI2",
"SERTAD1",
"SERTAD2",
"SERTAD3",
"SERTAD4",
"SERTAD4-AS1",
"SESN1",
"SESN2",
"SESN3",
"SESTD1",
"SET",
"SETBP1",
"SETD1A",
"SETD1B",
"SETD2",
"SETD3",
"SETD4",
"SETD5",
"SETD6",
"SETD7",
"SETD8",
"SETD9",
"SETDB1",
"SETDB2",
"SETMAR",
"SETSIP",
"SETX",
"SEZ6",
"SEZ6L2",
"SF1",
"SF3A1",
"SF3A2",
"SF3A3",
"SF3B1",
"SF3B2",
"SF3B3",
"SF3B4",
"SF3B5",
"SF3B6",
"SFI1",
"SFMBT1",
"SFMBT2",
"SFN",
"SFPQ",
"SFR1",
"SFRP1",
"SFRP2",
"SFRP5",
"SFSWAP",
"SFT2D1",
"SFT2D2",
"SFT2D3",
"SFTA1P",
"SFTA2",
"SFTPA2",
"SFTPB",
"SFTPC",
"SFTPD",
"SFXN1",
"SFXN2",
"SFXN3",
"SFXN4",
"SFXN5",
"SGCB",
"SGCE",
"SGCG",
"SGIP1",
"SGK1",
"SGK2",
"SGK223",
"SGK3",
"SGK494",
"SGMS1",
"SGMS1-AS1",
"SGMS2",
"SGOL1",
"SGOL1-AS1",
"SGOL2",
"SGPL1",
"SGPP1",
"SGPP2",
"SGSH",
"SGSM1",
"SGSM2",
"SGSM3",
"SGTA",
"SGTB",
"SH2B1",
"SH2B2",
"SH2B3",
"SH2D1B",
"SH2D2A",
"SH2D3A",
"SH2D3C",
"SH2D4A",
"SH2D4B",
"SH2D5",
"SH2D6",
"SH2D7",
"SH3BGR",
"SH3BGRL",
"SH3BGRL2",
"SH3BGRL3",
"SH3BP1",
"SH3BP2",
"SH3BP4",
"SH3BP5",
"SH3BP5-AS1",
"SH3BP5L",
"SH3D19",
"SH3D21",
"SH3GL1",
"SH3GL1P1",
"SH3GL1P2",
"SH3GL2",
"SH3GL3",
"SH3GLB1",
"SH3GLB2",
"SH3KBP1",
"SH3PXD2A",
"SH3PXD2A-AS1",
"SH3PXD2B",
"SH3RF1",
"SH3RF2",
"SH3RF3",
"SH3RF3-AS1",
"SH3TC1",
"SH3TC2",
"SH3YL1",
"SHANK1",
"SHANK2",
"SHANK2-AS1",
"SHANK2-AS3",
"SHANK3",
"SHARPIN",
"SHB",
"SHBG",
"SHC1",
"SHC2",
"SHC3",
"SHC4",
"SHCBP1",
"SHD",
"SHE",
"SHF",
"SHFM1",
"SHH",
"SHISA2",
"SHISA3",
"SHISA4",
"SHISA5",
"SHISA6",
"SHISA7",
"SHISA8",
"SHISA9",
"SHKBP1",
"SHMT1",
"SHMT2",
"SHOC2",
"SHOX2",
"SHPK",
"SHPRH",
"SHQ1",
"SHROOM1",
"SHROOM2",
"SHROOM3",
"SHROOM4",
"SHTN1",
"SIAE",
"SIAH1",
"SIAH2",
"SIAH3",
"SIDT1",
"SIDT2",
"SIGIRR",
"SIGLEC1",
"SIGLEC10",
"SIGLEC11",
"SIGLEC14",
"SIGLEC15",
"SIGLEC16",
"SIGLEC5",
"SIGMAR1",
"SIK1",
"SIK2",
"SIK3",
"SIKE1",
"SIL1",
"SIM1",
"SIM2",
"SIMC1",
"SIN3A",
"SIN3B",
"SIPA1",
"SIPA1L1",
"SIPA1L2",
"SIPA1L3",
"SIRPA",
"SIRPB1",
"SIRPB2",
"SIRPG",
"SIRPG-AS1",
"SIRT1",
"SIRT2",
"SIRT3",
"SIRT4",
"SIRT5",
"SIRT6",
"SIRT7",
"SIT1",
"SIVA1",
"SIX1",
"SIX2",
"SIX3",
"SIX4",
"SIX5",
"SIX6",
"SKA1",
"SKA2",
"SKA3",
"SKAP1",
"SKAP2",
"SKI",
"SKIDA1",
"SKIL",
"SKINTL",
"SKIV2L",
"SKIV2L2",
"SKOR1",
"SKP1",
"SKP2",
"SLA",
"SLA2",
"SLAIN1",
"SLAIN2",
"SLAMF7",
"SLAMF8",
"SLAMF9",
"SLBP",
"SLC10A1",
"SLC10A2",
"SLC10A3",
"SLC10A4",
"SLC10A5",
"SLC10A6",
"SLC10A7",
"SLC11A1",
"SLC11A2",
"SLC12A1",
"SLC12A2",
"SLC12A3",
"SLC12A4",
"SLC12A5",
"SLC12A6",
"SLC12A7",
"SLC12A8",
"SLC12A9",
"SLC13A2",
"SLC13A3",
"SLC13A4",
"SLC13A5",
"SLC14A1",
"SLC14A2",
"SLC14A2-AS1",
"SLC15A1",
"SLC15A2",
"SLC15A3",
"SLC15A4",
"SLC15A5",
"SLC16A1",
"SLC16A1-AS1",
"SLC16A10",
"SLC16A11",
"SLC16A12",
"SLC16A13",
"SLC16A14",
"SLC16A2",
"SLC16A3",
"SLC16A4",
"SLC16A5",
"SLC16A6",
"SLC16A7",
"SLC16A8",
"SLC16A9",
"SLC17A3",
"SLC17A5",
"SLC17A7",
"SLC17A8",
"SLC17A9",
"SLC18A1",
"SLC18A2",
"SLC18B1",
"SLC19A1",
"SLC19A2",
"SLC19A3",
"SLC1A1",
"SLC1A2",
"SLC1A3",
"SLC1A4",
"SLC1A5",
"SLC1A6",
"SLC20A1",
"SLC20A2",
"SLC22A1",
"SLC22A10",
"SLC22A11",
"SLC22A13",
"SLC22A14",
"SLC22A15",
"SLC22A17",
"SLC22A18",
"SLC22A18AS",
"SLC22A20",
"SLC22A23",
"SLC22A3",
"SLC22A31",
"SLC22A4",
"SLC22A5",
"SLC22A7",
"SLC22A9",
"SLC23A1",
"SLC23A2",
"SLC23A3",
"SLC24A1",
"SLC24A2",
"SLC24A3",
"SLC24A4",
"SLC24A5",
"SLC25A1",
"SLC25A10",
"SLC25A11",
"SLC25A12",
"SLC25A13",
"SLC25A14",
"SLC25A15",
"SLC25A16",
"SLC25A17",
"SLC25A18",
"SLC25A19",
"SLC25A2",
"SLC25A20",
"SLC25A21",
"SLC25A21-AS1",
"SLC25A22",
"SLC25A23",
"SLC25A24",
"SLC25A25",
"SLC25A25-AS1",
"SLC25A26",
"SLC25A27",
"SLC25A28",
"SLC25A29",
"SLC25A3",
"SLC25A30",
"SLC25A30-AS1",
"SLC25A32",
"SLC25A33",
"SLC25A34",
"SLC25A35",
"SLC25A36",
"SLC25A37",
"SLC25A38",
"SLC25A39",
"SLC25A4",
"SLC25A40",
"SLC25A41",
"SLC25A42",
"SLC25A43",
"SLC25A44",
"SLC25A45",
"SLC25A46",
"SLC25A47",
"SLC25A48",
"SLC25A5",
"SLC25A5-AS1",
"SLC25A51",
"SLC25A52",
"SLC25A53",
"SLC25A6",
"SLC26A1",
"SLC26A10",
"SLC26A11",
"SLC26A2",
"SLC26A3",
"SLC26A4",
"SLC26A4-AS1",
"SLC26A5",
"SLC26A6",
"SLC26A7",
"SLC26A8",
"SLC26A9",
"SLC27A1",
"SLC27A2",
"SLC27A3",
"SLC27A4",
"SLC27A5",
"SLC27A6",
"SLC28A1",
"SLC28A2",
"SLC28A3",
"SLC29A1",
"SLC29A2",
"SLC29A3",
"SLC29A4",
"SLC2A1",
"SLC2A1-AS1",
"SLC2A10",
"SLC2A11",
"SLC2A12",
"SLC2A13",
"SLC2A14",
"SLC2A2",
"SLC2A3",
"SLC2A4",
"SLC2A4RG",
"SLC2A5",
"SLC2A6",
"SLC2A8",
"SLC2A9",
"SLC30A1",
"SLC30A10",
"SLC30A2",
"SLC30A3",
"SLC30A4",
"SLC30A5",
"SLC30A6",
"SLC30A7",
"SLC30A9",
"SLC31A1",
"SLC31A2",
"SLC32A1",
"SLC33A1",
"SLC34A1",
"SLC34A2",
"SLC34A3",
"SLC35A1",
"SLC35A2",
"SLC35A3",
"SLC35A4",
"SLC35A5",
"SLC35B1",
"SLC35B2",
"SLC35B3",
"SLC35B4",
"SLC35C1",
"SLC35C2",
"SLC35D1",
"SLC35D2",
"SLC35D3",
"SLC35E1",
"SLC35E2",
"SLC35E2B",
"SLC35E3",
"SLC35E4",
"SLC35F1",
"SLC35F2",
"SLC35F3",
"SLC35F4",
"SLC35F5",
"SLC35F6",
"SLC35G1",
"SLC35G2",
"SLC35G3",
"SLC35G4",
"SLC35G5",
"SLC35G6",
"SLC36A1",
"SLC36A2",
"SLC36A3",
"SLC36A4",
"SLC37A1",
"SLC37A2",
"SLC37A3",
"SLC37A4",
"SLC38A1",
"SLC38A10",
"SLC38A2",
"SLC38A3",
"SLC38A4",
"SLC38A5",
"SLC38A6",
"SLC38A7",
"SLC38A8",
"SLC38A9",
"SLC39A1",
"SLC39A10",
"SLC39A11",
"SLC39A13",
"SLC39A14",
"SLC39A2",
"SLC39A3",
"SLC39A4",
"SLC39A5",
"SLC39A6",
"SLC39A7",
"SLC39A8",
"SLC39A9",
"SLC3A1",
"SLC3A2",
"SLC40A1",
"SLC41A1",
"SLC41A2",
"SLC41A3",
"SLC43A1",
"SLC43A2",
"SLC43A3",
"SLC44A1",
"SLC44A2",
"SLC44A3",
"SLC44A4",
"SLC44A5",
"SLC45A1",
"SLC45A2",
"SLC45A3",
"SLC45A4",
"SLC46A1",
"SLC46A2",
"SLC46A3",
"SLC47A1",
"SLC47A2",
"SLC48A1",
"SLC4A1",
"SLC4A10",
"SLC4A11",
"SLC4A1AP",
"SLC4A2",
"SLC4A3",
"SLC4A4",
"SLC4A5",
"SLC4A7",
"SLC4A8",
"SLC4A9",
"SLC50A1",
"SLC51A",
"SLC52A1",
"SLC52A2",
"SLC52A3",
"SLC5A1",
"SLC5A10",
"SLC5A11",
"SLC5A12",
"SLC5A2",
"SLC5A3",
"SLC5A4",
"SLC5A5",
"SLC5A6",
"SLC5A9",
"SLC6A10P",
"SLC6A11",
"SLC6A12",
"SLC6A13",
"SLC6A14",
"SLC6A15",
"SLC6A16",
"SLC6A17",
"SLC6A18",
"SLC6A19",
"SLC6A2",
"SLC6A20",
"SLC6A3",
"SLC6A4",
"SLC6A6",
"SLC6A7",
"SLC6A8",
"SLC6A9",
"SLC7A1",
"SLC7A10",
"SLC7A11",
"SLC7A11-AS1",
"SLC7A13",
"SLC7A14",
"SLC7A2",
"SLC7A4",
"SLC7A5",
"SLC7A5P1",
"SLC7A5P2",
"SLC7A6",
"SLC7A6OS",
"SLC7A7",
"SLC7A8",
"SLC7A9",
"SLC8A1",
"SLC8A1-AS1",
"SLC8A2",
"SLC8A3",
"SLC8B1",
"SLC9A1",
"SLC9A2",
"SLC9A3",
"SLC9A3R1",
"SLC9A3R2",
"SLC9A4",
"SLC9A5",
"SLC9A6",
"SLC9A7",
"SLC9A7P1",
"SLC9A8",
"SLC9A9",
"SLC9B1",
"SLC9B2",
"SLC9C1",
"SLC9C2",
"SLCO1A2",
"SLCO1B3",
"SLCO1B7",
"SLCO1C1",
"SLCO2A1",
"SLCO2B1",
"SLCO3A1",
"SLCO4A1",
"SLCO4A1-AS1",
"SLCO4C1",
"SLCO5A1",
"SLED1",
"SLF1",
"SLF2",
"SLFN11",
"SLFN12",
"SLFN12L",
"SLFN13",
"SLFN5",
"SLFNL1",
"SLFNL1-AS1",
"SLIRP",
"SLIT1",
"SLIT2",
"SLIT2-IT1",
"SLIT3",
"SLITRK1",
"SLITRK2",
"SLITRK4",
"SLITRK5",
"SLITRK6",
"SLK",
"SLMAP",
"SLMO1",
"SLMO2",
"SLMO2-ATP5E",
"SLN",
"SLPI",
"SLTM",
"SLU7",
"SLURP1",
"SLX1A",
"SLX1A-SULT1A3",
"SLX1B",
"SLX4",
"SLX4IP",
"SMA4",
"SMA5",
"SMAD1",
"SMAD1-AS1",
"SMAD1-AS2",
"SMAD2",
"SMAD3",
"SMAD4",
"SMAD5",
"SMAD5-AS1",
"SMAD6",
"SMAD7",
"SMAD9",
"SMAGP",
"SMAP1",
"SMAP2",
"SMARCA1",
"SMARCA2",
"SMARCA4",
"SMARCA5",
"SMARCA5-AS1",
"SMARCAD1",
"SMARCAL1",
"SMARCB1",
"SMARCC1",
"SMARCC2",
"SMARCD1",
"SMARCD2",
"SMARCD3",
"SMARCE1",
"SMC1A",
"SMC1B",
"SMC2",
"SMC2-AS1",
"SMC3",
"SMC4",
"SMC5",
"SMC5-AS1",
"SMC6",
"SMCHD1",
"SMCO1",
"SMCO2",
"SMCO3",
"SMCO4",
"SMCR2",
"SMCR5",
"SMCR8",
"SMDT1",
"SMG1",
"SMG1P1",
"SMG1P2",
"SMG1P3",
"SMG1P5",
"SMG1P7",
"SMG5",
"SMG6",
"SMG7",
"SMG7-AS1",
"SMG8",
"SMG9",
"SMIM1",
"SMIM10",
"SMIM10L1",
"SMIM10L2A",
"SMIM10L2B",
"SMIM11",
"SMIM12",
"SMIM13",
"SMIM14",
"SMIM15",
"SMIM17",
"SMIM18",
"SMIM19",
"SMIM2",
"SMIM2-AS1",
"SMIM2-IT1",
"SMIM20",
"SMIM21",
"SMIM22",
"SMIM24",
"SMIM3",
"SMIM4",
"SMIM5",
"SMIM6",
"SMIM7",
"SMIM8",
"SMKR1",
"SMLR1",
"SMN1",
"SMN2",
"SMNDC1",
"SMO",
"SMOC1",
"SMOC2",
"SMOX",
"SMPD1",
"SMPD2",
"SMPD3",
"SMPD4",
"SMPDL3A",
"SMPDL3B",
"SMS",
"SMTN",
"SMTNL1",
"SMTNL2",
"SMU1",
"SMUG1",
"SMURF1",
"SMURF2",
"SMYD2",
"SMYD3",
"SMYD4",
"SMYD5",
"SNAI1",
"SNAI2",
"SNAI3",
"SNAI3-AS1",
"SNAP23",
"SNAP25",
"SNAP25-AS1",
"SNAP29",
"SNAP47",
"SNAP91",
"SNAPC1",
"SNAPC2",
"SNAPC3",
"SNAPC4",
"SNAPC5",
"SNAPIN",
"SNCA",
"SNCAIP",
"SNCB",
"SNCG",
"SND1",
"SND1-IT1",
"SNED1",
"SNF8",
"SNHG1",
"SNHG10",
"SNHG11",
"SNHG12",
"SNHG15",
"SNHG16",
"SNHG17",
"SNHG18",
"SNHG19",
"SNHG20",
"SNHG21",
"SNHG22",
"SNHG24",
"SNHG3",
"SNHG4",
"SNHG5",
"SNHG6",
"SNHG7",
"SNHG8",
"SNHG9",
"SNIP1",
"SNN",
"SNORA23",
"SNORA53",
"SNORA57",
"SNORA58",
"SNORA59B",
"SNORA73A",
"SNORA73B",
"SNORA74A",
"SNORA74B",
"SNORA81",
"SNORD17",
"SNORD3A",
"SNORD3B-1",
"SNORD3B-2",
"SNORD3C",
"SNORD3D",
"SNPH",
"SNRK",
"SNRK-AS1",
"SNRNP200",
"SNRNP25",
"SNRNP27",
"SNRNP35",
"SNRNP40",
"SNRNP48",
"SNRNP70",
"SNRPA",
"SNRPA1",
"SNRPB",
"SNRPB2",
"SNRPC",
"SNRPD1",
"SNRPD2",
"SNRPD3",
"SNRPE",
"SNRPF",
"SNRPG",
"SNTA1",
"SNTB1",
"SNTB2",
"SNU13",
"SNUPN",
"SNURF",
"SNW1",
"SNX1",
"SNX10",
"SNX11",
"SNX12",
"SNX13",
"SNX14",
"SNX15",
"SNX16",
"SNX17",
"SNX18",
"SNX19",
"SNX2",
"SNX20",
"SNX21",
"SNX22",
"SNX24",
"SNX25",
"SNX27",
"SNX29",
"SNX29P1",
"SNX29P2",
"SNX3",
"SNX30",
"SNX31",
"SNX32",
"SNX33",
"SNX4",
"SNX5",
"SNX6",
"SNX7",
"SNX8",
"SNX9",
"SOAT1",
"SOAT2",
"SOBP",
"SOCS1",
"SOCS2",
"SOCS2-AS1",
"SOCS3",
"SOCS4",
"SOCS5",
"SOCS6",
"SOCS7",
"SOD1",
"SOD2",
"SOD3",
"SOGA1",
"SOGA3",
"SOHLH1",
"SOHLH2",
"SON",
"SORBS1",
"SORBS2",
"SORBS3",
"SORCS1",
"SORCS2",
"SORCS3",
"SORD",
"SORL1",
"SORT1",
"SOS1",
"SOS2",
"SOST",
"SOSTDC1",
"SOWAHA",
"SOWAHB",
"SOWAHC",
"SOWAHD",
"SOX10",
"SOX11",
"SOX12",
"SOX13",
"SOX15",
"SOX18",
"SOX2",
"SOX2-OT",
"SOX21",
"SOX21-AS1",
"SOX3",
"SOX30",
"SOX4",
"SOX5",
"SOX6",
"SOX7",
"SOX8",
"SOX9",
"SOX9-AS1",
"SP1",
"SP100",
"SP110",
"SP140",
"SP140L",
"SP2",
"SP2-AS1",
"SP3",
"SP4",
"SP5",
"SP6",
"SP7",
"SP8",
"SP9",
"SPA17",
"SPACA4",
"SPACA5B",
"SPACA6P",
"SPACA6P-AS",
"SPAG1",
"SPAG16",
"SPAG17",
"SPAG4",
"SPAG5",
"SPAG5-AS1",
"SPAG6",
"SPAG7",
"SPAG8",
"SPAG9",
"SPAM1",
"SPANXA1",
"SPANXA2-OT1",
"SPANXC",
"SPANXD",
"SPANXN3",
"SPARC",
"SPARCL1",
"SPAST",
"SPATA1",
"SPATA12",
"SPATA13",
"SPATA13-AS1",
"SPATA17",
"SPATA18",
"SPATA2",
"SPATA20",
"SPATA21",
"SPATA22",
"SPATA24",
"SPATA25",
"SPATA2L",
"SPATA3-AS1",
"SPATA31A3",
"SPATA31A5",
"SPATA31A6",
"SPATA31A7",
"SPATA31C1",
"SPATA31C2",
"SPATA31D3",
"SPATA31D4",
"SPATA31E1",
"SPATA32",
"SPATA33",
"SPATA4",
"SPATA41",
"SPATA42",
"SPATA45",
"SPATA5",
"SPATA5L1",
"SPATA6",
"SPATA6L",
"SPATA7",
"SPATA9",
"SPATC1",
"SPATC1L",
"SPATS1",
"SPATS2",
"SPATS2L",
"SPC24",
"SPC25",
"SPCS1",
"SPCS2",
"SPCS3",
"SPDEF",
"SPDL1",
"SPDYA",
"SPDYC",
"SPDYE1",
"SPDYE2B",
"SPDYE3",
"SPDYE5",
"SPDYE6",
"SPDYE7P",
"SPDYE8P",
"SPECC1",
"SPECC1L",
"SPECC1L-ADORA2A",
"SPEF1",
"SPEF2",
"SPEG",
"SPEM1",
"SPEN",
"SPERT",
"SPESP1",
"SPG11",
"SPG20",
"SPG20-AS1",
"SPG21",
"SPG7",
"SPHAR",
"SPHK1",
"SPHK2",
"SPHKAP",
"SPI1",
"SPIB",
"SPIC",
"SPICE1",
"SPIDR",
"SPIN1",
"SPIN2A",
"SPIN2B",
"SPIN3",
"SPIN4",
"SPINK1",
"SPINK13",
"SPINK2",
"SPINK4",
"SPINK5",
"SPINK6",
"SPINK7",
"SPINK8",
"SPINT1",
"SPINT2",
"SPINT3",
"SPIRE1",
"SPIRE2",
"SPN",
"SPNS1",
"SPNS2",
"SPNS3",
"SPOCD1",
"SPOCK1",
"SPOCK2",
"SPON1",
"SPON2",
"SPOP",
"SPOPL",
"SPP1",
"SPPL2A",
"SPPL2B",
"SPPL2C",
"SPPL3",
"SPR",
"SPRED1",
"SPRED2",
"SPRED3",
"SPRN",
"SPRNP1",
"SPRR1A",
"SPRR1B",
"SPRR2A",
"SPRR2D",
"SPRR2E",
"SPRR2F",
"SPRR3",
"SPRTN",
"SPRY1",
"SPRY2",
"SPRY3",
"SPRY4",
"SPRY4-IT1",
"SPRYD3",
"SPRYD4",
"SPRYD7",
"SPSB1",
"SPSB2",
"SPSB3",
"SPSB4",
"SPTAN1",
"SPTB",
"SPTBN1",
"SPTBN2",
"SPTBN4",
"SPTBN5",
"SPTLC1",
"SPTLC2",
"SPTLC3",
"SPTSSA",
"SPTSSB",
"SPTY2D1",
"SPTY2D1-AS1",
"SPX",
"SQLE",
"SQRDL",
"SQSTM1",
"SRA1",
"SRBD1",
"SRC",
"SRCAP",
"SRCIN1",
"SRD5A1",
"SRD5A2",
"SRD5A3",
"SRD5A3-AS1",
"SREBF1",
"SREBF2",
"SREK1",
"SREK1IP1",
"SRF",
"SRFBP1",
"SRGAP1",
"SRGAP2",
"SRGAP2-AS1",
"SRGAP2B",
"SRGAP2C",
"SRGAP2D",
"SRGAP3",
"SRGAP3-AS3",
"SRGN",
"SRI",
"SRL",
"SRM",
"SRMS",
"SRP14",
"SRP14-AS1",
"SRP19",
"SRP54",
"SRP68",
"SRP72",
"SRP9",
"SRPK1",
"SRPK2",
"SRPK3",
"SRPR",
"SRPRB",
"SRPX",
"SRPX2",
"SRR",
"SRRD",
"SRRM1",
"SRRM2",
"SRRM2-AS1",
"SRRM3",
"SRRM4",
"SRRM5",
"SRRT",
"SRSF1",
"SRSF10",
"SRSF11",
"SRSF12",
"SRSF2",
"SRSF3",
"SRSF4",
"SRSF5",
"SRSF6",
"SRSF7",
"SRSF8",
"SRSF9",
"SRXN1",
"SS18",
"SS18L1",
"SS18L2",
"SSB",
"SSBP1",
"SSBP2",
"SSBP3",
"SSBP3-AS1",
"SSBP4",
"SSC4D",
"SSC5D",
"SSFA2",
"SSH1",
"SSH2",
"SSH3",
"SSMEM1",
"SSNA1",
"SSPN",
"SSPO",
"SSR1",
"SSR2",
"SSR3",
"SSR4",
"SSR4P1",
"SSRP1",
"SSSCA1",
"SSSCA1-AS1",
"SSTR1",
"SSTR2",
"SSTR3",
"SSTR5",
"SSTR5-AS1",
"SSU72",
"SSUH2",
"SSX1",
"SSX2IP",
"SSX4",
"SSX4B",
"SSX6",
"ST13",
"ST13P4",
"ST14",
"ST18",
"ST20",
"ST20-AS1",
"ST20-MTHFS",
"ST3GAL1",
"ST3GAL2",
"ST3GAL3",
"ST3GAL4",
"ST3GAL4-AS1",
"ST3GAL5",
"ST3GAL5-AS1",
"ST3GAL6",
"ST3GAL6-AS1",
"ST5",
"ST6GAL1",
"ST6GAL2",
"ST6GALNAC1",
"ST6GALNAC2",
"ST6GALNAC3",
"ST6GALNAC4",
"ST6GALNAC5",
"ST6GALNAC6",
"ST7",
"ST7-AS1",
"ST7-AS2",
"ST7-OT3",
"ST7-OT4",
"ST7L",
"ST8SIA1",
"ST8SIA2",
"ST8SIA3",
"ST8SIA4",
"ST8SIA5",
"ST8SIA6",
"ST8SIA6-AS1",
"STAB1",
"STAB2",
"STAC",
"STAC2",
"STAC3",
"STAG1",
"STAG2",
"STAG3",
"STAG3L1",
"STAG3L2",
"STAG3L3",
"STAG3L4",
"STAG3L5P",
"STAG3L5P-PVRIG2P-PILRB",
"STAM",
"STAM-AS1",
"STAM2",
"STAMBP",
"STAMBPL1",
"STAP1",
"STAP2",
"STAR",
"STARD10",
"STARD13",
"STARD13-AS",
"STARD3",
"STARD3NL",
"STARD4",
"STARD4-AS1",
"STARD5",
"STARD6",
"STARD7",
"STARD7-AS1",
"STARD8",
"STARD9",
"STAT1",
"STAT2",
"STAT3",
"STAT4",
"STAT5A",
"STAT5B",
"STAT6",
"STAU1",
"STAU2",
"STAU2-AS1",
"STBD1",
"STC1",
"STC2",
"STEAP1",
"STEAP1B",
"STEAP2",
"STEAP2-AS1",
"STEAP3",
"STEAP3-AS1",
"STEAP4",
"STH",
"STIL",
"STIM1",
"STIM2",
"STIP1",
"STK10",
"STK11",
"STK11IP",
"STK16",
"STK17A",
"STK17B",
"STK19",
"STK24",
"STK25",
"STK26",
"STK3",
"STK31",
"STK32A",
"STK32B",
"STK32C",
"STK33",
"STK35",
"STK36",
"STK38",
"STK38L",
"STK39",
"STK4",
"STK4-AS1",
"STK40",
"STKLD1",
"STMN1",
"STMN2",
"STMN3",
"STMN4",
"STMND1",
"STOM",
"STOML1",
"STOML2",
"STOML3",
"STON1",
"STON1-GTF2A1L",
"STON2",
"STOX1",
"STOX2",
"STPG1",
"STPG2",
"STRA13",
"STRA6",
"STRADA",
"STRADB",
"STRAP",
"STRBP",
"STRC",
"STRIP1",
"STRIP2",
"STRN",
"STRN3",
"STRN4",
"STS",
"STT3A",
"STT3B",
"STUB1",
"STX10",
"STX11",
"STX12",
"STX16",
"STX16-NPEPL1",
"STX17",
"STX17-AS1",
"STX18",
"STX18-AS1",
"STX18-IT1",
"STX19",
"STX1A",
"STX1B",
"STX2",
"STX3",
"STX4",
"STX5",
"STX6",
"STX7",
"STX8",
"STXBP1",
"STXBP2",
"STXBP3",
"STXBP4",
"STXBP5",
"STXBP5-AS1",
"STXBP5L",
"STXBP6",
"STYK1",
"STYX",
"STYXL1",
"SUB1",
"SUCLA2",
"SUCLG1",
"SUCLG2",
"SUCLG2-AS1",
"SUCO",
"SUDS3",
"SUFU",
"SUGCT",
"SUGP1",
"SUGP2",
"SUGT1",
"SUGT1P1",
"SUGT1P3",
"SULF1",
"SULF2",
"SULT1A1",
"SULT1A2",
"SULT1A3",
"SULT1A4",
"SULT1B1",
"SULT1C2",
"SULT1C2P1",
"SULT1C3",
"SULT1C4",
"SULT1E1",
"SULT2A1",
"SULT2B1",
"SULT4A1",
"SUMF1",
"SUMF2",
"SUMO1",
"SUMO1P1",
"SUMO1P3",
"SUMO2",
"SUMO3",
"SUMO4",
"SUN1",
"SUN2",
"SUN3",
"SUOX",
"SUPT16H",
"SUPT20H",
"SUPT3H",
"SUPT4H1",
"SUPT5H",
"SUPT6H",
"SUPT7L",
"SUPV3L1",
"SURF1",
"SURF2",
"SURF4",
"SURF6",
"SUSD1",
"SUSD2",
"SUSD3",
"SUSD4",
"SUSD5",
"SUSD6",
"SUV39H1",
"SUV39H2",
"SUV420H1",
"SUV420H2",
"SUZ12",
"SUZ12P1",
"SV2A",
"SV2B",
"SV2C",
"SVBP",
"SVEP1",
"SVIL",
"SVIL-AS1",
"SVILP1",
"SVIP",
"SVOP",
"SVOPL",
"SWAP70",
"SWI5",
"SWSAP1",
"SWT1",
"SYAP1",
"SYBU",
"SYCE1L",
"SYCE2",
"SYCE3",
"SYCN",
"SYCP2",
"SYCP2L",
"SYCP3",
"SYDE1",
"SYDE2",
"SYF2",
"SYK",
"SYMPK",
"SYN1",
"SYN2",
"SYN3",
"SYNC",
"SYNCRIP",
"SYNDIG1",
"SYNE1",
"SYNE2",
"SYNE3",
"SYNE4",
"SYNGAP1",
"SYNGR1",
"SYNGR2",
"SYNGR3",
"SYNGR4",
"SYNJ1",
"SYNJ2",
"SYNJ2-IT1",
"SYNJ2BP",
"SYNJ2BP-COX16",
"SYNM",
"SYNPO",
"SYNPO2",
"SYNPO2L",
"SYNRG",
"SYP",
"SYP-AS1",
"SYPL1",
"SYPL2",
"SYS1",
"SYS1-DBNDD2",
"SYT1",
"SYT10",
"SYT11",
"SYT12",
"SYT13",
"SYT14",
"SYT14P1",
"SYT15",
"SYT16",
"SYT17",
"SYT2",
"SYT3",
"SYT5",
"SYT6",
"SYT7",
"SYT8",
"SYT9",
"SYTL1",
"SYTL2",
"SYTL3",
"SYTL4",
"SYTL5",
"SYVN1",
"SZRD1",
"SZT2",
"TAB1",
"TAB2",
"TAB3",
"TAC1",
"TAC3",
"TAC4",
"TACC1",
"TACC2",
"TACC3",
"TACO1",
"TACR1",
"TACR2",
"TACR3",
"TACSTD2",
"TADA1",
"TADA2A",
"TADA2B",
"TADA3",
"TAF1",
"TAF10",
"TAF11",
"TAF12",
"TAF13",
"TAF15",
"TAF1A",
"TAF1A-AS1",
"TAF1B",
"TAF1C",
"TAF1D",
"TAF1L",
"TAF2",
"TAF3",
"TAF4",
"TAF4B",
"TAF5",
"TAF5L",
"TAF6",
"TAF6L",
"TAF7",
"TAF7L",
"TAF8",
"TAF9",
"TAF9B",
"TAGAP",
"TAGLN",
"TAGLN2",
"TAGLN3",
"TAL1",
"TAL2",
"TALDO1",
"TAMM41",
"TANC1",
"TANC2",
"TANGO2",
"TANGO6",
"TANK",
"TAOK1",
"TAOK2",
"TAOK3",
"TAP1",
"TAP2",
"TAPBP",
"TAPBPL",
"TAPT1",
"TAPT1-AS1",
"TARBP1",
"TARBP2",
"TARDBP",
"TARID",
"TARP",
"TARS",
"TARS2",
"TARSL2",
"TAS1R1",
"TAS1R2",
"TAS1R3",
"TAS2R10",
"TAS2R13",
"TAS2R14",
"TAS2R19",
"TAS2R20",
"TAS2R3",
"TAS2R30",
"TAS2R31",
"TAS2R39",
"TAS2R4",
"TAS2R40",
"TAS2R42",
"TAS2R43",
"TAS2R46",
"TAS2R5",
"TAS2R50",
"TAS2R60",
"TAS2R8",
"TAS2R9",
"TASP1",
"TAT",
"TAT-AS1",
"TATDN1",
"TATDN2",
"TATDN3",
"TAX1BP1",
"TAX1BP3",
"TAZ",
"TBC1D1",
"TBC1D10A",
"TBC1D10B",
"TBC1D10C",
"TBC1D12",
"TBC1D13",
"TBC1D14",
"TBC1D15",
"TBC1D16",
"TBC1D17",
"TBC1D19",
"TBC1D2",
"TBC1D20",
"TBC1D22A",
"TBC1D22A-AS1",
"TBC1D22B",
"TBC1D23",
"TBC1D24",
"TBC1D25",
"TBC1D26",
"TBC1D28",
"TBC1D29",
"TBC1D2B",
"TBC1D3",
"TBC1D30",
"TBC1D31",
"TBC1D32",
"TBC1D3B",
"TBC1D3C",
"TBC1D3E",
"TBC1D3F",
"TBC1D3H",
"TBC1D3I",
"TBC1D3K",
"TBC1D3L",
"TBC1D3P1-DHX40P1",
"TBC1D3P2",
"TBC1D3P5",
"TBC1D4",
"TBC1D5",
"TBC1D7",
"TBC1D8",
"TBC1D8B",
"TBC1D9",
"TBC1D9B",
"TBCA",
"TBCB",
"TBCC",
"TBCCD1",
"TBCD",
"TBCE",
"TBCEL",
"TBCK",
"TBK1",
"TBKBP1",
"TBL1X",
"TBL1XR1",
"TBL2",
"TBL3",
"TBP",
"TBPL1",
"TBR1",
"TBRG1",
"TBRG4",
"TBX1",
"TBX10",
"TBX15",
"TBX18",
"TBX19",
"TBX2",
"TBX2-AS1",
"TBX20",
"TBX21",
"TBX3",
"TBX4",
"TBX5",
"TBX6",
"TBXA2R",
"TBXAS1",
"TC2N",
"TCAF1",
"TCAF2",
"TCAF2P1",
"TCAIM",
"TCAM1P",
"TCAP",
"TCEA1",
"TCEA2",
"TCEA3",
"TCEAL1",
"TCEAL3",
"TCEAL4",
"TCEAL6",
"TCEAL7",
"TCEAL8",
"TCEANC",
"TCEANC2",
"TCEB1",
"TCEB2",
"TCEB3",
"TCEB3-AS1",
"TCEB3B",
"TCEB3C",
"TCEB3CL",
"TCEB3CL2",
"TCERG1",
"TCERG1L",
"TCERG1L-AS1",
"TCF12",
"TCF19",
"TCF20",
"TCF24",
"TCF25",
"TCF3",
"TCF4",
"TCF7",
"TCF7L1",
"TCF7L2",
"TCFL5",
"TCHH",
"TCHHL1",
"TCHP",
"TCIRG1",
"TCL1B",
"TCL6",
"TCN1",
"TCN2",
"TCOF1",
"TCONS_00029157",
"TCP1",
"TCP10L",
"TCP11",
"TCP11L1",
"TCP11L2",
"TCP11X2",
"TCTA",
"TCTE1",
"TCTE3",
"TCTEX1D2",
"TCTEX1D4",
"TCTN1",
"TCTN2",
"TCTN3",
"TDG",
"TDGF1",
"TDH",
"TDP1",
"TDP2",
"TDRD1",
"TDRD10",
"TDRD12",
"TDRD3",
"TDRD5",
"TDRD6",
"TDRD7",
"TDRD9",
"TDRG1",
"TDRKH",
"TDRP",
"TEAD1",
"TEAD2",
"TEAD3",
"TEAD4",
"TEC",
"TECPR1",
"TECPR2",
"TECR",
"TECTA",
"TEDDM1",
"TEF",
"TEFM",
"TEK",
"TEKT2",
"TEKT3",
"TEKT4",
"TEKT4P2",
"TEKT5",
"TELO2",
"TEN1",
"TEN1-CDK3",
"TENM1",
"TENM2",
"TENM3",
"TENM4",
"TEP1",
"TEPP",
"TERC",
"TERF1",
"TERF2",
"TERF2IP",
"TERT",
"TES",
"TESC",
"TESK1",
"TESK2",
"TESPA1",
"TET1",
"TET2",
"TET2-AS1",
"TET3",
"TEX10",
"TEX101",
"TEX11",
"TEX12",
"TEX13A",
"TEX13B",
"TEX14",
"TEX15",
"TEX19",
"TEX2",
"TEX21P",
"TEX22",
"TEX261",
"TEX264",
"TEX28",
"TEX29",
"TEX30",
"TEX33",
"TEX35",
"TEX36",
"TEX37",
"TEX38",
"TEX40",
"TEX41",
"TEX9",
"TFAM",
"TFAMP1",
"TFAP2A",
"TFAP2A-AS1",
"TFAP2C",
"TFAP2E",
"TFAP4",
"TFB1M",
"TFB2M",
"TFCP2",
"TFCP2L1",
"TFDP1",
"TFDP2",
"TFDP3",
"TFE3",
"TFEB",
"TFEC",
"TFF1",
"TFF2",
"TFF3",
"TFG",
"TFIP11",
"TFPI",
"TFPI2",
"TFPT",
"TFR2",
"TFRC",
"TG",
"TGDS",
"TGFA",
"TGFA-IT1",
"TGFB1",
"TGFB1I1",
"TGFB2",
"TGFB2-AS1",
"TGFB2-OT1",
"TGFB3",
"TGFBI",
"TGFBR1",
"TGFBR2",
"TGFBR3",
"TGFBR3L",
"TGFBRAP1",
"TGIF1",
"TGIF2",
"TGIF2-C20orf24",
"TGM1",
"TGM2",
"TGM3",
"TGM4",
"TGM5",
"TGM6",
"TGOLN2",
"TGS1",
"TH",
"TH2LCRR",
"THADA",
"THAP1",
"THAP10",
"THAP11",
"THAP2",
"THAP3",
"THAP4",
"THAP5",
"THAP6",
"THAP7",
"THAP7-AS1",
"THAP8",
"THAP9",
"THAP9-AS1",
"THBD",
"THBS1",
"THBS2",
"THBS3",
"THBS4",
"THCAT158",
"THEG",
"THEGL",
"THEM4",
"THEM5",
"THEM6",
"THEMIS",
"THEMIS2",
"THG1L",
"THNSL1",
"THNSL2",
"THOC1",
"THOC2",
"THOC3",
"THOC5",
"THOC6",
"THOC7",
"THOC7-AS1",
"THOP1",
"THPO",
"THRA",
"THRA1/BTR",
"THRAP3",
"THRB",
"THRB-AS1",
"THRIL",
"THRSP",
"THSD1",
"THSD4",
"THSD4-AS1",
"THSD4-AS2",
"THSD7A",
"THSD7B",
"THTPA",
"THUMPD1",
"THUMPD2",
"THUMPD3",
"THUMPD3-AS1",
"THY1",
"THYN1",
"TIA1",
"TIAF1",
"TIAL1",
"TIAM1",
"TIAM2",
"TICAM1",
"TICAM2",
"TICRR",
"TIE1",
"TIFA",
"TIGAR",
"TIGD1",
"TIGD2",
"TIGD3",
"TIGD4",
"TIGD5",
"TIGD6",
"TIGD7",
"TIMELESS",
"TIMM10",
"TIMM10B",
"TIMM13",
"TIMM17A",
"TIMM17B",
"TIMM21",
"TIMM22",
"TIMM23",
"TIMM23B",
"TIMM44",
"TIMM50",
"TIMM8A",
"TIMM8B",
"TIMM9",
"TIMMDC1",
"TIMP1",
"TIMP2",
"TIMP3",
"TIMP4",
"TINAGL1",
"TINCR",
"TINF2",
"TIPARP",
"TIPARP-AS1",
"TIPIN",
"TIPRL",
"TIRAP",
"TJAP1",
"TJP1",
"TJP2",
"TJP3",
"TK1",
"TK2",
"TKFC",
"TKT",
"TKTL1",
"TKTL2",
"TLCD1",
"TLCD2",
"TLDC1",
"TLDC2",
"TLE1",
"TLE2",
"TLE3",
"TLE4",
"TLE6",
"TLK1",
"TLK2",
"TLL1",
"TLL2",
"TLN1",
"TLN2",
"TLR1",
"TLR10",
"TLR2",
"TLR3",
"TLR4",
"TLR5",
"TLR6",
"TLR7",
"TLR8",
"TLR8-AS1",
"TLR9",
"TLX1",
"TLX1NB",
"TLX2",
"TLX3",
"TM2D1",
"TM2D2",
"TM2D3",
"TM4SF1",
"TM4SF1-AS1",
"TM4SF18",
"TM4SF19",
"TM4SF19-AS1",
"TM4SF19-TCTEX1D2",
"TM4SF20",
"TM4SF4",
"TM4SF5",
"TM6SF1",
"TM6SF2",
"TM7SF2",
"TM7SF3",
"TM9SF1",
"TM9SF2",
"TM9SF3",
"TM9SF4",
"TMA16",
"TMA7",
"TMBIM1",
"TMBIM4",
"TMBIM6",
"TMC1",
"TMC2",
"TMC3",
"TMC3-AS1",
"TMC4",
"TMC5",
"TMC6",
"TMC7",
"TMC8",
"TMCC1",
"TMCC1-AS1",
"TMCC2",
"TMCC3",
"TMCO1",
"TMCO2",
"TMCO3",
"TMCO4",
"TMCO5A",
"TMCO5B",
"TMCO6",
"TMED1",
"TMED10",
"TMED10P1",
"TMED11P",
"TMED2",
"TMED3",
"TMED4",
"TMED5",
"TMED6",
"TMED7",
"TMED7-TICAM2",
"TMED8",
"TMED9",
"TMEFF1",
"TMEFF2",
"TMEM100",
"TMEM101",
"TMEM102",
"TMEM104",
"TMEM105",
"TMEM106A",
"TMEM106B",
"TMEM106C",
"TMEM107",
"TMEM108",
"TMEM108-AS1",
"TMEM109",
"TMEM11",
"TMEM110",
"TMEM110-MUSTN1",
"TMEM115",
"TMEM116",
"TMEM117",
"TMEM119",
"TMEM120A",
"TMEM120B",
"TMEM121",
"TMEM123",
"TMEM125",
"TMEM126A",
"TMEM126B",
"TMEM127",
"TMEM128",
"TMEM129",
"TMEM130",
"TMEM131",
"TMEM132A",
"TMEM132B",
"TMEM132D",
"TMEM132E",
"TMEM133",
"TMEM134",
"TMEM135",
"TMEM136",
"TMEM138",
"TMEM139",
"TMEM140",
"TMEM141",
"TMEM143",
"TMEM144",
"TMEM145",
"TMEM147",
"TMEM147-AS1",
"TMEM14A",
"TMEM14B",
"TMEM14C",
"TMEM14E",
"TMEM150A",
"TMEM150C",
"TMEM151A",
"TMEM151B",
"TMEM154",
"TMEM155",
"TMEM156",
"TMEM158",
"TMEM159",
"TMEM160",
"TMEM161A",
"TMEM161B",
"TMEM161B-AS1",
"TMEM163",
"TMEM164",
"TMEM165",
"TMEM167A",
"TMEM167B",
"TMEM168",
"TMEM169",
"TMEM17",
"TMEM170A",
"TMEM170B",
"TMEM171",
"TMEM173",
"TMEM175",
"TMEM176B",
"TMEM177",
"TMEM178A",
"TMEM178B",
"TMEM179",
"TMEM179B",
"TMEM18",
"TMEM180",
"TMEM181",
"TMEM182",
"TMEM183A",
"TMEM183B",
"TMEM184A",
"TMEM184B",
"TMEM184C",
"TMEM185A",
"TMEM185B",
"TMEM186",
"TMEM187",
"TMEM189",
"TMEM189-UBE2V1",
"TMEM19",
"TMEM190",
"TMEM191A",
"TMEM191B",
"TMEM191C",
"TMEM192",
"TMEM196",
"TMEM198",
"TMEM198B",
"TMEM199",
"TMEM2",
"TMEM200A",
"TMEM200B",
"TMEM201",
"TMEM203",
"TMEM204",
"TMEM205",
"TMEM206",
"TMEM208",
"TMEM209",
"TMEM210",
"TMEM211",
"TMEM212",
"TMEM213",
"TMEM214",
"TMEM215",
"TMEM216",
"TMEM217",
"TMEM218",
"TMEM219",
"TMEM220",
"TMEM220-AS1",
"TMEM221",
"TMEM222",
"TMEM223",
"TMEM229A",
"TMEM229B",
"TMEM230",
"TMEM231",
"TMEM232",
"TMEM234",
"TMEM235",
"TMEM236",
"TMEM237",
"TMEM238",
"TMEM240",
"TMEM241",
"TMEM242",
"TMEM243",
"TMEM244",
"TMEM245",
"TMEM246",
"TMEM248",
"TMEM249",
"TMEM25",
"TMEM251",
"TMEM252",
"TMEM253",
"TMEM254",
"TMEM254-AS1",
"TMEM255A",
"TMEM255B",
"TMEM256",
"TMEM256-PLSCR3",
"TMEM258",
"TMEM259",
"TMEM26",
"TMEM26-AS1",
"TMEM260",
"TMEM261",
"TMEM262",
"TMEM263",
"TMEM265",
"TMEM27",
"TMEM30A",
"TMEM30B",
"TMEM31",
"TMEM33",
"TMEM35",
"TMEM37",
"TMEM38A",
"TMEM38B",
"TMEM39A",
"TMEM39B",
"TMEM40",
"TMEM41A",
"TMEM41B",
"TMEM42",
"TMEM43",
"TMEM44",
"TMEM44-AS1",
"TMEM45A",
"TMEM45B",
"TMEM47",
"TMEM5",
"TMEM50A",
"TMEM50B",
"TMEM51",
"TMEM51-AS1",
"TMEM52",
"TMEM52B",
"TMEM53",
"TMEM54",
"TMEM55A",
"TMEM55B",
"TMEM56",
"TMEM56-RWDD3",
"TMEM57",
"TMEM59",
"TMEM59L",
"TMEM60",
"TMEM61",
"TMEM62",
"TMEM63A",
"TMEM63B",
"TMEM63C",
"TMEM64",
"TMEM65",
"TMEM67",
"TMEM68",
"TMEM69",
"TMEM70",
"TMEM71",
"TMEM72",
"TMEM74",
"TMEM74B",
"TMEM75",
"TMEM79",
"TMEM80",
"TMEM81",
"TMEM82",
"TMEM86A",
"TMEM86B",
"TMEM87A",
"TMEM87B",
"TMEM88",
"TMEM89",
"TMEM8A",
"TMEM8B",
"TMEM9",
"TMEM91",
"TMEM92",
"TMEM92-AS1",
"TMEM95",
"TMEM97",
"TMEM98",
"TMEM99",
"TMEM9B",
"TMEM9B-AS1",
"TMF1",
"TMIE",
"TMIGD3",
"TMLHE",
"TMLHE-AS1",
"TMOD1",
"TMOD2",
"TMOD3",
"TMOD4",
"TMPO",
"TMPO-AS1",
"TMPPE",
"TMPRSS11A",
"TMPRSS11B",
"TMPRSS11BNL",
"TMPRSS11D",
"TMPRSS11E",
"TMPRSS13",
"TMPRSS2",
"TMPRSS3",
"TMPRSS4",
"TMPRSS5",
"TMPRSS6",
"TMPRSS7",
"TMPRSS9",
"TMSB10",
"TMSB15A",
"TMSB15B",
"TMSB4X",
"TMTC1",
"TMTC2",
"TMTC3",
"TMTC4",
"TMUB1",
"TMUB2",
"TMX1",
"TMX2",
"TMX2-CTNND1",
"TMX3",
"TMX4",
"TNC",
"TNF",
"TNFAIP1",
"TNFAIP2",
"TNFAIP3",
"TNFAIP6",
"TNFAIP8",
"TNFAIP8L1",
"TNFAIP8L2",
"TNFAIP8L2-SCNM1",
"TNFAIP8L3",
"TNFRSF10A",
"TNFRSF10B",
"TNFRSF10C",
"TNFRSF10D",
"TNFRSF11A",
"TNFRSF11B",
"TNFRSF12A",
"TNFRSF13C",
"TNFRSF14",
"TNFRSF17",
"TNFRSF18",
"TNFRSF19",
"TNFRSF1A",
"TNFRSF1B",
"TNFRSF21",
"TNFRSF25",
"TNFRSF4",
"TNFRSF6B",
"TNFRSF8",
"TNFRSF9",
"TNFSF10",
"TNFSF11",
"TNFSF12",
"TNFSF12-TNFSF13",
"TNFSF13",
"TNFSF13B",
"TNFSF14",
"TNFSF15",
"TNFSF18",
"TNFSF4",
"TNFSF8",
"TNFSF9",
"TNIK",
"TNIP1",
"TNIP2",
"TNIP3",
"TNK1",
"TNK2",
"TNKS",
"TNKS1BP1",
"TNKS2",
"TNKS2-AS1",
"TNN",
"TNNC1",
"TNNC2",
"TNNI1",
"TNNI2",
"TNNI3",
"TNNT1",
"TNNT2",
"TNNT3",
"TNPO1",
"TNPO2",
"TNPO3",
"TNRC18",
"TNRC18P1",
"TNRC6A",
"TNRC6B",
"TNRC6C",
"TNRC6C-AS1",
"TNS1",
"TNS2",
"TNS3",
"TNS4",
"TNXA",
"TNXB",
"TOB1",
"TOB1-AS1",
"TOB2",
"TOB2P1",
"TOE1",
"TOLLIP",
"TOLLIP-AS1",
"TOM1",
"TOM1L1",
"TOM1L2",
"TOMM20",
"TOMM20L",
"TOMM22",
"TOMM34",
"TOMM40",
"TOMM40L",
"TOMM5",
"TOMM6",
"TOMM7",
"TOMM70A",
"TONSL",
"TONSL-AS1",
"TOP1",
"TOP1MT",
"TOP1P1",
"TOP1P2",
"TOP2A",
"TOP2B",
"TOP3A",
"TOP3B",
"TOPAZ1",
"TOPBP1",
"TOPORS",
"TOPORS-AS1",
"TOR1A",
"TOR1AIP1",
"TOR1AIP2",
"TOR1B",
"TOR2A",
"TOR3A",
"TOR4A",
"TOX",
"TOX2",
"TOX3",
"TOX4",
"TP53",
"TP53AIP1",
"TP53BP1",
"TP53BP2",
"TP53I11",
"TP53I13",
"TP53I3",
"TP53INP1",
"TP53INP2",
"TP53RK",
"TP53TG1",
"TP53TG3C",
"TP53TG5",
"TP63",
"TP73",
"TP73-AS1",
"TPBG",
"TPBGL",
"TPCN1",
"TPCN2",
"TPD52",
"TPD52L1",
"TPD52L2",
"TPD52L3",
"TPGS1",
"TPGS2",
"TPH1",
"TPH2",
"TPI1",
"TPI1P2",
"TPI1P3",
"TPK1",
"TPM1",
"TPM2",
"TPM3",
"TPM3P9",
"TPM4",
"TPMT",
"TPO",
"TPP1",
"TPP2",
"TPPP",
"TPPP2",
"TPPP3",
"TPR",
"TPRA1",
"TPRG1",
"TPRG1-AS1",
"TPRG1-AS2",
"TPRG1L",
"TPRKB",
"TPRN",
"TPRX1",
"TPRXL",
"TPSAB1",
"TPSB2",
"TPSG1",
"TPST1",
"TPST2",
"TPT1",
"TPT1-AS1",
"TPTE",
"TPTE2",
"TPTE2P1",
"TPTE2P3",
"TPTE2P5",
"TPTE2P6",
"TPTEP1",
"TPX2",
"TRA2A",
"TRA2B",
"TRABD",
"TRABD2A",
"TRABD2B",
"TRADD",
"TRAF1",
"TRAF2",
"TRAF3",
"TRAF3IP1",
"TRAF3IP2",
"TRAF3IP2-AS1",
"TRAF3IP3",
"TRAF4",
"TRAF5",
"TRAF6",
"TRAF7",
"TRAFD1",
"TRAIP",
"TRAK1",
"TRAK2",
"TRAM1",
"TRAM1L1",
"TRAM2",
"TRAM2-AS1",
"TRANK1",
"TRAP1",
"TRAPPC1",
"TRAPPC10",
"TRAPPC11",
"TRAPPC12",
"TRAPPC13",
"TRAPPC2",
"TRAPPC2B",
"TRAPPC2L",
"TRAPPC3",
"TRAPPC3L",
"TRAPPC4",
"TRAPPC5",
"TRAPPC6A",
"TRAPPC6B",
"TRAPPC8",
"TRAPPC9",
"TRDMT1",
"TRDN",
"TREH",
"TREM1",
"TREM2",
"TREML1",
"TREML2",
"TREML3P",
"TREML4",
"TRERF1",
"TREX1",
"TREX2",
"TRH",
"TRHDE",
"TRHDE-AS1",
"TRHR",
"TRIAP1",
"TRIB1",
"TRIB2",
"TRIB3",
"TRIL",
"TRIM10",
"TRIM11",
"TRIM13",
"TRIM14",
"TRIM15",
"TRIM16",
"TRIM16L",
"TRIM17",
"TRIM2",
"TRIM21",
"TRIM22",
"TRIM23",
"TRIM24",
"TRIM25",
"TRIM26",
"TRIM27",
"TRIM28",
"TRIM29",
"TRIM3",
"TRIM31",
"TRIM31-AS1",
"TRIM32",
"TRIM33",
"TRIM34",
"TRIM35",
"TRIM36",
"TRIM37",
"TRIM38",
"TRIM39",
"TRIM39-RPP21",
"TRIM4",
"TRIM40",
"TRIM41",
"TRIM44",
"TRIM45",
"TRIM46",
"TRIM47",
"TRIM49",
"TRIM49C",
"TRIM5",
"TRIM50",
"TRIM52",
"TRIM52-AS1",
"TRIM53AP",
"TRIM54",
"TRIM55",
"TRIM56",
"TRIM58",
"TRIM59",
"TRIM6",
"TRIM6-TRIM34",
"TRIM60",
"TRIM61",
"TRIM62",
"TRIM63",
"TRIM64B",
"TRIM65",
"TRIM66",
"TRIM67",
"TRIM68",
"TRIM69",
"TRIM7",
"TRIM71",
"TRIM72",
"TRIM73",
"TRIM74",
"TRIM8",
"TRIM9",
"TRIML2",
"TRIO",
"TRIOBP",
"TRIP10",
"TRIP11",
"TRIP12",
"TRIP13",
"TRIP4",
"TRIP6",
"TRIQK",
"TRIT1",
"TRMT1",
"TRMT10A",
"TRMT10B",
"TRMT10C",
"TRMT11",
"TRMT112",
"TRMT12",
"TRMT13",
"TRMT1L",
"TRMT2A",
"TRMT2B",
"TRMT44",
"TRMT5",
"TRMT6",
"TRMT61A",
"TRMT61B",
"TRMU",
"TRNAU1AP",
"TRNP1",
"TRNT1",
"TRO",
"TROAP",
"TROVE2",
"TRPA1",
"TRPC1",
"TRPC3",
"TRPC4",
"TRPC4AP",
"TRPC5",
"TRPC5OS",
"TRPC6",
"TRPC7",
"TRPM1",
"TRPM2",
"TRPM2-AS",
"TRPM3",
"TRPM4",
"TRPM5",
"TRPM6",
"TRPM7",
"TRPM8",
"TRPS1",
"TRPT1",
"TRPV1",
"TRPV2",
"TRPV3",
"TRPV4",
"TRPV6",
"TRRAP",
"TRUB1",
"TRUB2",
"TSACC",
"TSC1",
"TSC2",
"TSC22D1",
"TSC22D1-AS1",
"TSC22D2",
"TSC22D3",
"TSC22D4",
"TSEN15",
"TSEN2",
"TSEN34",
"TSEN54",
"TSFM",
"TSG1",
"TSG101",
"TSGA10",
"TSGA10IP",
"TSGA13",
"TSHR",
"TSHZ1",
"TSHZ2",
"TSHZ3",
"TSIX",
"TSKU",
"TSL",
"TSLP",
"TSN",
"TSNARE1",
"TSNAX",
"TSNAX-DISC1",
"TSNAXIP1",
"TSPAN1",
"TSPAN10",
"TSPAN11",
"TSPAN12",
"TSPAN13",
"TSPAN14",
"TSPAN15",
"TSPAN16",
"TSPAN17",
"TSPAN18",
"TSPAN19",
"TSPAN2",
"TSPAN3",
"TSPAN31",
"TSPAN32",
"TSPAN33",
"TSPAN4",
"TSPAN5",
"TSPAN6",
"TSPAN7",
"TSPAN8",
"TSPAN9",
"TSPEAR",
"TSPEAR-AS1",
"TSPEAR-AS2",
"TSPO",
"TSPO2",
"TSPY26P",
"TSPYL1",
"TSPYL2",
"TSPYL4",
"TSPYL5",
"TSPYL6",
"TSR1",
"TSR2",
"TSR3",
"TSSC1",
"TSSC2",
"TSSC4",
"TSSK1B",
"TSSK2",
"TSSK3",
"TSSK4",
"TSSK6",
"TST",
"TSTA3",
"TSTD1",
"TSTD2",
"TSTD3",
"TTBK1",
"TTBK2",
"TTC1",
"TTC12",
"TTC13",
"TTC14",
"TTC16",
"TTC17",
"TTC19",
"TTC21A",
"TTC21B",
"TTC21B-AS1",
"TTC22",
"TTC23",
"TTC23L",
"TTC25",
"TTC26",
"TTC27",
"TTC28",
"TTC28-AS1",
"TTC29",
"TTC3",
"TTC30A",
"TTC30B",
"TTC31",
"TTC32",
"TTC33",
"TTC34",
"TTC36",
"TTC37",
"TTC38",
"TTC39A",
"TTC39A-AS1",
"TTC39B",
"TTC39C",
"TTC39C-AS1",
"TTC3P1",
"TTC4",
"TTC41P",
"TTC5",
"TTC6",
"TTC7A",
"TTC7B",
"TTC8",
"TTC9",
"TTC9B",
"TTC9C",
"TTF1",
"TTF2",
"TTI1",
"TTI2",
"TTK",
"TTL",
"TTLL1",
"TTLL10",
"TTLL11",
"TTLL12",
"TTLL13P",
"TTLL3",
"TTLL4",
"TTLL5",
"TTLL6",
"TTLL7",
"TTLL9",
"TTN",
"TTN-AS1",
"TTPA",
"TTPAL",
"TTR",
"TTYH1",
"TTYH2",
"TTYH3",
"TUB",
"TUBA1A",
"TUBA1B",
"TUBA1C",
"TUBA3D",
"TUBA3E",
"TUBA3FP",
"TUBA4A",
"TUBA4B",
"TUBA8",
"TUBAL3",
"TUBB",
"TUBB1",
"TUBB2A",
"TUBB2B",
"TUBB3",
"TUBB4A",
"TUBB4B",
"TUBB6",
"TUBB8",
"TUBBP5",
"TUBD1",
"TUBE1",
"TUBG1",
"TUBG2",
"TUBGCP2",
"TUBGCP3",
"TUBGCP4",
"TUBGCP5",
"TUBGCP6",
"TUFM",
"TUFT1",
"TUG1",
"TULP1",
"TULP2",
"TULP3",
"TULP4",
"TUNAR",
"TUSC1",
"TUSC2",
"TUSC3",
"TUSC5",
"TUSC8",
"TUT1",
"TVP23A",
"TVP23B",
"TVP23C",
"TVP23C-CDRT4",
"TWF1",
"TWF2",
"TWIST1",
"TWIST2",
"TWISTNB",
"TWSG1",
"TXK",
"TXLNA",
"TXLNB",
"TXLNG",
"TXN",
"TXN2",
"TXNDC11",
"TXNDC12",
"TXNDC12-AS1",
"TXNDC15",
"TXNDC16",
"TXNDC17",
"TXNDC2",
"TXNDC5",
"TXNDC8",
"TXNDC9",
"TXNIP",
"TXNL1",
"TXNL4A",
"TXNL4B",
"TXNRD1",
"TXNRD2",
"TXNRD3",
"TXNRD3NB",
"TYK2",
"TYMP",
"TYMS",
"TYMSOS",
"TYRO3",
"TYRO3P",
"TYROBP",
"TYRP1",
"TYSND1",
"TYW1",
"TYW1B",
"TYW3",
"TYW5",
"U2AF1",
"U2AF1L4",
"U2AF2",
"U2SURP",
"UACA",
"UAP1",
"UAP1L1",
"UBA1",
"UBA2",
"UBA3",
"UBA5",
"UBA52",
"UBA6",
"UBA6-AS1",
"UBA7",
"UBAC1",
"UBAC2",
"UBAC2-AS1",
"UBALD1",
"UBALD2",
"UBAP1",
"UBAP1L",
"UBAP2",
"UBAP2L",
"UBASH3A",
"UBASH3B",
"UBB",
"UBC",
"UBD",
"UBE2A",
"UBE2B",
"UBE2C",
"UBE2D1",
"UBE2D2",
"UBE2D3",
"UBE2D4",
"UBE2E1",
"UBE2E1-AS1",
"UBE2E2",
"UBE2E3",
"UBE2E4P",
"UBE2F",
"UBE2F-SCLY",
"UBE2G1",
"UBE2G2",
"UBE2H",
"UBE2I",
"UBE2J1",
"UBE2J2",
"UBE2K",
"UBE2L3",
"UBE2L6",
"UBE2M",
"UBE2MP1",
"UBE2N",
"UBE2O",
"UBE2Q1",
"UBE2Q1-AS1",
"UBE2Q2",
"UBE2Q2L",
"UBE2Q2P1",
"UBE2Q2P2",
"UBE2QL1",
"UBE2R2",
"UBE2S",
"UBE2T",
"UBE2V1",
"UBE2V2",
"UBE2W",
"UBE2Z",
"UBE3A",
"UBE3B",
"UBE3C",
"UBE3D",
"UBE4A",
"UBE4B",
"UBFD1",
"UBIAD1",
"UBL3",
"UBL4A",
"UBL4B",
"UBL5",
"UBL7",
"UBL7-AS1",
"UBLCP1",
"UBN1",
"UBN2",
"UBOX5",
"UBOX5-AS1",
"UBP1",
"UBQLN1",
"UBQLN2",
"UBQLN4",
"UBQLNL",
"UBR1",
"UBR2",
"UBR3",
"UBR4",
"UBR5",
"UBR5-AS1",
"UBR7",
"UBTD1",
"UBTD2",
"UBTF",
"UBTFL1",
"UBXN1",
"UBXN10",
"UBXN11",
"UBXN2A",
"UBXN2B",
"UBXN4",
"UBXN6",
"UBXN7",
"UBXN8",
"UCA1",
"UCHL1",
"UCHL3",
"UCHL5",
"UCK1",
"UCK2",
"UCKL1",
"UCKL1-AS1",
"UCN",
"UCN2",
"UCP1",
"UCP2",
"UCP3",
"UEVLD",
"UFC1",
"UFD1L",
"UFL1",
"UFM1",
"UFSP1",
"UFSP2",
"UG0898H09",
"UGCG",
"UGDH",
"UGDH-AS1",
"UGGT1",
"UGGT2",
"UGP2",
"UGT1A1",
"UGT1A10",
"UGT1A3",
"UGT1A4",
"UGT1A5",
"UGT1A6",
"UGT1A7",
"UGT1A8",
"UGT1A9",
"UGT2A1",
"UGT2A2",
"UGT2A3",
"UGT2B10",
"UGT2B11",
"UGT2B15",
"UGT2B17",
"UGT2B7",
"UGT3A1",
"UGT3A2",
"UGT8",
"UHMK1",
"UHRF1",
"UHRF1BP1",
"UHRF1BP1L",
"UHRF2",
"UIMC1",
"ULBP1",
"ULBP2",
"ULBP3",
"ULK1",
"ULK2",
"ULK3",
"ULK4",
"ULK4P1",
"ULK4P3",
"UMAD1",
"UMODL1",
"UMODL1-AS1",
"UMPS",
"UNC119",
"UNC119B",
"UNC13A",
"UNC13B",
"UNC13C",
"UNC13D",
"UNC45A",
"UNC50",
"UNC5A",
"UNC5B",
"UNC5B-AS1",
"UNC5C",
"UNC5CL",
"UNC79",
"UNC80",
"UNC93A",
"UNC93B1",
"UNG",
"UNK",
"UNKL",
"UNQ6494",
"UOX",
"UPB1",
"UPF1",
"UPF2",
"UPF3A",
"UPF3B",
"UPK1A",
"UPK1A-AS1",
"UPK1B",
"UPK2",
"UPK3A",
"UPK3B",
"UPK3BL",
"UPP1",
"UPP2",
"UPRT",
"UQCC1",
"UQCC2",
"UQCC3",
"UQCR10",
"UQCR11",
"UQCRB",
"UQCRBP1",
"UQCRC1",
"UQCRC2",
"UQCRFS1",
"UQCRH",
"UQCRHL",
"UQCRQ",
"URAHP",
"URB1",
"URB1-AS1",
"URB2",
"URGCP",
"URGCP-MRPS24",
"URI1",
"URM1",
"UROC1",
"UROD",
"UROS",
"USB1",
"USE1",
"USF1",
"USF2",
"USH1C",
"USH1G",
"USH2A",
"USHBP1",
"USMG5",
"USO1",
"USP1",
"USP10",
"USP11",
"USP12",
"USP12-AS1",
"USP12-AS2",
"USP13",
"USP14",
"USP15",
"USP16",
"USP17L1",
"USP17L10",
"USP17L13",
"USP17L15",
"USP17L17",
"USP17L18",
"USP17L19",
"USP17L2",
"USP17L20",
"USP17L21",
"USP17L22",
"USP17L24",
"USP17L25",
"USP17L28",
"USP17L29",
"USP17L3",
"USP17L30",
"USP17L4",
"USP17L5",
"USP17L6P",
"USP17L7",
"USP17L8",
"USP17L9P",
"USP18",
"USP19",
"USP2",
"USP2-AS1",
"USP20",
"USP21",
"USP22",
"USP24",
"USP25",
"USP26",
"USP27X",
"USP27X-AS1",
"USP28",
"USP29",
"USP3",
"USP3-AS1",
"USP30",
"USP30-AS1",
"USP31",
"USP32",
"USP32P1",
"USP32P2",
"USP33",
"USP34",
"USP35",
"USP36",
"USP37",
"USP38",
"USP39",
"USP4",
"USP40",
"USP42",
"USP43",
"USP44",
"USP45",
"USP46",
"USP46-AS1",
"USP47",
"USP48",
"USP49",
"USP5",
"USP50",
"USP51",
"USP53",
"USP54",
"USP6",
"USP6NL",
"USP7",
"USP8",
"USP9X",
"USPL1",
"UST",
"UTAT33",
"UTP11L",
"UTP14A",
"UTP14C",
"UTP15",
"UTP18",
"UTP20",
"UTP23",
"UTP3",
"UTP6",
"UTRN",
"UTS2",
"UTS2B",
"UTS2R",
"UVRAG",
"UVSSA",
"UXS1",
"UXT",
"UXT-AS1",
"VAC14",
"VAC14-AS1",
"VAMP1",
"VAMP2",
"VAMP3",
"VAMP4",
"VAMP5",
"VAMP7",
"VAMP8",
"VANGL1",
"VANGL2",
"VAPA",
"VAPB",
"VARS",
"VARS2",
"VASH1",
"VASH2",
"VASN",
"VASP",
"VAT1",
"VAT1L",
"VAV1",
"VAV2",
"VAV3",
"VAV3-AS1",
"VAX2",
"VBP1",
"VCAN",
"VCL",
"VCP",
"VCPIP1",
"VCPKMT",
"VCX",
"VCX2",
"VCX3A",
"VCX3B",
"VDAC1",
"VDAC2",
"VDAC3",
"VDR",
"VEGFA",
"VEGFB",
"VEGFC",
"VENTX",
"VEPH1",
"VEZF1",
"VEZT",
"VGF",
"VGLL1",
"VGLL2",
"VGLL3",
"VGLL4",
"VHL",
"VHLL",
"VIL1",
"VILL",
"VIM",
"VIM-AS1",
"VIMP",
"VIP",
"VIPAS39",
"VIPR1",
"VIPR2",
"VKORC1",
"VKORC1L1",
"VLDLR",
"VLDLR-AS1",
"VMA21",
"VMAC",
"VMO1",
"VMP1",
"VN1R1",
"VN1R2",
"VN1R5",
"VNN1",
"VNN2",
"VNN3",
"VOPP1",
"VPRBP",
"VPREB3",
"VPS11",
"VPS13A",
"VPS13A-AS1",
"VPS13B",
"VPS13C",
"VPS13D",
"VPS16",
"VPS18",
"VPS25",
"VPS26A",
"VPS26B",
"VPS28",
"VPS29",
"VPS33A",
"VPS33B",
"VPS35",
"VPS36",
"VPS37A",
"VPS37B",
"VPS37C",
"VPS37D",
"VPS39",
"VPS41",
"VPS45",
"VPS4A",
"VPS4B",
"VPS50",
"VPS51",
"VPS52",
"VPS53",
"VPS54",
"VPS72",
"VPS8",
"VPS9D1",
"VPS9D1-AS1",
"VRK1",
"VRK2",
"VRK3",
"VSIG1",
"VSIG10",
"VSIG10L",
"VSIG2",
"VSIG8",
"VSNL1",
"VSTM1",
"VSTM2A",
"VSTM2L",
"VSTM4",
"VSTM5",
"VSX1",
"VSX2",
"VTA1",
"VTCN1",
"VTI1A",
"VTI1B",
"VTN",
"VWA1",
"VWA2",
"VWA3A",
"VWA3B",
"VWA5A",
"VWA5B2",
"VWA7",
"VWA8",
"VWA8-AS1",
"VWA9",
"VWCE",
"VWDE",
"VWF",
"WAC",
"WAC-AS1",
"WAPL",
"WARS",
"WARS2",
"WARS2-IT1",
"WAS",
"WASF1",
"WASF2",
"WASF3",
"WASH1",
"WASH2P",
"WASH3P",
"WASH5P",
"WASH7P",
"WASIR2",
"WASL",
"WBP1",
"WBP11",
"WBP11P1",
"WBP1L",
"WBP2",
"WBP2NL",
"WBP4",
"WBP5",
"WBSCR16",
"WBSCR22",
"WBSCR27",
"WBSCR28",
"WDFY1",
"WDFY2",
"WDFY3",
"WDFY3-AS2",
"WDFY4",
"WDHD1",
"WDPCP",
"WDR1",
"WDR11",
"WDR11-AS1",
"WDR12",
"WDR13",
"WDR17",
"WDR18",
"WDR19",
"WDR20",
"WDR24",
"WDR25",
"WDR26",
"WDR27",
"WDR3",
"WDR31",
"WDR33",
"WDR34",
"WDR35",
"WDR36",
"WDR37",
"WDR38",
"WDR4",
"WDR41",
"WDR43",
"WDR44",
"WDR45",
"WDR45B",
"WDR46",
"WDR47",
"WDR48",
"WDR49",
"WDR5",
"WDR53",
"WDR54",
"WDR55",
"WDR59",
"WDR5B",
"WDR6",
"WDR60",
"WDR61",
"WDR62",
"WDR63",
"WDR64",
"WDR66",
"WDR7",
"WDR70",
"WDR72",
"WDR73",
"WDR74",
"WDR75",
"WDR76",
"WDR77",
"WDR78",
"WDR81",
"WDR82",
"WDR83",
"WDR83OS",
"WDR86",
"WDR87",
"WDR88",
"WDR89",
"WDR90",
"WDR91",
"WDR92",
"WDR93",
"WDSUB1",
"WDTC1",
"WDYHV1",
"WEE1",
"WEE2",
"WEE2-AS1",
"WFDC10B",
"WFDC12",
"WFDC13",
"WFDC2",
"WFDC21P",
"WFDC3",
"WFDC5",
"WFDC6",
"WFDC8",
"WFIKKN1",
"WFIKKN2",
"WFS1",
"WHAMM",
"WHAMMP1",
"WHAMMP2",
"WHAMMP3",
"WHSC1",
"WHSC1L1",
"WIBG",
"WIF1",
"WIPF1",
"WIPF2",
"WIPF3",
"WIPI1",
"WIPI2",
"WISP1",
"WISP2",
"WISP3",
"WIZ",
"WLS",
"WNK1",
"WNK2",
"WNK3",
"WNK4",
"WNT1",
"WNT10A",
"WNT10B",
"WNT11",
"WNT16",
"WNT2B",
"WNT3",
"WNT3A",
"WNT4",
"WNT5A",
"WNT5B",
"WNT6",
"WNT7A",
"WNT7B",
"WNT8A",
"WNT8B",
"WNT9A",
"WRAP53",
"WRAP73",
"WRB",
"WRN",
"WRNIP1",
"WSB1",
"WSB2",
"WSCD1",
"WT1",
"WT1-AS",
"WTAP",
"WTH3DI",
"WTIP",
"WWC1",
"WWC2",
"WWC2-AS1",
"WWC2-AS2",
"WWC3",
"WWOX",
"WWP1",
"WWP2",
"WWTR1",
"WWTR1-AS1",
"XAB2",
"XAF1",
"XAGE2",
"XBP1",
"XCL2",
"XCR1",
"XDH",
"XG",
"XIAP",
"XIRP1",
"XIRP2",
"XIRP2-AS1",
"XIST",
"XK",
"XKR3",
"XKR4",
"XKR5",
"XKR6",
"XKR7",
"XKR8",
"XKR9",
"XKRX",
"XLOC_009911",
"XPA",
"XPC",
"XPNPEP1",
"XPNPEP2",
"XPNPEP3",
"XPO1",
"XPO4",
"XPO5",
"XPO6",
"XPO7",
"XPOT",
"XPR1",
"XRCC1",
"XRCC2",
"XRCC3",
"XRCC4",
"XRCC5",
"XRCC6",
"XRCC6BP1",
"XRCC6P5",
"XRN1",
"XRN2",
"XRRA1",
"XXYLT1",
"XXYLT1-AS2",
"XYLB",
"XYLT1",
"XYLT2",
"YAE1D1",
"YAF2",
"YAP1",
"YARS",
"YARS2",
"YBEY",
"YBX1",
"YBX2",
"YBX3",
"YBX3P1",
"YDJC",
"YEATS2",
"YEATS4",
"YES1",
"YIF1A",
"YIF1B",
"YIPF1",
"YIPF2",
"YIPF3",
"YIPF4",
"YIPF5",
"YIPF6",
"YIPF7",
"YJEFN3",
"YKT6",
"YLPM1",
"YME1L1",
"YOD1",
"YPEL1",
"YPEL2",
"YPEL3",
"YPEL4",
"YPEL5",
"YRDC",
"YTHDC1",
"YTHDC2",
"YTHDF1",
"YTHDF2",
"YTHDF3",
"YTHDF3-AS1",
"YWHAB",
"YWHAE",
"YWHAEP1",
"YWHAEP7",
"YWHAG",
"YWHAH",
"YWHAQ",
"YWHAZ",
"YY1",
"YY1AP1",
"YY2",
"ZACN",
"ZADH2",
"ZAK",
"ZAN",
"ZAP70",
"ZAR1",
"ZAR1L",
"ZASP",
"ZBBX",
"ZBED1",
"ZBED2",
"ZBED3",
"ZBED3-AS1",
"ZBED4",
"ZBED5",
"ZBED5-AS1",
"ZBED6",
"ZBED6CL",
"ZBED8",
"ZBED9",
"ZBP1",
"ZBTB1",
"ZBTB10",
"ZBTB11",
"ZBTB11-AS1",
"ZBTB12",
"ZBTB14",
"ZBTB16",
"ZBTB17",
"ZBTB18",
"ZBTB2",
"ZBTB20",
"ZBTB21",
"ZBTB22",
"ZBTB24",
"ZBTB25",
"ZBTB26",
"ZBTB3",
"ZBTB32",
"ZBTB33",
"ZBTB34",
"ZBTB37",
"ZBTB38",
"ZBTB39",
"ZBTB4",
"ZBTB40",
"ZBTB41",
"ZBTB42",
"ZBTB43",
"ZBTB44",
"ZBTB45",
"ZBTB46",
"ZBTB46-AS1",
"ZBTB47",
"ZBTB48",
"ZBTB49",
"ZBTB5",
"ZBTB6",
"ZBTB7A",
"ZBTB7B",
"ZBTB7C",
"ZBTB8A",
"ZBTB8B",
"ZBTB8OS",
"ZBTB9",
"ZC2HC1A",
"ZC2HC1C",
"ZC3H10",
"ZC3H11A",
"ZC3H12A",
"ZC3H12B",
"ZC3H12C",
"ZC3H12D",
"ZC3H13",
"ZC3H14",
"ZC3H15",
"ZC3H18",
"ZC3H3",
"ZC3H4",
"ZC3H6",
"ZC3H7A",
"ZC3H7B",
"ZC3H8",
"ZC3HAV1",
"ZC3HAV1L",
"ZC3HC1",
"ZC4H2",
"ZCCHC10",
"ZCCHC11",
"ZCCHC12",
"ZCCHC14",
"ZCCHC16",
"ZCCHC17",
"ZCCHC18",
"ZCCHC2",
"ZCCHC24",
"ZCCHC3",
"ZCCHC4",
"ZCCHC5",
"ZCCHC6",
"ZCCHC7",
"ZCCHC8",
"ZCCHC9",
"ZCRB1",
"ZCWPW1",
"ZCWPW2",
"ZDBF2",
"ZDHHC1",
"ZDHHC11",
"ZDHHC12",
"ZDHHC13",
"ZDHHC14",
"ZDHHC15",
"ZDHHC16",
"ZDHHC17",
"ZDHHC18",
"ZDHHC19",
"ZDHHC2",
"ZDHHC20",
"ZDHHC21",
"ZDHHC22",
"ZDHHC23",
"ZDHHC24",
"ZDHHC3",
"ZDHHC4",
"ZDHHC5",
"ZDHHC6",
"ZDHHC7",
"ZDHHC8",
"ZDHHC8P1",
"ZDHHC9",
"ZEB1",
"ZEB1-AS1",
"ZEB2",
"ZER1",
"ZFAND1",
"ZFAND2A",
"ZFAND2B",
"ZFAND3",
"ZFAND4",
"ZFAND5",
"ZFAND6",
"ZFAS1",
"ZFAT",
"ZFAT-AS1",
"ZFC3H1",
"ZFHX2",
"ZFHX3",
"ZFHX4",
"ZFHX4-AS1",
"ZFP1",
"ZFP14",
"ZFP2",
"ZFP28",
"ZFP3",
"ZFP30",
"ZFP36",
"ZFP36L1",
"ZFP36L2",
"ZFP37",
"ZFP41",
"ZFP42",
"ZFP57",
"ZFP62",
"ZFP64",
"ZFP69",
"ZFP69B",
"ZFP82",
"ZFP90",
"ZFP91",
"ZFP91-CNTF",
"ZFP92",
"ZFPL1",
"ZFPM1",
"ZFPM2",
"ZFPM2-AS1",
"ZFR",
"ZFR2",
"ZFX",
"ZFYVE1",
"ZFYVE16",
"ZFYVE19",
"ZFYVE21",
"ZFYVE26",
"ZFYVE27",
"ZFYVE28",
"ZFYVE9",
"ZG16",
"ZG16B",
"ZGLP1",
"ZGPAT",
"ZGRF1",
"ZHX1",
"ZHX1-C8orf76",
"ZHX2",
"ZHX3",
"ZIC1",
"ZIC2",
"ZIC3",
"ZIC4",
"ZIC5",
"ZIK1",
"ZKSCAN1",
"ZKSCAN2",
"ZKSCAN3",
"ZKSCAN4",
"ZKSCAN5",
"ZKSCAN7",
"ZKSCAN8",
"ZMAT1",
"ZMAT2",
"ZMAT3",
"ZMAT4",
"ZMAT5",
"ZMIZ1",
"ZMIZ1-AS1",
"ZMIZ2",
"ZMPSTE24",
"ZMYM1",
"ZMYM2",
"ZMYM3",
"ZMYM4",
"ZMYM5",
"ZMYM6",
"ZMYM6NB",
"ZMYND10",
"ZMYND11",
"ZMYND12",
"ZMYND15",
"ZMYND19",
"ZMYND8",
"ZNF10",
"ZNF100",
"ZNF101",
"ZNF106",
"ZNF107",
"ZNF112",
"ZNF114",
"ZNF117",
"ZNF12",
"ZNF121",
"ZNF124",
"ZNF131",
"ZNF132",
"ZNF133",
"ZNF134",
"ZNF135",
"ZNF136",
"ZNF137P",
"ZNF138",
"ZNF14",
"ZNF140",
"ZNF141",
"ZNF142",
"ZNF143",
"ZNF146",
"ZNF148",
"ZNF154",
"ZNF155",
"ZNF157",
"ZNF16",
"ZNF160",
"ZNF165",
"ZNF169",
"ZNF17",
"ZNF174",
"ZNF175",
"ZNF177",
"ZNF18",
"ZNF180",
"ZNF181",
"ZNF182",
"ZNF184",
"ZNF185",
"ZNF189",
"ZNF19",
"ZNF192P1",
"ZNF195",
"ZNF197",
"ZNF197-AS1",
"ZNF2",
"ZNF20",
"ZNF200",
"ZNF202",
"ZNF204P",
"ZNF205",
"ZNF205-AS1",
"ZNF207",
"ZNF211",
"ZNF212",
"ZNF213",
"ZNF213-AS1",
"ZNF214",
"ZNF215",
"ZNF217",
"ZNF219",
"ZNF22",
"ZNF221",
"ZNF222",
"ZNF223",
"ZNF224",
"ZNF225",
"ZNF226",
"ZNF227",
"ZNF229",
"ZNF23",
"ZNF230",
"ZNF232",
"ZNF233",
"ZNF234",
"ZNF235",
"ZNF236",
"ZNF239",
"ZNF24",
"ZNF248",
"ZNF25",
"ZNF250",
"ZNF251",
"ZNF252P",
"ZNF252P-AS1",
"ZNF253",
"ZNF254",
"ZNF256",
"ZNF257",
"ZNF26",
"ZNF260",
"ZNF263",
"ZNF264",
"ZNF266",
"ZNF267",
"ZNF268",
"ZNF271P",
"ZNF273",
"ZNF274",
"ZNF275",
"ZNF276",
"ZNF277",
"ZNF28",
"ZNF280A",
"ZNF280B",
"ZNF280C",
"ZNF280D",
"ZNF281",
"ZNF282",
"ZNF283",
"ZNF284",
"ZNF285",
"ZNF286A",
"ZNF286B",
"ZNF287",
"ZNF292",
"ZNF295-AS1",
"ZNF296",
"ZNF3",
"ZNF30",
"ZNF300",
"ZNF300P1",
"ZNF302",
"ZNF304",
"ZNF311",
"ZNF316",
"ZNF317",
"ZNF318",
"ZNF319",
"ZNF32",
"ZNF32-AS1",
"ZNF32-AS2",
"ZNF32-AS3",
"ZNF320",
"ZNF321P",
"ZNF322",
"ZNF324",
"ZNF324B",
"ZNF326",
"ZNF329",
"ZNF330",
"ZNF331",
"ZNF333",
"ZNF335",
"ZNF337",
"ZNF337-AS1",
"ZNF33A",
"ZNF33B",
"ZNF33BP1",
"ZNF34",
"ZNF341",
"ZNF341-AS1",
"ZNF343",
"ZNF345",
"ZNF346",
"ZNF347",
"ZNF35",
"ZNF350",
"ZNF350-AS1",
"ZNF354A",
"ZNF354B",
"ZNF354C",
"ZNF358",
"ZNF362",
"ZNF365",
"ZNF366",
"ZNF367",
"ZNF37A",
"ZNF37BP",
"ZNF382",
"ZNF383",
"ZNF384",
"ZNF385A",
"ZNF385B",
"ZNF385C",
"ZNF391",
"ZNF394",
"ZNF395",
"ZNF396",
"ZNF397",
"ZNF398",
"ZNF404",
"ZNF407",
"ZNF408",
"ZNF41",
"ZNF410",
"ZNF414",
"ZNF415",
"ZNF416",
"ZNF417",
"ZNF418",
"ZNF419",
"ZNF420",
"ZNF423",
"ZNF425",
"ZNF426",
"ZNF428",
"ZNF429",
"ZNF43",
"ZNF430",
"ZNF431",
"ZNF432",
"ZNF433",
"ZNF436",
"ZNF436-AS1",
"ZNF438",
"ZNF439",
"ZNF44",
"ZNF440",
"ZNF441",
"ZNF442",
"ZNF443",
"ZNF444",
"ZNF445",
"ZNF446",
"ZNF449",
"ZNF45",
"ZNF451",
"ZNF454",
"ZNF460",
"ZNF461",
"ZNF462",
"ZNF467",
"ZNF468",
"ZNF469",
"ZNF470",
"ZNF471",
"ZNF473",
"ZNF474",
"ZNF48",
"ZNF480",
"ZNF483",
"ZNF484",
"ZNF485",
"ZNF486",
"ZNF487",
"ZNF488",
"ZNF490",
"ZNF491",
"ZNF492",
"ZNF493",
"ZNF496",
"ZNF497",
"ZNF500",
"ZNF501",
"ZNF502",
"ZNF503",
"ZNF503-AS1",
"ZNF503-AS2",
"ZNF506",
"ZNF507",
"ZNF510",
"ZNF511",
"ZNF512",
"ZNF512B",
"ZNF513",
"ZNF514",
"ZNF516",
"ZNF517",
"ZNF518A",
"ZNF518B",
"ZNF519",
"ZNF521",
"ZNF524",
"ZNF525",
"ZNF526",
"ZNF527",
"ZNF528",
"ZNF528-AS1",
"ZNF529",
"ZNF529-AS1",
"ZNF530",
"ZNF532",
"ZNF534",
"ZNF540",
"ZNF541",
"ZNF543",
"ZNF544",
"ZNF546",
"ZNF547",
"ZNF548",
"ZNF549",
"ZNF550",
"ZNF551",
"ZNF552",
"ZNF554",
"ZNF555",
"ZNF556",
"ZNF557",
"ZNF558",
"ZNF559",
"ZNF559-ZNF177",
"ZNF560",
"ZNF561",
"ZNF561-AS1",
"ZNF562",
"ZNF563",
"ZNF564",
"ZNF565",
"ZNF566",
"ZNF567",
"ZNF568",
"ZNF569",
"ZNF57",
"ZNF570",
"ZNF571",
"ZNF571-AS1",
"ZNF572",
"ZNF573",
"ZNF574",
"ZNF575",
"ZNF576",
"ZNF577",
"ZNF578",
"ZNF579",
"ZNF580",
"ZNF581",
"ZNF582",
"ZNF583",
"ZNF584",
"ZNF585A",
"ZNF585B",
"ZNF586",
"ZNF587",
"ZNF587B",
"ZNF589",
"ZNF592",
"ZNF593",
"ZNF594",
"ZNF595",
"ZNF596",
"ZNF597",
"ZNF598",
"ZNF599",
"ZNF600",
"ZNF605",
"ZNF606",
"ZNF607",
"ZNF608",
"ZNF609",
"ZNF610",
"ZNF611",
"ZNF613",
"ZNF614",
"ZNF615",
"ZNF616",
"ZNF618",
"ZNF619",
"ZNF620",
"ZNF621",
"ZNF622",
"ZNF623",
"ZNF624",
"ZNF625",
"ZNF625-ZNF20",
"ZNF626",
"ZNF627",
"ZNF628",
"ZNF629",
"ZNF630",
"ZNF630-AS1",
"ZNF638",
"ZNF639",
"ZNF641",
"ZNF644",
"ZNF646",
"ZNF648",
"ZNF649",
"ZNF652",
"ZNF653",
"ZNF654",
"ZNF655",
"ZNF658",
"ZNF658B",
"ZNF660",
"ZNF662",
"ZNF664",
"ZNF664-FAM101A",
"ZNF665",
"ZNF667-AS1",
"ZNF668",
"ZNF669",
"ZNF670",
"ZNF670-ZNF695",
"ZNF671",
"ZNF672",
"ZNF674",
"ZNF674-AS1",
"ZNF675",
"ZNF676",
"ZNF678",
"ZNF680",
"ZNF681",
"ZNF682",
"ZNF684",
"ZNF687",
"ZNF688",
"ZNF689",
"ZNF69",
"ZNF691",
"ZNF692",
"ZNF695",
"ZNF696",
"ZNF697",
"ZNF699",
"ZNF7",
"ZNF70",
"ZNF700",
"ZNF701",
"ZNF702P",
"ZNF703",
"ZNF704",
"ZNF705A",
"ZNF705B",
"ZNF705D",
"ZNF705E",
"ZNF705G",
"ZNF706",
"ZNF707",
"ZNF708",
"ZNF709",
"ZNF71",
"ZNF710",
"ZNF711",
"ZNF713",
"ZNF714",
"ZNF717",
"ZNF718",
"ZNF720",
"ZNF721",
"ZNF724P",
"ZNF726",
"ZNF730",
"ZNF732",
"ZNF736",
"ZNF737",
"ZNF738",
"ZNF74",
"ZNF740",
"ZNF746",
"ZNF747",
"ZNF749",
"ZNF750",
"ZNF75A",
"ZNF75D",
"ZNF76",
"ZNF761",
"ZNF763",
"ZNF764",
"ZNF765",
"ZNF766",
"ZNF767P",
"ZNF768",
"ZNF77",
"ZNF770",
"ZNF771",
"ZNF772",
"ZNF773",
"ZNF774",
"ZNF775",
"ZNF776",
"ZNF777",
"ZNF778",
"ZNF780A",
"ZNF780B",
"ZNF781",
"ZNF782",
"ZNF783",
"ZNF784",
"ZNF785",
"ZNF786",
"ZNF787",
"ZNF788",
"ZNF789",
"ZNF79",
"ZNF790",
"ZNF790-AS1",
"ZNF791",
"ZNF792",
"ZNF793",
"ZNF793-AS1",
"ZNF799",
"ZNF8",
"ZNF80",
"ZNF800",
"ZNF804A",
"ZNF804B",
"ZNF805",
"ZNF806",
"ZNF808",
"ZNF81",
"ZNF812",
"ZNF813",
"ZNF814",
"ZNF815P",
"ZNF816",
"ZNF816-ZNF321P",
"ZNF818P",
"ZNF821",
"ZNF823",
"ZNF826P",
"ZNF827",
"ZNF829",
"ZNF83",
"ZNF830",
"ZNF831",
"ZNF833P",
"ZNF836",
"ZNF837",
"ZNF839",
"ZNF84",
"ZNF841",
"ZNF843",
"ZNF844",
"ZNF845",
"ZNF846",
"ZNF85",
"ZNF850",
"ZNF852",
"ZNF853",
"ZNF860",
"ZNF862",
"ZNF865",
"ZNF876P",
"ZNF878",
"ZNF879",
"ZNF880",
"ZNF883",
"ZNF888",
"ZNF890P",
"ZNF891",
"ZNF90",
"ZNF91",
"ZNF92",
"ZNF93",
"ZNF98",
"ZNFX1",
"ZNHIT1",
"ZNHIT2",
"ZNHIT3",
"ZNHIT6",
"ZNRD1",
"ZNRD1-AS1",
"ZNRF1",
"ZNRF2",
"ZNRF2P1",
"ZNRF2P2",
"ZNRF3",
"ZNRF3-AS1",
"ZP1",
"ZP2",
"ZP3",
"ZP4",
"ZPBP",
"ZPLD1",
"ZPR1",
"ZRANB1",
"ZRANB2",
"ZRANB2-AS1",
"ZRANB2-AS2",
"ZRANB3",
"ZRSR2",
"ZSCAN12",
"ZSCAN12P1",
"ZSCAN16",
"ZSCAN16-AS1",
"ZSCAN18",
"ZSCAN2",
"ZSCAN20",
"ZSCAN21",
"ZSCAN22",
"ZSCAN23",
"ZSCAN25",
"ZSCAN26",
"ZSCAN29",
"ZSCAN30",
"ZSCAN31",
"ZSCAN32",
"ZSCAN4",
"ZSCAN5A",
"ZSCAN5B",
"ZSCAN9",
"ZSWIM1",
"ZSWIM2",
"ZSWIM3",
"ZSWIM4",
"ZSWIM5",
"ZSWIM6",
"ZSWIM7",
"ZSWIM8",
"ZSWIM8-AS1",
"ZUFSP",
"ZW10",
"ZWILCH",
"ZWINT",
"ZXDA",
"ZXDB",
"ZXDC",
"ZYG11A",
"ZYG11B",
"ZYX",
"ZZEF1",
"ZZZ3"
];

export default AllGeneList;